function pj(n, i) {
  for (var l = 0; l < i.length; l++) {
    const o = i[l];
    if (typeof o != "string" && !Array.isArray(o)) {
      for (const d in o)
        if (d !== "default" && !(d in n)) {
          const f = Object.getOwnPropertyDescriptor(o, d);
          f && Object.defineProperty(n, d, f.get ? f : {
            enumerable: !0,
            get: () => o[d]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
function ll(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ld = { exports: {} }, _r = {};
var qx;
function gj() {
  if (qx) return _r;
  qx = 1;
  var n = /* @__PURE__ */ Symbol.for("react.transitional.element"), i = /* @__PURE__ */ Symbol.for("react.fragment");
  function l(o, d, f) {
    var h = null;
    if (f !== void 0 && (h = "" + f), d.key !== void 0 && (h = "" + d.key), "key" in d) {
      f = {};
      for (var p in d)
        p !== "key" && (f[p] = d[p]);
    } else f = d;
    return d = f.ref, {
      $$typeof: n,
      type: o,
      key: h,
      ref: d !== void 0 ? d : null,
      props: f
    };
  }
  return _r.Fragment = i, _r.jsx = l, _r.jsxs = l, _r;
}
var Gx;
function xj() {
  return Gx || (Gx = 1, Ld.exports = gj()), Ld.exports;
}
var s = xj(), Pd = { exports: {} }, Dr = {}, Id = { exports: {} }, qd = {};
var Yx;
function yj() {
  return Yx || (Yx = 1, (function(n) {
    function i(O, X) {
      var ne = O.length;
      O.push(X);
      e: for (; 0 < ne; ) {
        var he = ne - 1 >>> 1, K = O[he];
        if (0 < d(K, X))
          O[he] = X, O[ne] = K, ne = he;
        else break e;
      }
    }
    function l(O) {
      return O.length === 0 ? null : O[0];
    }
    function o(O) {
      if (O.length === 0) return null;
      var X = O[0], ne = O.pop();
      if (ne !== X) {
        O[0] = ne;
        e: for (var he = 0, K = O.length, S = K >>> 1; he < S; ) {
          var L = 2 * (he + 1) - 1, Y = O[L], J = L + 1, te = O[J];
          if (0 > d(Y, ne))
            J < K && 0 > d(te, Y) ? (O[he] = te, O[J] = ne, he = J) : (O[he] = Y, O[L] = ne, he = L);
          else if (J < K && 0 > d(te, ne))
            O[he] = te, O[J] = ne, he = J;
          else break e;
        }
      }
      return X;
    }
    function d(O, X) {
      var ne = O.sortIndex - X.sortIndex;
      return ne !== 0 ? ne : O.id - X.id;
    }
    if (n.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var f = performance;
      n.unstable_now = function() {
        return f.now();
      };
    } else {
      var h = Date, p = h.now();
      n.unstable_now = function() {
        return h.now() - p;
      };
    }
    var g = [], m = [], b = 1, y = null, w = 3, N = !1, T = !1, R = !1, _ = !1, z = typeof setTimeout == "function" ? setTimeout : null, q = typeof clearTimeout == "function" ? clearTimeout : null, G = typeof setImmediate < "u" ? setImmediate : null;
    function Q(O) {
      for (var X = l(m); X !== null; ) {
        if (X.callback === null) o(m);
        else if (X.startTime <= O)
          o(m), X.sortIndex = X.expirationTime, i(g, X);
        else break;
        X = l(m);
      }
    }
    function H(O) {
      if (R = !1, Q(O), !T)
        if (l(g) !== null)
          T = !0, W || (W = !0, xe());
        else {
          var X = l(m);
          X !== null && ze(H, X.startTime - O);
        }
    }
    var W = !1, $ = -1, k = 5, ee = -1;
    function ae() {
      return _ ? !0 : !(n.unstable_now() - ee < k);
    }
    function me() {
      if (_ = !1, W) {
        var O = n.unstable_now();
        ee = O;
        var X = !0;
        try {
          e: {
            T = !1, R && (R = !1, q($), $ = -1), N = !0;
            var ne = w;
            try {
              t: {
                for (Q(O), y = l(g); y !== null && !(y.expirationTime > O && ae()); ) {
                  var he = y.callback;
                  if (typeof he == "function") {
                    y.callback = null, w = y.priorityLevel;
                    var K = he(
                      y.expirationTime <= O
                    );
                    if (O = n.unstable_now(), typeof K == "function") {
                      y.callback = K, Q(O), X = !0;
                      break t;
                    }
                    y === l(g) && o(g), Q(O);
                  } else o(g);
                  y = l(g);
                }
                if (y !== null) X = !0;
                else {
                  var S = l(m);
                  S !== null && ze(
                    H,
                    S.startTime - O
                  ), X = !1;
                }
              }
              break e;
            } finally {
              y = null, w = ne, N = !1;
            }
            X = void 0;
          }
        } finally {
          X ? xe() : W = !1;
        }
      }
    }
    var xe;
    if (typeof G == "function")
      xe = function() {
        G(me);
      };
    else if (typeof MessageChannel < "u") {
      var _e = new MessageChannel(), Be = _e.port2;
      _e.port1.onmessage = me, xe = function() {
        Be.postMessage(null);
      };
    } else
      xe = function() {
        z(me, 0);
      };
    function ze(O, X) {
      $ = z(function() {
        O(n.unstable_now());
      }, X);
    }
    n.unstable_IdlePriority = 5, n.unstable_ImmediatePriority = 1, n.unstable_LowPriority = 4, n.unstable_NormalPriority = 3, n.unstable_Profiling = null, n.unstable_UserBlockingPriority = 2, n.unstable_cancelCallback = function(O) {
      O.callback = null;
    }, n.unstable_forceFrameRate = function(O) {
      0 > O || 125 < O ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : k = 0 < O ? Math.floor(1e3 / O) : 5;
    }, n.unstable_getCurrentPriorityLevel = function() {
      return w;
    }, n.unstable_next = function(O) {
      switch (w) {
        case 1:
        case 2:
        case 3:
          var X = 3;
          break;
        default:
          X = w;
      }
      var ne = w;
      w = X;
      try {
        return O();
      } finally {
        w = ne;
      }
    }, n.unstable_requestPaint = function() {
      _ = !0;
    }, n.unstable_runWithPriority = function(O, X) {
      switch (O) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          O = 3;
      }
      var ne = w;
      w = O;
      try {
        return X();
      } finally {
        w = ne;
      }
    }, n.unstable_scheduleCallback = function(O, X, ne) {
      var he = n.unstable_now();
      switch (typeof ne == "object" && ne !== null ? (ne = ne.delay, ne = typeof ne == "number" && 0 < ne ? he + ne : he) : ne = he, O) {
        case 1:
          var K = -1;
          break;
        case 2:
          K = 250;
          break;
        case 5:
          K = 1073741823;
          break;
        case 4:
          K = 1e4;
          break;
        default:
          K = 5e3;
      }
      return K = ne + K, O = {
        id: b++,
        callback: X,
        priorityLevel: O,
        startTime: ne,
        expirationTime: K,
        sortIndex: -1
      }, ne > he ? (O.sortIndex = ne, i(m, O), l(g) === null && O === l(m) && (R ? (q($), $ = -1) : R = !0, ze(H, ne - he))) : (O.sortIndex = K, i(g, O), T || N || (T = !0, W || (W = !0, xe()))), O;
    }, n.unstable_shouldYield = ae, n.unstable_wrapCallback = function(O) {
      var X = w;
      return function() {
        var ne = w;
        w = X;
        try {
          return O.apply(this, arguments);
        } finally {
          w = ne;
        }
      };
    };
  })(qd)), qd;
}
var Qx;
function bj() {
  return Qx || (Qx = 1, Id.exports = yj()), Id.exports;
}
var Gd = { exports: {} }, ye = {};
var Zx;
function vj() {
  if (Zx) return ye;
  Zx = 1;
  var n = /* @__PURE__ */ Symbol.for("react.transitional.element"), i = /* @__PURE__ */ Symbol.for("react.portal"), l = /* @__PURE__ */ Symbol.for("react.fragment"), o = /* @__PURE__ */ Symbol.for("react.strict_mode"), d = /* @__PURE__ */ Symbol.for("react.profiler"), f = /* @__PURE__ */ Symbol.for("react.consumer"), h = /* @__PURE__ */ Symbol.for("react.context"), p = /* @__PURE__ */ Symbol.for("react.forward_ref"), g = /* @__PURE__ */ Symbol.for("react.suspense"), m = /* @__PURE__ */ Symbol.for("react.memo"), b = /* @__PURE__ */ Symbol.for("react.lazy"), y = /* @__PURE__ */ Symbol.for("react.activity"), w = Symbol.iterator;
  function N(S) {
    return S === null || typeof S != "object" ? null : (S = w && S[w] || S["@@iterator"], typeof S == "function" ? S : null);
  }
  var T = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, R = Object.assign, _ = {};
  function z(S, L, Y) {
    this.props = S, this.context = L, this.refs = _, this.updater = Y || T;
  }
  z.prototype.isReactComponent = {}, z.prototype.setState = function(S, L) {
    if (typeof S != "object" && typeof S != "function" && S != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, S, L, "setState");
  }, z.prototype.forceUpdate = function(S) {
    this.updater.enqueueForceUpdate(this, S, "forceUpdate");
  };
  function q() {
  }
  q.prototype = z.prototype;
  function G(S, L, Y) {
    this.props = S, this.context = L, this.refs = _, this.updater = Y || T;
  }
  var Q = G.prototype = new q();
  Q.constructor = G, R(Q, z.prototype), Q.isPureReactComponent = !0;
  var H = Array.isArray;
  function W() {
  }
  var $ = { H: null, A: null, T: null, S: null }, k = Object.prototype.hasOwnProperty;
  function ee(S, L, Y) {
    var J = Y.ref;
    return {
      $$typeof: n,
      type: S,
      key: L,
      ref: J !== void 0 ? J : null,
      props: Y
    };
  }
  function ae(S, L) {
    return ee(S.type, L, S.props);
  }
  function me(S) {
    return typeof S == "object" && S !== null && S.$$typeof === n;
  }
  function xe(S) {
    var L = { "=": "=0", ":": "=2" };
    return "$" + S.replace(/[=:]/g, function(Y) {
      return L[Y];
    });
  }
  var _e = /\/+/g;
  function Be(S, L) {
    return typeof S == "object" && S !== null && S.key != null ? xe("" + S.key) : L.toString(36);
  }
  function ze(S) {
    switch (S.status) {
      case "fulfilled":
        return S.value;
      case "rejected":
        throw S.reason;
      default:
        switch (typeof S.status == "string" ? S.then(W, W) : (S.status = "pending", S.then(
          function(L) {
            S.status === "pending" && (S.status = "fulfilled", S.value = L);
          },
          function(L) {
            S.status === "pending" && (S.status = "rejected", S.reason = L);
          }
        )), S.status) {
          case "fulfilled":
            return S.value;
          case "rejected":
            throw S.reason;
        }
    }
    throw S;
  }
  function O(S, L, Y, J, te) {
    var se = typeof S;
    (se === "undefined" || se === "boolean") && (S = null);
    var ve = !1;
    if (S === null) ve = !0;
    else
      switch (se) {
        case "bigint":
        case "string":
        case "number":
          ve = !0;
          break;
        case "object":
          switch (S.$$typeof) {
            case n:
            case i:
              ve = !0;
              break;
            case b:
              return ve = S._init, O(
                ve(S._payload),
                L,
                Y,
                J,
                te
              );
          }
      }
    if (ve)
      return te = te(S), ve = J === "" ? "." + Be(S, 0) : J, H(te) ? (Y = "", ve != null && (Y = ve.replace(_e, "$&/") + "/"), O(te, L, Y, "", function(Qt) {
        return Qt;
      })) : te != null && (me(te) && (te = ae(
        te,
        Y + (te.key == null || S && S.key === te.key ? "" : ("" + te.key).replace(
          _e,
          "$&/"
        ) + "/") + ve
      )), L.push(te)), 1;
    ve = 0;
    var be = J === "" ? "." : J + ":";
    if (H(S))
      for (var pe = 0; pe < S.length; pe++)
        J = S[pe], se = be + Be(J, pe), ve += O(
          J,
          L,
          Y,
          se,
          te
        );
    else if (pe = N(S), typeof pe == "function")
      for (S = pe.call(S), pe = 0; !(J = S.next()).done; )
        J = J.value, se = be + Be(J, pe++), ve += O(
          J,
          L,
          Y,
          se,
          te
        );
    else if (se === "object") {
      if (typeof S.then == "function")
        return O(
          ze(S),
          L,
          Y,
          J,
          te
        );
      throw L = String(S), Error(
        "Objects are not valid as a React child (found: " + (L === "[object Object]" ? "object with keys {" + Object.keys(S).join(", ") + "}" : L) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return ve;
  }
  function X(S, L, Y) {
    if (S == null) return S;
    var J = [], te = 0;
    return O(S, J, "", "", function(se) {
      return L.call(Y, se, te++);
    }), J;
  }
  function ne(S) {
    if (S._status === -1) {
      var L = S._result;
      L = L(), L.then(
        function(Y) {
          (S._status === 0 || S._status === -1) && (S._status = 1, S._result = Y);
        },
        function(Y) {
          (S._status === 0 || S._status === -1) && (S._status = 2, S._result = Y);
        }
      ), S._status === -1 && (S._status = 0, S._result = L);
    }
    if (S._status === 1) return S._result.default;
    throw S._result;
  }
  var he = typeof reportError == "function" ? reportError : function(S) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var L = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof S == "object" && S !== null && typeof S.message == "string" ? String(S.message) : String(S),
        error: S
      });
      if (!window.dispatchEvent(L)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", S);
      return;
    }
    console.error(S);
  }, K = {
    map: X,
    forEach: function(S, L, Y) {
      X(
        S,
        function() {
          L.apply(this, arguments);
        },
        Y
      );
    },
    count: function(S) {
      var L = 0;
      return X(S, function() {
        L++;
      }), L;
    },
    toArray: function(S) {
      return X(S, function(L) {
        return L;
      }) || [];
    },
    only: function(S) {
      if (!me(S))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return S;
    }
  };
  return ye.Activity = y, ye.Children = K, ye.Component = z, ye.Fragment = l, ye.Profiler = d, ye.PureComponent = G, ye.StrictMode = o, ye.Suspense = g, ye.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = $, ye.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(S) {
      return $.H.useMemoCache(S);
    }
  }, ye.cache = function(S) {
    return function() {
      return S.apply(null, arguments);
    };
  }, ye.cacheSignal = function() {
    return null;
  }, ye.cloneElement = function(S, L, Y) {
    if (S == null)
      throw Error(
        "The argument must be a React element, but you passed " + S + "."
      );
    var J = R({}, S.props), te = S.key;
    if (L != null)
      for (se in L.key !== void 0 && (te = "" + L.key), L)
        !k.call(L, se) || se === "key" || se === "__self" || se === "__source" || se === "ref" && L.ref === void 0 || (J[se] = L[se]);
    var se = arguments.length - 2;
    if (se === 1) J.children = Y;
    else if (1 < se) {
      for (var ve = Array(se), be = 0; be < se; be++)
        ve[be] = arguments[be + 2];
      J.children = ve;
    }
    return ee(S.type, te, J);
  }, ye.createContext = function(S) {
    return S = {
      $$typeof: h,
      _currentValue: S,
      _currentValue2: S,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, S.Provider = S, S.Consumer = {
      $$typeof: f,
      _context: S
    }, S;
  }, ye.createElement = function(S, L, Y) {
    var J, te = {}, se = null;
    if (L != null)
      for (J in L.key !== void 0 && (se = "" + L.key), L)
        k.call(L, J) && J !== "key" && J !== "__self" && J !== "__source" && (te[J] = L[J]);
    var ve = arguments.length - 2;
    if (ve === 1) te.children = Y;
    else if (1 < ve) {
      for (var be = Array(ve), pe = 0; pe < ve; pe++)
        be[pe] = arguments[pe + 2];
      te.children = be;
    }
    if (S && S.defaultProps)
      for (J in ve = S.defaultProps, ve)
        te[J] === void 0 && (te[J] = ve[J]);
    return ee(S, se, te);
  }, ye.createRef = function() {
    return { current: null };
  }, ye.forwardRef = function(S) {
    return { $$typeof: p, render: S };
  }, ye.isValidElement = me, ye.lazy = function(S) {
    return {
      $$typeof: b,
      _payload: { _status: -1, _result: S },
      _init: ne
    };
  }, ye.memo = function(S, L) {
    return {
      $$typeof: m,
      type: S,
      compare: L === void 0 ? null : L
    };
  }, ye.startTransition = function(S) {
    var L = $.T, Y = {};
    $.T = Y;
    try {
      var J = S(), te = $.S;
      te !== null && te(Y, J), typeof J == "object" && J !== null && typeof J.then == "function" && J.then(W, he);
    } catch (se) {
      he(se);
    } finally {
      L !== null && Y.types !== null && (L.types = Y.types), $.T = L;
    }
  }, ye.unstable_useCacheRefresh = function() {
    return $.H.useCacheRefresh();
  }, ye.use = function(S) {
    return $.H.use(S);
  }, ye.useActionState = function(S, L, Y) {
    return $.H.useActionState(S, L, Y);
  }, ye.useCallback = function(S, L) {
    return $.H.useCallback(S, L);
  }, ye.useContext = function(S) {
    return $.H.useContext(S);
  }, ye.useDebugValue = function() {
  }, ye.useDeferredValue = function(S, L) {
    return $.H.useDeferredValue(S, L);
  }, ye.useEffect = function(S, L) {
    return $.H.useEffect(S, L);
  }, ye.useEffectEvent = function(S) {
    return $.H.useEffectEvent(S);
  }, ye.useId = function() {
    return $.H.useId();
  }, ye.useImperativeHandle = function(S, L, Y) {
    return $.H.useImperativeHandle(S, L, Y);
  }, ye.useInsertionEffect = function(S, L) {
    return $.H.useInsertionEffect(S, L);
  }, ye.useLayoutEffect = function(S, L) {
    return $.H.useLayoutEffect(S, L);
  }, ye.useMemo = function(S, L) {
    return $.H.useMemo(S, L);
  }, ye.useOptimistic = function(S, L) {
    return $.H.useOptimistic(S, L);
  }, ye.useReducer = function(S, L, Y) {
    return $.H.useReducer(S, L, Y);
  }, ye.useRef = function(S) {
    return $.H.useRef(S);
  }, ye.useState = function(S) {
    return $.H.useState(S);
  }, ye.useSyncExternalStore = function(S, L, Y) {
    return $.H.useSyncExternalStore(
      S,
      L,
      Y
    );
  }, ye.useTransition = function() {
    return $.H.useTransition();
  }, ye.version = "19.2.8", ye;
}
var Xx;
function gc() {
  return Xx || (Xx = 1, Gd.exports = vj()), Gd.exports;
}
var Yd = { exports: {} }, Nt = {};
var Kx;
function wj() {
  if (Kx) return Nt;
  Kx = 1;
  var n = gc();
  function i(g) {
    var m = "https://react.dev/errors/" + g;
    if (1 < arguments.length) {
      m += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var b = 2; b < arguments.length; b++)
        m += "&args[]=" + encodeURIComponent(arguments[b]);
    }
    return "Minified React error #" + g + "; visit " + m + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function l() {
  }
  var o = {
    d: {
      f: l,
      r: function() {
        throw Error(i(522));
      },
      D: l,
      C: l,
      L: l,
      m: l,
      X: l,
      S: l,
      M: l
    },
    p: 0,
    findDOMNode: null
  }, d = /* @__PURE__ */ Symbol.for("react.portal");
  function f(g, m, b) {
    var y = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: d,
      key: y == null ? null : "" + y,
      children: g,
      containerInfo: m,
      implementation: b
    };
  }
  var h = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function p(g, m) {
    if (g === "font") return "";
    if (typeof m == "string")
      return m === "use-credentials" ? m : "";
  }
  return Nt.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = o, Nt.createPortal = function(g, m) {
    var b = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!m || m.nodeType !== 1 && m.nodeType !== 9 && m.nodeType !== 11)
      throw Error(i(299));
    return f(g, m, null, b);
  }, Nt.flushSync = function(g) {
    var m = h.T, b = o.p;
    try {
      if (h.T = null, o.p = 2, g) return g();
    } finally {
      h.T = m, o.p = b, o.d.f();
    }
  }, Nt.preconnect = function(g, m) {
    typeof g == "string" && (m ? (m = m.crossOrigin, m = typeof m == "string" ? m === "use-credentials" ? m : "" : void 0) : m = null, o.d.C(g, m));
  }, Nt.prefetchDNS = function(g) {
    typeof g == "string" && o.d.D(g);
  }, Nt.preinit = function(g, m) {
    if (typeof g == "string" && m && typeof m.as == "string") {
      var b = m.as, y = p(b, m.crossOrigin), w = typeof m.integrity == "string" ? m.integrity : void 0, N = typeof m.fetchPriority == "string" ? m.fetchPriority : void 0;
      b === "style" ? o.d.S(
        g,
        typeof m.precedence == "string" ? m.precedence : void 0,
        {
          crossOrigin: y,
          integrity: w,
          fetchPriority: N
        }
      ) : b === "script" && o.d.X(g, {
        crossOrigin: y,
        integrity: w,
        fetchPriority: N,
        nonce: typeof m.nonce == "string" ? m.nonce : void 0
      });
    }
  }, Nt.preinitModule = function(g, m) {
    if (typeof g == "string")
      if (typeof m == "object" && m !== null) {
        if (m.as == null || m.as === "script") {
          var b = p(
            m.as,
            m.crossOrigin
          );
          o.d.M(g, {
            crossOrigin: b,
            integrity: typeof m.integrity == "string" ? m.integrity : void 0,
            nonce: typeof m.nonce == "string" ? m.nonce : void 0
          });
        }
      } else m == null && o.d.M(g);
  }, Nt.preload = function(g, m) {
    if (typeof g == "string" && typeof m == "object" && m !== null && typeof m.as == "string") {
      var b = m.as, y = p(b, m.crossOrigin);
      o.d.L(g, b, {
        crossOrigin: y,
        integrity: typeof m.integrity == "string" ? m.integrity : void 0,
        nonce: typeof m.nonce == "string" ? m.nonce : void 0,
        type: typeof m.type == "string" ? m.type : void 0,
        fetchPriority: typeof m.fetchPriority == "string" ? m.fetchPriority : void 0,
        referrerPolicy: typeof m.referrerPolicy == "string" ? m.referrerPolicy : void 0,
        imageSrcSet: typeof m.imageSrcSet == "string" ? m.imageSrcSet : void 0,
        imageSizes: typeof m.imageSizes == "string" ? m.imageSizes : void 0,
        media: typeof m.media == "string" ? m.media : void 0
      });
    }
  }, Nt.preloadModule = function(g, m) {
    if (typeof g == "string")
      if (m) {
        var b = p(m.as, m.crossOrigin);
        o.d.m(g, {
          as: typeof m.as == "string" && m.as !== "script" ? m.as : void 0,
          crossOrigin: b,
          integrity: typeof m.integrity == "string" ? m.integrity : void 0
        });
      } else o.d.m(g);
  }, Nt.requestFormReset = function(g) {
    o.d.r(g);
  }, Nt.unstable_batchedUpdates = function(g, m) {
    return g(m);
  }, Nt.useFormState = function(g, m, b) {
    return h.H.useFormState(g, m, b);
  }, Nt.useFormStatus = function() {
    return h.H.useHostTransitionStatus();
  }, Nt.version = "19.2.8", Nt;
}
var $x;
function dv() {
  if ($x) return Yd.exports;
  $x = 1;
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (i) {
        console.error(i);
      }
  }
  return n(), Yd.exports = wj(), Yd.exports;
}
var Wx;
function jj() {
  if (Wx) return Dr;
  Wx = 1;
  var n = bj(), i = gc(), l = dv();
  function o(e) {
    var t = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var a = 2; a < arguments.length; a++)
        t += "&args[]=" + encodeURIComponent(arguments[a]);
    }
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function d(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function f(e) {
    var t = e, a = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else {
      e = t;
      do
        t = e, (t.flags & 4098) !== 0 && (a = t.return), e = t.return;
      while (e);
    }
    return t.tag === 3 ? a : null;
  }
  function h(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function p(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function g(e) {
    if (f(e) !== e)
      throw Error(o(188));
  }
  function m(e) {
    var t = e.alternate;
    if (!t) {
      if (t = f(e), t === null) throw Error(o(188));
      return t !== e ? null : e;
    }
    for (var a = e, r = t; ; ) {
      var c = a.return;
      if (c === null) break;
      var u = c.alternate;
      if (u === null) {
        if (r = c.return, r !== null) {
          a = r;
          continue;
        }
        break;
      }
      if (c.child === u.child) {
        for (u = c.child; u; ) {
          if (u === a) return g(c), e;
          if (u === r) return g(c), t;
          u = u.sibling;
        }
        throw Error(o(188));
      }
      if (a.return !== r.return) a = c, r = u;
      else {
        for (var x = !1, v = c.child; v; ) {
          if (v === a) {
            x = !0, a = c, r = u;
            break;
          }
          if (v === r) {
            x = !0, r = c, a = u;
            break;
          }
          v = v.sibling;
        }
        if (!x) {
          for (v = u.child; v; ) {
            if (v === a) {
              x = !0, a = u, r = c;
              break;
            }
            if (v === r) {
              x = !0, r = u, a = c;
              break;
            }
            v = v.sibling;
          }
          if (!x) throw Error(o(189));
        }
      }
      if (a.alternate !== r) throw Error(o(190));
    }
    if (a.tag !== 3) throw Error(o(188));
    return a.stateNode.current === a ? e : t;
  }
  function b(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
    for (e = e.child; e !== null; ) {
      if (t = b(e), t !== null) return t;
      e = e.sibling;
    }
    return null;
  }
  var y = Object.assign, w = /* @__PURE__ */ Symbol.for("react.element"), N = /* @__PURE__ */ Symbol.for("react.transitional.element"), T = /* @__PURE__ */ Symbol.for("react.portal"), R = /* @__PURE__ */ Symbol.for("react.fragment"), _ = /* @__PURE__ */ Symbol.for("react.strict_mode"), z = /* @__PURE__ */ Symbol.for("react.profiler"), q = /* @__PURE__ */ Symbol.for("react.consumer"), G = /* @__PURE__ */ Symbol.for("react.context"), Q = /* @__PURE__ */ Symbol.for("react.forward_ref"), H = /* @__PURE__ */ Symbol.for("react.suspense"), W = /* @__PURE__ */ Symbol.for("react.suspense_list"), $ = /* @__PURE__ */ Symbol.for("react.memo"), k = /* @__PURE__ */ Symbol.for("react.lazy"), ee = /* @__PURE__ */ Symbol.for("react.activity"), ae = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), me = Symbol.iterator;
  function xe(e) {
    return e === null || typeof e != "object" ? null : (e = me && e[me] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var _e = /* @__PURE__ */ Symbol.for("react.client.reference");
  function Be(e) {
    if (e == null) return null;
    if (typeof e == "function")
      return e.$$typeof === _e ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case R:
        return "Fragment";
      case z:
        return "Profiler";
      case _:
        return "StrictMode";
      case H:
        return "Suspense";
      case W:
        return "SuspenseList";
      case ee:
        return "Activity";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case T:
          return "Portal";
        case G:
          return e.displayName || "Context";
        case q:
          return (e._context.displayName || "Context") + ".Consumer";
        case Q:
          var t = e.render;
          return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case $:
          return t = e.displayName || null, t !== null ? t : Be(e.type) || "Memo";
        case k:
          t = e._payload, e = e._init;
          try {
            return Be(e(t));
          } catch {
          }
      }
    return null;
  }
  var ze = Array.isArray, O = i.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = l.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ne = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, he = [], K = -1;
  function S(e) {
    return { current: e };
  }
  function L(e) {
    0 > K || (e.current = he[K], he[K] = null, K--);
  }
  function Y(e, t) {
    K++, he[K] = e.current, e.current = t;
  }
  var J = S(null), te = S(null), se = S(null), ve = S(null);
  function be(e, t) {
    switch (Y(se, t), Y(te, e), Y(J, null), t.nodeType) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? fx(e) : 0;
        break;
      default:
        if (e = t.tagName, t = t.namespaceURI)
          t = fx(t), e = mx(t, e);
        else
          switch (e) {
            case "svg":
              e = 1;
              break;
            case "math":
              e = 2;
              break;
            default:
              e = 0;
          }
    }
    L(J), Y(J, e);
  }
  function pe() {
    L(J), L(te), L(se);
  }
  function Qt(e) {
    e.memoizedState !== null && Y(ve, e);
    var t = J.current, a = mx(t, e.type);
    t !== a && (Y(te, e), Y(J, a));
  }
  function _t(e) {
    te.current === e && (L(J), L(te)), ve.current === e && (L(ve), Mr._currentValue = ne);
  }
  var Ct, pa;
  function wt(e) {
    if (Ct === void 0)
      try {
        throw Error();
      } catch (a) {
        var t = a.stack.trim().match(/\n( *(at )?)/);
        Ct = t && t[1] || "", pa = -1 < a.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < a.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Ct + e + pa;
  }
  var Hs = !1;
  function Fi(e, t) {
    if (!e || Hs) return "";
    Hs = !0;
    var a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var r = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var I = function() {
                throw Error();
              };
              if (Object.defineProperty(I.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(I, []);
                } catch (V) {
                  var B = V;
                }
                Reflect.construct(e, [], I);
              } else {
                try {
                  I.call();
                } catch (V) {
                  B = V;
                }
                e.call(I.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (V) {
                B = V;
              }
              (I = e()) && typeof I.catch == "function" && I.catch(function() {
              });
            }
          } catch (V) {
            if (V && B && typeof V.stack == "string")
              return [V.stack, B.stack];
          }
          return [null, null];
        }
      };
      r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var c = Object.getOwnPropertyDescriptor(
        r.DetermineComponentFrameRoot,
        "name"
      );
      c && c.configurable && Object.defineProperty(
        r.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var u = r.DetermineComponentFrameRoot(), x = u[0], v = u[1];
      if (x && v) {
        var j = x.split(`
`), F = v.split(`
`);
        for (c = r = 0; r < j.length && !j[r].includes("DetermineComponentFrameRoot"); )
          r++;
        for (; c < F.length && !F[c].includes(
          "DetermineComponentFrameRoot"
        ); )
          c++;
        if (r === j.length || c === F.length)
          for (r = j.length - 1, c = F.length - 1; 1 <= r && 0 <= c && j[r] !== F[c]; )
            c--;
        for (; 1 <= r && 0 <= c; r--, c--)
          if (j[r] !== F[c]) {
            if (r !== 1 || c !== 1)
              do
                if (r--, c--, 0 > c || j[r] !== F[c]) {
                  var U = `
` + j[r].replace(" at new ", " at ");
                  return e.displayName && U.includes("<anonymous>") && (U = U.replace("<anonymous>", e.displayName)), U;
                }
              while (1 <= r && 0 <= c);
            break;
          }
      }
    } finally {
      Hs = !1, Error.prepareStackTrace = a;
    }
    return (a = e ? e.displayName || e.name : "") ? wt(a) : "";
  }
  function Ja(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return wt(e.type);
      case 16:
        return wt("Lazy");
      case 13:
        return e.child !== t && t !== null ? wt("Suspense Fallback") : wt("Suspense");
      case 19:
        return wt("SuspenseList");
      case 0:
      case 15:
        return Fi(e.type, !1);
      case 11:
        return Fi(e.type.render, !1);
      case 1:
        return Fi(e.type, !0);
      case 31:
        return wt("Activity");
      default:
        return "";
    }
  }
  function Us(e) {
    try {
      var t = "", a = null;
      do
        t += Ja(e, a), a = e, e = e.return;
      while (e);
      return t;
    } catch (r) {
      return `
Error generating stack: ` + r.message + `
` + r.stack;
    }
  }
  var Zt = Object.prototype.hasOwnProperty, Ls = n.unstable_scheduleCallback, Ps = n.unstable_cancelCallback, Et = n.unstable_shouldYield, ga = n.unstable_requestPaint, kt = n.unstable_now, kc = n.unstable_getCurrentPriorityLevel, ei = n.unstable_ImmediatePriority, pl = n.unstable_UserBlockingPriority, ti = n.unstable_NormalPriority, Is = n.unstable_LowPriority, Zn = n.unstable_IdlePriority, gl = n.log, xa = n.unstable_setDisableYieldValue, ni = null, Mt = null;
  function Nn(e) {
    if (typeof gl == "function" && xa(e), Mt && typeof Mt.setStrictMode == "function")
      try {
        Mt.setStrictMode(ni, e);
      } catch {
      }
  }
  var jt = Math.clz32 ? Math.clz32 : _n, Mc = Math.log, qs = Math.LN2;
  function _n(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (Mc(e) / qs | 0) | 0;
  }
  var Bi = 256, Vi = 262144, ai = 4194304;
  function Dn(e) {
    var t = e & 42;
    if (t !== 0) return t;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function ge(e, t, a) {
    var r = e.pendingLanes;
    if (r === 0) return 0;
    var c = 0, u = e.suspendedLanes, x = e.pingedLanes;
    e = e.warmLanes;
    var v = r & 134217727;
    return v !== 0 ? (r = v & ~u, r !== 0 ? c = Dn(r) : (x &= v, x !== 0 ? c = Dn(x) : a || (a = v & ~e, a !== 0 && (c = Dn(a))))) : (v = r & ~u, v !== 0 ? c = Dn(v) : x !== 0 ? c = Dn(x) : a || (a = r & ~e, a !== 0 && (c = Dn(a)))), c === 0 ? 0 : t !== 0 && t !== c && (t & u) === 0 && (u = c & -c, a = t & -t, u >= a || u === 32 && (a & 4194048) !== 0) ? t : c;
  }
  function Ze(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function ut(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function St() {
    var e = ai;
    return ai <<= 1, (ai & 62914560) === 0 && (ai = 4194304), e;
  }
  function ya(e) {
    for (var t = [], a = 0; 31 > a; a++) t.push(e);
    return t;
  }
  function Ke(e, t) {
    e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
  }
  function Dt(e, t, a, r, c, u) {
    var x = e.pendingLanes;
    e.pendingLanes = a, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= a, e.entangledLanes &= a, e.errorRecoveryDisabledLanes &= a, e.shellSuspendCounter = 0;
    var v = e.entanglements, j = e.expirationTimes, F = e.hiddenUpdates;
    for (a = x & ~a; 0 < a; ) {
      var U = 31 - jt(a), I = 1 << U;
      v[U] = 0, j[U] = -1;
      var B = F[U];
      if (B !== null)
        for (F[U] = null, U = 0; U < B.length; U++) {
          var V = B[U];
          V !== null && (V.lane &= -536870913);
        }
      a &= ~I;
    }
    r !== 0 && ii(e, r, 0), u !== 0 && c === 0 && e.tag !== 0 && (e.suspendedLanes |= u & ~(x & ~t));
  }
  function ii(e, t, a) {
    e.pendingLanes |= t, e.suspendedLanes &= ~t;
    var r = 31 - jt(t);
    e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | a & 261930;
  }
  function Ft(e, t) {
    var a = e.entangledLanes |= t;
    for (e = e.entanglements; a; ) {
      var r = 31 - jt(a), c = 1 << r;
      c & t | e[r] & t && (e[r] |= t), a &= ~c;
    }
  }
  function Bt(e, t) {
    var a = t & -t;
    return a = (a & 42) !== 0 ? 1 : Hi(a), (a & (e.suspendedLanes | t)) !== 0 ? 0 : a;
  }
  function Hi(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function Tn(e) {
    return e &= -e, 2 < e ? 8 < e ? (e & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function zc() {
    var e = X.p;
    return e !== 0 ? e : (e = window.event, e === void 0 ? 32 : Bx(e.type));
  }
  function Jf(e, t) {
    var a = X.p;
    try {
      return X.p = e, t();
    } finally {
      X.p = a;
    }
  }
  var ba = Math.random().toString(36).slice(2), mt = "__reactFiber$" + ba, Vt = "__reactProps$" + ba, Ui = "__reactContainer$" + ba, Oc = "__reactEvents$" + ba, iw = "__reactListeners$" + ba, sw = "__reactHandles$" + ba, em = "__reactResources$" + ba, Gs = "__reactMarker$" + ba;
  function Rc(e) {
    delete e[mt], delete e[Vt], delete e[Oc], delete e[iw], delete e[sw];
  }
  function Li(e) {
    var t = e[mt];
    if (t) return t;
    for (var a = e.parentNode; a; ) {
      if (t = a[Ui] || a[mt]) {
        if (a = t.alternate, t.child !== null || a !== null && a.child !== null)
          for (e = wx(e); e !== null; ) {
            if (a = e[mt]) return a;
            e = wx(e);
          }
        return t;
      }
      e = a, a = e.parentNode;
    }
    return null;
  }
  function Pi(e) {
    if (e = e[mt] || e[Ui]) {
      var t = e.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return e;
    }
    return null;
  }
  function Ys(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
    throw Error(o(33));
  }
  function Ii(e) {
    var t = e[em];
    return t || (t = e[em] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function dt(e) {
    e[Gs] = !0;
  }
  var tm = /* @__PURE__ */ new Set(), nm = {};
  function si(e, t) {
    qi(e, t), qi(e + "Capture", t);
  }
  function qi(e, t) {
    for (nm[e] = t, e = 0; e < t.length; e++)
      tm.add(t[e]);
  }
  var rw = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), am = {}, im = {};
  function lw(e) {
    return Zt.call(im, e) ? !0 : Zt.call(am, e) ? !1 : rw.test(e) ? im[e] = !0 : (am[e] = !0, !1);
  }
  function xl(e, t, a) {
    if (lw(t))
      if (a === null) e.removeAttribute(t);
      else {
        switch (typeof a) {
          case "undefined":
          case "function":
          case "symbol":
            e.removeAttribute(t);
            return;
          case "boolean":
            var r = t.toLowerCase().slice(0, 5);
            if (r !== "data-" && r !== "aria-") {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, "" + a);
      }
  }
  function yl(e, t, a) {
    if (a === null) e.removeAttribute(t);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, "" + a);
    }
  }
  function Xn(e, t, a, r) {
    if (r === null) e.removeAttribute(a);
    else {
      switch (typeof r) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(a);
          return;
      }
      e.setAttributeNS(t, a, "" + r);
    }
  }
  function cn(e) {
    switch (typeof e) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function sm(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function ow(e, t, a) {
    var r = Object.getOwnPropertyDescriptor(
      e.constructor.prototype,
      t
    );
    if (!e.hasOwnProperty(t) && typeof r < "u" && typeof r.get == "function" && typeof r.set == "function") {
      var c = r.get, u = r.set;
      return Object.defineProperty(e, t, {
        configurable: !0,
        get: function() {
          return c.call(this);
        },
        set: function(x) {
          a = "" + x, u.call(this, x);
        }
      }), Object.defineProperty(e, t, {
        enumerable: r.enumerable
      }), {
        getValue: function() {
          return a;
        },
        setValue: function(x) {
          a = "" + x;
        },
        stopTracking: function() {
          e._valueTracker = null, delete e[t];
        }
      };
    }
  }
  function _c(e) {
    if (!e._valueTracker) {
      var t = sm(e) ? "checked" : "value";
      e._valueTracker = ow(
        e,
        t,
        "" + e[t]
      );
    }
  }
  function rm(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var a = t.getValue(), r = "";
    return e && (r = sm(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== a ? (t.setValue(e), !0) : !1;
  }
  function bl(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var cw = /[\n"\\]/g;
  function un(e) {
    return e.replace(
      cw,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Dc(e, t, a, r, c, u, x, v) {
    e.name = "", x != null && typeof x != "function" && typeof x != "symbol" && typeof x != "boolean" ? e.type = x : e.removeAttribute("type"), t != null ? x === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + cn(t)) : e.value !== "" + cn(t) && (e.value = "" + cn(t)) : x !== "submit" && x !== "reset" || e.removeAttribute("value"), t != null ? Fc(e, x, cn(t)) : a != null ? Fc(e, x, cn(a)) : r != null && e.removeAttribute("value"), c == null && u != null && (e.defaultChecked = !!u), c != null && (e.checked = c && typeof c != "function" && typeof c != "symbol"), v != null && typeof v != "function" && typeof v != "symbol" && typeof v != "boolean" ? e.name = "" + cn(v) : e.removeAttribute("name");
  }
  function lm(e, t, a, r, c, u, x, v) {
    if (u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && (e.type = u), t != null || a != null) {
      if (!(u !== "submit" && u !== "reset" || t != null)) {
        _c(e);
        return;
      }
      a = a != null ? "" + cn(a) : "", t = t != null ? "" + cn(t) : a, v || t === e.value || (e.value = t), e.defaultValue = t;
    }
    r = r ?? c, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = v ? e.checked : !!r, e.defaultChecked = !!r, x != null && typeof x != "function" && typeof x != "symbol" && typeof x != "boolean" && (e.name = x), _c(e);
  }
  function Fc(e, t, a) {
    t === "number" && bl(e.ownerDocument) === e || e.defaultValue === "" + a || (e.defaultValue = "" + a);
  }
  function Gi(e, t, a, r) {
    if (e = e.options, t) {
      t = {};
      for (var c = 0; c < a.length; c++)
        t["$" + a[c]] = !0;
      for (a = 0; a < e.length; a++)
        c = t.hasOwnProperty("$" + e[a].value), e[a].selected !== c && (e[a].selected = c), c && r && (e[a].defaultSelected = !0);
    } else {
      for (a = "" + cn(a), t = null, c = 0; c < e.length; c++) {
        if (e[c].value === a) {
          e[c].selected = !0, r && (e[c].defaultSelected = !0);
          return;
        }
        t !== null || e[c].disabled || (t = e[c]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function om(e, t, a) {
    if (t != null && (t = "" + cn(t), t !== e.value && (e.value = t), a == null)) {
      e.defaultValue !== t && (e.defaultValue = t);
      return;
    }
    e.defaultValue = a != null ? "" + cn(a) : "";
  }
  function cm(e, t, a, r) {
    if (t == null) {
      if (r != null) {
        if (a != null) throw Error(o(92));
        if (ze(r)) {
          if (1 < r.length) throw Error(o(93));
          r = r[0];
        }
        a = r;
      }
      a == null && (a = ""), t = a;
    }
    a = cn(t), e.defaultValue = a, r = e.textContent, r === a && r !== "" && r !== null && (e.value = r), _c(e);
  }
  function Yi(e, t) {
    if (t) {
      var a = e.firstChild;
      if (a && a === e.lastChild && a.nodeType === 3) {
        a.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var uw = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function um(e, t, a) {
    var r = t.indexOf("--") === 0;
    a == null || typeof a == "boolean" || a === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, a) : typeof a != "number" || a === 0 || uw.has(t) ? t === "float" ? e.cssFloat = a : e[t] = ("" + a).trim() : e[t] = a + "px";
  }
  function dm(e, t, a) {
    if (t != null && typeof t != "object")
      throw Error(o(62));
    if (e = e.style, a != null) {
      for (var r in a)
        !a.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
      for (var c in t)
        r = t[c], t.hasOwnProperty(c) && a[c] !== r && um(e, c, r);
    } else
      for (var u in t)
        t.hasOwnProperty(u) && um(e, u, t[u]);
  }
  function Bc(e) {
    if (e.indexOf("-") === -1) return !1;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var dw = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), hw = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function vl(e) {
    return hw.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
  }
  function Kn() {
  }
  var Vc = null;
  function Hc(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var Qi = null, Zi = null;
  function hm(e) {
    var t = Pi(e);
    if (t && (e = t.stateNode)) {
      var a = e[Vt] || null;
      e: switch (e = t.stateNode, t.type) {
        case "input":
          if (Dc(
            e,
            a.value,
            a.defaultValue,
            a.defaultValue,
            a.checked,
            a.defaultChecked,
            a.type,
            a.name
          ), t = a.name, a.type === "radio" && t != null) {
            for (a = e; a.parentNode; ) a = a.parentNode;
            for (a = a.querySelectorAll(
              'input[name="' + un(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < a.length; t++) {
              var r = a[t];
              if (r !== e && r.form === e.form) {
                var c = r[Vt] || null;
                if (!c) throw Error(o(90));
                Dc(
                  r,
                  c.value,
                  c.defaultValue,
                  c.defaultValue,
                  c.checked,
                  c.defaultChecked,
                  c.type,
                  c.name
                );
              }
            }
            for (t = 0; t < a.length; t++)
              r = a[t], r.form === e.form && rm(r);
          }
          break e;
        case "textarea":
          om(e, a.value, a.defaultValue);
          break e;
        case "select":
          t = a.value, t != null && Gi(e, !!a.multiple, t, !1);
      }
    }
  }
  var Uc = !1;
  function fm(e, t, a) {
    if (Uc) return e(t, a);
    Uc = !0;
    try {
      var r = e(t);
      return r;
    } finally {
      if (Uc = !1, (Qi !== null || Zi !== null) && (lo(), Qi && (t = Qi, e = Zi, Zi = Qi = null, hm(t), e)))
        for (t = 0; t < e.length; t++) hm(e[t]);
    }
  }
  function Qs(e, t) {
    var a = e.stateNode;
    if (a === null) return null;
    var r = a[Vt] || null;
    if (r === null) return null;
    a = r[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (a && typeof a != "function")
      throw Error(
        o(231, t, typeof a)
      );
    return a;
  }
  var $n = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Lc = !1;
  if ($n)
    try {
      var Zs = {};
      Object.defineProperty(Zs, "passive", {
        get: function() {
          Lc = !0;
        }
      }), window.addEventListener("test", Zs, Zs), window.removeEventListener("test", Zs, Zs);
    } catch {
      Lc = !1;
    }
  var va = null, Pc = null, wl = null;
  function mm() {
    if (wl) return wl;
    var e, t = Pc, a = t.length, r, c = "value" in va ? va.value : va.textContent, u = c.length;
    for (e = 0; e < a && t[e] === c[e]; e++) ;
    var x = a - e;
    for (r = 1; r <= x && t[a - r] === c[u - r]; r++) ;
    return wl = c.slice(e, 1 < r ? 1 - r : void 0);
  }
  function jl(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function Sl() {
    return !0;
  }
  function pm() {
    return !1;
  }
  function Ht(e) {
    function t(a, r, c, u, x) {
      this._reactName = a, this._targetInst = c, this.type = r, this.nativeEvent = u, this.target = x, this.currentTarget = null;
      for (var v in e)
        e.hasOwnProperty(v) && (a = e[v], this[v] = a ? a(u) : u[v]);
      return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? Sl : pm, this.isPropagationStopped = pm, this;
    }
    return y(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = Sl);
      },
      stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = Sl);
      },
      persist: function() {
      },
      isPersistent: Sl
    }), t;
  }
  var ri = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Nl = Ht(ri), Xs = y({}, ri, { view: 0, detail: 0 }), fw = Ht(Xs), Ic, qc, Ks, Tl = y({}, Xs, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Yc,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
      return "movementX" in e ? e.movementX : (e !== Ks && (Ks && e.type === "mousemove" ? (Ic = e.screenX - Ks.screenX, qc = e.screenY - Ks.screenY) : qc = Ic = 0, Ks = e), Ic);
    },
    movementY: function(e) {
      return "movementY" in e ? e.movementY : qc;
    }
  }), gm = Ht(Tl), mw = y({}, Tl, { dataTransfer: 0 }), pw = Ht(mw), gw = y({}, Xs, { relatedTarget: 0 }), Gc = Ht(gw), xw = y({}, ri, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), yw = Ht(xw), bw = y({}, ri, {
    clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }), vw = Ht(bw), ww = y({}, ri, { data: 0 }), xm = Ht(ww), jw = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Sw = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Nw = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Tw(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = Nw[e]) ? !!t[e] : !1;
  }
  function Yc() {
    return Tw;
  }
  var Aw = y({}, Xs, {
    key: function(e) {
      if (e.key) {
        var t = jw[e.key] || e.key;
        if (t !== "Unidentified") return t;
      }
      return e.type === "keypress" ? (e = jl(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Sw[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Yc,
    charCode: function(e) {
      return e.type === "keypress" ? jl(e) : 0;
    },
    keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
      return e.type === "keypress" ? jl(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }), Cw = Ht(Aw), Ew = y({}, Tl, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), ym = Ht(Ew), kw = y({}, Xs, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Yc
  }), Mw = Ht(kw), zw = y({}, ri, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Ow = Ht(zw), Rw = y({}, Tl, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), _w = Ht(Rw), Dw = y({}, ri, {
    newState: 0,
    oldState: 0
  }), Fw = Ht(Dw), Bw = [9, 13, 27, 32], Qc = $n && "CompositionEvent" in window, $s = null;
  $n && "documentMode" in document && ($s = document.documentMode);
  var Vw = $n && "TextEvent" in window && !$s, bm = $n && (!Qc || $s && 8 < $s && 11 >= $s), vm = " ", wm = !1;
  function jm(e, t) {
    switch (e) {
      case "keyup":
        return Bw.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Sm(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var Xi = !1;
  function Hw(e, t) {
    switch (e) {
      case "compositionend":
        return Sm(t);
      case "keypress":
        return t.which !== 32 ? null : (wm = !0, vm);
      case "textInput":
        return e = t.data, e === vm && wm ? null : e;
      default:
        return null;
    }
  }
  function Uw(e, t) {
    if (Xi)
      return e === "compositionend" || !Qc && jm(e, t) ? (e = mm(), wl = Pc = va = null, Xi = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return bm && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Lw = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Nm(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!Lw[e.type] : t === "textarea";
  }
  function Tm(e, t, a, r) {
    Qi ? Zi ? Zi.push(r) : Zi = [r] : Qi = r, t = po(t, "onChange"), 0 < t.length && (a = new Nl(
      "onChange",
      "change",
      null,
      a,
      r
    ), e.push({ event: a, listeners: t }));
  }
  var Ws = null, Js = null;
  function Pw(e) {
    lx(e, 0);
  }
  function Al(e) {
    var t = Ys(e);
    if (rm(t)) return e;
  }
  function Am(e, t) {
    if (e === "change") return t;
  }
  var Cm = !1;
  if ($n) {
    var Zc;
    if ($n) {
      var Xc = "oninput" in document;
      if (!Xc) {
        var Em = document.createElement("div");
        Em.setAttribute("oninput", "return;"), Xc = typeof Em.oninput == "function";
      }
      Zc = Xc;
    } else Zc = !1;
    Cm = Zc && (!document.documentMode || 9 < document.documentMode);
  }
  function km() {
    Ws && (Ws.detachEvent("onpropertychange", Mm), Js = Ws = null);
  }
  function Mm(e) {
    if (e.propertyName === "value" && Al(Js)) {
      var t = [];
      Tm(
        t,
        Js,
        e,
        Hc(e)
      ), fm(Pw, t);
    }
  }
  function Iw(e, t, a) {
    e === "focusin" ? (km(), Ws = t, Js = a, Ws.attachEvent("onpropertychange", Mm)) : e === "focusout" && km();
  }
  function qw(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return Al(Js);
  }
  function Gw(e, t) {
    if (e === "click") return Al(t);
  }
  function Yw(e, t) {
    if (e === "input" || e === "change")
      return Al(t);
  }
  function Qw(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var Xt = typeof Object.is == "function" ? Object.is : Qw;
  function er(e, t) {
    if (Xt(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null)
      return !1;
    var a = Object.keys(e), r = Object.keys(t);
    if (a.length !== r.length) return !1;
    for (r = 0; r < a.length; r++) {
      var c = a[r];
      if (!Zt.call(t, c) || !Xt(e[c], t[c]))
        return !1;
    }
    return !0;
  }
  function zm(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function Om(e, t) {
    var a = zm(e);
    e = 0;
    for (var r; a; ) {
      if (a.nodeType === 3) {
        if (r = e + a.textContent.length, e <= t && r >= t)
          return { node: a, offset: t - e };
        e = r;
      }
      e: {
        for (; a; ) {
          if (a.nextSibling) {
            a = a.nextSibling;
            break e;
          }
          a = a.parentNode;
        }
        a = void 0;
      }
      a = zm(a);
    }
  }
  function Rm(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Rm(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function _m(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var t = bl(e.document); t instanceof e.HTMLIFrameElement; ) {
      try {
        var a = typeof t.contentWindow.location.href == "string";
      } catch {
        a = !1;
      }
      if (a) e = t.contentWindow;
      else break;
      t = bl(e.document);
    }
    return t;
  }
  function Kc(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  var Zw = $n && "documentMode" in document && 11 >= document.documentMode, Ki = null, $c = null, tr = null, Wc = !1;
  function Dm(e, t, a) {
    var r = a.window === a ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
    Wc || Ki == null || Ki !== bl(r) || (r = Ki, "selectionStart" in r && Kc(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
      anchorNode: r.anchorNode,
      anchorOffset: r.anchorOffset,
      focusNode: r.focusNode,
      focusOffset: r.focusOffset
    }), tr && er(tr, r) || (tr = r, r = po($c, "onSelect"), 0 < r.length && (t = new Nl(
      "onSelect",
      "select",
      null,
      t,
      a
    ), e.push({ event: t, listeners: r }), t.target = Ki)));
  }
  function li(e, t) {
    var a = {};
    return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
  }
  var $i = {
    animationend: li("Animation", "AnimationEnd"),
    animationiteration: li("Animation", "AnimationIteration"),
    animationstart: li("Animation", "AnimationStart"),
    transitionrun: li("Transition", "TransitionRun"),
    transitionstart: li("Transition", "TransitionStart"),
    transitioncancel: li("Transition", "TransitionCancel"),
    transitionend: li("Transition", "TransitionEnd")
  }, Jc = {}, Fm = {};
  $n && (Fm = document.createElement("div").style, "AnimationEvent" in window || (delete $i.animationend.animation, delete $i.animationiteration.animation, delete $i.animationstart.animation), "TransitionEvent" in window || delete $i.transitionend.transition);
  function oi(e) {
    if (Jc[e]) return Jc[e];
    if (!$i[e]) return e;
    var t = $i[e], a;
    for (a in t)
      if (t.hasOwnProperty(a) && a in Fm)
        return Jc[e] = t[a];
    return e;
  }
  var Bm = oi("animationend"), Vm = oi("animationiteration"), Hm = oi("animationstart"), Xw = oi("transitionrun"), Kw = oi("transitionstart"), $w = oi("transitioncancel"), Um = oi("transitionend"), Lm = /* @__PURE__ */ new Map(), eu = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  eu.push("scrollEnd");
  function An(e, t) {
    Lm.set(e, t), si(t, [e]);
  }
  var Cl = typeof reportError == "function" ? reportError : function(e) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", e);
      return;
    }
    console.error(e);
  }, dn = [], Wi = 0, tu = 0;
  function El() {
    for (var e = Wi, t = tu = Wi = 0; t < e; ) {
      var a = dn[t];
      dn[t++] = null;
      var r = dn[t];
      dn[t++] = null;
      var c = dn[t];
      dn[t++] = null;
      var u = dn[t];
      if (dn[t++] = null, r !== null && c !== null) {
        var x = r.pending;
        x === null ? c.next = c : (c.next = x.next, x.next = c), r.pending = c;
      }
      u !== 0 && Pm(a, c, u);
    }
  }
  function kl(e, t, a, r) {
    dn[Wi++] = e, dn[Wi++] = t, dn[Wi++] = a, dn[Wi++] = r, tu |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
  }
  function nu(e, t, a, r) {
    return kl(e, t, a, r), Ml(e);
  }
  function ci(e, t) {
    return kl(e, null, null, t), Ml(e);
  }
  function Pm(e, t, a) {
    e.lanes |= a;
    var r = e.alternate;
    r !== null && (r.lanes |= a);
    for (var c = !1, u = e.return; u !== null; )
      u.childLanes |= a, r = u.alternate, r !== null && (r.childLanes |= a), u.tag === 22 && (e = u.stateNode, e === null || e._visibility & 1 || (c = !0)), e = u, u = u.return;
    return e.tag === 3 ? (u = e.stateNode, c && t !== null && (c = 31 - jt(a), e = u.hiddenUpdates, r = e[c], r === null ? e[c] = [t] : r.push(t), t.lane = a | 536870912), u) : null;
  }
  function Ml(e) {
    if (50 < Sr)
      throw Sr = 0, dd = null, Error(o(185));
    for (var t = e.return; t !== null; )
      e = t, t = e.return;
    return e.tag === 3 ? e.stateNode : null;
  }
  var Ji = {};
  function Ww(e, t, a, r) {
    this.tag = e, this.key = a, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Kt(e, t, a, r) {
    return new Ww(e, t, a, r);
  }
  function au(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function Wn(e, t) {
    var a = e.alternate;
    return a === null ? (a = Kt(
      e.tag,
      t,
      e.key,
      e.mode
    ), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = 0, a.subtreeFlags = 0, a.deletions = null), a.flags = e.flags & 65011712, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue, t = e.dependencies, a.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.refCleanup = e.refCleanup, a;
  }
  function Im(e, t) {
    e.flags &= 65011714;
    var a = e.alternate;
    return a === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type, t = a.dependencies, e.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), e;
  }
  function zl(e, t, a, r, c, u) {
    var x = 0;
    if (r = e, typeof e == "function") au(e) && (x = 1);
    else if (typeof e == "string")
      x = aj(
        e,
        a,
        J.current
      ) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
    else
      e: switch (e) {
        case ee:
          return e = Kt(31, a, t, c), e.elementType = ee, e.lanes = u, e;
        case R:
          return ui(a.children, c, u, t);
        case _:
          x = 8, c |= 24;
          break;
        case z:
          return e = Kt(12, a, t, c | 2), e.elementType = z, e.lanes = u, e;
        case H:
          return e = Kt(13, a, t, c), e.elementType = H, e.lanes = u, e;
        case W:
          return e = Kt(19, a, t, c), e.elementType = W, e.lanes = u, e;
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case G:
                x = 10;
                break e;
              case q:
                x = 9;
                break e;
              case Q:
                x = 11;
                break e;
              case $:
                x = 14;
                break e;
              case k:
                x = 16, r = null;
                break e;
            }
          x = 29, a = Error(
            o(130, e === null ? "null" : typeof e, "")
          ), r = null;
      }
    return t = Kt(x, a, t, c), t.elementType = e, t.type = r, t.lanes = u, t;
  }
  function ui(e, t, a, r) {
    return e = Kt(7, e, r, t), e.lanes = a, e;
  }
  function iu(e, t, a) {
    return e = Kt(6, e, null, t), e.lanes = a, e;
  }
  function qm(e) {
    var t = Kt(18, null, null, 0);
    return t.stateNode = e, t;
  }
  function su(e, t, a) {
    return t = Kt(
      4,
      e.children !== null ? e.children : [],
      e.key,
      t
    ), t.lanes = a, t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, t;
  }
  var Gm = /* @__PURE__ */ new WeakMap();
  function hn(e, t) {
    if (typeof e == "object" && e !== null) {
      var a = Gm.get(e);
      return a !== void 0 ? a : (t = {
        value: e,
        source: t,
        stack: Us(t)
      }, Gm.set(e, t), t);
    }
    return {
      value: e,
      source: t,
      stack: Us(t)
    };
  }
  var es = [], ts = 0, Ol = null, nr = 0, fn = [], mn = 0, wa = null, Fn = 1, Bn = "";
  function Jn(e, t) {
    es[ts++] = nr, es[ts++] = Ol, Ol = e, nr = t;
  }
  function Ym(e, t, a) {
    fn[mn++] = Fn, fn[mn++] = Bn, fn[mn++] = wa, wa = e;
    var r = Fn;
    e = Bn;
    var c = 32 - jt(r) - 1;
    r &= ~(1 << c), a += 1;
    var u = 32 - jt(t) + c;
    if (30 < u) {
      var x = c - c % 5;
      u = (r & (1 << x) - 1).toString(32), r >>= x, c -= x, Fn = 1 << 32 - jt(t) + c | a << c | r, Bn = u + e;
    } else
      Fn = 1 << u | a << c | r, Bn = e;
  }
  function ru(e) {
    e.return !== null && (Jn(e, 1), Ym(e, 1, 0));
  }
  function lu(e) {
    for (; e === Ol; )
      Ol = es[--ts], es[ts] = null, nr = es[--ts], es[ts] = null;
    for (; e === wa; )
      wa = fn[--mn], fn[mn] = null, Bn = fn[--mn], fn[mn] = null, Fn = fn[--mn], fn[mn] = null;
  }
  function Qm(e, t) {
    fn[mn++] = Fn, fn[mn++] = Bn, fn[mn++] = wa, Fn = t.id, Bn = t.overflow, wa = e;
  }
  var pt = null, Ye = null, Me = !1, ja = null, pn = !1, ou = Error(o(519));
  function Sa(e) {
    var t = Error(
      o(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw ar(hn(t, e)), ou;
  }
  function Zm(e) {
    var t = e.stateNode, a = e.type, r = e.memoizedProps;
    switch (t[mt] = e, t[Vt] = r, a) {
      case "dialog":
        Ae("cancel", t), Ae("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        Ae("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Tr.length; a++)
          Ae(Tr[a], t);
        break;
      case "source":
        Ae("error", t);
        break;
      case "img":
      case "image":
      case "link":
        Ae("error", t), Ae("load", t);
        break;
      case "details":
        Ae("toggle", t);
        break;
      case "input":
        Ae("invalid", t), lm(
          t,
          r.value,
          r.defaultValue,
          r.checked,
          r.defaultChecked,
          r.type,
          r.name,
          !0
        );
        break;
      case "select":
        Ae("invalid", t);
        break;
      case "textarea":
        Ae("invalid", t), cm(t, r.value, r.defaultValue, r.children);
    }
    a = r.children, typeof a != "string" && typeof a != "number" && typeof a != "bigint" || t.textContent === "" + a || r.suppressHydrationWarning === !0 || dx(t.textContent, a) ? (r.popover != null && (Ae("beforetoggle", t), Ae("toggle", t)), r.onScroll != null && Ae("scroll", t), r.onScrollEnd != null && Ae("scrollend", t), r.onClick != null && (t.onclick = Kn), t = !0) : t = !1, t || Sa(e, !0);
  }
  function Xm(e) {
    for (pt = e.return; pt; )
      switch (pt.tag) {
        case 5:
        case 31:
        case 13:
          pn = !1;
          return;
        case 27:
        case 3:
          pn = !0;
          return;
        default:
          pt = pt.return;
      }
  }
  function ns(e) {
    if (e !== pt) return !1;
    if (!Me) return Xm(e), Me = !0, !1;
    var t = e.tag, a;
    if ((a = t !== 3 && t !== 27) && ((a = t === 5) && (a = e.type, a = !(a !== "form" && a !== "button") || Ad(e.type, e.memoizedProps)), a = !a), a && Ye && Sa(e), Xm(e), t === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(317));
      Ye = vx(e);
    } else if (t === 31) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(317));
      Ye = vx(e);
    } else
      t === 27 ? (t = Ye, Ba(e.type) ? (e = zd, zd = null, Ye = e) : Ye = t) : Ye = pt ? xn(e.stateNode.nextSibling) : null;
    return !0;
  }
  function di() {
    Ye = pt = null, Me = !1;
  }
  function cu() {
    var e = ja;
    return e !== null && (It === null ? It = e : It.push.apply(
      It,
      e
    ), ja = null), e;
  }
  function ar(e) {
    ja === null ? ja = [e] : ja.push(e);
  }
  var uu = S(null), hi = null, ea = null;
  function Na(e, t, a) {
    Y(uu, t._currentValue), t._currentValue = a;
  }
  function ta(e) {
    e._currentValue = uu.current, L(uu);
  }
  function du(e, t, a) {
    for (; e !== null; ) {
      var r = e.alternate;
      if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === a) break;
      e = e.return;
    }
  }
  function hu(e, t, a, r) {
    var c = e.child;
    for (c !== null && (c.return = e); c !== null; ) {
      var u = c.dependencies;
      if (u !== null) {
        var x = c.child;
        u = u.firstContext;
        e: for (; u !== null; ) {
          var v = u;
          u = c;
          for (var j = 0; j < t.length; j++)
            if (v.context === t[j]) {
              u.lanes |= a, v = u.alternate, v !== null && (v.lanes |= a), du(
                u.return,
                a,
                e
              ), r || (x = null);
              break e;
            }
          u = v.next;
        }
      } else if (c.tag === 18) {
        if (x = c.return, x === null) throw Error(o(341));
        x.lanes |= a, u = x.alternate, u !== null && (u.lanes |= a), du(x, a, e), x = null;
      } else x = c.child;
      if (x !== null) x.return = c;
      else
        for (x = c; x !== null; ) {
          if (x === e) {
            x = null;
            break;
          }
          if (c = x.sibling, c !== null) {
            c.return = x.return, x = c;
            break;
          }
          x = x.return;
        }
      c = x;
    }
  }
  function as(e, t, a, r) {
    e = null;
    for (var c = t, u = !1; c !== null; ) {
      if (!u) {
        if ((c.flags & 524288) !== 0) u = !0;
        else if ((c.flags & 262144) !== 0) break;
      }
      if (c.tag === 10) {
        var x = c.alternate;
        if (x === null) throw Error(o(387));
        if (x = x.memoizedProps, x !== null) {
          var v = c.type;
          Xt(c.pendingProps.value, x.value) || (e !== null ? e.push(v) : e = [v]);
        }
      } else if (c === ve.current) {
        if (x = c.alternate, x === null) throw Error(o(387));
        x.memoizedState.memoizedState !== c.memoizedState.memoizedState && (e !== null ? e.push(Mr) : e = [Mr]);
      }
      c = c.return;
    }
    e !== null && hu(
      t,
      e,
      a,
      r
    ), t.flags |= 262144;
  }
  function Rl(e) {
    for (e = e.firstContext; e !== null; ) {
      if (!Xt(
        e.context._currentValue,
        e.memoizedValue
      ))
        return !0;
      e = e.next;
    }
    return !1;
  }
  function fi(e) {
    hi = e, ea = null, e = e.dependencies, e !== null && (e.firstContext = null);
  }
  function gt(e) {
    return Km(hi, e);
  }
  function _l(e, t) {
    return hi === null && fi(e), Km(e, t);
  }
  function Km(e, t) {
    var a = t._currentValue;
    if (t = { context: t, memoizedValue: a, next: null }, ea === null) {
      if (e === null) throw Error(o(308));
      ea = t, e.dependencies = { lanes: 0, firstContext: t }, e.flags |= 524288;
    } else ea = ea.next = t;
    return a;
  }
  var Jw = typeof AbortController < "u" ? AbortController : function() {
    var e = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(a, r) {
        e.push(r);
      }
    };
    this.abort = function() {
      t.aborted = !0, e.forEach(function(a) {
        return a();
      });
    };
  }, e2 = n.unstable_scheduleCallback, t2 = n.unstable_NormalPriority, nt = {
    $$typeof: G,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function fu() {
    return {
      controller: new Jw(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function ir(e) {
    e.refCount--, e.refCount === 0 && e2(t2, function() {
      e.controller.abort();
    });
  }
  var sr = null, mu = 0, is = 0, ss = null;
  function n2(e, t) {
    if (sr === null) {
      var a = sr = [];
      mu = 0, is = xd(), ss = {
        status: "pending",
        value: void 0,
        then: function(r) {
          a.push(r);
        }
      };
    }
    return mu++, t.then($m, $m), t;
  }
  function $m() {
    if (--mu === 0 && sr !== null) {
      ss !== null && (ss.status = "fulfilled");
      var e = sr;
      sr = null, is = 0, ss = null;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
  }
  function a2(e, t) {
    var a = [], r = {
      status: "pending",
      value: null,
      reason: null,
      then: function(c) {
        a.push(c);
      }
    };
    return e.then(
      function() {
        r.status = "fulfilled", r.value = t;
        for (var c = 0; c < a.length; c++) (0, a[c])(t);
      },
      function(c) {
        for (r.status = "rejected", r.reason = c, c = 0; c < a.length; c++)
          (0, a[c])(void 0);
      }
    ), r;
  }
  var Wm = O.S;
  O.S = function(e, t) {
    Dg = kt(), typeof t == "object" && t !== null && typeof t.then == "function" && n2(e, t), Wm !== null && Wm(e, t);
  };
  var mi = S(null);
  function pu() {
    var e = mi.current;
    return e !== null ? e : Ie.pooledCache;
  }
  function Dl(e, t) {
    t === null ? Y(mi, mi.current) : Y(mi, t.pool);
  }
  function Jm() {
    var e = pu();
    return e === null ? null : { parent: nt._currentValue, pool: e };
  }
  var rs = Error(o(460)), gu = Error(o(474)), Fl = Error(o(542)), Bl = { then: function() {
  } };
  function ep(e) {
    return e = e.status, e === "fulfilled" || e === "rejected";
  }
  function tp(e, t, a) {
    switch (a = e[a], a === void 0 ? e.push(t) : a !== t && (t.then(Kn, Kn), t = a), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw e = t.reason, ap(e), e;
      default:
        if (typeof t.status == "string") t.then(Kn, Kn);
        else {
          if (e = Ie, e !== null && 100 < e.shellSuspendCounter)
            throw Error(o(482));
          e = t, e.status = "pending", e.then(
            function(r) {
              if (t.status === "pending") {
                var c = t;
                c.status = "fulfilled", c.value = r;
              }
            },
            function(r) {
              if (t.status === "pending") {
                var c = t;
                c.status = "rejected", c.reason = r;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw e = t.reason, ap(e), e;
        }
        throw gi = t, rs;
    }
  }
  function pi(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (a) {
      throw a !== null && typeof a == "object" && typeof a.then == "function" ? (gi = a, rs) : a;
    }
  }
  var gi = null;
  function np() {
    if (gi === null) throw Error(o(459));
    var e = gi;
    return gi = null, e;
  }
  function ap(e) {
    if (e === rs || e === Fl)
      throw Error(o(483));
  }
  var ls = null, rr = 0;
  function Vl(e) {
    var t = rr;
    return rr += 1, ls === null && (ls = []), tp(ls, e, t);
  }
  function lr(e, t) {
    t = t.props.ref, e.ref = t !== void 0 ? t : null;
  }
  function Hl(e, t) {
    throw t.$$typeof === w ? Error(o(525)) : (e = Object.prototype.toString.call(t), Error(
      o(
        31,
        e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e
      )
    ));
  }
  function ip(e) {
    function t(M, A) {
      if (e) {
        var D = M.deletions;
        D === null ? (M.deletions = [A], M.flags |= 16) : D.push(A);
      }
    }
    function a(M, A) {
      if (!e) return null;
      for (; A !== null; )
        t(M, A), A = A.sibling;
      return null;
    }
    function r(M) {
      for (var A = /* @__PURE__ */ new Map(); M !== null; )
        M.key !== null ? A.set(M.key, M) : A.set(M.index, M), M = M.sibling;
      return A;
    }
    function c(M, A) {
      return M = Wn(M, A), M.index = 0, M.sibling = null, M;
    }
    function u(M, A, D) {
      return M.index = D, e ? (D = M.alternate, D !== null ? (D = D.index, D < A ? (M.flags |= 67108866, A) : D) : (M.flags |= 67108866, A)) : (M.flags |= 1048576, A);
    }
    function x(M) {
      return e && M.alternate === null && (M.flags |= 67108866), M;
    }
    function v(M, A, D, P) {
      return A === null || A.tag !== 6 ? (A = iu(D, M.mode, P), A.return = M, A) : (A = c(A, D), A.return = M, A);
    }
    function j(M, A, D, P) {
      var de = D.type;
      return de === R ? U(
        M,
        A,
        D.props.children,
        P,
        D.key
      ) : A !== null && (A.elementType === de || typeof de == "object" && de !== null && de.$$typeof === k && pi(de) === A.type) ? (A = c(A, D.props), lr(A, D), A.return = M, A) : (A = zl(
        D.type,
        D.key,
        D.props,
        null,
        M.mode,
        P
      ), lr(A, D), A.return = M, A);
    }
    function F(M, A, D, P) {
      return A === null || A.tag !== 4 || A.stateNode.containerInfo !== D.containerInfo || A.stateNode.implementation !== D.implementation ? (A = su(D, M.mode, P), A.return = M, A) : (A = c(A, D.children || []), A.return = M, A);
    }
    function U(M, A, D, P, de) {
      return A === null || A.tag !== 7 ? (A = ui(
        D,
        M.mode,
        P,
        de
      ), A.return = M, A) : (A = c(A, D), A.return = M, A);
    }
    function I(M, A, D) {
      if (typeof A == "string" && A !== "" || typeof A == "number" || typeof A == "bigint")
        return A = iu(
          "" + A,
          M.mode,
          D
        ), A.return = M, A;
      if (typeof A == "object" && A !== null) {
        switch (A.$$typeof) {
          case N:
            return D = zl(
              A.type,
              A.key,
              A.props,
              null,
              M.mode,
              D
            ), lr(D, A), D.return = M, D;
          case T:
            return A = su(
              A,
              M.mode,
              D
            ), A.return = M, A;
          case k:
            return A = pi(A), I(M, A, D);
        }
        if (ze(A) || xe(A))
          return A = ui(
            A,
            M.mode,
            D,
            null
          ), A.return = M, A;
        if (typeof A.then == "function")
          return I(M, Vl(A), D);
        if (A.$$typeof === G)
          return I(
            M,
            _l(M, A),
            D
          );
        Hl(M, A);
      }
      return null;
    }
    function B(M, A, D, P) {
      var de = A !== null ? A.key : null;
      if (typeof D == "string" && D !== "" || typeof D == "number" || typeof D == "bigint")
        return de !== null ? null : v(M, A, "" + D, P);
      if (typeof D == "object" && D !== null) {
        switch (D.$$typeof) {
          case N:
            return D.key === de ? j(M, A, D, P) : null;
          case T:
            return D.key === de ? F(M, A, D, P) : null;
          case k:
            return D = pi(D), B(M, A, D, P);
        }
        if (ze(D) || xe(D))
          return de !== null ? null : U(M, A, D, P, null);
        if (typeof D.then == "function")
          return B(
            M,
            A,
            Vl(D),
            P
          );
        if (D.$$typeof === G)
          return B(
            M,
            A,
            _l(M, D),
            P
          );
        Hl(M, D);
      }
      return null;
    }
    function V(M, A, D, P, de) {
      if (typeof P == "string" && P !== "" || typeof P == "number" || typeof P == "bigint")
        return M = M.get(D) || null, v(A, M, "" + P, de);
      if (typeof P == "object" && P !== null) {
        switch (P.$$typeof) {
          case N:
            return M = M.get(
              P.key === null ? D : P.key
            ) || null, j(A, M, P, de);
          case T:
            return M = M.get(
              P.key === null ? D : P.key
            ) || null, F(A, M, P, de);
          case k:
            return P = pi(P), V(
              M,
              A,
              D,
              P,
              de
            );
        }
        if (ze(P) || xe(P))
          return M = M.get(D) || null, U(A, M, P, de, null);
        if (typeof P.then == "function")
          return V(
            M,
            A,
            D,
            Vl(P),
            de
          );
        if (P.$$typeof === G)
          return V(
            M,
            A,
            D,
            _l(A, P),
            de
          );
        Hl(A, P);
      }
      return null;
    }
    function oe(M, A, D, P) {
      for (var de = null, Oe = null, ue = A, je = A = 0, Ee = null; ue !== null && je < D.length; je++) {
        ue.index > je ? (Ee = ue, ue = null) : Ee = ue.sibling;
        var Re = B(
          M,
          ue,
          D[je],
          P
        );
        if (Re === null) {
          ue === null && (ue = Ee);
          break;
        }
        e && ue && Re.alternate === null && t(M, ue), A = u(Re, A, je), Oe === null ? de = Re : Oe.sibling = Re, Oe = Re, ue = Ee;
      }
      if (je === D.length)
        return a(M, ue), Me && Jn(M, je), de;
      if (ue === null) {
        for (; je < D.length; je++)
          ue = I(M, D[je], P), ue !== null && (A = u(
            ue,
            A,
            je
          ), Oe === null ? de = ue : Oe.sibling = ue, Oe = ue);
        return Me && Jn(M, je), de;
      }
      for (ue = r(ue); je < D.length; je++)
        Ee = V(
          ue,
          M,
          je,
          D[je],
          P
        ), Ee !== null && (e && Ee.alternate !== null && ue.delete(
          Ee.key === null ? je : Ee.key
        ), A = u(
          Ee,
          A,
          je
        ), Oe === null ? de = Ee : Oe.sibling = Ee, Oe = Ee);
      return e && ue.forEach(function(Pa) {
        return t(M, Pa);
      }), Me && Jn(M, je), de;
    }
    function fe(M, A, D, P) {
      if (D == null) throw Error(o(151));
      for (var de = null, Oe = null, ue = A, je = A = 0, Ee = null, Re = D.next(); ue !== null && !Re.done; je++, Re = D.next()) {
        ue.index > je ? (Ee = ue, ue = null) : Ee = ue.sibling;
        var Pa = B(M, ue, Re.value, P);
        if (Pa === null) {
          ue === null && (ue = Ee);
          break;
        }
        e && ue && Pa.alternate === null && t(M, ue), A = u(Pa, A, je), Oe === null ? de = Pa : Oe.sibling = Pa, Oe = Pa, ue = Ee;
      }
      if (Re.done)
        return a(M, ue), Me && Jn(M, je), de;
      if (ue === null) {
        for (; !Re.done; je++, Re = D.next())
          Re = I(M, Re.value, P), Re !== null && (A = u(Re, A, je), Oe === null ? de = Re : Oe.sibling = Re, Oe = Re);
        return Me && Jn(M, je), de;
      }
      for (ue = r(ue); !Re.done; je++, Re = D.next())
        Re = V(ue, M, je, Re.value, P), Re !== null && (e && Re.alternate !== null && ue.delete(Re.key === null ? je : Re.key), A = u(Re, A, je), Oe === null ? de = Re : Oe.sibling = Re, Oe = Re);
      return e && ue.forEach(function(mj) {
        return t(M, mj);
      }), Me && Jn(M, je), de;
    }
    function Pe(M, A, D, P) {
      if (typeof D == "object" && D !== null && D.type === R && D.key === null && (D = D.props.children), typeof D == "object" && D !== null) {
        switch (D.$$typeof) {
          case N:
            e: {
              for (var de = D.key; A !== null; ) {
                if (A.key === de) {
                  if (de = D.type, de === R) {
                    if (A.tag === 7) {
                      a(
                        M,
                        A.sibling
                      ), P = c(
                        A,
                        D.props.children
                      ), P.return = M, M = P;
                      break e;
                    }
                  } else if (A.elementType === de || typeof de == "object" && de !== null && de.$$typeof === k && pi(de) === A.type) {
                    a(
                      M,
                      A.sibling
                    ), P = c(A, D.props), lr(P, D), P.return = M, M = P;
                    break e;
                  }
                  a(M, A);
                  break;
                } else t(M, A);
                A = A.sibling;
              }
              D.type === R ? (P = ui(
                D.props.children,
                M.mode,
                P,
                D.key
              ), P.return = M, M = P) : (P = zl(
                D.type,
                D.key,
                D.props,
                null,
                M.mode,
                P
              ), lr(P, D), P.return = M, M = P);
            }
            return x(M);
          case T:
            e: {
              for (de = D.key; A !== null; ) {
                if (A.key === de)
                  if (A.tag === 4 && A.stateNode.containerInfo === D.containerInfo && A.stateNode.implementation === D.implementation) {
                    a(
                      M,
                      A.sibling
                    ), P = c(A, D.children || []), P.return = M, M = P;
                    break e;
                  } else {
                    a(M, A);
                    break;
                  }
                else t(M, A);
                A = A.sibling;
              }
              P = su(D, M.mode, P), P.return = M, M = P;
            }
            return x(M);
          case k:
            return D = pi(D), Pe(
              M,
              A,
              D,
              P
            );
        }
        if (ze(D))
          return oe(
            M,
            A,
            D,
            P
          );
        if (xe(D)) {
          if (de = xe(D), typeof de != "function") throw Error(o(150));
          return D = de.call(D), fe(
            M,
            A,
            D,
            P
          );
        }
        if (typeof D.then == "function")
          return Pe(
            M,
            A,
            Vl(D),
            P
          );
        if (D.$$typeof === G)
          return Pe(
            M,
            A,
            _l(M, D),
            P
          );
        Hl(M, D);
      }
      return typeof D == "string" && D !== "" || typeof D == "number" || typeof D == "bigint" ? (D = "" + D, A !== null && A.tag === 6 ? (a(M, A.sibling), P = c(A, D), P.return = M, M = P) : (a(M, A), P = iu(D, M.mode, P), P.return = M, M = P), x(M)) : a(M, A);
    }
    return function(M, A, D, P) {
      try {
        rr = 0;
        var de = Pe(
          M,
          A,
          D,
          P
        );
        return ls = null, de;
      } catch (ue) {
        if (ue === rs || ue === Fl) throw ue;
        var Oe = Kt(29, ue, null, M.mode);
        return Oe.lanes = P, Oe.return = M, Oe;
      }
    };
  }
  var xi = ip(!0), sp = ip(!1), Ta = !1;
  function xu(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function yu(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    });
  }
  function Aa(e) {
    return { lane: e, tag: 0, payload: null, callback: null, next: null };
  }
  function Ca(e, t, a) {
    var r = e.updateQueue;
    if (r === null) return null;
    if (r = r.shared, (De & 2) !== 0) {
      var c = r.pending;
      return c === null ? t.next = t : (t.next = c.next, c.next = t), r.pending = t, t = Ml(e), Pm(e, null, a), t;
    }
    return kl(e, r, t, a), Ml(e);
  }
  function or(e, t, a) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (a & 4194048) !== 0)) {
      var r = t.lanes;
      r &= e.pendingLanes, a |= r, t.lanes = a, Ft(e, a);
    }
  }
  function bu(e, t) {
    var a = e.updateQueue, r = e.alternate;
    if (r !== null && (r = r.updateQueue, a === r)) {
      var c = null, u = null;
      if (a = a.firstBaseUpdate, a !== null) {
        do {
          var x = {
            lane: a.lane,
            tag: a.tag,
            payload: a.payload,
            callback: null,
            next: null
          };
          u === null ? c = u = x : u = u.next = x, a = a.next;
        } while (a !== null);
        u === null ? c = u = t : u = u.next = t;
      } else c = u = t;
      a = {
        baseState: r.baseState,
        firstBaseUpdate: c,
        lastBaseUpdate: u,
        shared: r.shared,
        callbacks: r.callbacks
      }, e.updateQueue = a;
      return;
    }
    e = a.lastBaseUpdate, e === null ? a.firstBaseUpdate = t : e.next = t, a.lastBaseUpdate = t;
  }
  var vu = !1;
  function cr() {
    if (vu) {
      var e = ss;
      if (e !== null) throw e;
    }
  }
  function ur(e, t, a, r) {
    vu = !1;
    var c = e.updateQueue;
    Ta = !1;
    var u = c.firstBaseUpdate, x = c.lastBaseUpdate, v = c.shared.pending;
    if (v !== null) {
      c.shared.pending = null;
      var j = v, F = j.next;
      j.next = null, x === null ? u = F : x.next = F, x = j;
      var U = e.alternate;
      U !== null && (U = U.updateQueue, v = U.lastBaseUpdate, v !== x && (v === null ? U.firstBaseUpdate = F : v.next = F, U.lastBaseUpdate = j));
    }
    if (u !== null) {
      var I = c.baseState;
      x = 0, U = F = j = null, v = u;
      do {
        var B = v.lane & -536870913, V = B !== v.lane;
        if (V ? (Ce & B) === B : (r & B) === B) {
          B !== 0 && B === is && (vu = !0), U !== null && (U = U.next = {
            lane: 0,
            tag: v.tag,
            payload: v.payload,
            callback: null,
            next: null
          });
          e: {
            var oe = e, fe = v;
            B = t;
            var Pe = a;
            switch (fe.tag) {
              case 1:
                if (oe = fe.payload, typeof oe == "function") {
                  I = oe.call(Pe, I, B);
                  break e;
                }
                I = oe;
                break e;
              case 3:
                oe.flags = oe.flags & -65537 | 128;
              case 0:
                if (oe = fe.payload, B = typeof oe == "function" ? oe.call(Pe, I, B) : oe, B == null) break e;
                I = y({}, I, B);
                break e;
              case 2:
                Ta = !0;
            }
          }
          B = v.callback, B !== null && (e.flags |= 64, V && (e.flags |= 8192), V = c.callbacks, V === null ? c.callbacks = [B] : V.push(B));
        } else
          V = {
            lane: B,
            tag: v.tag,
            payload: v.payload,
            callback: v.callback,
            next: null
          }, U === null ? (F = U = V, j = I) : U = U.next = V, x |= B;
        if (v = v.next, v === null) {
          if (v = c.shared.pending, v === null)
            break;
          V = v, v = V.next, V.next = null, c.lastBaseUpdate = V, c.shared.pending = null;
        }
      } while (!0);
      U === null && (j = I), c.baseState = j, c.firstBaseUpdate = F, c.lastBaseUpdate = U, u === null && (c.shared.lanes = 0), Oa |= x, e.lanes = x, e.memoizedState = I;
    }
  }
  function rp(e, t) {
    if (typeof e != "function")
      throw Error(o(191, e));
    e.call(t);
  }
  function lp(e, t) {
    var a = e.callbacks;
    if (a !== null)
      for (e.callbacks = null, e = 0; e < a.length; e++)
        rp(a[e], t);
  }
  var os = S(null), Ul = S(0);
  function op(e, t) {
    e = ua, Y(Ul, e), Y(os, t), ua = e | t.baseLanes;
  }
  function wu() {
    Y(Ul, ua), Y(os, os.current);
  }
  function ju() {
    ua = Ul.current, L(os), L(Ul);
  }
  var $t = S(null), gn = null;
  function Ea(e) {
    var t = e.alternate;
    Y(et, et.current & 1), Y($t, e), gn === null && (t === null || os.current !== null || t.memoizedState !== null) && (gn = e);
  }
  function Su(e) {
    Y(et, et.current), Y($t, e), gn === null && (gn = e);
  }
  function cp(e) {
    e.tag === 22 ? (Y(et, et.current), Y($t, e), gn === null && (gn = e)) : ka();
  }
  function ka() {
    Y(et, et.current), Y($t, $t.current);
  }
  function Wt(e) {
    L($t), gn === e && (gn = null), L(et);
  }
  var et = S(0);
  function Ll(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var a = t.memoizedState;
        if (a !== null && (a = a.dehydrated, a === null || kd(a) || Md(a)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var na = 0, we = null, Ue = null, at = null, Pl = !1, cs = !1, yi = !1, Il = 0, dr = 0, us = null, i2 = 0;
  function $e() {
    throw Error(o(321));
  }
  function Nu(e, t) {
    if (t === null) return !1;
    for (var a = 0; a < t.length && a < e.length; a++)
      if (!Xt(e[a], t[a])) return !1;
    return !0;
  }
  function Tu(e, t, a, r, c, u) {
    return na = u, we = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, O.H = e === null || e.memoizedState === null ? Yp : Uu, yi = !1, u = a(r, c), yi = !1, cs && (u = dp(
      t,
      a,
      r,
      c
    )), up(e), u;
  }
  function up(e) {
    O.H = mr;
    var t = Ue !== null && Ue.next !== null;
    if (na = 0, at = Ue = we = null, Pl = !1, dr = 0, us = null, t) throw Error(o(300));
    e === null || it || (e = e.dependencies, e !== null && Rl(e) && (it = !0));
  }
  function dp(e, t, a, r) {
    we = e;
    var c = 0;
    do {
      if (cs && (us = null), dr = 0, cs = !1, 25 <= c) throw Error(o(301));
      if (c += 1, at = Ue = null, e.updateQueue != null) {
        var u = e.updateQueue;
        u.lastEffect = null, u.events = null, u.stores = null, u.memoCache != null && (u.memoCache.index = 0);
      }
      O.H = Qp, u = t(a, r);
    } while (cs);
    return u;
  }
  function s2() {
    var e = O.H, t = e.useState()[0];
    return t = typeof t.then == "function" ? hr(t) : t, e = e.useState()[0], (Ue !== null ? Ue.memoizedState : null) !== e && (we.flags |= 1024), t;
  }
  function Au() {
    var e = Il !== 0;
    return Il = 0, e;
  }
  function Cu(e, t, a) {
    t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~a;
  }
  function Eu(e) {
    if (Pl) {
      for (e = e.memoizedState; e !== null; ) {
        var t = e.queue;
        t !== null && (t.pending = null), e = e.next;
      }
      Pl = !1;
    }
    na = 0, at = Ue = we = null, cs = !1, dr = Il = 0, us = null;
  }
  function zt() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return at === null ? we.memoizedState = at = e : at = at.next = e, at;
  }
  function tt() {
    if (Ue === null) {
      var e = we.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = Ue.next;
    var t = at === null ? we.memoizedState : at.next;
    if (t !== null)
      at = t, Ue = e;
    else {
      if (e === null)
        throw we.alternate === null ? Error(o(467)) : Error(o(310));
      Ue = e, e = {
        memoizedState: Ue.memoizedState,
        baseState: Ue.baseState,
        baseQueue: Ue.baseQueue,
        queue: Ue.queue,
        next: null
      }, at === null ? we.memoizedState = at = e : at = at.next = e;
    }
    return at;
  }
  function ql() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function hr(e) {
    var t = dr;
    return dr += 1, us === null && (us = []), e = tp(us, e, t), t = we, (at === null ? t.memoizedState : at.next) === null && (t = t.alternate, O.H = t === null || t.memoizedState === null ? Yp : Uu), e;
  }
  function Gl(e) {
    if (e !== null && typeof e == "object") {
      if (typeof e.then == "function") return hr(e);
      if (e.$$typeof === G) return gt(e);
    }
    throw Error(o(438, String(e)));
  }
  function ku(e) {
    var t = null, a = we.updateQueue;
    if (a !== null && (t = a.memoCache), t == null) {
      var r = we.alternate;
      r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
        data: r.data.map(function(c) {
          return c.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), a === null && (a = ql(), we.updateQueue = a), a.memoCache = t, a = t.data[t.index], a === void 0)
      for (a = t.data[t.index] = Array(e), r = 0; r < e; r++)
        a[r] = ae;
    return t.index++, a;
  }
  function aa(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function Yl(e) {
    var t = tt();
    return Mu(t, Ue, e);
  }
  function Mu(e, t, a) {
    var r = e.queue;
    if (r === null) throw Error(o(311));
    r.lastRenderedReducer = a;
    var c = e.baseQueue, u = r.pending;
    if (u !== null) {
      if (c !== null) {
        var x = c.next;
        c.next = u.next, u.next = x;
      }
      t.baseQueue = c = u, r.pending = null;
    }
    if (u = e.baseState, c === null) e.memoizedState = u;
    else {
      t = c.next;
      var v = x = null, j = null, F = t, U = !1;
      do {
        var I = F.lane & -536870913;
        if (I !== F.lane ? (Ce & I) === I : (na & I) === I) {
          var B = F.revertLane;
          if (B === 0)
            j !== null && (j = j.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: F.action,
              hasEagerState: F.hasEagerState,
              eagerState: F.eagerState,
              next: null
            }), I === is && (U = !0);
          else if ((na & B) === B) {
            F = F.next, B === is && (U = !0);
            continue;
          } else
            I = {
              lane: 0,
              revertLane: F.revertLane,
              gesture: null,
              action: F.action,
              hasEagerState: F.hasEagerState,
              eagerState: F.eagerState,
              next: null
            }, j === null ? (v = j = I, x = u) : j = j.next = I, we.lanes |= B, Oa |= B;
          I = F.action, yi && a(u, I), u = F.hasEagerState ? F.eagerState : a(u, I);
        } else
          B = {
            lane: I,
            revertLane: F.revertLane,
            gesture: F.gesture,
            action: F.action,
            hasEagerState: F.hasEagerState,
            eagerState: F.eagerState,
            next: null
          }, j === null ? (v = j = B, x = u) : j = j.next = B, we.lanes |= I, Oa |= I;
        F = F.next;
      } while (F !== null && F !== t);
      if (j === null ? x = u : j.next = v, !Xt(u, e.memoizedState) && (it = !0, U && (a = ss, a !== null)))
        throw a;
      e.memoizedState = u, e.baseState = x, e.baseQueue = j, r.lastRenderedState = u;
    }
    return c === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
  }
  function zu(e) {
    var t = tt(), a = t.queue;
    if (a === null) throw Error(o(311));
    a.lastRenderedReducer = e;
    var r = a.dispatch, c = a.pending, u = t.memoizedState;
    if (c !== null) {
      a.pending = null;
      var x = c = c.next;
      do
        u = e(u, x.action), x = x.next;
      while (x !== c);
      Xt(u, t.memoizedState) || (it = !0), t.memoizedState = u, t.baseQueue === null && (t.baseState = u), a.lastRenderedState = u;
    }
    return [u, r];
  }
  function hp(e, t, a) {
    var r = we, c = tt(), u = Me;
    if (u) {
      if (a === void 0) throw Error(o(407));
      a = a();
    } else a = t();
    var x = !Xt(
      (Ue || c).memoizedState,
      a
    );
    if (x && (c.memoizedState = a, it = !0), c = c.queue, _u(pp.bind(null, r, c, e), [
      e
    ]), c.getSnapshot !== t || x || at !== null && at.memoizedState.tag & 1) {
      if (r.flags |= 2048, ds(
        9,
        { destroy: void 0 },
        mp.bind(
          null,
          r,
          c,
          a,
          t
        ),
        null
      ), Ie === null) throw Error(o(349));
      u || (na & 127) !== 0 || fp(r, t, a);
    }
    return a;
  }
  function fp(e, t, a) {
    e.flags |= 16384, e = { getSnapshot: t, value: a }, t = we.updateQueue, t === null ? (t = ql(), we.updateQueue = t, t.stores = [e]) : (a = t.stores, a === null ? t.stores = [e] : a.push(e));
  }
  function mp(e, t, a, r) {
    t.value = a, t.getSnapshot = r, gp(t) && xp(e);
  }
  function pp(e, t, a) {
    return a(function() {
      gp(t) && xp(e);
    });
  }
  function gp(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var a = t();
      return !Xt(e, a);
    } catch {
      return !0;
    }
  }
  function xp(e) {
    var t = ci(e, 2);
    t !== null && qt(t, e, 2);
  }
  function Ou(e) {
    var t = zt();
    if (typeof e == "function") {
      var a = e;
      if (e = a(), yi) {
        Nn(!0);
        try {
          a();
        } finally {
          Nn(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = e, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: aa,
      lastRenderedState: e
    }, t;
  }
  function yp(e, t, a, r) {
    return e.baseState = a, Mu(
      e,
      Ue,
      typeof r == "function" ? r : aa
    );
  }
  function r2(e, t, a, r, c) {
    if (Xl(e)) throw Error(o(485));
    if (e = t.action, e !== null) {
      var u = {
        payload: c,
        action: e,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(x) {
          u.listeners.push(x);
        }
      };
      O.T !== null ? a(!0) : u.isTransition = !1, r(u), a = t.pending, a === null ? (u.next = t.pending = u, bp(t, u)) : (u.next = a.next, t.pending = a.next = u);
    }
  }
  function bp(e, t) {
    var a = t.action, r = t.payload, c = e.state;
    if (t.isTransition) {
      var u = O.T, x = {};
      O.T = x;
      try {
        var v = a(c, r), j = O.S;
        j !== null && j(x, v), vp(e, t, v);
      } catch (F) {
        Ru(e, t, F);
      } finally {
        u !== null && x.types !== null && (u.types = x.types), O.T = u;
      }
    } else
      try {
        u = a(c, r), vp(e, t, u);
      } catch (F) {
        Ru(e, t, F);
      }
  }
  function vp(e, t, a) {
    a !== null && typeof a == "object" && typeof a.then == "function" ? a.then(
      function(r) {
        wp(e, t, r);
      },
      function(r) {
        return Ru(e, t, r);
      }
    ) : wp(e, t, a);
  }
  function wp(e, t, a) {
    t.status = "fulfilled", t.value = a, jp(t), e.state = a, t = e.pending, t !== null && (a = t.next, a === t ? e.pending = null : (a = a.next, t.next = a, bp(e, a)));
  }
  function Ru(e, t, a) {
    var r = e.pending;
    if (e.pending = null, r !== null) {
      r = r.next;
      do
        t.status = "rejected", t.reason = a, jp(t), t = t.next;
      while (t !== r);
    }
    e.action = null;
  }
  function jp(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) (0, e[t])();
  }
  function Sp(e, t) {
    return t;
  }
  function Np(e, t) {
    if (Me) {
      var a = Ie.formState;
      if (a !== null) {
        e: {
          var r = we;
          if (Me) {
            if (Ye) {
              t: {
                for (var c = Ye, u = pn; c.nodeType !== 8; ) {
                  if (!u) {
                    c = null;
                    break t;
                  }
                  if (c = xn(
                    c.nextSibling
                  ), c === null) {
                    c = null;
                    break t;
                  }
                }
                u = c.data, c = u === "F!" || u === "F" ? c : null;
              }
              if (c) {
                Ye = xn(
                  c.nextSibling
                ), r = c.data === "F!";
                break e;
              }
            }
            Sa(r);
          }
          r = !1;
        }
        r && (t = a[0]);
      }
    }
    return a = zt(), a.memoizedState = a.baseState = t, r = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Sp,
      lastRenderedState: t
    }, a.queue = r, a = Ip.bind(
      null,
      we,
      r
    ), r.dispatch = a, r = Ou(!1), u = Hu.bind(
      null,
      we,
      !1,
      r.queue
    ), r = zt(), c = {
      state: t,
      dispatch: null,
      action: e,
      pending: null
    }, r.queue = c, a = r2.bind(
      null,
      we,
      c,
      u,
      a
    ), c.dispatch = a, r.memoizedState = e, [t, a, !1];
  }
  function Tp(e) {
    var t = tt();
    return Ap(t, Ue, e);
  }
  function Ap(e, t, a) {
    if (t = Mu(
      e,
      t,
      Sp
    )[0], e = Yl(aa)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var r = hr(t);
      } catch (x) {
        throw x === rs ? Fl : x;
      }
    else r = t;
    t = tt();
    var c = t.queue, u = c.dispatch;
    return a !== t.memoizedState && (we.flags |= 2048, ds(
      9,
      { destroy: void 0 },
      l2.bind(null, c, a),
      null
    )), [r, u, e];
  }
  function l2(e, t) {
    e.action = t;
  }
  function Cp(e) {
    var t = tt(), a = Ue;
    if (a !== null)
      return Ap(t, a, e);
    tt(), t = t.memoizedState, a = tt();
    var r = a.queue.dispatch;
    return a.memoizedState = e, [t, r, !1];
  }
  function ds(e, t, a, r) {
    return e = { tag: e, create: a, deps: r, inst: t, next: null }, t = we.updateQueue, t === null && (t = ql(), we.updateQueue = t), a = t.lastEffect, a === null ? t.lastEffect = e.next = e : (r = a.next, a.next = e, e.next = r, t.lastEffect = e), e;
  }
  function Ep() {
    return tt().memoizedState;
  }
  function Ql(e, t, a, r) {
    var c = zt();
    we.flags |= e, c.memoizedState = ds(
      1 | t,
      { destroy: void 0 },
      a,
      r === void 0 ? null : r
    );
  }
  function Zl(e, t, a, r) {
    var c = tt();
    r = r === void 0 ? null : r;
    var u = c.memoizedState.inst;
    Ue !== null && r !== null && Nu(r, Ue.memoizedState.deps) ? c.memoizedState = ds(t, u, a, r) : (we.flags |= e, c.memoizedState = ds(
      1 | t,
      u,
      a,
      r
    ));
  }
  function kp(e, t) {
    Ql(8390656, 8, e, t);
  }
  function _u(e, t) {
    Zl(2048, 8, e, t);
  }
  function o2(e) {
    we.flags |= 4;
    var t = we.updateQueue;
    if (t === null)
      t = ql(), we.updateQueue = t, t.events = [e];
    else {
      var a = t.events;
      a === null ? t.events = [e] : a.push(e);
    }
  }
  function Mp(e) {
    var t = tt().memoizedState;
    return o2({ ref: t, nextImpl: e }), function() {
      if ((De & 2) !== 0) throw Error(o(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function zp(e, t) {
    return Zl(4, 2, e, t);
  }
  function Op(e, t) {
    return Zl(4, 4, e, t);
  }
  function Rp(e, t) {
    if (typeof t == "function") {
      e = e();
      var a = t(e);
      return function() {
        typeof a == "function" ? a() : t(null);
      };
    }
    if (t != null)
      return e = e(), t.current = e, function() {
        t.current = null;
      };
  }
  function _p(e, t, a) {
    a = a != null ? a.concat([e]) : null, Zl(4, 4, Rp.bind(null, t, e), a);
  }
  function Du() {
  }
  function Dp(e, t) {
    var a = tt();
    t = t === void 0 ? null : t;
    var r = a.memoizedState;
    return t !== null && Nu(t, r[1]) ? r[0] : (a.memoizedState = [e, t], e);
  }
  function Fp(e, t) {
    var a = tt();
    t = t === void 0 ? null : t;
    var r = a.memoizedState;
    if (t !== null && Nu(t, r[1]))
      return r[0];
    if (r = e(), yi) {
      Nn(!0);
      try {
        e();
      } finally {
        Nn(!1);
      }
    }
    return a.memoizedState = [r, t], r;
  }
  function Fu(e, t, a) {
    return a === void 0 || (na & 1073741824) !== 0 && (Ce & 261930) === 0 ? e.memoizedState = t : (e.memoizedState = a, e = Bg(), we.lanes |= e, Oa |= e, a);
  }
  function Bp(e, t, a, r) {
    return Xt(a, t) ? a : os.current !== null ? (e = Fu(e, a, r), Xt(e, t) || (it = !0), e) : (na & 42) === 0 || (na & 1073741824) !== 0 && (Ce & 261930) === 0 ? (it = !0, e.memoizedState = a) : (e = Bg(), we.lanes |= e, Oa |= e, t);
  }
  function Vp(e, t, a, r, c) {
    var u = X.p;
    X.p = u !== 0 && 8 > u ? u : 8;
    var x = O.T, v = {};
    O.T = v, Hu(e, !1, t, a);
    try {
      var j = c(), F = O.S;
      if (F !== null && F(v, j), j !== null && typeof j == "object" && typeof j.then == "function") {
        var U = a2(
          j,
          r
        );
        fr(
          e,
          t,
          U,
          tn(e)
        );
      } else
        fr(
          e,
          t,
          r,
          tn(e)
        );
    } catch (I) {
      fr(
        e,
        t,
        { then: function() {
        }, status: "rejected", reason: I },
        tn()
      );
    } finally {
      X.p = u, x !== null && v.types !== null && (x.types = v.types), O.T = x;
    }
  }
  function c2() {
  }
  function Bu(e, t, a, r) {
    if (e.tag !== 5) throw Error(o(476));
    var c = Hp(e).queue;
    Vp(
      e,
      c,
      t,
      ne,
      a === null ? c2 : function() {
        return Up(e), a(r);
      }
    );
  }
  function Hp(e) {
    var t = e.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: ne,
      baseState: ne,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: aa,
        lastRenderedState: ne
      },
      next: null
    };
    var a = {};
    return t.next = {
      memoizedState: a,
      baseState: a,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: aa,
        lastRenderedState: a
      },
      next: null
    }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
  }
  function Up(e) {
    var t = Hp(e);
    t.next === null && (t = e.alternate.memoizedState), fr(
      e,
      t.next.queue,
      {},
      tn()
    );
  }
  function Vu() {
    return gt(Mr);
  }
  function Lp() {
    return tt().memoizedState;
  }
  function Pp() {
    return tt().memoizedState;
  }
  function u2(e) {
    for (var t = e.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var a = tn();
          e = Aa(a);
          var r = Ca(t, e, a);
          r !== null && (qt(r, t, a), or(r, t, a)), t = { cache: fu() }, e.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function d2(e, t, a) {
    var r = tn();
    a = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Xl(e) ? qp(t, a) : (a = nu(e, t, a, r), a !== null && (qt(a, e, r), Gp(a, t, r)));
  }
  function Ip(e, t, a) {
    var r = tn();
    fr(e, t, a, r);
  }
  function fr(e, t, a, r) {
    var c = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Xl(e)) qp(t, c);
    else {
      var u = e.alternate;
      if (e.lanes === 0 && (u === null || u.lanes === 0) && (u = t.lastRenderedReducer, u !== null))
        try {
          var x = t.lastRenderedState, v = u(x, a);
          if (c.hasEagerState = !0, c.eagerState = v, Xt(v, x))
            return kl(e, t, c, 0), Ie === null && El(), !1;
        } catch {
        }
      if (a = nu(e, t, c, r), a !== null)
        return qt(a, e, r), Gp(a, t, r), !0;
    }
    return !1;
  }
  function Hu(e, t, a, r) {
    if (r = {
      lane: 2,
      revertLane: xd(),
      gesture: null,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Xl(e)) {
      if (t) throw Error(o(479));
    } else
      t = nu(
        e,
        a,
        r,
        2
      ), t !== null && qt(t, e, 2);
  }
  function Xl(e) {
    var t = e.alternate;
    return e === we || t !== null && t === we;
  }
  function qp(e, t) {
    cs = Pl = !0;
    var a = e.pending;
    a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
  }
  function Gp(e, t, a) {
    if ((a & 4194048) !== 0) {
      var r = t.lanes;
      r &= e.pendingLanes, a |= r, t.lanes = a, Ft(e, a);
    }
  }
  var mr = {
    readContext: gt,
    use: Gl,
    useCallback: $e,
    useContext: $e,
    useEffect: $e,
    useImperativeHandle: $e,
    useLayoutEffect: $e,
    useInsertionEffect: $e,
    useMemo: $e,
    useReducer: $e,
    useRef: $e,
    useState: $e,
    useDebugValue: $e,
    useDeferredValue: $e,
    useTransition: $e,
    useSyncExternalStore: $e,
    useId: $e,
    useHostTransitionStatus: $e,
    useFormState: $e,
    useActionState: $e,
    useOptimistic: $e,
    useMemoCache: $e,
    useCacheRefresh: $e
  };
  mr.useEffectEvent = $e;
  var Yp = {
    readContext: gt,
    use: Gl,
    useCallback: function(e, t) {
      return zt().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    },
    useContext: gt,
    useEffect: kp,
    useImperativeHandle: function(e, t, a) {
      a = a != null ? a.concat([e]) : null, Ql(
        4194308,
        4,
        Rp.bind(null, t, e),
        a
      );
    },
    useLayoutEffect: function(e, t) {
      return Ql(4194308, 4, e, t);
    },
    useInsertionEffect: function(e, t) {
      Ql(4, 2, e, t);
    },
    useMemo: function(e, t) {
      var a = zt();
      t = t === void 0 ? null : t;
      var r = e();
      if (yi) {
        Nn(!0);
        try {
          e();
        } finally {
          Nn(!1);
        }
      }
      return a.memoizedState = [r, t], r;
    },
    useReducer: function(e, t, a) {
      var r = zt();
      if (a !== void 0) {
        var c = a(t);
        if (yi) {
          Nn(!0);
          try {
            a(t);
          } finally {
            Nn(!1);
          }
        }
      } else c = t;
      return r.memoizedState = r.baseState = c, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      }, r.queue = e, e = e.dispatch = d2.bind(
        null,
        we,
        e
      ), [r.memoizedState, e];
    },
    useRef: function(e) {
      var t = zt();
      return e = { current: e }, t.memoizedState = e;
    },
    useState: function(e) {
      e = Ou(e);
      var t = e.queue, a = Ip.bind(null, we, t);
      return t.dispatch = a, [e.memoizedState, a];
    },
    useDebugValue: Du,
    useDeferredValue: function(e, t) {
      var a = zt();
      return Fu(a, e, t);
    },
    useTransition: function() {
      var e = Ou(!1);
      return e = Vp.bind(
        null,
        we,
        e.queue,
        !0,
        !1
      ), zt().memoizedState = e, [!1, e];
    },
    useSyncExternalStore: function(e, t, a) {
      var r = we, c = zt();
      if (Me) {
        if (a === void 0)
          throw Error(o(407));
        a = a();
      } else {
        if (a = t(), Ie === null)
          throw Error(o(349));
        (Ce & 127) !== 0 || fp(r, t, a);
      }
      c.memoizedState = a;
      var u = { value: a, getSnapshot: t };
      return c.queue = u, kp(pp.bind(null, r, u, e), [
        e
      ]), r.flags |= 2048, ds(
        9,
        { destroy: void 0 },
        mp.bind(
          null,
          r,
          u,
          a,
          t
        ),
        null
      ), a;
    },
    useId: function() {
      var e = zt(), t = Ie.identifierPrefix;
      if (Me) {
        var a = Bn, r = Fn;
        a = (r & ~(1 << 32 - jt(r) - 1)).toString(32) + a, t = "_" + t + "R_" + a, a = Il++, 0 < a && (t += "H" + a.toString(32)), t += "_";
      } else
        a = i2++, t = "_" + t + "r_" + a.toString(32) + "_";
      return e.memoizedState = t;
    },
    useHostTransitionStatus: Vu,
    useFormState: Np,
    useActionState: Np,
    useOptimistic: function(e) {
      var t = zt();
      t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = a, t = Hu.bind(
        null,
        we,
        !0,
        a
      ), a.dispatch = t, [e, t];
    },
    useMemoCache: ku,
    useCacheRefresh: function() {
      return zt().memoizedState = u2.bind(
        null,
        we
      );
    },
    useEffectEvent: function(e) {
      var t = zt(), a = { impl: e };
      return t.memoizedState = a, function() {
        if ((De & 2) !== 0)
          throw Error(o(440));
        return a.impl.apply(void 0, arguments);
      };
    }
  }, Uu = {
    readContext: gt,
    use: Gl,
    useCallback: Dp,
    useContext: gt,
    useEffect: _u,
    useImperativeHandle: _p,
    useInsertionEffect: zp,
    useLayoutEffect: Op,
    useMemo: Fp,
    useReducer: Yl,
    useRef: Ep,
    useState: function() {
      return Yl(aa);
    },
    useDebugValue: Du,
    useDeferredValue: function(e, t) {
      var a = tt();
      return Bp(
        a,
        Ue.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = Yl(aa)[0], t = tt().memoizedState;
      return [
        typeof e == "boolean" ? e : hr(e),
        t
      ];
    },
    useSyncExternalStore: hp,
    useId: Lp,
    useHostTransitionStatus: Vu,
    useFormState: Tp,
    useActionState: Tp,
    useOptimistic: function(e, t) {
      var a = tt();
      return yp(a, Ue, e, t);
    },
    useMemoCache: ku,
    useCacheRefresh: Pp
  };
  Uu.useEffectEvent = Mp;
  var Qp = {
    readContext: gt,
    use: Gl,
    useCallback: Dp,
    useContext: gt,
    useEffect: _u,
    useImperativeHandle: _p,
    useInsertionEffect: zp,
    useLayoutEffect: Op,
    useMemo: Fp,
    useReducer: zu,
    useRef: Ep,
    useState: function() {
      return zu(aa);
    },
    useDebugValue: Du,
    useDeferredValue: function(e, t) {
      var a = tt();
      return Ue === null ? Fu(a, e, t) : Bp(
        a,
        Ue.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = zu(aa)[0], t = tt().memoizedState;
      return [
        typeof e == "boolean" ? e : hr(e),
        t
      ];
    },
    useSyncExternalStore: hp,
    useId: Lp,
    useHostTransitionStatus: Vu,
    useFormState: Cp,
    useActionState: Cp,
    useOptimistic: function(e, t) {
      var a = tt();
      return Ue !== null ? yp(a, Ue, e, t) : (a.baseState = e, [e, a.queue.dispatch]);
    },
    useMemoCache: ku,
    useCacheRefresh: Pp
  };
  Qp.useEffectEvent = Mp;
  function Lu(e, t, a, r) {
    t = e.memoizedState, a = a(r, t), a = a == null ? t : y({}, t, a), e.memoizedState = a, e.lanes === 0 && (e.updateQueue.baseState = a);
  }
  var Pu = {
    enqueueSetState: function(e, t, a) {
      e = e._reactInternals;
      var r = tn(), c = Aa(r);
      c.payload = t, a != null && (c.callback = a), t = Ca(e, c, r), t !== null && (qt(t, e, r), or(t, e, r));
    },
    enqueueReplaceState: function(e, t, a) {
      e = e._reactInternals;
      var r = tn(), c = Aa(r);
      c.tag = 1, c.payload = t, a != null && (c.callback = a), t = Ca(e, c, r), t !== null && (qt(t, e, r), or(t, e, r));
    },
    enqueueForceUpdate: function(e, t) {
      e = e._reactInternals;
      var a = tn(), r = Aa(a);
      r.tag = 2, t != null && (r.callback = t), t = Ca(e, r, a), t !== null && (qt(t, e, a), or(t, e, a));
    }
  };
  function Zp(e, t, a, r, c, u, x) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, u, x) : t.prototype && t.prototype.isPureReactComponent ? !er(a, r) || !er(c, u) : !0;
  }
  function Xp(e, t, a, r) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, r), t.state !== e && Pu.enqueueReplaceState(t, t.state, null);
  }
  function bi(e, t) {
    var a = t;
    if ("ref" in t) {
      a = {};
      for (var r in t)
        r !== "ref" && (a[r] = t[r]);
    }
    if (e = e.defaultProps) {
      a === t && (a = y({}, a));
      for (var c in e)
        a[c] === void 0 && (a[c] = e[c]);
    }
    return a;
  }
  function Kp(e) {
    Cl(e);
  }
  function $p(e) {
    console.error(e);
  }
  function Wp(e) {
    Cl(e);
  }
  function Kl(e, t) {
    try {
      var a = e.onUncaughtError;
      a(t.value, { componentStack: t.stack });
    } catch (r) {
      setTimeout(function() {
        throw r;
      });
    }
  }
  function Jp(e, t, a) {
    try {
      var r = e.onCaughtError;
      r(a.value, {
        componentStack: a.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (c) {
      setTimeout(function() {
        throw c;
      });
    }
  }
  function Iu(e, t, a) {
    return a = Aa(a), a.tag = 3, a.payload = { element: null }, a.callback = function() {
      Kl(e, t);
    }, a;
  }
  function eg(e) {
    return e = Aa(e), e.tag = 3, e;
  }
  function tg(e, t, a, r) {
    var c = a.type.getDerivedStateFromError;
    if (typeof c == "function") {
      var u = r.value;
      e.payload = function() {
        return c(u);
      }, e.callback = function() {
        Jp(t, a, r);
      };
    }
    var x = a.stateNode;
    x !== null && typeof x.componentDidCatch == "function" && (e.callback = function() {
      Jp(t, a, r), typeof c != "function" && (Ra === null ? Ra = /* @__PURE__ */ new Set([this]) : Ra.add(this));
      var v = r.stack;
      this.componentDidCatch(r.value, {
        componentStack: v !== null ? v : ""
      });
    });
  }
  function h2(e, t, a, r, c) {
    if (a.flags |= 32768, r !== null && typeof r == "object" && typeof r.then == "function") {
      if (t = a.alternate, t !== null && as(
        t,
        a,
        c,
        !0
      ), a = $t.current, a !== null) {
        switch (a.tag) {
          case 31:
          case 13:
            return gn === null ? oo() : a.alternate === null && We === 0 && (We = 3), a.flags &= -257, a.flags |= 65536, a.lanes = c, r === Bl ? a.flags |= 16384 : (t = a.updateQueue, t === null ? a.updateQueue = /* @__PURE__ */ new Set([r]) : t.add(r), md(e, r, c)), !1;
          case 22:
            return a.flags |= 65536, r === Bl ? a.flags |= 16384 : (t = a.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([r])
            }, a.updateQueue = t) : (a = t.retryQueue, a === null ? t.retryQueue = /* @__PURE__ */ new Set([r]) : a.add(r)), md(e, r, c)), !1;
        }
        throw Error(o(435, a.tag));
      }
      return md(e, r, c), oo(), !1;
    }
    if (Me)
      return t = $t.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = c, r !== ou && (e = Error(o(422), { cause: r }), ar(hn(e, a)))) : (r !== ou && (t = Error(o(423), {
        cause: r
      }), ar(
        hn(t, a)
      )), e = e.current.alternate, e.flags |= 65536, c &= -c, e.lanes |= c, r = hn(r, a), c = Iu(
        e.stateNode,
        r,
        c
      ), bu(e, c), We !== 4 && (We = 2)), !1;
    var u = Error(o(520), { cause: r });
    if (u = hn(u, a), jr === null ? jr = [u] : jr.push(u), We !== 4 && (We = 2), t === null) return !0;
    r = hn(r, a), a = t;
    do {
      switch (a.tag) {
        case 3:
          return a.flags |= 65536, e = c & -c, a.lanes |= e, e = Iu(a.stateNode, r, e), bu(a, e), !1;
        case 1:
          if (t = a.type, u = a.stateNode, (a.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || u !== null && typeof u.componentDidCatch == "function" && (Ra === null || !Ra.has(u))))
            return a.flags |= 65536, c &= -c, a.lanes |= c, c = eg(c), tg(
              c,
              e,
              a,
              r
            ), bu(a, c), !1;
      }
      a = a.return;
    } while (a !== null);
    return !1;
  }
  var qu = Error(o(461)), it = !1;
  function xt(e, t, a, r) {
    t.child = e === null ? sp(t, null, a, r) : xi(
      t,
      e.child,
      a,
      r
    );
  }
  function ng(e, t, a, r, c) {
    a = a.render;
    var u = t.ref;
    if ("ref" in r) {
      var x = {};
      for (var v in r)
        v !== "ref" && (x[v] = r[v]);
    } else x = r;
    return fi(t), r = Tu(
      e,
      t,
      a,
      x,
      u,
      c
    ), v = Au(), e !== null && !it ? (Cu(e, t, c), ia(e, t, c)) : (Me && v && ru(t), t.flags |= 1, xt(e, t, r, c), t.child);
  }
  function ag(e, t, a, r, c) {
    if (e === null) {
      var u = a.type;
      return typeof u == "function" && !au(u) && u.defaultProps === void 0 && a.compare === null ? (t.tag = 15, t.type = u, ig(
        e,
        t,
        u,
        r,
        c
      )) : (e = zl(
        a.type,
        null,
        r,
        t,
        t.mode,
        c
      ), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (u = e.child, !Wu(e, c)) {
      var x = u.memoizedProps;
      if (a = a.compare, a = a !== null ? a : er, a(x, r) && e.ref === t.ref)
        return ia(e, t, c);
    }
    return t.flags |= 1, e = Wn(u, r), e.ref = t.ref, e.return = t, t.child = e;
  }
  function ig(e, t, a, r, c) {
    if (e !== null) {
      var u = e.memoizedProps;
      if (er(u, r) && e.ref === t.ref)
        if (it = !1, t.pendingProps = r = u, Wu(e, c))
          (e.flags & 131072) !== 0 && (it = !0);
        else
          return t.lanes = e.lanes, ia(e, t, c);
    }
    return Gu(
      e,
      t,
      a,
      r,
      c
    );
  }
  function sg(e, t, a, r) {
    var c = r.children, u = e !== null ? e.memoizedState : null;
    if (e === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), r.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (u = u !== null ? u.baseLanes | a : a, e !== null) {
          for (r = t.child = e.child, c = 0; r !== null; )
            c = c | r.lanes | r.childLanes, r = r.sibling;
          r = c & ~u;
        } else r = 0, t.child = null;
        return rg(
          e,
          t,
          u,
          a,
          r
        );
      }
      if ((a & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && Dl(
          t,
          u !== null ? u.cachePool : null
        ), u !== null ? op(t, u) : wu(), cp(t);
      else
        return r = t.lanes = 536870912, rg(
          e,
          t,
          u !== null ? u.baseLanes | a : a,
          a,
          r
        );
    } else
      u !== null ? (Dl(t, u.cachePool), op(t, u), ka(), t.memoizedState = null) : (e !== null && Dl(t, null), wu(), ka());
    return xt(e, t, c, a), t.child;
  }
  function pr(e, t) {
    return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function rg(e, t, a, r, c) {
    var u = pu();
    return u = u === null ? null : { parent: nt._currentValue, pool: u }, t.memoizedState = {
      baseLanes: a,
      cachePool: u
    }, e !== null && Dl(t, null), wu(), cp(t), e !== null && as(e, t, r, !0), t.childLanes = c, null;
  }
  function $l(e, t) {
    return t = Jl(
      { mode: t.mode, children: t.children },
      e.mode
    ), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function lg(e, t, a) {
    return xi(t, e.child, null, a), e = $l(t, t.pendingProps), e.flags |= 2, Wt(t), t.memoizedState = null, e;
  }
  function f2(e, t, a) {
    var r = t.pendingProps, c = (t.flags & 128) !== 0;
    if (t.flags &= -129, e === null) {
      if (Me) {
        if (r.mode === "hidden")
          return e = $l(t, r), t.lanes = 536870912, pr(null, e);
        if (Su(t), (e = Ye) ? (e = bx(
          e,
          pn
        ), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: wa !== null ? { id: Fn, overflow: Bn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, a = qm(e), a.return = t, t.child = a, pt = t, Ye = null)) : e = null, e === null) throw Sa(t);
        return t.lanes = 536870912, null;
      }
      return $l(t, r);
    }
    var u = e.memoizedState;
    if (u !== null) {
      var x = u.dehydrated;
      if (Su(t), c)
        if (t.flags & 256)
          t.flags &= -257, t = lg(
            e,
            t,
            a
          );
        else if (t.memoizedState !== null)
          t.child = e.child, t.flags |= 128, t = null;
        else throw Error(o(558));
      else if (it || as(e, t, a, !1), c = (a & e.childLanes) !== 0, it || c) {
        if (r = Ie, r !== null && (x = Bt(r, a), x !== 0 && x !== u.retryLane))
          throw u.retryLane = x, ci(e, x), qt(r, e, x), qu;
        oo(), t = lg(
          e,
          t,
          a
        );
      } else
        e = u.treeContext, Ye = xn(x.nextSibling), pt = t, Me = !0, ja = null, pn = !1, e !== null && Qm(t, e), t = $l(t, r), t.flags |= 4096;
      return t;
    }
    return e = Wn(e.child, {
      mode: r.mode,
      children: r.children
    }), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Wl(e, t) {
    var a = t.ref;
    if (a === null)
      e !== null && e.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof a != "function" && typeof a != "object")
        throw Error(o(284));
      (e === null || e.ref !== a) && (t.flags |= 4194816);
    }
  }
  function Gu(e, t, a, r, c) {
    return fi(t), a = Tu(
      e,
      t,
      a,
      r,
      void 0,
      c
    ), r = Au(), e !== null && !it ? (Cu(e, t, c), ia(e, t, c)) : (Me && r && ru(t), t.flags |= 1, xt(e, t, a, c), t.child);
  }
  function og(e, t, a, r, c, u) {
    return fi(t), t.updateQueue = null, a = dp(
      t,
      r,
      a,
      c
    ), up(e), r = Au(), e !== null && !it ? (Cu(e, t, u), ia(e, t, u)) : (Me && r && ru(t), t.flags |= 1, xt(e, t, a, u), t.child);
  }
  function cg(e, t, a, r, c) {
    if (fi(t), t.stateNode === null) {
      var u = Ji, x = a.contextType;
      typeof x == "object" && x !== null && (u = gt(x)), u = new a(r, u), t.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = Pu, t.stateNode = u, u._reactInternals = t, u = t.stateNode, u.props = r, u.state = t.memoizedState, u.refs = {}, xu(t), x = a.contextType, u.context = typeof x == "object" && x !== null ? gt(x) : Ji, u.state = t.memoizedState, x = a.getDerivedStateFromProps, typeof x == "function" && (Lu(
        t,
        a,
        x,
        r
      ), u.state = t.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof u.getSnapshotBeforeUpdate == "function" || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (x = u.state, typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), x !== u.state && Pu.enqueueReplaceState(u, u.state, null), ur(t, r, u, c), cr(), u.state = t.memoizedState), typeof u.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
    } else if (e === null) {
      u = t.stateNode;
      var v = t.memoizedProps, j = bi(a, v);
      u.props = j;
      var F = u.context, U = a.contextType;
      x = Ji, typeof U == "object" && U !== null && (x = gt(U));
      var I = a.getDerivedStateFromProps;
      U = typeof I == "function" || typeof u.getSnapshotBeforeUpdate == "function", v = t.pendingProps !== v, U || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (v || F !== x) && Xp(
        t,
        u,
        r,
        x
      ), Ta = !1;
      var B = t.memoizedState;
      u.state = B, ur(t, r, u, c), cr(), F = t.memoizedState, v || B !== F || Ta ? (typeof I == "function" && (Lu(
        t,
        a,
        I,
        r
      ), F = t.memoizedState), (j = Ta || Zp(
        t,
        a,
        j,
        r,
        B,
        F,
        x
      )) ? (U || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = F), u.props = r, u.state = F, u.context = x, r = j) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
    } else {
      u = t.stateNode, yu(e, t), x = t.memoizedProps, U = bi(a, x), u.props = U, I = t.pendingProps, B = u.context, F = a.contextType, j = Ji, typeof F == "object" && F !== null && (j = gt(F)), v = a.getDerivedStateFromProps, (F = typeof v == "function" || typeof u.getSnapshotBeforeUpdate == "function") || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (x !== I || B !== j) && Xp(
        t,
        u,
        r,
        j
      ), Ta = !1, B = t.memoizedState, u.state = B, ur(t, r, u, c), cr();
      var V = t.memoizedState;
      x !== I || B !== V || Ta || e !== null && e.dependencies !== null && Rl(e.dependencies) ? (typeof v == "function" && (Lu(
        t,
        a,
        v,
        r
      ), V = t.memoizedState), (U = Ta || Zp(
        t,
        a,
        U,
        r,
        B,
        V,
        j
      ) || e !== null && e.dependencies !== null && Rl(e.dependencies)) ? (F || typeof u.UNSAFE_componentWillUpdate != "function" && typeof u.componentWillUpdate != "function" || (typeof u.componentWillUpdate == "function" && u.componentWillUpdate(r, V, j), typeof u.UNSAFE_componentWillUpdate == "function" && u.UNSAFE_componentWillUpdate(
        r,
        V,
        j
      )), typeof u.componentDidUpdate == "function" && (t.flags |= 4), typeof u.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof u.componentDidUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = V), u.props = r, u.state = V, u.context = j, r = U) : (typeof u.componentDidUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || x === e.memoizedProps && B === e.memoizedState || (t.flags |= 1024), r = !1);
    }
    return u = r, Wl(e, t), r = (t.flags & 128) !== 0, u || r ? (u = t.stateNode, a = r && typeof a.getDerivedStateFromError != "function" ? null : u.render(), t.flags |= 1, e !== null && r ? (t.child = xi(
      t,
      e.child,
      null,
      c
    ), t.child = xi(
      t,
      null,
      a,
      c
    )) : xt(e, t, a, c), t.memoizedState = u.state, e = t.child) : e = ia(
      e,
      t,
      c
    ), e;
  }
  function ug(e, t, a, r) {
    return di(), t.flags |= 256, xt(e, t, a, r), t.child;
  }
  var Yu = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Qu(e) {
    return { baseLanes: e, cachePool: Jm() };
  }
  function Zu(e, t, a) {
    return e = e !== null ? e.childLanes & ~a : 0, t && (e |= en), e;
  }
  function dg(e, t, a) {
    var r = t.pendingProps, c = !1, u = (t.flags & 128) !== 0, x;
    if ((x = u) || (x = e !== null && e.memoizedState === null ? !1 : (et.current & 2) !== 0), x && (c = !0, t.flags &= -129), x = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
      if (Me) {
        if (c ? Ea(t) : ka(), (e = Ye) ? (e = bx(
          e,
          pn
        ), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: wa !== null ? { id: Fn, overflow: Bn } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, a = qm(e), a.return = t, t.child = a, pt = t, Ye = null)) : e = null, e === null) throw Sa(t);
        return Md(e) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var v = r.children;
      return r = r.fallback, c ? (ka(), c = t.mode, v = Jl(
        { mode: "hidden", children: v },
        c
      ), r = ui(
        r,
        c,
        a,
        null
      ), v.return = t, r.return = t, v.sibling = r, t.child = v, r = t.child, r.memoizedState = Qu(a), r.childLanes = Zu(
        e,
        x,
        a
      ), t.memoizedState = Yu, pr(null, r)) : (Ea(t), Xu(t, v));
    }
    var j = e.memoizedState;
    if (j !== null && (v = j.dehydrated, v !== null)) {
      if (u)
        t.flags & 256 ? (Ea(t), t.flags &= -257, t = Ku(
          e,
          t,
          a
        )) : t.memoizedState !== null ? (ka(), t.child = e.child, t.flags |= 128, t = null) : (ka(), v = r.fallback, c = t.mode, r = Jl(
          { mode: "visible", children: r.children },
          c
        ), v = ui(
          v,
          c,
          a,
          null
        ), v.flags |= 2, r.return = t, v.return = t, r.sibling = v, t.child = r, xi(
          t,
          e.child,
          null,
          a
        ), r = t.child, r.memoizedState = Qu(a), r.childLanes = Zu(
          e,
          x,
          a
        ), t.memoizedState = Yu, t = pr(null, r));
      else if (Ea(t), Md(v)) {
        if (x = v.nextSibling && v.nextSibling.dataset, x) var F = x.dgst;
        x = F, r = Error(o(419)), r.stack = "", r.digest = x, ar({ value: r, source: null, stack: null }), t = Ku(
          e,
          t,
          a
        );
      } else if (it || as(e, t, a, !1), x = (a & e.childLanes) !== 0, it || x) {
        if (x = Ie, x !== null && (r = Bt(x, a), r !== 0 && r !== j.retryLane))
          throw j.retryLane = r, ci(e, r), qt(x, e, r), qu;
        kd(v) || oo(), t = Ku(
          e,
          t,
          a
        );
      } else
        kd(v) ? (t.flags |= 192, t.child = e.child, t = null) : (e = j.treeContext, Ye = xn(
          v.nextSibling
        ), pt = t, Me = !0, ja = null, pn = !1, e !== null && Qm(t, e), t = Xu(
          t,
          r.children
        ), t.flags |= 4096);
      return t;
    }
    return c ? (ka(), v = r.fallback, c = t.mode, j = e.child, F = j.sibling, r = Wn(j, {
      mode: "hidden",
      children: r.children
    }), r.subtreeFlags = j.subtreeFlags & 65011712, F !== null ? v = Wn(
      F,
      v
    ) : (v = ui(
      v,
      c,
      a,
      null
    ), v.flags |= 2), v.return = t, r.return = t, r.sibling = v, t.child = r, pr(null, r), r = t.child, v = e.child.memoizedState, v === null ? v = Qu(a) : (c = v.cachePool, c !== null ? (j = nt._currentValue, c = c.parent !== j ? { parent: j, pool: j } : c) : c = Jm(), v = {
      baseLanes: v.baseLanes | a,
      cachePool: c
    }), r.memoizedState = v, r.childLanes = Zu(
      e,
      x,
      a
    ), t.memoizedState = Yu, pr(e.child, r)) : (Ea(t), a = e.child, e = a.sibling, a = Wn(a, {
      mode: "visible",
      children: r.children
    }), a.return = t, a.sibling = null, e !== null && (x = t.deletions, x === null ? (t.deletions = [e], t.flags |= 16) : x.push(e)), t.child = a, t.memoizedState = null, a);
  }
  function Xu(e, t) {
    return t = Jl(
      { mode: "visible", children: t },
      e.mode
    ), t.return = e, e.child = t;
  }
  function Jl(e, t) {
    return e = Kt(22, e, null, t), e.lanes = 0, e;
  }
  function Ku(e, t, a) {
    return xi(t, e.child, null, a), e = Xu(
      t,
      t.pendingProps.children
    ), e.flags |= 2, t.memoizedState = null, e;
  }
  function hg(e, t, a) {
    e.lanes |= t;
    var r = e.alternate;
    r !== null && (r.lanes |= t), du(e.return, t, a);
  }
  function $u(e, t, a, r, c, u) {
    var x = e.memoizedState;
    x === null ? e.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: r,
      tail: a,
      tailMode: c,
      treeForkCount: u
    } : (x.isBackwards = t, x.rendering = null, x.renderingStartTime = 0, x.last = r, x.tail = a, x.tailMode = c, x.treeForkCount = u);
  }
  function fg(e, t, a) {
    var r = t.pendingProps, c = r.revealOrder, u = r.tail;
    r = r.children;
    var x = et.current, v = (x & 2) !== 0;
    if (v ? (x = x & 1 | 2, t.flags |= 128) : x &= 1, Y(et, x), xt(e, t, r, a), r = Me ? nr : 0, !v && e !== null && (e.flags & 128) !== 0)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13)
          e.memoizedState !== null && hg(e, a, t);
        else if (e.tag === 19)
          hg(e, a, t);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t)
            break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    switch (c) {
      case "forwards":
        for (a = t.child, c = null; a !== null; )
          e = a.alternate, e !== null && Ll(e) === null && (c = a), a = a.sibling;
        a = c, a === null ? (c = t.child, t.child = null) : (c = a.sibling, a.sibling = null), $u(
          t,
          !1,
          c,
          a,
          u,
          r
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (a = null, c = t.child, t.child = null; c !== null; ) {
          if (e = c.alternate, e !== null && Ll(e) === null) {
            t.child = c;
            break;
          }
          e = c.sibling, c.sibling = a, a = c, c = e;
        }
        $u(
          t,
          !0,
          a,
          null,
          u,
          r
        );
        break;
      case "together":
        $u(
          t,
          !1,
          null,
          null,
          void 0,
          r
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function ia(e, t, a) {
    if (e !== null && (t.dependencies = e.dependencies), Oa |= t.lanes, (a & t.childLanes) === 0)
      if (e !== null) {
        if (as(
          e,
          t,
          a,
          !1
        ), (a & t.childLanes) === 0)
          return null;
      } else return null;
    if (e !== null && t.child !== e.child)
      throw Error(o(153));
    if (t.child !== null) {
      for (e = t.child, a = Wn(e, e.pendingProps), t.child = a, a.return = t; e.sibling !== null; )
        e = e.sibling, a = a.sibling = Wn(e, e.pendingProps), a.return = t;
      a.sibling = null;
    }
    return t.child;
  }
  function Wu(e, t) {
    return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && Rl(e)));
  }
  function m2(e, t, a) {
    switch (t.tag) {
      case 3:
        be(t, t.stateNode.containerInfo), Na(t, nt, e.memoizedState.cache), di();
        break;
      case 27:
      case 5:
        Qt(t);
        break;
      case 4:
        be(t, t.stateNode.containerInfo);
        break;
      case 10:
        Na(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, Su(t), null;
        break;
      case 13:
        var r = t.memoizedState;
        if (r !== null)
          return r.dehydrated !== null ? (Ea(t), t.flags |= 128, null) : (a & t.child.childLanes) !== 0 ? dg(e, t, a) : (Ea(t), e = ia(
            e,
            t,
            a
          ), e !== null ? e.sibling : null);
        Ea(t);
        break;
      case 19:
        var c = (e.flags & 128) !== 0;
        if (r = (a & t.childLanes) !== 0, r || (as(
          e,
          t,
          a,
          !1
        ), r = (a & t.childLanes) !== 0), c) {
          if (r)
            return fg(
              e,
              t,
              a
            );
          t.flags |= 128;
        }
        if (c = t.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), Y(et, et.current), r) break;
        return null;
      case 22:
        return t.lanes = 0, sg(
          e,
          t,
          a,
          t.pendingProps
        );
      case 24:
        Na(t, nt, e.memoizedState.cache);
    }
    return ia(e, t, a);
  }
  function mg(e, t, a) {
    if (e !== null)
      if (e.memoizedProps !== t.pendingProps)
        it = !0;
      else {
        if (!Wu(e, a) && (t.flags & 128) === 0)
          return it = !1, m2(
            e,
            t,
            a
          );
        it = (e.flags & 131072) !== 0;
      }
    else
      it = !1, Me && (t.flags & 1048576) !== 0 && Ym(t, nr, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        e: {
          var r = t.pendingProps;
          if (e = pi(t.elementType), t.type = e, typeof e == "function")
            au(e) ? (r = bi(e, r), t.tag = 1, t = cg(
              null,
              t,
              e,
              r,
              a
            )) : (t.tag = 0, t = Gu(
              null,
              t,
              e,
              r,
              a
            ));
          else {
            if (e != null) {
              var c = e.$$typeof;
              if (c === Q) {
                t.tag = 11, t = ng(
                  null,
                  t,
                  e,
                  r,
                  a
                );
                break e;
              } else if (c === $) {
                t.tag = 14, t = ag(
                  null,
                  t,
                  e,
                  r,
                  a
                );
                break e;
              }
            }
            throw t = Be(e) || e, Error(o(306, t, ""));
          }
        }
        return t;
      case 0:
        return Gu(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 1:
        return r = t.type, c = bi(
          r,
          t.pendingProps
        ), cg(
          e,
          t,
          r,
          c,
          a
        );
      case 3:
        e: {
          if (be(
            t,
            t.stateNode.containerInfo
          ), e === null) throw Error(o(387));
          r = t.pendingProps;
          var u = t.memoizedState;
          c = u.element, yu(e, t), ur(t, r, null, a);
          var x = t.memoizedState;
          if (r = x.cache, Na(t, nt, r), r !== u.cache && hu(
            t,
            [nt],
            a,
            !0
          ), cr(), r = x.element, u.isDehydrated)
            if (u = {
              element: r,
              isDehydrated: !1,
              cache: x.cache
            }, t.updateQueue.baseState = u, t.memoizedState = u, t.flags & 256) {
              t = ug(
                e,
                t,
                r,
                a
              );
              break e;
            } else if (r !== c) {
              c = hn(
                Error(o(424)),
                t
              ), ar(c), t = ug(
                e,
                t,
                r,
                a
              );
              break e;
            } else
              for (e = t.stateNode.containerInfo, e.nodeType === 9 ? e = e.body : e = e.nodeName === "HTML" ? e.ownerDocument.body : e, Ye = xn(e.firstChild), pt = t, Me = !0, ja = null, pn = !0, a = sp(
                t,
                null,
                r,
                a
              ), t.child = a; a; )
                a.flags = a.flags & -3 | 4096, a = a.sibling;
          else {
            if (di(), r === c) {
              t = ia(
                e,
                t,
                a
              );
              break e;
            }
            xt(e, t, r, a);
          }
          t = t.child;
        }
        return t;
      case 26:
        return Wl(e, t), e === null ? (a = Tx(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = a : Me || (a = t.type, e = t.pendingProps, r = go(
          se.current
        ).createElement(a), r[mt] = t, r[Vt] = e, yt(r, a, e), dt(r), t.stateNode = r) : t.memoizedState = Tx(
          t.type,
          e.memoizedProps,
          t.pendingProps,
          e.memoizedState
        ), null;
      case 27:
        return Qt(t), e === null && Me && (r = t.stateNode = jx(
          t.type,
          t.pendingProps,
          se.current
        ), pt = t, pn = !0, c = Ye, Ba(t.type) ? (zd = c, Ye = xn(r.firstChild)) : Ye = c), xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), Wl(e, t), e === null && (t.flags |= 4194304), t.child;
      case 5:
        return e === null && Me && ((c = r = Ye) && (r = q2(
          r,
          t.type,
          t.pendingProps,
          pn
        ), r !== null ? (t.stateNode = r, pt = t, Ye = xn(r.firstChild), pn = !1, c = !0) : c = !1), c || Sa(t)), Qt(t), c = t.type, u = t.pendingProps, x = e !== null ? e.memoizedProps : null, r = u.children, Ad(c, u) ? r = null : x !== null && Ad(c, x) && (t.flags |= 32), t.memoizedState !== null && (c = Tu(
          e,
          t,
          s2,
          null,
          null,
          a
        ), Mr._currentValue = c), Wl(e, t), xt(e, t, r, a), t.child;
      case 6:
        return e === null && Me && ((e = a = Ye) && (a = G2(
          a,
          t.pendingProps,
          pn
        ), a !== null ? (t.stateNode = a, pt = t, Ye = null, e = !0) : e = !1), e || Sa(t)), null;
      case 13:
        return dg(e, t, a);
      case 4:
        return be(
          t,
          t.stateNode.containerInfo
        ), r = t.pendingProps, e === null ? t.child = xi(
          t,
          null,
          r,
          a
        ) : xt(e, t, r, a), t.child;
      case 11:
        return ng(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 7:
        return xt(
          e,
          t,
          t.pendingProps,
          a
        ), t.child;
      case 8:
        return xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), t.child;
      case 12:
        return xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), t.child;
      case 10:
        return r = t.pendingProps, Na(t, t.type, r.value), xt(e, t, r.children, a), t.child;
      case 9:
        return c = t.type._context, r = t.pendingProps.children, fi(t), c = gt(c), r = r(c), t.flags |= 1, xt(e, t, r, a), t.child;
      case 14:
        return ag(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 15:
        return ig(
          e,
          t,
          t.type,
          t.pendingProps,
          a
        );
      case 19:
        return fg(e, t, a);
      case 31:
        return f2(e, t, a);
      case 22:
        return sg(
          e,
          t,
          a,
          t.pendingProps
        );
      case 24:
        return fi(t), r = gt(nt), e === null ? (c = pu(), c === null && (c = Ie, u = fu(), c.pooledCache = u, u.refCount++, u !== null && (c.pooledCacheLanes |= a), c = u), t.memoizedState = { parent: r, cache: c }, xu(t), Na(t, nt, c)) : ((e.lanes & a) !== 0 && (yu(e, t), ur(t, null, null, a), cr()), c = e.memoizedState, u = t.memoizedState, c.parent !== r ? (c = { parent: r, cache: r }, t.memoizedState = c, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = c), Na(t, nt, r)) : (r = u.cache, Na(t, nt, r), r !== c.cache && hu(
          t,
          [nt],
          a,
          !0
        ))), xt(
          e,
          t,
          t.pendingProps.children,
          a
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(o(156, t.tag));
  }
  function sa(e) {
    e.flags |= 4;
  }
  function Ju(e, t, a, r, c) {
    if ((t = (e.mode & 32) !== 0) && (t = !1), t) {
      if (e.flags |= 16777216, (c & 335544128) === c)
        if (e.stateNode.complete) e.flags |= 8192;
        else if (Lg()) e.flags |= 8192;
        else
          throw gi = Bl, gu;
    } else e.flags &= -16777217;
  }
  function pg(e, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      e.flags &= -16777217;
    else if (e.flags |= 16777216, !Mx(t))
      if (Lg()) e.flags |= 8192;
      else
        throw gi = Bl, gu;
  }
  function eo(e, t) {
    t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? St() : 536870912, e.lanes |= t, ps |= t);
  }
  function gr(e, t) {
    if (!Me)
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var a = null; t !== null; )
            t.alternate !== null && (a = t), t = t.sibling;
          a === null ? e.tail = null : a.sibling = null;
          break;
        case "collapsed":
          a = e.tail;
          for (var r = null; a !== null; )
            a.alternate !== null && (r = a), a = a.sibling;
          r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
      }
  }
  function Qe(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, a = 0, r = 0;
    if (t)
      for (var c = e.child; c !== null; )
        a |= c.lanes | c.childLanes, r |= c.subtreeFlags & 65011712, r |= c.flags & 65011712, c.return = e, c = c.sibling;
    else
      for (c = e.child; c !== null; )
        a |= c.lanes | c.childLanes, r |= c.subtreeFlags, r |= c.flags, c.return = e, c = c.sibling;
    return e.subtreeFlags |= r, e.childLanes = a, t;
  }
  function p2(e, t, a) {
    var r = t.pendingProps;
    switch (lu(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Qe(t), null;
      case 1:
        return Qe(t), null;
      case 3:
        return a = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), ta(nt), pe(), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), (e === null || e.child === null) && (ns(t) ? sa(t) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, cu())), Qe(t), null;
      case 26:
        var c = t.type, u = t.memoizedState;
        return e === null ? (sa(t), u !== null ? (Qe(t), pg(t, u)) : (Qe(t), Ju(
          t,
          c,
          null,
          r,
          a
        ))) : u ? u !== e.memoizedState ? (sa(t), Qe(t), pg(t, u)) : (Qe(t), t.flags &= -16777217) : (e = e.memoizedProps, e !== r && sa(t), Qe(t), Ju(
          t,
          c,
          e,
          r,
          a
        )), null;
      case 27:
        if (_t(t), a = se.current, c = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== r && sa(t);
        else {
          if (!r) {
            if (t.stateNode === null)
              throw Error(o(166));
            return Qe(t), null;
          }
          e = J.current, ns(t) ? Zm(t) : (e = jx(c, r, a), t.stateNode = e, sa(t));
        }
        return Qe(t), null;
      case 5:
        if (_t(t), c = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== r && sa(t);
        else {
          if (!r) {
            if (t.stateNode === null)
              throw Error(o(166));
            return Qe(t), null;
          }
          if (u = J.current, ns(t))
            Zm(t);
          else {
            var x = go(
              se.current
            );
            switch (u) {
              case 1:
                u = x.createElementNS(
                  "http://www.w3.org/2000/svg",
                  c
                );
                break;
              case 2:
                u = x.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  c
                );
                break;
              default:
                switch (c) {
                  case "svg":
                    u = x.createElementNS(
                      "http://www.w3.org/2000/svg",
                      c
                    );
                    break;
                  case "math":
                    u = x.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      c
                    );
                    break;
                  case "script":
                    u = x.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(
                      u.firstChild
                    );
                    break;
                  case "select":
                    u = typeof r.is == "string" ? x.createElement("select", {
                      is: r.is
                    }) : x.createElement("select"), r.multiple ? u.multiple = !0 : r.size && (u.size = r.size);
                    break;
                  default:
                    u = typeof r.is == "string" ? x.createElement(c, { is: r.is }) : x.createElement(c);
                }
            }
            u[mt] = t, u[Vt] = r;
            e: for (x = t.child; x !== null; ) {
              if (x.tag === 5 || x.tag === 6)
                u.appendChild(x.stateNode);
              else if (x.tag !== 4 && x.tag !== 27 && x.child !== null) {
                x.child.return = x, x = x.child;
                continue;
              }
              if (x === t) break e;
              for (; x.sibling === null; ) {
                if (x.return === null || x.return === t)
                  break e;
                x = x.return;
              }
              x.sibling.return = x.return, x = x.sibling;
            }
            t.stateNode = u;
            e: switch (yt(u, c, r), c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
            r && sa(t);
          }
        }
        return Qe(t), Ju(
          t,
          t.type,
          e === null ? null : e.memoizedProps,
          t.pendingProps,
          a
        ), null;
      case 6:
        if (e && t.stateNode != null)
          e.memoizedProps !== r && sa(t);
        else {
          if (typeof r != "string" && t.stateNode === null)
            throw Error(o(166));
          if (e = se.current, ns(t)) {
            if (e = t.stateNode, a = t.memoizedProps, r = null, c = pt, c !== null)
              switch (c.tag) {
                case 27:
                case 5:
                  r = c.memoizedProps;
              }
            e[mt] = t, e = !!(e.nodeValue === a || r !== null && r.suppressHydrationWarning === !0 || dx(e.nodeValue, a)), e || Sa(t, !0);
          } else
            e = go(e).createTextNode(
              r
            ), e[mt] = t, t.stateNode = e;
        }
        return Qe(t), null;
      case 31:
        if (a = t.memoizedState, e === null || e.memoizedState !== null) {
          if (r = ns(t), a !== null) {
            if (e === null) {
              if (!r) throw Error(o(318));
              if (e = t.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(o(557));
              e[mt] = t;
            } else
              di(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            Qe(t), e = !1;
          } else
            a = cu(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), e = !0;
          if (!e)
            return t.flags & 256 ? (Wt(t), t) : (Wt(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(o(558));
        }
        return Qe(t), null;
      case 13:
        if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (c = ns(t), r !== null && r.dehydrated !== null) {
            if (e === null) {
              if (!c) throw Error(o(318));
              if (c = t.memoizedState, c = c !== null ? c.dehydrated : null, !c) throw Error(o(317));
              c[mt] = t;
            } else
              di(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            Qe(t), c = !1;
          } else
            c = cu(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = c), c = !0;
          if (!c)
            return t.flags & 256 ? (Wt(t), t) : (Wt(t), null);
        }
        return Wt(t), (t.flags & 128) !== 0 ? (t.lanes = a, t) : (a = r !== null, e = e !== null && e.memoizedState !== null, a && (r = t.child, c = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (c = r.alternate.memoizedState.cachePool.pool), u = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (u = r.memoizedState.cachePool.pool), u !== c && (r.flags |= 2048)), a !== e && a && (t.child.flags |= 8192), eo(t, t.updateQueue), Qe(t), null);
      case 4:
        return pe(), e === null && wd(t.stateNode.containerInfo), Qe(t), null;
      case 10:
        return ta(t.type), Qe(t), null;
      case 19:
        if (L(et), r = t.memoizedState, r === null) return Qe(t), null;
        if (c = (t.flags & 128) !== 0, u = r.rendering, u === null)
          if (c) gr(r, !1);
          else {
            if (We !== 0 || e !== null && (e.flags & 128) !== 0)
              for (e = t.child; e !== null; ) {
                if (u = Ll(e), u !== null) {
                  for (t.flags |= 128, gr(r, !1), e = u.updateQueue, t.updateQueue = e, eo(t, e), t.subtreeFlags = 0, e = a, a = t.child; a !== null; )
                    Im(a, e), a = a.sibling;
                  return Y(
                    et,
                    et.current & 1 | 2
                  ), Me && Jn(t, r.treeForkCount), t.child;
                }
                e = e.sibling;
              }
            r.tail !== null && kt() > so && (t.flags |= 128, c = !0, gr(r, !1), t.lanes = 4194304);
          }
        else {
          if (!c)
            if (e = Ll(u), e !== null) {
              if (t.flags |= 128, c = !0, e = e.updateQueue, t.updateQueue = e, eo(t, e), gr(r, !0), r.tail === null && r.tailMode === "hidden" && !u.alternate && !Me)
                return Qe(t), null;
            } else
              2 * kt() - r.renderingStartTime > so && a !== 536870912 && (t.flags |= 128, c = !0, gr(r, !1), t.lanes = 4194304);
          r.isBackwards ? (u.sibling = t.child, t.child = u) : (e = r.last, e !== null ? e.sibling = u : t.child = u, r.last = u);
        }
        return r.tail !== null ? (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = kt(), e.sibling = null, a = et.current, Y(
          et,
          c ? a & 1 | 2 : a & 1
        ), Me && Jn(t, r.treeForkCount), e) : (Qe(t), null);
      case 22:
      case 23:
        return Wt(t), ju(), r = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== r && (t.flags |= 8192) : r && (t.flags |= 8192), r ? (a & 536870912) !== 0 && (t.flags & 128) === 0 && (Qe(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Qe(t), a = t.updateQueue, a !== null && eo(t, a.retryQueue), a = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== a && (t.flags |= 2048), e !== null && L(mi), null;
      case 24:
        return a = null, e !== null && (a = e.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), ta(nt), Qe(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(o(156, t.tag));
  }
  function g2(e, t) {
    switch (lu(t), t.tag) {
      case 1:
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 3:
        return ta(nt), pe(), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return _t(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (Wt(t), t.alternate === null)
            throw Error(o(340));
          di();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 13:
        if (Wt(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(o(340));
          di();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 19:
        return L(et), null;
      case 4:
        return pe(), null;
      case 10:
        return ta(t.type), null;
      case 22:
      case 23:
        return Wt(t), ju(), e !== null && L(mi), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 24:
        return ta(nt), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function gg(e, t) {
    switch (lu(t), t.tag) {
      case 3:
        ta(nt), pe();
        break;
      case 26:
      case 27:
      case 5:
        _t(t);
        break;
      case 4:
        pe();
        break;
      case 31:
        t.memoizedState !== null && Wt(t);
        break;
      case 13:
        Wt(t);
        break;
      case 19:
        L(et);
        break;
      case 10:
        ta(t.type);
        break;
      case 22:
      case 23:
        Wt(t), ju(), e !== null && L(mi);
        break;
      case 24:
        ta(nt);
    }
  }
  function xr(e, t) {
    try {
      var a = t.updateQueue, r = a !== null ? a.lastEffect : null;
      if (r !== null) {
        var c = r.next;
        a = c;
        do {
          if ((a.tag & e) === e) {
            r = void 0;
            var u = a.create, x = a.inst;
            r = u(), x.destroy = r;
          }
          a = a.next;
        } while (a !== c);
      }
    } catch (v) {
      He(t, t.return, v);
    }
  }
  function Ma(e, t, a) {
    try {
      var r = t.updateQueue, c = r !== null ? r.lastEffect : null;
      if (c !== null) {
        var u = c.next;
        r = u;
        do {
          if ((r.tag & e) === e) {
            var x = r.inst, v = x.destroy;
            if (v !== void 0) {
              x.destroy = void 0, c = t;
              var j = a, F = v;
              try {
                F();
              } catch (U) {
                He(
                  c,
                  j,
                  U
                );
              }
            }
          }
          r = r.next;
        } while (r !== u);
      }
    } catch (U) {
      He(t, t.return, U);
    }
  }
  function xg(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var a = e.stateNode;
      try {
        lp(t, a);
      } catch (r) {
        He(e, e.return, r);
      }
    }
  }
  function yg(e, t, a) {
    a.props = bi(
      e.type,
      e.memoizedProps
    ), a.state = e.memoizedState;
    try {
      a.componentWillUnmount();
    } catch (r) {
      He(e, t, r);
    }
  }
  function yr(e, t) {
    try {
      var a = e.ref;
      if (a !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var r = e.stateNode;
            break;
          case 30:
            r = e.stateNode;
            break;
          default:
            r = e.stateNode;
        }
        typeof a == "function" ? e.refCleanup = a(r) : a.current = r;
      }
    } catch (c) {
      He(e, t, c);
    }
  }
  function Vn(e, t) {
    var a = e.ref, r = e.refCleanup;
    if (a !== null)
      if (typeof r == "function")
        try {
          r();
        } catch (c) {
          He(e, t, c);
        } finally {
          e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
        }
      else if (typeof a == "function")
        try {
          a(null);
        } catch (c) {
          He(e, t, c);
        }
      else a.current = null;
  }
  function bg(e) {
    var t = e.type, a = e.memoizedProps, r = e.stateNode;
    try {
      e: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && r.focus();
          break e;
        case "img":
          a.src ? r.src = a.src : a.srcSet && (r.srcset = a.srcSet);
      }
    } catch (c) {
      He(e, e.return, c);
    }
  }
  function ed(e, t, a) {
    try {
      var r = e.stateNode;
      V2(r, e.type, a, t), r[Vt] = t;
    } catch (c) {
      He(e, e.return, c);
    }
  }
  function vg(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Ba(e.type) || e.tag === 4;
  }
  function td(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || vg(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.tag === 27 && Ba(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function nd(e, t, a) {
    var r = e.tag;
    if (r === 5 || r === 6)
      e = e.stateNode, t ? (a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a).insertBefore(e, t) : (t = a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a, t.appendChild(e), a = a._reactRootContainer, a != null || t.onclick !== null || (t.onclick = Kn));
    else if (r !== 4 && (r === 27 && Ba(e.type) && (a = e.stateNode, t = null), e = e.child, e !== null))
      for (nd(e, t, a), e = e.sibling; e !== null; )
        nd(e, t, a), e = e.sibling;
  }
  function to(e, t, a) {
    var r = e.tag;
    if (r === 5 || r === 6)
      e = e.stateNode, t ? a.insertBefore(e, t) : a.appendChild(e);
    else if (r !== 4 && (r === 27 && Ba(e.type) && (a = e.stateNode), e = e.child, e !== null))
      for (to(e, t, a), e = e.sibling; e !== null; )
        to(e, t, a), e = e.sibling;
  }
  function wg(e) {
    var t = e.stateNode, a = e.memoizedProps;
    try {
      for (var r = e.type, c = t.attributes; c.length; )
        t.removeAttributeNode(c[0]);
      yt(t, r, a), t[mt] = e, t[Vt] = a;
    } catch (u) {
      He(e, e.return, u);
    }
  }
  var ra = !1, st = !1, ad = !1, jg = typeof WeakSet == "function" ? WeakSet : Set, ht = null;
  function x2(e, t) {
    if (e = e.containerInfo, Nd = So, e = _m(e), Kc(e)) {
      if ("selectionStart" in e)
        var a = {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      else
        e: {
          a = (a = e.ownerDocument) && a.defaultView || window;
          var r = a.getSelection && a.getSelection();
          if (r && r.rangeCount !== 0) {
            a = r.anchorNode;
            var c = r.anchorOffset, u = r.focusNode;
            r = r.focusOffset;
            try {
              a.nodeType, u.nodeType;
            } catch {
              a = null;
              break e;
            }
            var x = 0, v = -1, j = -1, F = 0, U = 0, I = e, B = null;
            t: for (; ; ) {
              for (var V; I !== a || c !== 0 && I.nodeType !== 3 || (v = x + c), I !== u || r !== 0 && I.nodeType !== 3 || (j = x + r), I.nodeType === 3 && (x += I.nodeValue.length), (V = I.firstChild) !== null; )
                B = I, I = V;
              for (; ; ) {
                if (I === e) break t;
                if (B === a && ++F === c && (v = x), B === u && ++U === r && (j = x), (V = I.nextSibling) !== null) break;
                I = B, B = I.parentNode;
              }
              I = V;
            }
            a = v === -1 || j === -1 ? null : { start: v, end: j };
          } else a = null;
        }
      a = a || { start: 0, end: 0 };
    } else a = null;
    for (Td = { focusedElem: e, selectionRange: a }, So = !1, ht = t; ht !== null; )
      if (t = ht, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null)
        e.return = t, ht = e;
      else
        for (; ht !== null; ) {
          switch (t = ht, u = t.alternate, e = t.flags, t.tag) {
            case 0:
              if ((e & 4) !== 0 && (e = t.updateQueue, e = e !== null ? e.events : null, e !== null))
                for (a = 0; a < e.length; a++)
                  c = e[a], c.ref.impl = c.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((e & 1024) !== 0 && u !== null) {
                e = void 0, a = t, c = u.memoizedProps, u = u.memoizedState, r = a.stateNode;
                try {
                  var oe = bi(
                    a.type,
                    c
                  );
                  e = r.getSnapshotBeforeUpdate(
                    oe,
                    u
                  ), r.__reactInternalSnapshotBeforeUpdate = e;
                } catch (fe) {
                  He(
                    a,
                    a.return,
                    fe
                  );
                }
              }
              break;
            case 3:
              if ((e & 1024) !== 0) {
                if (e = t.stateNode.containerInfo, a = e.nodeType, a === 9)
                  Ed(e);
                else if (a === 1)
                  switch (e.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Ed(e);
                      break;
                    default:
                      e.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((e & 1024) !== 0) throw Error(o(163));
          }
          if (e = t.sibling, e !== null) {
            e.return = t.return, ht = e;
            break;
          }
          ht = t.return;
        }
  }
  function Sg(e, t, a) {
    var r = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        oa(e, a), r & 4 && xr(5, a);
        break;
      case 1:
        if (oa(e, a), r & 4)
          if (e = a.stateNode, t === null)
            try {
              e.componentDidMount();
            } catch (x) {
              He(a, a.return, x);
            }
          else {
            var c = bi(
              a.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              e.componentDidUpdate(
                c,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            } catch (x) {
              He(
                a,
                a.return,
                x
              );
            }
          }
        r & 64 && xg(a), r & 512 && yr(a, a.return);
        break;
      case 3:
        if (oa(e, a), r & 64 && (e = a.updateQueue, e !== null)) {
          if (t = null, a.child !== null)
            switch (a.child.tag) {
              case 27:
              case 5:
                t = a.child.stateNode;
                break;
              case 1:
                t = a.child.stateNode;
            }
          try {
            lp(e, t);
          } catch (x) {
            He(a, a.return, x);
          }
        }
        break;
      case 27:
        t === null && r & 4 && wg(a);
      case 26:
      case 5:
        oa(e, a), t === null && r & 4 && bg(a), r & 512 && yr(a, a.return);
        break;
      case 12:
        oa(e, a);
        break;
      case 31:
        oa(e, a), r & 4 && Ag(e, a);
        break;
      case 13:
        oa(e, a), r & 4 && Cg(e, a), r & 64 && (e = a.memoizedState, e !== null && (e = e.dehydrated, e !== null && (a = A2.bind(
          null,
          a
        ), Y2(e, a))));
        break;
      case 22:
        if (r = a.memoizedState !== null || ra, !r) {
          t = t !== null && t.memoizedState !== null || st, c = ra;
          var u = st;
          ra = r, (st = t) && !u ? ca(
            e,
            a,
            (a.subtreeFlags & 8772) !== 0
          ) : oa(e, a), ra = c, st = u;
        }
        break;
      case 30:
        break;
      default:
        oa(e, a);
    }
  }
  function Ng(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, Ng(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && Rc(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  var Xe = null, Ut = !1;
  function la(e, t, a) {
    for (a = a.child; a !== null; )
      Tg(e, t, a), a = a.sibling;
  }
  function Tg(e, t, a) {
    if (Mt && typeof Mt.onCommitFiberUnmount == "function")
      try {
        Mt.onCommitFiberUnmount(ni, a);
      } catch {
      }
    switch (a.tag) {
      case 26:
        st || Vn(a, t), la(
          e,
          t,
          a
        ), a.memoizedState ? a.memoizedState.count-- : a.stateNode && (a = a.stateNode, a.parentNode.removeChild(a));
        break;
      case 27:
        st || Vn(a, t);
        var r = Xe, c = Ut;
        Ba(a.type) && (Xe = a.stateNode, Ut = !1), la(
          e,
          t,
          a
        ), Cr(a.stateNode), Xe = r, Ut = c;
        break;
      case 5:
        st || Vn(a, t);
      case 6:
        if (r = Xe, c = Ut, Xe = null, la(
          e,
          t,
          a
        ), Xe = r, Ut = c, Xe !== null)
          if (Ut)
            try {
              (Xe.nodeType === 9 ? Xe.body : Xe.nodeName === "HTML" ? Xe.ownerDocument.body : Xe).removeChild(a.stateNode);
            } catch (u) {
              He(
                a,
                t,
                u
              );
            }
          else
            try {
              Xe.removeChild(a.stateNode);
            } catch (u) {
              He(
                a,
                t,
                u
              );
            }
        break;
      case 18:
        Xe !== null && (Ut ? (e = Xe, xx(
          e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
          a.stateNode
        ), Ss(e)) : xx(Xe, a.stateNode));
        break;
      case 4:
        r = Xe, c = Ut, Xe = a.stateNode.containerInfo, Ut = !0, la(
          e,
          t,
          a
        ), Xe = r, Ut = c;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Ma(2, a, t), st || Ma(4, a, t), la(
          e,
          t,
          a
        );
        break;
      case 1:
        st || (Vn(a, t), r = a.stateNode, typeof r.componentWillUnmount == "function" && yg(
          a,
          t,
          r
        )), la(
          e,
          t,
          a
        );
        break;
      case 21:
        la(
          e,
          t,
          a
        );
        break;
      case 22:
        st = (r = st) || a.memoizedState !== null, la(
          e,
          t,
          a
        ), st = r;
        break;
      default:
        la(
          e,
          t,
          a
        );
    }
  }
  function Ag(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        Ss(e);
      } catch (a) {
        He(t, t.return, a);
      }
    }
  }
  function Cg(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
      try {
        Ss(e);
      } catch (a) {
        He(t, t.return, a);
      }
  }
  function y2(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        return t === null && (t = e.stateNode = new jg()), t;
      case 22:
        return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new jg()), t;
      default:
        throw Error(o(435, e.tag));
    }
  }
  function no(e, t) {
    var a = y2(e);
    t.forEach(function(r) {
      if (!a.has(r)) {
        a.add(r);
        var c = C2.bind(null, e, r);
        r.then(c, c);
      }
    });
  }
  function Lt(e, t) {
    var a = t.deletions;
    if (a !== null)
      for (var r = 0; r < a.length; r++) {
        var c = a[r], u = e, x = t, v = x;
        e: for (; v !== null; ) {
          switch (v.tag) {
            case 27:
              if (Ba(v.type)) {
                Xe = v.stateNode, Ut = !1;
                break e;
              }
              break;
            case 5:
              Xe = v.stateNode, Ut = !1;
              break e;
            case 3:
            case 4:
              Xe = v.stateNode.containerInfo, Ut = !0;
              break e;
          }
          v = v.return;
        }
        if (Xe === null) throw Error(o(160));
        Tg(u, x, c), Xe = null, Ut = !1, u = c.alternate, u !== null && (u.return = null), c.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        Eg(t, e), t = t.sibling;
  }
  var Cn = null;
  function Eg(e, t) {
    var a = e.alternate, r = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Lt(t, e), Pt(e), r & 4 && (Ma(3, e, e.return), xr(3, e), Ma(5, e, e.return));
        break;
      case 1:
        Lt(t, e), Pt(e), r & 512 && (st || a === null || Vn(a, a.return)), r & 64 && ra && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (a = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = a === null ? r : a.concat(r))));
        break;
      case 26:
        var c = Cn;
        if (Lt(t, e), Pt(e), r & 512 && (st || a === null || Vn(a, a.return)), r & 4) {
          var u = a !== null ? a.memoizedState : null;
          if (r = e.memoizedState, a === null)
            if (r === null)
              if (e.stateNode === null) {
                e: {
                  r = e.type, a = e.memoizedProps, c = c.ownerDocument || c;
                  t: switch (r) {
                    case "title":
                      u = c.getElementsByTagName("title")[0], (!u || u[Gs] || u[mt] || u.namespaceURI === "http://www.w3.org/2000/svg" || u.hasAttribute("itemprop")) && (u = c.createElement(r), c.head.insertBefore(
                        u,
                        c.querySelector("head > title")
                      )), yt(u, r, a), u[mt] = e, dt(u), r = u;
                      break e;
                    case "link":
                      var x = Ex(
                        "link",
                        "href",
                        c
                      ).get(r + (a.href || ""));
                      if (x) {
                        for (var v = 0; v < x.length; v++)
                          if (u = x[v], u.getAttribute("href") === (a.href == null || a.href === "" ? null : a.href) && u.getAttribute("rel") === (a.rel == null ? null : a.rel) && u.getAttribute("title") === (a.title == null ? null : a.title) && u.getAttribute("crossorigin") === (a.crossOrigin == null ? null : a.crossOrigin)) {
                            x.splice(v, 1);
                            break t;
                          }
                      }
                      u = c.createElement(r), yt(u, r, a), c.head.appendChild(u);
                      break;
                    case "meta":
                      if (x = Ex(
                        "meta",
                        "content",
                        c
                      ).get(r + (a.content || ""))) {
                        for (v = 0; v < x.length; v++)
                          if (u = x[v], u.getAttribute("content") === (a.content == null ? null : "" + a.content) && u.getAttribute("name") === (a.name == null ? null : a.name) && u.getAttribute("property") === (a.property == null ? null : a.property) && u.getAttribute("http-equiv") === (a.httpEquiv == null ? null : a.httpEquiv) && u.getAttribute("charset") === (a.charSet == null ? null : a.charSet)) {
                            x.splice(v, 1);
                            break t;
                          }
                      }
                      u = c.createElement(r), yt(u, r, a), c.head.appendChild(u);
                      break;
                    default:
                      throw Error(o(468, r));
                  }
                  u[mt] = e, dt(u), r = u;
                }
                e.stateNode = r;
              } else
                kx(
                  c,
                  e.type,
                  e.stateNode
                );
            else
              e.stateNode = Cx(
                c,
                r,
                e.memoizedProps
              );
          else
            u !== r ? (u === null ? a.stateNode !== null && (a = a.stateNode, a.parentNode.removeChild(a)) : u.count--, r === null ? kx(
              c,
              e.type,
              e.stateNode
            ) : Cx(
              c,
              r,
              e.memoizedProps
            )) : r === null && e.stateNode !== null && ed(
              e,
              e.memoizedProps,
              a.memoizedProps
            );
        }
        break;
      case 27:
        Lt(t, e), Pt(e), r & 512 && (st || a === null || Vn(a, a.return)), a !== null && r & 4 && ed(
          e,
          e.memoizedProps,
          a.memoizedProps
        );
        break;
      case 5:
        if (Lt(t, e), Pt(e), r & 512 && (st || a === null || Vn(a, a.return)), e.flags & 32) {
          c = e.stateNode;
          try {
            Yi(c, "");
          } catch (oe) {
            He(e, e.return, oe);
          }
        }
        r & 4 && e.stateNode != null && (c = e.memoizedProps, ed(
          e,
          c,
          a !== null ? a.memoizedProps : c
        )), r & 1024 && (ad = !0);
        break;
      case 6:
        if (Lt(t, e), Pt(e), r & 4) {
          if (e.stateNode === null)
            throw Error(o(162));
          r = e.memoizedProps, a = e.stateNode;
          try {
            a.nodeValue = r;
          } catch (oe) {
            He(e, e.return, oe);
          }
        }
        break;
      case 3:
        if (bo = null, c = Cn, Cn = xo(t.containerInfo), Lt(t, e), Cn = c, Pt(e), r & 4 && a !== null && a.memoizedState.isDehydrated)
          try {
            Ss(t.containerInfo);
          } catch (oe) {
            He(e, e.return, oe);
          }
        ad && (ad = !1, kg(e));
        break;
      case 4:
        r = Cn, Cn = xo(
          e.stateNode.containerInfo
        ), Lt(t, e), Pt(e), Cn = r;
        break;
      case 12:
        Lt(t, e), Pt(e);
        break;
      case 31:
        Lt(t, e), Pt(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, no(e, r)));
        break;
      case 13:
        Lt(t, e), Pt(e), e.child.flags & 8192 && e.memoizedState !== null != (a !== null && a.memoizedState !== null) && (io = kt()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, no(e, r)));
        break;
      case 22:
        c = e.memoizedState !== null;
        var j = a !== null && a.memoizedState !== null, F = ra, U = st;
        if (ra = F || c, st = U || j, Lt(t, e), st = U, ra = F, Pt(e), r & 8192)
          e: for (t = e.stateNode, t._visibility = c ? t._visibility & -2 : t._visibility | 1, c && (a === null || j || ra || st || vi(e)), a = null, t = e; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (a === null) {
                j = a = t;
                try {
                  if (u = j.stateNode, c)
                    x = u.style, typeof x.setProperty == "function" ? x.setProperty("display", "none", "important") : x.display = "none";
                  else {
                    v = j.stateNode;
                    var I = j.memoizedProps.style, B = I != null && I.hasOwnProperty("display") ? I.display : null;
                    v.style.display = B == null || typeof B == "boolean" ? "" : ("" + B).trim();
                  }
                } catch (oe) {
                  He(j, j.return, oe);
                }
              }
            } else if (t.tag === 6) {
              if (a === null) {
                j = t;
                try {
                  j.stateNode.nodeValue = c ? "" : j.memoizedProps;
                } catch (oe) {
                  He(j, j.return, oe);
                }
              }
            } else if (t.tag === 18) {
              if (a === null) {
                j = t;
                try {
                  var V = j.stateNode;
                  c ? yx(V, !0) : yx(j.stateNode, !1);
                } catch (oe) {
                  He(j, j.return, oe);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === e) break e;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) break e;
              a === t && (a = null), t = t.return;
            }
            a === t && (a = null), t.sibling.return = t.return, t = t.sibling;
          }
        r & 4 && (r = e.updateQueue, r !== null && (a = r.retryQueue, a !== null && (r.retryQueue = null, no(e, a))));
        break;
      case 19:
        Lt(t, e), Pt(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, no(e, r)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Lt(t, e), Pt(e);
    }
  }
  function Pt(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        for (var a, r = e.return; r !== null; ) {
          if (vg(r)) {
            a = r;
            break;
          }
          r = r.return;
        }
        if (a == null) throw Error(o(160));
        switch (a.tag) {
          case 27:
            var c = a.stateNode, u = td(e);
            to(e, u, c);
            break;
          case 5:
            var x = a.stateNode;
            a.flags & 32 && (Yi(x, ""), a.flags &= -33);
            var v = td(e);
            to(e, v, x);
            break;
          case 3:
          case 4:
            var j = a.stateNode.containerInfo, F = td(e);
            nd(
              e,
              F,
              j
            );
            break;
          default:
            throw Error(o(161));
        }
      } catch (U) {
        He(e, e.return, U);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function kg(e) {
    if (e.subtreeFlags & 1024)
      for (e = e.child; e !== null; ) {
        var t = e;
        kg(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
      }
  }
  function oa(e, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        Sg(e, t.alternate, t), t = t.sibling;
  }
  function vi(e) {
    for (e = e.child; e !== null; ) {
      var t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ma(4, t, t.return), vi(t);
          break;
        case 1:
          Vn(t, t.return);
          var a = t.stateNode;
          typeof a.componentWillUnmount == "function" && yg(
            t,
            t.return,
            a
          ), vi(t);
          break;
        case 27:
          Cr(t.stateNode);
        case 26:
        case 5:
          Vn(t, t.return), vi(t);
          break;
        case 22:
          t.memoizedState === null && vi(t);
          break;
        case 30:
          vi(t);
          break;
        default:
          vi(t);
      }
      e = e.sibling;
    }
  }
  function ca(e, t, a) {
    for (a = a && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var r = t.alternate, c = e, u = t, x = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          ca(
            c,
            u,
            a
          ), xr(4, u);
          break;
        case 1:
          if (ca(
            c,
            u,
            a
          ), r = u, c = r.stateNode, typeof c.componentDidMount == "function")
            try {
              c.componentDidMount();
            } catch (F) {
              He(r, r.return, F);
            }
          if (r = u, c = r.updateQueue, c !== null) {
            var v = r.stateNode;
            try {
              var j = c.shared.hiddenCallbacks;
              if (j !== null)
                for (c.shared.hiddenCallbacks = null, c = 0; c < j.length; c++)
                  rp(j[c], v);
            } catch (F) {
              He(r, r.return, F);
            }
          }
          a && x & 64 && xg(u), yr(u, u.return);
          break;
        case 27:
          wg(u);
        case 26:
        case 5:
          ca(
            c,
            u,
            a
          ), a && r === null && x & 4 && bg(u), yr(u, u.return);
          break;
        case 12:
          ca(
            c,
            u,
            a
          );
          break;
        case 31:
          ca(
            c,
            u,
            a
          ), a && x & 4 && Ag(c, u);
          break;
        case 13:
          ca(
            c,
            u,
            a
          ), a && x & 4 && Cg(c, u);
          break;
        case 22:
          u.memoizedState === null && ca(
            c,
            u,
            a
          ), yr(u, u.return);
          break;
        case 30:
          break;
        default:
          ca(
            c,
            u,
            a
          );
      }
      t = t.sibling;
    }
  }
  function id(e, t) {
    var a = null;
    e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== a && (e != null && e.refCount++, a != null && ir(a));
  }
  function sd(e, t) {
    e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ir(e));
  }
  function En(e, t, a, r) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        Mg(
          e,
          t,
          a,
          r
        ), t = t.sibling;
  }
  function Mg(e, t, a, r) {
    var c = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        En(
          e,
          t,
          a,
          r
        ), c & 2048 && xr(9, t);
        break;
      case 1:
        En(
          e,
          t,
          a,
          r
        );
        break;
      case 3:
        En(
          e,
          t,
          a,
          r
        ), c & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ir(e)));
        break;
      case 12:
        if (c & 2048) {
          En(
            e,
            t,
            a,
            r
          ), e = t.stateNode;
          try {
            var u = t.memoizedProps, x = u.id, v = u.onPostCommit;
            typeof v == "function" && v(
              x,
              t.alternate === null ? "mount" : "update",
              e.passiveEffectDuration,
              -0
            );
          } catch (j) {
            He(t, t.return, j);
          }
        } else
          En(
            e,
            t,
            a,
            r
          );
        break;
      case 31:
        En(
          e,
          t,
          a,
          r
        );
        break;
      case 13:
        En(
          e,
          t,
          a,
          r
        );
        break;
      case 23:
        break;
      case 22:
        u = t.stateNode, x = t.alternate, t.memoizedState !== null ? u._visibility & 2 ? En(
          e,
          t,
          a,
          r
        ) : br(e, t) : u._visibility & 2 ? En(
          e,
          t,
          a,
          r
        ) : (u._visibility |= 2, hs(
          e,
          t,
          a,
          r,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), c & 2048 && id(x, t);
        break;
      case 24:
        En(
          e,
          t,
          a,
          r
        ), c & 2048 && sd(t.alternate, t);
        break;
      default:
        En(
          e,
          t,
          a,
          r
        );
    }
  }
  function hs(e, t, a, r, c) {
    for (c = c && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var u = e, x = t, v = a, j = r, F = x.flags;
      switch (x.tag) {
        case 0:
        case 11:
        case 15:
          hs(
            u,
            x,
            v,
            j,
            c
          ), xr(8, x);
          break;
        case 23:
          break;
        case 22:
          var U = x.stateNode;
          x.memoizedState !== null ? U._visibility & 2 ? hs(
            u,
            x,
            v,
            j,
            c
          ) : br(
            u,
            x
          ) : (U._visibility |= 2, hs(
            u,
            x,
            v,
            j,
            c
          )), c && F & 2048 && id(
            x.alternate,
            x
          );
          break;
        case 24:
          hs(
            u,
            x,
            v,
            j,
            c
          ), c && F & 2048 && sd(x.alternate, x);
          break;
        default:
          hs(
            u,
            x,
            v,
            j,
            c
          );
      }
      t = t.sibling;
    }
  }
  function br(e, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var a = e, r = t, c = r.flags;
        switch (r.tag) {
          case 22:
            br(a, r), c & 2048 && id(
              r.alternate,
              r
            );
            break;
          case 24:
            br(a, r), c & 2048 && sd(r.alternate, r);
            break;
          default:
            br(a, r);
        }
        t = t.sibling;
      }
  }
  var vr = 8192;
  function fs(e, t, a) {
    if (e.subtreeFlags & vr)
      for (e = e.child; e !== null; )
        zg(
          e,
          t,
          a
        ), e = e.sibling;
  }
  function zg(e, t, a) {
    switch (e.tag) {
      case 26:
        fs(
          e,
          t,
          a
        ), e.flags & vr && e.memoizedState !== null && ij(
          a,
          Cn,
          e.memoizedState,
          e.memoizedProps
        );
        break;
      case 5:
        fs(
          e,
          t,
          a
        );
        break;
      case 3:
      case 4:
        var r = Cn;
        Cn = xo(e.stateNode.containerInfo), fs(
          e,
          t,
          a
        ), Cn = r;
        break;
      case 22:
        e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = vr, vr = 16777216, fs(
          e,
          t,
          a
        ), vr = r) : fs(
          e,
          t,
          a
        ));
        break;
      default:
        fs(
          e,
          t,
          a
        );
    }
  }
  function Og(e) {
    var t = e.alternate;
    if (t !== null && (e = t.child, e !== null)) {
      t.child = null;
      do
        t = e.sibling, e.sibling = null, e = t;
      while (e !== null);
    }
  }
  function wr(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          ht = r, _g(
            r,
            e
          );
        }
      Og(e);
    }
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        Rg(e), e = e.sibling;
  }
  function Rg(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        wr(e), e.flags & 2048 && Ma(9, e, e.return);
        break;
      case 3:
        wr(e);
        break;
      case 12:
        wr(e);
        break;
      case 22:
        var t = e.stateNode;
        e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, ao(e)) : wr(e);
        break;
      default:
        wr(e);
    }
  }
  function ao(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          ht = r, _g(
            r,
            e
          );
        }
      Og(e);
    }
    for (e = e.child; e !== null; ) {
      switch (t = e, t.tag) {
        case 0:
        case 11:
        case 15:
          Ma(8, t, t.return), ao(t);
          break;
        case 22:
          a = t.stateNode, a._visibility & 2 && (a._visibility &= -3, ao(t));
          break;
        default:
          ao(t);
      }
      e = e.sibling;
    }
  }
  function _g(e, t) {
    for (; ht !== null; ) {
      var a = ht;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          Ma(8, a, t);
          break;
        case 23:
        case 22:
          if (a.memoizedState !== null && a.memoizedState.cachePool !== null) {
            var r = a.memoizedState.cachePool.pool;
            r != null && r.refCount++;
          }
          break;
        case 24:
          ir(a.memoizedState.cache);
      }
      if (r = a.child, r !== null) r.return = a, ht = r;
      else
        e: for (a = e; ht !== null; ) {
          r = ht;
          var c = r.sibling, u = r.return;
          if (Ng(r), r === a) {
            ht = null;
            break e;
          }
          if (c !== null) {
            c.return = u, ht = c;
            break e;
          }
          ht = u;
        }
    }
  }
  var b2 = {
    getCacheForType: function(e) {
      var t = gt(nt), a = t.data.get(e);
      return a === void 0 && (a = e(), t.data.set(e, a)), a;
    },
    cacheSignal: function() {
      return gt(nt).controller.signal;
    }
  }, v2 = typeof WeakMap == "function" ? WeakMap : Map, De = 0, Ie = null, Te = null, Ce = 0, Ve = 0, Jt = null, za = !1, ms = !1, rd = !1, ua = 0, We = 0, Oa = 0, wi = 0, ld = 0, en = 0, ps = 0, jr = null, It = null, od = !1, io = 0, Dg = 0, so = 1 / 0, ro = null, Ra = null, lt = 0, _a = null, gs = null, da = 0, cd = 0, ud = null, Fg = null, Sr = 0, dd = null;
  function tn() {
    return (De & 2) !== 0 && Ce !== 0 ? Ce & -Ce : O.T !== null ? xd() : zc();
  }
  function Bg() {
    if (en === 0)
      if ((Ce & 536870912) === 0 || Me) {
        var e = Vi;
        Vi <<= 1, (Vi & 3932160) === 0 && (Vi = 262144), en = e;
      } else en = 536870912;
    return e = $t.current, e !== null && (e.flags |= 32), en;
  }
  function qt(e, t, a) {
    (e === Ie && (Ve === 2 || Ve === 9) || e.cancelPendingCommit !== null) && (xs(e, 0), Da(
      e,
      Ce,
      en,
      !1
    )), Ke(e, a), ((De & 2) === 0 || e !== Ie) && (e === Ie && ((De & 2) === 0 && (wi |= a), We === 4 && Da(
      e,
      Ce,
      en,
      !1
    )), Hn(e));
  }
  function Vg(e, t, a) {
    if ((De & 6) !== 0) throw Error(o(327));
    var r = !a && (t & 127) === 0 && (t & e.expiredLanes) === 0 || Ze(e, t), c = r ? S2(e, t) : fd(e, t, !0), u = r;
    do {
      if (c === 0) {
        ms && !r && Da(e, t, 0, !1);
        break;
      } else {
        if (a = e.current.alternate, u && !w2(a)) {
          c = fd(e, t, !1), u = !1;
          continue;
        }
        if (c === 2) {
          if (u = t, e.errorRecoveryDisabledLanes & u)
            var x = 0;
          else
            x = e.pendingLanes & -536870913, x = x !== 0 ? x : x & 536870912 ? 536870912 : 0;
          if (x !== 0) {
            t = x;
            e: {
              var v = e;
              c = jr;
              var j = v.current.memoizedState.isDehydrated;
              if (j && (xs(v, x).flags |= 256), x = fd(
                v,
                x,
                !1
              ), x !== 2) {
                if (rd && !j) {
                  v.errorRecoveryDisabledLanes |= u, wi |= u, c = 4;
                  break e;
                }
                u = It, It = c, u !== null && (It === null ? It = u : It.push.apply(
                  It,
                  u
                ));
              }
              c = x;
            }
            if (u = !1, c !== 2) continue;
          }
        }
        if (c === 1) {
          xs(e, 0), Da(e, t, 0, !0);
          break;
        }
        e: {
          switch (r = e, u = c, u) {
            case 0:
            case 1:
              throw Error(o(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              Da(
                r,
                t,
                en,
                !za
              );
              break e;
            case 2:
              It = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(o(329));
          }
          if ((t & 62914560) === t && (c = io + 300 - kt(), 10 < c)) {
            if (Da(
              r,
              t,
              en,
              !za
            ), ge(r, 0, !0) !== 0) break e;
            da = t, r.timeoutHandle = px(
              Hg.bind(
                null,
                r,
                a,
                It,
                ro,
                od,
                t,
                en,
                wi,
                ps,
                za,
                u,
                "Throttled",
                -0,
                0
              ),
              c
            );
            break e;
          }
          Hg(
            r,
            a,
            It,
            ro,
            od,
            t,
            en,
            wi,
            ps,
            za,
            u,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Hn(e);
  }
  function Hg(e, t, a, r, c, u, x, v, j, F, U, I, B, V) {
    if (e.timeoutHandle = -1, I = t.subtreeFlags, I & 8192 || (I & 16785408) === 16785408) {
      I = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Kn
      }, zg(
        t,
        u,
        I
      );
      var oe = (u & 62914560) === u ? io - kt() : (u & 4194048) === u ? Dg - kt() : 0;
      if (oe = sj(
        I,
        oe
      ), oe !== null) {
        da = u, e.cancelPendingCommit = oe(
          Qg.bind(
            null,
            e,
            t,
            u,
            a,
            r,
            c,
            x,
            v,
            j,
            U,
            I,
            null,
            B,
            V
          )
        ), Da(e, u, x, !F);
        return;
      }
    }
    Qg(
      e,
      t,
      u,
      a,
      r,
      c,
      x,
      v,
      j
    );
  }
  function w2(e) {
    for (var t = e; ; ) {
      var a = t.tag;
      if ((a === 0 || a === 11 || a === 15) && t.flags & 16384 && (a = t.updateQueue, a !== null && (a = a.stores, a !== null)))
        for (var r = 0; r < a.length; r++) {
          var c = a[r], u = c.getSnapshot;
          c = c.value;
          try {
            if (!Xt(u(), c)) return !1;
          } catch {
            return !1;
          }
        }
      if (a = t.child, t.subtreeFlags & 16384 && a !== null)
        a.return = t, t = a;
      else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function Da(e, t, a, r) {
    t &= ~ld, t &= ~wi, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
    for (var c = t; 0 < c; ) {
      var u = 31 - jt(c), x = 1 << u;
      r[u] = -1, c &= ~x;
    }
    a !== 0 && ii(e, a, t);
  }
  function lo() {
    return (De & 6) === 0 ? (Nr(0), !1) : !0;
  }
  function hd() {
    if (Te !== null) {
      if (Ve === 0)
        var e = Te.return;
      else
        e = Te, ea = hi = null, Eu(e), ls = null, rr = 0, e = Te;
      for (; e !== null; )
        gg(e.alternate, e), e = e.return;
      Te = null;
    }
  }
  function xs(e, t) {
    var a = e.timeoutHandle;
    a !== -1 && (e.timeoutHandle = -1, L2(a)), a = e.cancelPendingCommit, a !== null && (e.cancelPendingCommit = null, a()), da = 0, hd(), Ie = e, Te = a = Wn(e.current, null), Ce = t, Ve = 0, Jt = null, za = !1, ms = Ze(e, t), rd = !1, ps = en = ld = wi = Oa = We = 0, It = jr = null, od = !1, (t & 8) !== 0 && (t |= t & 32);
    var r = e.entangledLanes;
    if (r !== 0)
      for (e = e.entanglements, r &= t; 0 < r; ) {
        var c = 31 - jt(r), u = 1 << c;
        t |= e[c], r &= ~u;
      }
    return ua = t, El(), a;
  }
  function Ug(e, t) {
    we = null, O.H = mr, t === rs || t === Fl ? (t = np(), Ve = 3) : t === gu ? (t = np(), Ve = 4) : Ve = t === qu ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, Jt = t, Te === null && (We = 1, Kl(
      e,
      hn(t, e.current)
    ));
  }
  function Lg() {
    var e = $t.current;
    return e === null ? !0 : (Ce & 4194048) === Ce ? gn === null : (Ce & 62914560) === Ce || (Ce & 536870912) !== 0 ? e === gn : !1;
  }
  function Pg() {
    var e = O.H;
    return O.H = mr, e === null ? mr : e;
  }
  function Ig() {
    var e = O.A;
    return O.A = b2, e;
  }
  function oo() {
    We = 4, za || (Ce & 4194048) !== Ce && $t.current !== null || (ms = !0), (Oa & 134217727) === 0 && (wi & 134217727) === 0 || Ie === null || Da(
      Ie,
      Ce,
      en,
      !1
    );
  }
  function fd(e, t, a) {
    var r = De;
    De |= 2;
    var c = Pg(), u = Ig();
    (Ie !== e || Ce !== t) && (ro = null, xs(e, t)), t = !1;
    var x = We;
    e: do
      try {
        if (Ve !== 0 && Te !== null) {
          var v = Te, j = Jt;
          switch (Ve) {
            case 8:
              hd(), x = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              $t.current === null && (t = !0);
              var F = Ve;
              if (Ve = 0, Jt = null, ys(e, v, j, F), a && ms) {
                x = 0;
                break e;
              }
              break;
            default:
              F = Ve, Ve = 0, Jt = null, ys(e, v, j, F);
          }
        }
        j2(), x = We;
        break;
      } catch (U) {
        Ug(e, U);
      }
    while (!0);
    return t && e.shellSuspendCounter++, ea = hi = null, De = r, O.H = c, O.A = u, Te === null && (Ie = null, Ce = 0, El()), x;
  }
  function j2() {
    for (; Te !== null; ) qg(Te);
  }
  function S2(e, t) {
    var a = De;
    De |= 2;
    var r = Pg(), c = Ig();
    Ie !== e || Ce !== t ? (ro = null, so = kt() + 500, xs(e, t)) : ms = Ze(
      e,
      t
    );
    e: do
      try {
        if (Ve !== 0 && Te !== null) {
          t = Te;
          var u = Jt;
          t: switch (Ve) {
            case 1:
              Ve = 0, Jt = null, ys(e, t, u, 1);
              break;
            case 2:
            case 9:
              if (ep(u)) {
                Ve = 0, Jt = null, Gg(t);
                break;
              }
              t = function() {
                Ve !== 2 && Ve !== 9 || Ie !== e || (Ve = 7), Hn(e);
              }, u.then(t, t);
              break e;
            case 3:
              Ve = 7;
              break e;
            case 4:
              Ve = 5;
              break e;
            case 7:
              ep(u) ? (Ve = 0, Jt = null, Gg(t)) : (Ve = 0, Jt = null, ys(e, t, u, 7));
              break;
            case 5:
              var x = null;
              switch (Te.tag) {
                case 26:
                  x = Te.memoizedState;
                case 5:
                case 27:
                  var v = Te;
                  if (x ? Mx(x) : v.stateNode.complete) {
                    Ve = 0, Jt = null;
                    var j = v.sibling;
                    if (j !== null) Te = j;
                    else {
                      var F = v.return;
                      F !== null ? (Te = F, co(F)) : Te = null;
                    }
                    break t;
                  }
              }
              Ve = 0, Jt = null, ys(e, t, u, 5);
              break;
            case 6:
              Ve = 0, Jt = null, ys(e, t, u, 6);
              break;
            case 8:
              hd(), We = 6;
              break e;
            default:
              throw Error(o(462));
          }
        }
        N2();
        break;
      } catch (U) {
        Ug(e, U);
      }
    while (!0);
    return ea = hi = null, O.H = r, O.A = c, De = a, Te !== null ? 0 : (Ie = null, Ce = 0, El(), We);
  }
  function N2() {
    for (; Te !== null && !Et(); )
      qg(Te);
  }
  function qg(e) {
    var t = mg(e.alternate, e, ua);
    e.memoizedProps = e.pendingProps, t === null ? co(e) : Te = t;
  }
  function Gg(e) {
    var t = e, a = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = og(
          a,
          t,
          t.pendingProps,
          t.type,
          void 0,
          Ce
        );
        break;
      case 11:
        t = og(
          a,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          Ce
        );
        break;
      case 5:
        Eu(t);
      default:
        gg(a, t), t = Te = Im(t, ua), t = mg(a, t, ua);
    }
    e.memoizedProps = e.pendingProps, t === null ? co(e) : Te = t;
  }
  function ys(e, t, a, r) {
    ea = hi = null, Eu(t), ls = null, rr = 0;
    var c = t.return;
    try {
      if (h2(
        e,
        c,
        t,
        a,
        Ce
      )) {
        We = 1, Kl(
          e,
          hn(a, e.current)
        ), Te = null;
        return;
      }
    } catch (u) {
      if (c !== null) throw Te = c, u;
      We = 1, Kl(
        e,
        hn(a, e.current)
      ), Te = null;
      return;
    }
    t.flags & 32768 ? (Me || r === 1 ? e = !0 : ms || (Ce & 536870912) !== 0 ? e = !1 : (za = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = $t.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Yg(t, e)) : co(t);
  }
  function co(e) {
    var t = e;
    do {
      if ((t.flags & 32768) !== 0) {
        Yg(
          t,
          za
        );
        return;
      }
      e = t.return;
      var a = p2(
        t.alternate,
        t,
        ua
      );
      if (a !== null) {
        Te = a;
        return;
      }
      if (t = t.sibling, t !== null) {
        Te = t;
        return;
      }
      Te = t = e;
    } while (t !== null);
    We === 0 && (We = 5);
  }
  function Yg(e, t) {
    do {
      var a = g2(e.alternate, e);
      if (a !== null) {
        a.flags &= 32767, Te = a;
        return;
      }
      if (a = e.return, a !== null && (a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null), !t && (e = e.sibling, e !== null)) {
        Te = e;
        return;
      }
      Te = e = a;
    } while (e !== null);
    We = 6, Te = null;
  }
  function Qg(e, t, a, r, c, u, x, v, j) {
    e.cancelPendingCommit = null;
    do
      uo();
    while (lt !== 0);
    if ((De & 6) !== 0) throw Error(o(327));
    if (t !== null) {
      if (t === e.current) throw Error(o(177));
      if (u = t.lanes | t.childLanes, u |= tu, Dt(
        e,
        a,
        u,
        x,
        v,
        j
      ), e === Ie && (Te = Ie = null, Ce = 0), gs = t, _a = e, da = a, cd = u, ud = c, Fg = r, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, E2(ti, function() {
        return Wg(), null;
      })) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || r) {
        r = O.T, O.T = null, c = X.p, X.p = 2, x = De, De |= 4;
        try {
          x2(e, t, a);
        } finally {
          De = x, X.p = c, O.T = r;
        }
      }
      lt = 1, Zg(), Xg(), Kg();
    }
  }
  function Zg() {
    if (lt === 1) {
      lt = 0;
      var e = _a, t = gs, a = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || a) {
        a = O.T, O.T = null;
        var r = X.p;
        X.p = 2;
        var c = De;
        De |= 4;
        try {
          Eg(t, e);
          var u = Td, x = _m(e.containerInfo), v = u.focusedElem, j = u.selectionRange;
          if (x !== v && v && v.ownerDocument && Rm(
            v.ownerDocument.documentElement,
            v
          )) {
            if (j !== null && Kc(v)) {
              var F = j.start, U = j.end;
              if (U === void 0 && (U = F), "selectionStart" in v)
                v.selectionStart = F, v.selectionEnd = Math.min(
                  U,
                  v.value.length
                );
              else {
                var I = v.ownerDocument || document, B = I && I.defaultView || window;
                if (B.getSelection) {
                  var V = B.getSelection(), oe = v.textContent.length, fe = Math.min(j.start, oe), Pe = j.end === void 0 ? fe : Math.min(j.end, oe);
                  !V.extend && fe > Pe && (x = Pe, Pe = fe, fe = x);
                  var M = Om(
                    v,
                    fe
                  ), A = Om(
                    v,
                    Pe
                  );
                  if (M && A && (V.rangeCount !== 1 || V.anchorNode !== M.node || V.anchorOffset !== M.offset || V.focusNode !== A.node || V.focusOffset !== A.offset)) {
                    var D = I.createRange();
                    D.setStart(M.node, M.offset), V.removeAllRanges(), fe > Pe ? (V.addRange(D), V.extend(A.node, A.offset)) : (D.setEnd(A.node, A.offset), V.addRange(D));
                  }
                }
              }
            }
            for (I = [], V = v; V = V.parentNode; )
              V.nodeType === 1 && I.push({
                element: V,
                left: V.scrollLeft,
                top: V.scrollTop
              });
            for (typeof v.focus == "function" && v.focus(), v = 0; v < I.length; v++) {
              var P = I[v];
              P.element.scrollLeft = P.left, P.element.scrollTop = P.top;
            }
          }
          So = !!Nd, Td = Nd = null;
        } finally {
          De = c, X.p = r, O.T = a;
        }
      }
      e.current = t, lt = 2;
    }
  }
  function Xg() {
    if (lt === 2) {
      lt = 0;
      var e = _a, t = gs, a = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || a) {
        a = O.T, O.T = null;
        var r = X.p;
        X.p = 2;
        var c = De;
        De |= 4;
        try {
          Sg(e, t.alternate, t);
        } finally {
          De = c, X.p = r, O.T = a;
        }
      }
      lt = 3;
    }
  }
  function Kg() {
    if (lt === 4 || lt === 3) {
      lt = 0, ga();
      var e = _a, t = gs, a = da, r = Fg;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? lt = 5 : (lt = 0, gs = _a = null, $g(e, e.pendingLanes));
      var c = e.pendingLanes;
      if (c === 0 && (Ra = null), Tn(a), t = t.stateNode, Mt && typeof Mt.onCommitFiberRoot == "function")
        try {
          Mt.onCommitFiberRoot(
            ni,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (r !== null) {
        t = O.T, c = X.p, X.p = 2, O.T = null;
        try {
          for (var u = e.onRecoverableError, x = 0; x < r.length; x++) {
            var v = r[x];
            u(v.value, {
              componentStack: v.stack
            });
          }
        } finally {
          O.T = t, X.p = c;
        }
      }
      (da & 3) !== 0 && uo(), Hn(e), c = e.pendingLanes, (a & 261930) !== 0 && (c & 42) !== 0 ? e === dd ? Sr++ : (Sr = 0, dd = e) : Sr = 0, Nr(0);
    }
  }
  function $g(e, t) {
    (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, ir(t)));
  }
  function uo() {
    return Zg(), Xg(), Kg(), Wg();
  }
  function Wg() {
    if (lt !== 5) return !1;
    var e = _a, t = cd;
    cd = 0;
    var a = Tn(da), r = O.T, c = X.p;
    try {
      X.p = 32 > a ? 32 : a, O.T = null, a = ud, ud = null;
      var u = _a, x = da;
      if (lt = 0, gs = _a = null, da = 0, (De & 6) !== 0) throw Error(o(331));
      var v = De;
      if (De |= 4, Rg(u.current), Mg(
        u,
        u.current,
        x,
        a
      ), De = v, Nr(0, !1), Mt && typeof Mt.onPostCommitFiberRoot == "function")
        try {
          Mt.onPostCommitFiberRoot(ni, u);
        } catch {
        }
      return !0;
    } finally {
      X.p = c, O.T = r, $g(e, t);
    }
  }
  function Jg(e, t, a) {
    t = hn(a, t), t = Iu(e.stateNode, t, 2), e = Ca(e, t, 2), e !== null && (Ke(e, 2), Hn(e));
  }
  function He(e, t, a) {
    if (e.tag === 3)
      Jg(e, e, a);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          Jg(
            t,
            e,
            a
          );
          break;
        } else if (t.tag === 1) {
          var r = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (Ra === null || !Ra.has(r))) {
            e = hn(a, e), a = eg(2), r = Ca(t, a, 2), r !== null && (tg(
              a,
              r,
              t,
              e
            ), Ke(r, 2), Hn(r));
            break;
          }
        }
        t = t.return;
      }
  }
  function md(e, t, a) {
    var r = e.pingCache;
    if (r === null) {
      r = e.pingCache = new v2();
      var c = /* @__PURE__ */ new Set();
      r.set(t, c);
    } else
      c = r.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), r.set(t, c));
    c.has(a) || (rd = !0, c.add(a), e = T2.bind(null, e, t, a), t.then(e, e));
  }
  function T2(e, t, a) {
    var r = e.pingCache;
    r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & a, e.warmLanes &= ~a, Ie === e && (Ce & a) === a && (We === 4 || We === 3 && (Ce & 62914560) === Ce && 300 > kt() - io ? (De & 2) === 0 && xs(e, 0) : ld |= a, ps === Ce && (ps = 0)), Hn(e);
  }
  function ex(e, t) {
    t === 0 && (t = St()), e = ci(e, t), e !== null && (Ke(e, t), Hn(e));
  }
  function A2(e) {
    var t = e.memoizedState, a = 0;
    t !== null && (a = t.retryLane), ex(e, a);
  }
  function C2(e, t) {
    var a = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var r = e.stateNode, c = e.memoizedState;
        c !== null && (a = c.retryLane);
        break;
      case 19:
        r = e.stateNode;
        break;
      case 22:
        r = e.stateNode._retryCache;
        break;
      default:
        throw Error(o(314));
    }
    r !== null && r.delete(t), ex(e, a);
  }
  function E2(e, t) {
    return Ls(e, t);
  }
  var ho = null, bs = null, pd = !1, fo = !1, gd = !1, Fa = 0;
  function Hn(e) {
    e !== bs && e.next === null && (bs === null ? ho = bs = e : bs = bs.next = e), fo = !0, pd || (pd = !0, M2());
  }
  function Nr(e, t) {
    if (!gd && fo) {
      gd = !0;
      do
        for (var a = !1, r = ho; r !== null; ) {
          if (e !== 0) {
            var c = r.pendingLanes;
            if (c === 0) var u = 0;
            else {
              var x = r.suspendedLanes, v = r.pingedLanes;
              u = (1 << 31 - jt(42 | e) + 1) - 1, u &= c & ~(x & ~v), u = u & 201326741 ? u & 201326741 | 1 : u ? u | 2 : 0;
            }
            u !== 0 && (a = !0, ix(r, u));
          } else
            u = Ce, u = ge(
              r,
              r === Ie ? u : 0,
              r.cancelPendingCommit !== null || r.timeoutHandle !== -1
            ), (u & 3) === 0 || Ze(r, u) || (a = !0, ix(r, u));
          r = r.next;
        }
      while (a);
      gd = !1;
    }
  }
  function k2() {
    tx();
  }
  function tx() {
    fo = pd = !1;
    var e = 0;
    Fa !== 0 && U2() && (e = Fa);
    for (var t = kt(), a = null, r = ho; r !== null; ) {
      var c = r.next, u = nx(r, t);
      u === 0 ? (r.next = null, a === null ? ho = c : a.next = c, c === null && (bs = a)) : (a = r, (e !== 0 || (u & 3) !== 0) && (fo = !0)), r = c;
    }
    lt !== 0 && lt !== 5 || Nr(e), Fa !== 0 && (Fa = 0);
  }
  function nx(e, t) {
    for (var a = e.suspendedLanes, r = e.pingedLanes, c = e.expirationTimes, u = e.pendingLanes & -62914561; 0 < u; ) {
      var x = 31 - jt(u), v = 1 << x, j = c[x];
      j === -1 ? ((v & a) === 0 || (v & r) !== 0) && (c[x] = ut(v, t)) : j <= t && (e.expiredLanes |= v), u &= ~v;
    }
    if (t = Ie, a = Ce, a = ge(
      e,
      e === t ? a : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), r = e.callbackNode, a === 0 || e === t && (Ve === 2 || Ve === 9) || e.cancelPendingCommit !== null)
      return r !== null && r !== null && Ps(r), e.callbackNode = null, e.callbackPriority = 0;
    if ((a & 3) === 0 || Ze(e, a)) {
      if (t = a & -a, t === e.callbackPriority) return t;
      switch (r !== null && Ps(r), Tn(a)) {
        case 2:
        case 8:
          a = pl;
          break;
        case 32:
          a = ti;
          break;
        case 268435456:
          a = Zn;
          break;
        default:
          a = ti;
      }
      return r = ax.bind(null, e), a = Ls(a, r), e.callbackPriority = t, e.callbackNode = a, t;
    }
    return r !== null && r !== null && Ps(r), e.callbackPriority = 2, e.callbackNode = null, 2;
  }
  function ax(e, t) {
    if (lt !== 0 && lt !== 5)
      return e.callbackNode = null, e.callbackPriority = 0, null;
    var a = e.callbackNode;
    if (uo() && e.callbackNode !== a)
      return null;
    var r = Ce;
    return r = ge(
      e,
      e === Ie ? r : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), r === 0 ? null : (Vg(e, r, t), nx(e, kt()), e.callbackNode != null && e.callbackNode === a ? ax.bind(null, e) : null);
  }
  function ix(e, t) {
    if (uo()) return null;
    Vg(e, t, !0);
  }
  function M2() {
    P2(function() {
      (De & 6) !== 0 ? Ls(
        ei,
        k2
      ) : tx();
    });
  }
  function xd() {
    if (Fa === 0) {
      var e = is;
      e === 0 && (e = Bi, Bi <<= 1, (Bi & 261888) === 0 && (Bi = 256)), Fa = e;
    }
    return Fa;
  }
  function sx(e) {
    return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : vl("" + e);
  }
  function rx(e, t) {
    var a = t.ownerDocument.createElement("input");
    return a.name = t.name, a.value = t.value, e.id && a.setAttribute("form", e.id), t.parentNode.insertBefore(a, t), e = new FormData(e), a.parentNode.removeChild(a), e;
  }
  function z2(e, t, a, r, c) {
    if (t === "submit" && a && a.stateNode === c) {
      var u = sx(
        (c[Vt] || null).action
      ), x = r.submitter;
      x && (t = (t = x[Vt] || null) ? sx(t.formAction) : x.getAttribute("formAction"), t !== null && (u = t, x = null));
      var v = new Nl(
        "action",
        "action",
        null,
        r,
        c
      );
      e.push({
        event: v,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (r.defaultPrevented) {
                if (Fa !== 0) {
                  var j = x ? rx(c, x) : new FormData(c);
                  Bu(
                    a,
                    {
                      pending: !0,
                      data: j,
                      method: c.method,
                      action: u
                    },
                    null,
                    j
                  );
                }
              } else
                typeof u == "function" && (v.preventDefault(), j = x ? rx(c, x) : new FormData(c), Bu(
                  a,
                  {
                    pending: !0,
                    data: j,
                    method: c.method,
                    action: u
                  },
                  u,
                  j
                ));
            },
            currentTarget: c
          }
        ]
      });
    }
  }
  for (var yd = 0; yd < eu.length; yd++) {
    var bd = eu[yd], O2 = bd.toLowerCase(), R2 = bd[0].toUpperCase() + bd.slice(1);
    An(
      O2,
      "on" + R2
    );
  }
  An(Bm, "onAnimationEnd"), An(Vm, "onAnimationIteration"), An(Hm, "onAnimationStart"), An("dblclick", "onDoubleClick"), An("focusin", "onFocus"), An("focusout", "onBlur"), An(Xw, "onTransitionRun"), An(Kw, "onTransitionStart"), An($w, "onTransitionCancel"), An(Um, "onTransitionEnd"), qi("onMouseEnter", ["mouseout", "mouseover"]), qi("onMouseLeave", ["mouseout", "mouseover"]), qi("onPointerEnter", ["pointerout", "pointerover"]), qi("onPointerLeave", ["pointerout", "pointerover"]), si(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), si(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), si("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), si(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), si(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), si(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Tr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), _2 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Tr)
  );
  function lx(e, t) {
    t = (t & 4) !== 0;
    for (var a = 0; a < e.length; a++) {
      var r = e[a], c = r.event;
      r = r.listeners;
      e: {
        var u = void 0;
        if (t)
          for (var x = r.length - 1; 0 <= x; x--) {
            var v = r[x], j = v.instance, F = v.currentTarget;
            if (v = v.listener, j !== u && c.isPropagationStopped())
              break e;
            u = v, c.currentTarget = F;
            try {
              u(c);
            } catch (U) {
              Cl(U);
            }
            c.currentTarget = null, u = j;
          }
        else
          for (x = 0; x < r.length; x++) {
            if (v = r[x], j = v.instance, F = v.currentTarget, v = v.listener, j !== u && c.isPropagationStopped())
              break e;
            u = v, c.currentTarget = F;
            try {
              u(c);
            } catch (U) {
              Cl(U);
            }
            c.currentTarget = null, u = j;
          }
      }
    }
  }
  function Ae(e, t) {
    var a = t[Oc];
    a === void 0 && (a = t[Oc] = /* @__PURE__ */ new Set());
    var r = e + "__bubble";
    a.has(r) || (ox(t, e, 2, !1), a.add(r));
  }
  function vd(e, t, a) {
    var r = 0;
    t && (r |= 4), ox(
      a,
      e,
      r,
      t
    );
  }
  var mo = "_reactListening" + Math.random().toString(36).slice(2);
  function wd(e) {
    if (!e[mo]) {
      e[mo] = !0, tm.forEach(function(a) {
        a !== "selectionchange" && (_2.has(a) || vd(a, !1, e), vd(a, !0, e));
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[mo] || (t[mo] = !0, vd("selectionchange", !1, t));
    }
  }
  function ox(e, t, a, r) {
    switch (Bx(t)) {
      case 2:
        var c = oj;
        break;
      case 8:
        c = cj;
        break;
      default:
        c = Fd;
    }
    a = c.bind(
      null,
      t,
      a,
      e
    ), c = void 0, !Lc || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (c = !0), r ? c !== void 0 ? e.addEventListener(t, a, {
      capture: !0,
      passive: c
    }) : e.addEventListener(t, a, !0) : c !== void 0 ? e.addEventListener(t, a, {
      passive: c
    }) : e.addEventListener(t, a, !1);
  }
  function jd(e, t, a, r, c) {
    var u = r;
    if ((t & 1) === 0 && (t & 2) === 0 && r !== null)
      e: for (; ; ) {
        if (r === null) return;
        var x = r.tag;
        if (x === 3 || x === 4) {
          var v = r.stateNode.containerInfo;
          if (v === c) break;
          if (x === 4)
            for (x = r.return; x !== null; ) {
              var j = x.tag;
              if ((j === 3 || j === 4) && x.stateNode.containerInfo === c)
                return;
              x = x.return;
            }
          for (; v !== null; ) {
            if (x = Li(v), x === null) return;
            if (j = x.tag, j === 5 || j === 6 || j === 26 || j === 27) {
              r = u = x;
              continue e;
            }
            v = v.parentNode;
          }
        }
        r = r.return;
      }
    fm(function() {
      var F = u, U = Hc(a), I = [];
      e: {
        var B = Lm.get(e);
        if (B !== void 0) {
          var V = Nl, oe = e;
          switch (e) {
            case "keypress":
              if (jl(a) === 0) break e;
            case "keydown":
            case "keyup":
              V = Cw;
              break;
            case "focusin":
              oe = "focus", V = Gc;
              break;
            case "focusout":
              oe = "blur", V = Gc;
              break;
            case "beforeblur":
            case "afterblur":
              V = Gc;
              break;
            case "click":
              if (a.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              V = gm;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              V = pw;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              V = Mw;
              break;
            case Bm:
            case Vm:
            case Hm:
              V = yw;
              break;
            case Um:
              V = Ow;
              break;
            case "scroll":
            case "scrollend":
              V = fw;
              break;
            case "wheel":
              V = _w;
              break;
            case "copy":
            case "cut":
            case "paste":
              V = vw;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              V = ym;
              break;
            case "toggle":
            case "beforetoggle":
              V = Fw;
          }
          var fe = (t & 4) !== 0, Pe = !fe && (e === "scroll" || e === "scrollend"), M = fe ? B !== null ? B + "Capture" : null : B;
          fe = [];
          for (var A = F, D; A !== null; ) {
            var P = A;
            if (D = P.stateNode, P = P.tag, P !== 5 && P !== 26 && P !== 27 || D === null || M === null || (P = Qs(A, M), P != null && fe.push(
              Ar(A, P, D)
            )), Pe) break;
            A = A.return;
          }
          0 < fe.length && (B = new V(
            B,
            oe,
            null,
            a,
            U
          ), I.push({ event: B, listeners: fe }));
        }
      }
      if ((t & 7) === 0) {
        e: {
          if (B = e === "mouseover" || e === "pointerover", V = e === "mouseout" || e === "pointerout", B && a !== Vc && (oe = a.relatedTarget || a.fromElement) && (Li(oe) || oe[Ui]))
            break e;
          if ((V || B) && (B = U.window === U ? U : (B = U.ownerDocument) ? B.defaultView || B.parentWindow : window, V ? (oe = a.relatedTarget || a.toElement, V = F, oe = oe ? Li(oe) : null, oe !== null && (Pe = f(oe), fe = oe.tag, oe !== Pe || fe !== 5 && fe !== 27 && fe !== 6) && (oe = null)) : (V = null, oe = F), V !== oe)) {
            if (fe = gm, P = "onMouseLeave", M = "onMouseEnter", A = "mouse", (e === "pointerout" || e === "pointerover") && (fe = ym, P = "onPointerLeave", M = "onPointerEnter", A = "pointer"), Pe = V == null ? B : Ys(V), D = oe == null ? B : Ys(oe), B = new fe(
              P,
              A + "leave",
              V,
              a,
              U
            ), B.target = Pe, B.relatedTarget = D, P = null, Li(U) === F && (fe = new fe(
              M,
              A + "enter",
              oe,
              a,
              U
            ), fe.target = D, fe.relatedTarget = Pe, P = fe), Pe = P, V && oe)
              t: {
                for (fe = D2, M = V, A = oe, D = 0, P = M; P; P = fe(P))
                  D++;
                P = 0;
                for (var de = A; de; de = fe(de))
                  P++;
                for (; 0 < D - P; )
                  M = fe(M), D--;
                for (; 0 < P - D; )
                  A = fe(A), P--;
                for (; D--; ) {
                  if (M === A || A !== null && M === A.alternate) {
                    fe = M;
                    break t;
                  }
                  M = fe(M), A = fe(A);
                }
                fe = null;
              }
            else fe = null;
            V !== null && cx(
              I,
              B,
              V,
              fe,
              !1
            ), oe !== null && Pe !== null && cx(
              I,
              Pe,
              oe,
              fe,
              !0
            );
          }
        }
        e: {
          if (B = F ? Ys(F) : window, V = B.nodeName && B.nodeName.toLowerCase(), V === "select" || V === "input" && B.type === "file")
            var Oe = Am;
          else if (Nm(B))
            if (Cm)
              Oe = Yw;
            else {
              Oe = qw;
              var ue = Iw;
            }
          else
            V = B.nodeName, !V || V.toLowerCase() !== "input" || B.type !== "checkbox" && B.type !== "radio" ? F && Bc(F.elementType) && (Oe = Am) : Oe = Gw;
          if (Oe && (Oe = Oe(e, F))) {
            Tm(
              I,
              Oe,
              a,
              U
            );
            break e;
          }
          ue && ue(e, B, F), e === "focusout" && F && B.type === "number" && F.memoizedProps.value != null && Fc(B, "number", B.value);
        }
        switch (ue = F ? Ys(F) : window, e) {
          case "focusin":
            (Nm(ue) || ue.contentEditable === "true") && (Ki = ue, $c = F, tr = null);
            break;
          case "focusout":
            tr = $c = Ki = null;
            break;
          case "mousedown":
            Wc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Wc = !1, Dm(I, a, U);
            break;
          case "selectionchange":
            if (Zw) break;
          case "keydown":
          case "keyup":
            Dm(I, a, U);
        }
        var je;
        if (Qc)
          e: {
            switch (e) {
              case "compositionstart":
                var Ee = "onCompositionStart";
                break e;
              case "compositionend":
                Ee = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Ee = "onCompositionUpdate";
                break e;
            }
            Ee = void 0;
          }
        else
          Xi ? jm(e, a) && (Ee = "onCompositionEnd") : e === "keydown" && a.keyCode === 229 && (Ee = "onCompositionStart");
        Ee && (bm && a.locale !== "ko" && (Xi || Ee !== "onCompositionStart" ? Ee === "onCompositionEnd" && Xi && (je = mm()) : (va = U, Pc = "value" in va ? va.value : va.textContent, Xi = !0)), ue = po(F, Ee), 0 < ue.length && (Ee = new xm(
          Ee,
          e,
          null,
          a,
          U
        ), I.push({ event: Ee, listeners: ue }), je ? Ee.data = je : (je = Sm(a), je !== null && (Ee.data = je)))), (je = Vw ? Hw(e, a) : Uw(e, a)) && (Ee = po(F, "onBeforeInput"), 0 < Ee.length && (ue = new xm(
          "onBeforeInput",
          "beforeinput",
          null,
          a,
          U
        ), I.push({
          event: ue,
          listeners: Ee
        }), ue.data = je)), z2(
          I,
          e,
          F,
          a,
          U
        );
      }
      lx(I, t);
    });
  }
  function Ar(e, t, a) {
    return {
      instance: e,
      listener: t,
      currentTarget: a
    };
  }
  function po(e, t) {
    for (var a = t + "Capture", r = []; e !== null; ) {
      var c = e, u = c.stateNode;
      if (c = c.tag, c !== 5 && c !== 26 && c !== 27 || u === null || (c = Qs(e, a), c != null && r.unshift(
        Ar(e, c, u)
      ), c = Qs(e, t), c != null && r.push(
        Ar(e, c, u)
      )), e.tag === 3) return r;
      e = e.return;
    }
    return [];
  }
  function D2(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function cx(e, t, a, r, c) {
    for (var u = t._reactName, x = []; a !== null && a !== r; ) {
      var v = a, j = v.alternate, F = v.stateNode;
      if (v = v.tag, j !== null && j === r) break;
      v !== 5 && v !== 26 && v !== 27 || F === null || (j = F, c ? (F = Qs(a, u), F != null && x.unshift(
        Ar(a, F, j)
      )) : c || (F = Qs(a, u), F != null && x.push(
        Ar(a, F, j)
      ))), a = a.return;
    }
    x.length !== 0 && e.push({ event: t, listeners: x });
  }
  var F2 = /\r\n?/g, B2 = /\u0000|\uFFFD/g;
  function ux(e) {
    return (typeof e == "string" ? e : "" + e).replace(F2, `
`).replace(B2, "");
  }
  function dx(e, t) {
    return t = ux(t), ux(e) === t;
  }
  function Le(e, t, a, r, c, u) {
    switch (a) {
      case "children":
        typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Yi(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Yi(e, "" + r);
        break;
      case "className":
        yl(e, "class", r);
        break;
      case "tabIndex":
        yl(e, "tabindex", r);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        yl(e, a, r);
        break;
      case "style":
        dm(e, r, u);
        break;
      case "data":
        if (t !== "object") {
          yl(e, "data", r);
          break;
        }
      case "src":
      case "href":
        if (r === "" && (t !== "a" || a !== "href")) {
          e.removeAttribute(a);
          break;
        }
        if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
          e.removeAttribute(a);
          break;
        }
        r = vl("" + r), e.setAttribute(a, r);
        break;
      case "action":
      case "formAction":
        if (typeof r == "function") {
          e.setAttribute(
            a,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof u == "function" && (a === "formAction" ? (t !== "input" && Le(e, t, "name", c.name, c, null), Le(
            e,
            t,
            "formEncType",
            c.formEncType,
            c,
            null
          ), Le(
            e,
            t,
            "formMethod",
            c.formMethod,
            c,
            null
          ), Le(
            e,
            t,
            "formTarget",
            c.formTarget,
            c,
            null
          )) : (Le(e, t, "encType", c.encType, c, null), Le(e, t, "method", c.method, c, null), Le(e, t, "target", c.target, c, null)));
        if (r == null || typeof r == "symbol" || typeof r == "boolean") {
          e.removeAttribute(a);
          break;
        }
        r = vl("" + r), e.setAttribute(a, r);
        break;
      case "onClick":
        r != null && (e.onclick = Kn);
        break;
      case "onScroll":
        r != null && Ae("scroll", e);
        break;
      case "onScrollEnd":
        r != null && Ae("scrollend", e);
        break;
      case "dangerouslySetInnerHTML":
        if (r != null) {
          if (typeof r != "object" || !("__html" in r))
            throw Error(o(61));
          if (a = r.__html, a != null) {
            if (c.children != null) throw Error(o(60));
            e.innerHTML = a;
          }
        }
        break;
      case "multiple":
        e.multiple = r && typeof r != "function" && typeof r != "symbol";
        break;
      case "muted":
        e.muted = r && typeof r != "function" && typeof r != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
          e.removeAttribute("xlink:href");
          break;
        }
        a = vl("" + r), e.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          a
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(a, "" + r) : e.removeAttribute(a);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(a, "") : e.removeAttribute(a);
        break;
      case "capture":
      case "download":
        r === !0 ? e.setAttribute(a, "") : r !== !1 && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(a, r) : e.removeAttribute(a);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(a, r) : e.removeAttribute(a);
        break;
      case "rowSpan":
      case "start":
        r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(a) : e.setAttribute(a, r);
        break;
      case "popover":
        Ae("beforetoggle", e), Ae("toggle", e), xl(e, "popover", r);
        break;
      case "xlinkActuate":
        Xn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          r
        );
        break;
      case "xlinkArcrole":
        Xn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          r
        );
        break;
      case "xlinkRole":
        Xn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          r
        );
        break;
      case "xlinkShow":
        Xn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          r
        );
        break;
      case "xlinkTitle":
        Xn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          r
        );
        break;
      case "xlinkType":
        Xn(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          r
        );
        break;
      case "xmlBase":
        Xn(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          r
        );
        break;
      case "xmlLang":
        Xn(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          r
        );
        break;
      case "xmlSpace":
        Xn(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          r
        );
        break;
      case "is":
        xl(e, "is", r);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N") && (a = dw.get(a) || a, xl(e, a, r));
    }
  }
  function Sd(e, t, a, r, c, u) {
    switch (a) {
      case "style":
        dm(e, r, u);
        break;
      case "dangerouslySetInnerHTML":
        if (r != null) {
          if (typeof r != "object" || !("__html" in r))
            throw Error(o(61));
          if (a = r.__html, a != null) {
            if (c.children != null) throw Error(o(60));
            e.innerHTML = a;
          }
        }
        break;
      case "children":
        typeof r == "string" ? Yi(e, r) : (typeof r == "number" || typeof r == "bigint") && Yi(e, "" + r);
        break;
      case "onScroll":
        r != null && Ae("scroll", e);
        break;
      case "onScrollEnd":
        r != null && Ae("scrollend", e);
        break;
      case "onClick":
        r != null && (e.onclick = Kn);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!nm.hasOwnProperty(a))
          e: {
            if (a[0] === "o" && a[1] === "n" && (c = a.endsWith("Capture"), t = a.slice(2, c ? a.length - 7 : void 0), u = e[Vt] || null, u = u != null ? u[a] : null, typeof u == "function" && e.removeEventListener(t, u, c), typeof r == "function")) {
              typeof u != "function" && u !== null && (a in e ? e[a] = null : e.hasAttribute(a) && e.removeAttribute(a)), e.addEventListener(t, r, c);
              break e;
            }
            a in e ? e[a] = r : r === !0 ? e.setAttribute(a, "") : xl(e, a, r);
          }
    }
  }
  function yt(e, t, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Ae("error", e), Ae("load", e);
        var r = !1, c = !1, u;
        for (u in a)
          if (a.hasOwnProperty(u)) {
            var x = a[u];
            if (x != null)
              switch (u) {
                case "src":
                  r = !0;
                  break;
                case "srcSet":
                  c = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(o(137, t));
                default:
                  Le(e, t, u, x, a, null);
              }
          }
        c && Le(e, t, "srcSet", a.srcSet, a, null), r && Le(e, t, "src", a.src, a, null);
        return;
      case "input":
        Ae("invalid", e);
        var v = u = x = c = null, j = null, F = null;
        for (r in a)
          if (a.hasOwnProperty(r)) {
            var U = a[r];
            if (U != null)
              switch (r) {
                case "name":
                  c = U;
                  break;
                case "type":
                  x = U;
                  break;
                case "checked":
                  j = U;
                  break;
                case "defaultChecked":
                  F = U;
                  break;
                case "value":
                  u = U;
                  break;
                case "defaultValue":
                  v = U;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (U != null)
                    throw Error(o(137, t));
                  break;
                default:
                  Le(e, t, r, U, a, null);
              }
          }
        lm(
          e,
          u,
          v,
          j,
          F,
          x,
          c,
          !1
        );
        return;
      case "select":
        Ae("invalid", e), r = x = u = null;
        for (c in a)
          if (a.hasOwnProperty(c) && (v = a[c], v != null))
            switch (c) {
              case "value":
                u = v;
                break;
              case "defaultValue":
                x = v;
                break;
              case "multiple":
                r = v;
              default:
                Le(e, t, c, v, a, null);
            }
        t = u, a = x, e.multiple = !!r, t != null ? Gi(e, !!r, t, !1) : a != null && Gi(e, !!r, a, !0);
        return;
      case "textarea":
        Ae("invalid", e), u = c = r = null;
        for (x in a)
          if (a.hasOwnProperty(x) && (v = a[x], v != null))
            switch (x) {
              case "value":
                r = v;
                break;
              case "defaultValue":
                c = v;
                break;
              case "children":
                u = v;
                break;
              case "dangerouslySetInnerHTML":
                if (v != null) throw Error(o(91));
                break;
              default:
                Le(e, t, x, v, a, null);
            }
        cm(e, r, c, u);
        return;
      case "option":
        for (j in a)
          a.hasOwnProperty(j) && (r = a[j], r != null) && (j === "selected" ? e.selected = r && typeof r != "function" && typeof r != "symbol" : Le(e, t, j, r, a, null));
        return;
      case "dialog":
        Ae("beforetoggle", e), Ae("toggle", e), Ae("cancel", e), Ae("close", e);
        break;
      case "iframe":
      case "object":
        Ae("load", e);
        break;
      case "video":
      case "audio":
        for (r = 0; r < Tr.length; r++)
          Ae(Tr[r], e);
        break;
      case "image":
        Ae("error", e), Ae("load", e);
        break;
      case "details":
        Ae("toggle", e);
        break;
      case "embed":
      case "source":
      case "link":
        Ae("error", e), Ae("load", e);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (F in a)
          if (a.hasOwnProperty(F) && (r = a[F], r != null))
            switch (F) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(o(137, t));
              default:
                Le(e, t, F, r, a, null);
            }
        return;
      default:
        if (Bc(t)) {
          for (U in a)
            a.hasOwnProperty(U) && (r = a[U], r !== void 0 && Sd(
              e,
              t,
              U,
              r,
              a,
              void 0
            ));
          return;
        }
    }
    for (v in a)
      a.hasOwnProperty(v) && (r = a[v], r != null && Le(e, t, v, r, a, null));
  }
  function V2(e, t, a, r) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var c = null, u = null, x = null, v = null, j = null, F = null, U = null;
        for (V in a) {
          var I = a[V];
          if (a.hasOwnProperty(V) && I != null)
            switch (V) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                j = I;
              default:
                r.hasOwnProperty(V) || Le(e, t, V, null, r, I);
            }
        }
        for (var B in r) {
          var V = r[B];
          if (I = a[B], r.hasOwnProperty(B) && (V != null || I != null))
            switch (B) {
              case "type":
                u = V;
                break;
              case "name":
                c = V;
                break;
              case "checked":
                F = V;
                break;
              case "defaultChecked":
                U = V;
                break;
              case "value":
                x = V;
                break;
              case "defaultValue":
                v = V;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (V != null)
                  throw Error(o(137, t));
                break;
              default:
                V !== I && Le(
                  e,
                  t,
                  B,
                  V,
                  r,
                  I
                );
            }
        }
        Dc(
          e,
          x,
          v,
          j,
          F,
          U,
          u,
          c
        );
        return;
      case "select":
        V = x = v = B = null;
        for (u in a)
          if (j = a[u], a.hasOwnProperty(u) && j != null)
            switch (u) {
              case "value":
                break;
              case "multiple":
                V = j;
              default:
                r.hasOwnProperty(u) || Le(
                  e,
                  t,
                  u,
                  null,
                  r,
                  j
                );
            }
        for (c in r)
          if (u = r[c], j = a[c], r.hasOwnProperty(c) && (u != null || j != null))
            switch (c) {
              case "value":
                B = u;
                break;
              case "defaultValue":
                v = u;
                break;
              case "multiple":
                x = u;
              default:
                u !== j && Le(
                  e,
                  t,
                  c,
                  u,
                  r,
                  j
                );
            }
        t = v, a = x, r = V, B != null ? Gi(e, !!a, B, !1) : !!r != !!a && (t != null ? Gi(e, !!a, t, !0) : Gi(e, !!a, a ? [] : "", !1));
        return;
      case "textarea":
        V = B = null;
        for (v in a)
          if (c = a[v], a.hasOwnProperty(v) && c != null && !r.hasOwnProperty(v))
            switch (v) {
              case "value":
                break;
              case "children":
                break;
              default:
                Le(e, t, v, null, r, c);
            }
        for (x in r)
          if (c = r[x], u = a[x], r.hasOwnProperty(x) && (c != null || u != null))
            switch (x) {
              case "value":
                B = c;
                break;
              case "defaultValue":
                V = c;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(o(91));
                break;
              default:
                c !== u && Le(e, t, x, c, r, u);
            }
        om(e, B, V);
        return;
      case "option":
        for (var oe in a)
          B = a[oe], a.hasOwnProperty(oe) && B != null && !r.hasOwnProperty(oe) && (oe === "selected" ? e.selected = !1 : Le(
            e,
            t,
            oe,
            null,
            r,
            B
          ));
        for (j in r)
          B = r[j], V = a[j], r.hasOwnProperty(j) && B !== V && (B != null || V != null) && (j === "selected" ? e.selected = B && typeof B != "function" && typeof B != "symbol" : Le(
            e,
            t,
            j,
            B,
            r,
            V
          ));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var fe in a)
          B = a[fe], a.hasOwnProperty(fe) && B != null && !r.hasOwnProperty(fe) && Le(e, t, fe, null, r, B);
        for (F in r)
          if (B = r[F], V = a[F], r.hasOwnProperty(F) && B !== V && (B != null || V != null))
            switch (F) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (B != null)
                  throw Error(o(137, t));
                break;
              default:
                Le(
                  e,
                  t,
                  F,
                  B,
                  r,
                  V
                );
            }
        return;
      default:
        if (Bc(t)) {
          for (var Pe in a)
            B = a[Pe], a.hasOwnProperty(Pe) && B !== void 0 && !r.hasOwnProperty(Pe) && Sd(
              e,
              t,
              Pe,
              void 0,
              r,
              B
            );
          for (U in r)
            B = r[U], V = a[U], !r.hasOwnProperty(U) || B === V || B === void 0 && V === void 0 || Sd(
              e,
              t,
              U,
              B,
              r,
              V
            );
          return;
        }
    }
    for (var M in a)
      B = a[M], a.hasOwnProperty(M) && B != null && !r.hasOwnProperty(M) && Le(e, t, M, null, r, B);
    for (I in r)
      B = r[I], V = a[I], !r.hasOwnProperty(I) || B === V || B == null && V == null || Le(e, t, I, B, r, V);
  }
  function hx(e) {
    switch (e) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function H2() {
    if (typeof performance.getEntriesByType == "function") {
      for (var e = 0, t = 0, a = performance.getEntriesByType("resource"), r = 0; r < a.length; r++) {
        var c = a[r], u = c.transferSize, x = c.initiatorType, v = c.duration;
        if (u && v && hx(x)) {
          for (x = 0, v = c.responseEnd, r += 1; r < a.length; r++) {
            var j = a[r], F = j.startTime;
            if (F > v) break;
            var U = j.transferSize, I = j.initiatorType;
            U && hx(I) && (j = j.responseEnd, x += U * (j < v ? 1 : (v - F) / (j - F)));
          }
          if (--r, t += 8 * (u + x) / (c.duration / 1e3), e++, 10 < e) break;
        }
      }
      if (0 < e) return t / e / 1e6;
    }
    return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
  }
  var Nd = null, Td = null;
  function go(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function fx(e) {
    switch (e) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function mx(e, t) {
    if (e === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return e === 1 && t === "foreignObject" ? 0 : e;
  }
  function Ad(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Cd = null;
  function U2() {
    var e = window.event;
    return e && e.type === "popstate" ? e === Cd ? !1 : (Cd = e, !0) : (Cd = null, !1);
  }
  var px = typeof setTimeout == "function" ? setTimeout : void 0, L2 = typeof clearTimeout == "function" ? clearTimeout : void 0, gx = typeof Promise == "function" ? Promise : void 0, P2 = typeof queueMicrotask == "function" ? queueMicrotask : typeof gx < "u" ? function(e) {
    return gx.resolve(null).then(e).catch(I2);
  } : px;
  function I2(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function Ba(e) {
    return e === "head";
  }
  function xx(e, t) {
    var a = t, r = 0;
    do {
      var c = a.nextSibling;
      if (e.removeChild(a), c && c.nodeType === 8)
        if (a = c.data, a === "/$" || a === "/&") {
          if (r === 0) {
            e.removeChild(c), Ss(t);
            return;
          }
          r--;
        } else if (a === "$" || a === "$?" || a === "$~" || a === "$!" || a === "&")
          r++;
        else if (a === "html")
          Cr(e.ownerDocument.documentElement);
        else if (a === "head") {
          a = e.ownerDocument.head, Cr(a);
          for (var u = a.firstChild; u; ) {
            var x = u.nextSibling, v = u.nodeName;
            u[Gs] || v === "SCRIPT" || v === "STYLE" || v === "LINK" && u.rel.toLowerCase() === "stylesheet" || a.removeChild(u), u = x;
          }
        } else
          a === "body" && Cr(e.ownerDocument.body);
      a = c;
    } while (a);
    Ss(t);
  }
  function yx(e, t) {
    var a = e;
    e = 0;
    do {
      var r = a.nextSibling;
      if (a.nodeType === 1 ? t ? (a._stashedDisplay = a.style.display, a.style.display = "none") : (a.style.display = a._stashedDisplay || "", a.getAttribute("style") === "" && a.removeAttribute("style")) : a.nodeType === 3 && (t ? (a._stashedText = a.nodeValue, a.nodeValue = "") : a.nodeValue = a._stashedText || ""), r && r.nodeType === 8)
        if (a = r.data, a === "/$") {
          if (e === 0) break;
          e--;
        } else
          a !== "$" && a !== "$?" && a !== "$~" && a !== "$!" || e++;
      a = r;
    } while (a);
  }
  function Ed(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var a = t;
      switch (t = t.nextSibling, a.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Ed(a), Rc(a);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (a.rel.toLowerCase() === "stylesheet") continue;
      }
      e.removeChild(a);
    }
  }
  function q2(e, t, a, r) {
    for (; e.nodeType === 1; ) {
      var c = a;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden"))
          break;
      } else if (r) {
        if (!e[Gs])
          switch (t) {
            case "meta":
              if (!e.hasAttribute("itemprop")) break;
              return e;
            case "link":
              if (u = e.getAttribute("rel"), u === "stylesheet" && e.hasAttribute("data-precedence"))
                break;
              if (u !== c.rel || e.getAttribute("href") !== (c.href == null || c.href === "" ? null : c.href) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin) || e.getAttribute("title") !== (c.title == null ? null : c.title))
                break;
              return e;
            case "style":
              if (e.hasAttribute("data-precedence")) break;
              return e;
            case "script":
              if (u = e.getAttribute("src"), (u !== (c.src == null ? null : c.src) || e.getAttribute("type") !== (c.type == null ? null : c.type) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin)) && u && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                break;
              return e;
            default:
              return e;
          }
      } else if (t === "input" && e.type === "hidden") {
        var u = c.name == null ? null : "" + c.name;
        if (c.type === "hidden" && e.getAttribute("name") === u)
          return e;
      } else return e;
      if (e = xn(e.nextSibling), e === null) break;
    }
    return null;
  }
  function G2(e, t, a) {
    if (t === "") return null;
    for (; e.nodeType !== 3; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !a || (e = xn(e.nextSibling), e === null)) return null;
    return e;
  }
  function bx(e, t) {
    for (; e.nodeType !== 8; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = xn(e.nextSibling), e === null)) return null;
    return e;
  }
  function kd(e) {
    return e.data === "$?" || e.data === "$~";
  }
  function Md(e) {
    return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
  }
  function Y2(e, t) {
    var a = e.ownerDocument;
    if (e.data === "$~") e._reactRetry = t;
    else if (e.data !== "$?" || a.readyState !== "loading")
      t();
    else {
      var r = function() {
        t(), a.removeEventListener("DOMContentLoaded", r);
      };
      a.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
    }
  }
  function xn(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return e;
  }
  var zd = null;
  function vx(e) {
    e = e.nextSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var a = e.data;
        if (a === "/$" || a === "/&") {
          if (t === 0)
            return xn(e.nextSibling);
          t--;
        } else
          a !== "$" && a !== "$!" && a !== "$?" && a !== "$~" && a !== "&" || t++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function wx(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var a = e.data;
        if (a === "$" || a === "$!" || a === "$?" || a === "$~" || a === "&") {
          if (t === 0) return e;
          t--;
        } else a !== "/$" && a !== "/&" || t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function jx(e, t, a) {
    switch (t = go(a), e) {
      case "html":
        if (e = t.documentElement, !e) throw Error(o(452));
        return e;
      case "head":
        if (e = t.head, !e) throw Error(o(453));
        return e;
      case "body":
        if (e = t.body, !e) throw Error(o(454));
        return e;
      default:
        throw Error(o(451));
    }
  }
  function Cr(e) {
    for (var t = e.attributes; t.length; )
      e.removeAttributeNode(t[0]);
    Rc(e);
  }
  var yn = /* @__PURE__ */ new Map(), Sx = /* @__PURE__ */ new Set();
  function xo(e) {
    return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
  }
  var ha = X.d;
  X.d = {
    f: Q2,
    r: Z2,
    D: X2,
    C: K2,
    L: $2,
    m: W2,
    X: ej,
    S: J2,
    M: tj
  };
  function Q2() {
    var e = ha.f(), t = lo();
    return e || t;
  }
  function Z2(e) {
    var t = Pi(e);
    t !== null && t.tag === 5 && t.type === "form" ? Up(t) : ha.r(e);
  }
  var vs = typeof document > "u" ? null : document;
  function Nx(e, t, a) {
    var r = vs;
    if (r && typeof t == "string" && t) {
      var c = un(t);
      c = 'link[rel="' + e + '"][href="' + c + '"]', typeof a == "string" && (c += '[crossorigin="' + a + '"]'), Sx.has(c) || (Sx.add(c), e = { rel: e, crossOrigin: a, href: t }, r.querySelector(c) === null && (t = r.createElement("link"), yt(t, "link", e), dt(t), r.head.appendChild(t)));
    }
  }
  function X2(e) {
    ha.D(e), Nx("dns-prefetch", e, null);
  }
  function K2(e, t) {
    ha.C(e, t), Nx("preconnect", e, t);
  }
  function $2(e, t, a) {
    ha.L(e, t, a);
    var r = vs;
    if (r && e && t) {
      var c = 'link[rel="preload"][as="' + un(t) + '"]';
      t === "image" && a && a.imageSrcSet ? (c += '[imagesrcset="' + un(
        a.imageSrcSet
      ) + '"]', typeof a.imageSizes == "string" && (c += '[imagesizes="' + un(
        a.imageSizes
      ) + '"]')) : c += '[href="' + un(e) + '"]';
      var u = c;
      switch (t) {
        case "style":
          u = ws(e);
          break;
        case "script":
          u = js(e);
      }
      yn.has(u) || (e = y(
        {
          rel: "preload",
          href: t === "image" && a && a.imageSrcSet ? void 0 : e,
          as: t
        },
        a
      ), yn.set(u, e), r.querySelector(c) !== null || t === "style" && r.querySelector(Er(u)) || t === "script" && r.querySelector(kr(u)) || (t = r.createElement("link"), yt(t, "link", e), dt(t), r.head.appendChild(t)));
    }
  }
  function W2(e, t) {
    ha.m(e, t);
    var a = vs;
    if (a && e) {
      var r = t && typeof t.as == "string" ? t.as : "script", c = 'link[rel="modulepreload"][as="' + un(r) + '"][href="' + un(e) + '"]', u = c;
      switch (r) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          u = js(e);
      }
      if (!yn.has(u) && (e = y({ rel: "modulepreload", href: e }, t), yn.set(u, e), a.querySelector(c) === null)) {
        switch (r) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (a.querySelector(kr(u)))
              return;
        }
        r = a.createElement("link"), yt(r, "link", e), dt(r), a.head.appendChild(r);
      }
    }
  }
  function J2(e, t, a) {
    ha.S(e, t, a);
    var r = vs;
    if (r && e) {
      var c = Ii(r).hoistableStyles, u = ws(e);
      t = t || "default";
      var x = c.get(u);
      if (!x) {
        var v = { loading: 0, preload: null };
        if (x = r.querySelector(
          Er(u)
        ))
          v.loading = 5;
        else {
          e = y(
            { rel: "stylesheet", href: e, "data-precedence": t },
            a
          ), (a = yn.get(u)) && Od(e, a);
          var j = x = r.createElement("link");
          dt(j), yt(j, "link", e), j._p = new Promise(function(F, U) {
            j.onload = F, j.onerror = U;
          }), j.addEventListener("load", function() {
            v.loading |= 1;
          }), j.addEventListener("error", function() {
            v.loading |= 2;
          }), v.loading |= 4, yo(x, t, r);
        }
        x = {
          type: "stylesheet",
          instance: x,
          count: 1,
          state: v
        }, c.set(u, x);
      }
    }
  }
  function ej(e, t) {
    ha.X(e, t);
    var a = vs;
    if (a && e) {
      var r = Ii(a).hoistableScripts, c = js(e), u = r.get(c);
      u || (u = a.querySelector(kr(c)), u || (e = y({ src: e, async: !0 }, t), (t = yn.get(c)) && Rd(e, t), u = a.createElement("script"), dt(u), yt(u, "link", e), a.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, r.set(c, u));
    }
  }
  function tj(e, t) {
    ha.M(e, t);
    var a = vs;
    if (a && e) {
      var r = Ii(a).hoistableScripts, c = js(e), u = r.get(c);
      u || (u = a.querySelector(kr(c)), u || (e = y({ src: e, async: !0, type: "module" }, t), (t = yn.get(c)) && Rd(e, t), u = a.createElement("script"), dt(u), yt(u, "link", e), a.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, r.set(c, u));
    }
  }
  function Tx(e, t, a, r) {
    var c = (c = se.current) ? xo(c) : null;
    if (!c) throw Error(o(446));
    switch (e) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof a.precedence == "string" && typeof a.href == "string" ? (t = ws(a.href), a = Ii(
          c
        ).hoistableStyles, r = a.get(t), r || (r = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, a.set(t, r)), r) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (a.rel === "stylesheet" && typeof a.href == "string" && typeof a.precedence == "string") {
          e = ws(a.href);
          var u = Ii(
            c
          ).hoistableStyles, x = u.get(e);
          if (x || (c = c.ownerDocument || c, x = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, u.set(e, x), (u = c.querySelector(
            Er(e)
          )) && !u._p && (x.instance = u, x.state.loading = 5), yn.has(e) || (a = {
            rel: "preload",
            as: "style",
            href: a.href,
            crossOrigin: a.crossOrigin,
            integrity: a.integrity,
            media: a.media,
            hrefLang: a.hrefLang,
            referrerPolicy: a.referrerPolicy
          }, yn.set(e, a), u || nj(
            c,
            e,
            a,
            x.state
          ))), t && r === null)
            throw Error(o(528, ""));
          return x;
        }
        if (t && r !== null)
          throw Error(o(529, ""));
        return null;
      case "script":
        return t = a.async, a = a.src, typeof a == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = js(a), a = Ii(
          c
        ).hoistableScripts, r = a.get(t), r || (r = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, a.set(t, r)), r) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(o(444, e));
    }
  }
  function ws(e) {
    return 'href="' + un(e) + '"';
  }
  function Er(e) {
    return 'link[rel="stylesheet"][' + e + "]";
  }
  function Ax(e) {
    return y({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function nj(e, t, a, r) {
    e.querySelector('link[rel="preload"][as="style"][' + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
      return r.loading |= 1;
    }), t.addEventListener("error", function() {
      return r.loading |= 2;
    }), yt(t, "link", a), dt(t), e.head.appendChild(t));
  }
  function js(e) {
    return '[src="' + un(e) + '"]';
  }
  function kr(e) {
    return "script[async]" + e;
  }
  function Cx(e, t, a) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var r = e.querySelector(
            'style[data-href~="' + un(a.href) + '"]'
          );
          if (r)
            return t.instance = r, dt(r), r;
          var c = y({}, a, {
            "data-href": a.href,
            "data-precedence": a.precedence,
            href: null,
            precedence: null
          });
          return r = (e.ownerDocument || e).createElement(
            "style"
          ), dt(r), yt(r, "style", c), yo(r, a.precedence, e), t.instance = r;
        case "stylesheet":
          c = ws(a.href);
          var u = e.querySelector(
            Er(c)
          );
          if (u)
            return t.state.loading |= 4, t.instance = u, dt(u), u;
          r = Ax(a), (c = yn.get(c)) && Od(r, c), u = (e.ownerDocument || e).createElement("link"), dt(u);
          var x = u;
          return x._p = new Promise(function(v, j) {
            x.onload = v, x.onerror = j;
          }), yt(u, "link", r), t.state.loading |= 4, yo(u, a.precedence, e), t.instance = u;
        case "script":
          return u = js(a.src), (c = e.querySelector(
            kr(u)
          )) ? (t.instance = c, dt(c), c) : (r = a, (c = yn.get(u)) && (r = y({}, a), Rd(r, c)), e = e.ownerDocument || e, c = e.createElement("script"), dt(c), yt(c, "link", r), e.head.appendChild(c), t.instance = c);
        case "void":
          return null;
        default:
          throw Error(o(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (r = t.instance, t.state.loading |= 4, yo(r, a.precedence, e));
    return t.instance;
  }
  function yo(e, t, a) {
    for (var r = a.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), c = r.length ? r[r.length - 1] : null, u = c, x = 0; x < r.length; x++) {
      var v = r[x];
      if (v.dataset.precedence === t) u = v;
      else if (u !== c) break;
    }
    u ? u.parentNode.insertBefore(e, u.nextSibling) : (t = a.nodeType === 9 ? a.head : a, t.insertBefore(e, t.firstChild));
  }
  function Od(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
  }
  function Rd(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
  }
  var bo = null;
  function Ex(e, t, a) {
    if (bo === null) {
      var r = /* @__PURE__ */ new Map(), c = bo = /* @__PURE__ */ new Map();
      c.set(a, r);
    } else
      c = bo, r = c.get(a), r || (r = /* @__PURE__ */ new Map(), c.set(a, r));
    if (r.has(e)) return r;
    for (r.set(e, null), a = a.getElementsByTagName(e), c = 0; c < a.length; c++) {
      var u = a[c];
      if (!(u[Gs] || u[mt] || e === "link" && u.getAttribute("rel") === "stylesheet") && u.namespaceURI !== "http://www.w3.org/2000/svg") {
        var x = u.getAttribute(t) || "";
        x = e + x;
        var v = r.get(x);
        v ? v.push(u) : r.set(x, [u]);
      }
    }
    return r;
  }
  function kx(e, t, a) {
    e = e.ownerDocument || e, e.head.insertBefore(
      a,
      t === "title" ? e.querySelector("head > title") : null
    );
  }
  function aj(e, t, a) {
    if (a === 1 || t.itemProp != null) return !1;
    switch (e) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        return t.rel === "stylesheet" ? (e = t.disabled, typeof t.precedence == "string" && e == null) : !0;
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function Mx(e) {
    return !(e.type === "stylesheet" && (e.state.loading & 3) === 0);
  }
  function ij(e, t, a, r) {
    if (a.type === "stylesheet" && (typeof r.media != "string" || matchMedia(r.media).matches !== !1) && (a.state.loading & 4) === 0) {
      if (a.instance === null) {
        var c = ws(r.href), u = t.querySelector(
          Er(c)
        );
        if (u) {
          t = u._p, t !== null && typeof t == "object" && typeof t.then == "function" && (e.count++, e = vo.bind(e), t.then(e, e)), a.state.loading |= 4, a.instance = u, dt(u);
          return;
        }
        u = t.ownerDocument || t, r = Ax(r), (c = yn.get(c)) && Od(r, c), u = u.createElement("link"), dt(u);
        var x = u;
        x._p = new Promise(function(v, j) {
          x.onload = v, x.onerror = j;
        }), yt(u, "link", r), a.instance = u;
      }
      e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(a, t), (t = a.state.preload) && (a.state.loading & 3) === 0 && (e.count++, a = vo.bind(e), t.addEventListener("load", a), t.addEventListener("error", a));
    }
  }
  var _d = 0;
  function sj(e, t) {
    return e.stylesheets && e.count === 0 && jo(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(a) {
      var r = setTimeout(function() {
        if (e.stylesheets && jo(e, e.stylesheets), e.unsuspend) {
          var u = e.unsuspend;
          e.unsuspend = null, u();
        }
      }, 6e4 + t);
      0 < e.imgBytes && _d === 0 && (_d = 62500 * H2());
      var c = setTimeout(
        function() {
          if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && jo(e, e.stylesheets), e.unsuspend)) {
            var u = e.unsuspend;
            e.unsuspend = null, u();
          }
        },
        (e.imgBytes > _d ? 50 : 800) + t
      );
      return e.unsuspend = a, function() {
        e.unsuspend = null, clearTimeout(r), clearTimeout(c);
      };
    } : null;
  }
  function vo() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) jo(this, this.stylesheets);
      else if (this.unsuspend) {
        var e = this.unsuspend;
        this.unsuspend = null, e();
      }
    }
  }
  var wo = null;
  function jo(e, t) {
    e.stylesheets = null, e.unsuspend !== null && (e.count++, wo = /* @__PURE__ */ new Map(), t.forEach(rj, e), wo = null, vo.call(e));
  }
  function rj(e, t) {
    if (!(t.state.loading & 4)) {
      var a = wo.get(e);
      if (a) var r = a.get(null);
      else {
        a = /* @__PURE__ */ new Map(), wo.set(e, a);
        for (var c = e.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), u = 0; u < c.length; u++) {
          var x = c[u];
          (x.nodeName === "LINK" || x.getAttribute("media") !== "not all") && (a.set(x.dataset.precedence, x), r = x);
        }
        r && a.set(null, r);
      }
      c = t.instance, x = c.getAttribute("data-precedence"), u = a.get(x) || r, u === r && a.set(null, c), a.set(x, c), this.count++, r = vo.bind(this), c.addEventListener("load", r), c.addEventListener("error", r), u ? u.parentNode.insertBefore(c, u.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(c, e.firstChild)), t.state.loading |= 4;
    }
  }
  var Mr = {
    $$typeof: G,
    Provider: null,
    Consumer: null,
    _currentValue: ne,
    _currentValue2: ne,
    _threadCount: 0
  };
  function lj(e, t, a, r, c, u, x, v, j) {
    this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ya(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ya(0), this.hiddenUpdates = ya(null), this.identifierPrefix = r, this.onUncaughtError = c, this.onCaughtError = u, this.onRecoverableError = x, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = j, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function zx(e, t, a, r, c, u, x, v, j, F, U, I) {
    return e = new lj(
      e,
      t,
      a,
      x,
      j,
      F,
      U,
      I,
      v
    ), t = 1, u === !0 && (t |= 24), u = Kt(3, null, null, t), e.current = u, u.stateNode = e, t = fu(), t.refCount++, e.pooledCache = t, t.refCount++, u.memoizedState = {
      element: r,
      isDehydrated: a,
      cache: t
    }, xu(u), e;
  }
  function Ox(e) {
    return e ? (e = Ji, e) : Ji;
  }
  function Rx(e, t, a, r, c, u) {
    c = Ox(c), r.context === null ? r.context = c : r.pendingContext = c, r = Aa(t), r.payload = { element: a }, u = u === void 0 ? null : u, u !== null && (r.callback = u), a = Ca(e, r, t), a !== null && (qt(a, e, t), or(a, e, t));
  }
  function _x(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var a = e.retryLane;
      e.retryLane = a !== 0 && a < t ? a : t;
    }
  }
  function Dd(e, t) {
    _x(e, t), (e = e.alternate) && _x(e, t);
  }
  function Dx(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = ci(e, 67108864);
      t !== null && qt(t, e, 67108864), Dd(e, 67108864);
    }
  }
  function Fx(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = tn();
      t = Hi(t);
      var a = ci(e, t);
      a !== null && qt(a, e, t), Dd(e, t);
    }
  }
  var So = !0;
  function oj(e, t, a, r) {
    var c = O.T;
    O.T = null;
    var u = X.p;
    try {
      X.p = 2, Fd(e, t, a, r);
    } finally {
      X.p = u, O.T = c;
    }
  }
  function cj(e, t, a, r) {
    var c = O.T;
    O.T = null;
    var u = X.p;
    try {
      X.p = 8, Fd(e, t, a, r);
    } finally {
      X.p = u, O.T = c;
    }
  }
  function Fd(e, t, a, r) {
    if (So) {
      var c = Bd(r);
      if (c === null)
        jd(
          e,
          t,
          r,
          No,
          a
        ), Vx(e, r);
      else if (dj(
        c,
        e,
        t,
        a,
        r
      ))
        r.stopPropagation();
      else if (Vx(e, r), t & 4 && -1 < uj.indexOf(e)) {
        for (; c !== null; ) {
          var u = Pi(c);
          if (u !== null)
            switch (u.tag) {
              case 3:
                if (u = u.stateNode, u.current.memoizedState.isDehydrated) {
                  var x = Dn(u.pendingLanes);
                  if (x !== 0) {
                    var v = u;
                    for (v.pendingLanes |= 2, v.entangledLanes |= 2; x; ) {
                      var j = 1 << 31 - jt(x);
                      v.entanglements[1] |= j, x &= ~j;
                    }
                    Hn(u), (De & 6) === 0 && (so = kt() + 500, Nr(0));
                  }
                }
                break;
              case 31:
              case 13:
                v = ci(u, 2), v !== null && qt(v, u, 2), lo(), Dd(u, 2);
            }
          if (u = Bd(r), u === null && jd(
            e,
            t,
            r,
            No,
            a
          ), u === c) break;
          c = u;
        }
        c !== null && r.stopPropagation();
      } else
        jd(
          e,
          t,
          r,
          null,
          a
        );
    }
  }
  function Bd(e) {
    return e = Hc(e), Vd(e);
  }
  var No = null;
  function Vd(e) {
    if (No = null, e = Li(e), e !== null) {
      var t = f(e);
      if (t === null) e = null;
      else {
        var a = t.tag;
        if (a === 13) {
          if (e = h(t), e !== null) return e;
          e = null;
        } else if (a === 31) {
          if (e = p(t), e !== null) return e;
          e = null;
        } else if (a === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          e = null;
        } else t !== e && (e = null);
      }
    }
    return No = e, null;
  }
  function Bx(e) {
    switch (e) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (kc()) {
          case ei:
            return 2;
          case pl:
            return 8;
          case ti:
          case Is:
            return 32;
          case Zn:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Hd = !1, Va = null, Ha = null, Ua = null, zr = /* @__PURE__ */ new Map(), Or = /* @__PURE__ */ new Map(), La = [], uj = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Vx(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        Va = null;
        break;
      case "dragenter":
      case "dragleave":
        Ha = null;
        break;
      case "mouseover":
      case "mouseout":
        Ua = null;
        break;
      case "pointerover":
      case "pointerout":
        zr.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Or.delete(t.pointerId);
    }
  }
  function Rr(e, t, a, r, c, u) {
    return e === null || e.nativeEvent !== u ? (e = {
      blockedOn: t,
      domEventName: a,
      eventSystemFlags: r,
      nativeEvent: u,
      targetContainers: [c]
    }, t !== null && (t = Pi(t), t !== null && Dx(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, c !== null && t.indexOf(c) === -1 && t.push(c), e);
  }
  function dj(e, t, a, r, c) {
    switch (t) {
      case "focusin":
        return Va = Rr(
          Va,
          e,
          t,
          a,
          r,
          c
        ), !0;
      case "dragenter":
        return Ha = Rr(
          Ha,
          e,
          t,
          a,
          r,
          c
        ), !0;
      case "mouseover":
        return Ua = Rr(
          Ua,
          e,
          t,
          a,
          r,
          c
        ), !0;
      case "pointerover":
        var u = c.pointerId;
        return zr.set(
          u,
          Rr(
            zr.get(u) || null,
            e,
            t,
            a,
            r,
            c
          )
        ), !0;
      case "gotpointercapture":
        return u = c.pointerId, Or.set(
          u,
          Rr(
            Or.get(u) || null,
            e,
            t,
            a,
            r,
            c
          )
        ), !0;
    }
    return !1;
  }
  function Hx(e) {
    var t = Li(e.target);
    if (t !== null) {
      var a = f(t);
      if (a !== null) {
        if (t = a.tag, t === 13) {
          if (t = h(a), t !== null) {
            e.blockedOn = t, Jf(e.priority, function() {
              Fx(a);
            });
            return;
          }
        } else if (t === 31) {
          if (t = p(a), t !== null) {
            e.blockedOn = t, Jf(e.priority, function() {
              Fx(a);
            });
            return;
          }
        } else if (t === 3 && a.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function To(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var a = Bd(e.nativeEvent);
      if (a === null) {
        a = e.nativeEvent;
        var r = new a.constructor(
          a.type,
          a
        );
        Vc = r, a.target.dispatchEvent(r), Vc = null;
      } else
        return t = Pi(a), t !== null && Dx(t), e.blockedOn = a, !1;
      t.shift();
    }
    return !0;
  }
  function Ux(e, t, a) {
    To(e) && a.delete(t);
  }
  function hj() {
    Hd = !1, Va !== null && To(Va) && (Va = null), Ha !== null && To(Ha) && (Ha = null), Ua !== null && To(Ua) && (Ua = null), zr.forEach(Ux), Or.forEach(Ux);
  }
  function Ao(e, t) {
    e.blockedOn === t && (e.blockedOn = null, Hd || (Hd = !0, n.unstable_scheduleCallback(
      n.unstable_NormalPriority,
      hj
    )));
  }
  var Co = null;
  function Lx(e) {
    Co !== e && (Co = e, n.unstable_scheduleCallback(
      n.unstable_NormalPriority,
      function() {
        Co === e && (Co = null);
        for (var t = 0; t < e.length; t += 3) {
          var a = e[t], r = e[t + 1], c = e[t + 2];
          if (typeof r != "function") {
            if (Vd(r || a) === null)
              continue;
            break;
          }
          var u = Pi(a);
          u !== null && (e.splice(t, 3), t -= 3, Bu(
            u,
            {
              pending: !0,
              data: c,
              method: a.method,
              action: r
            },
            r,
            c
          ));
        }
      }
    ));
  }
  function Ss(e) {
    function t(j) {
      return Ao(j, e);
    }
    Va !== null && Ao(Va, e), Ha !== null && Ao(Ha, e), Ua !== null && Ao(Ua, e), zr.forEach(t), Or.forEach(t);
    for (var a = 0; a < La.length; a++) {
      var r = La[a];
      r.blockedOn === e && (r.blockedOn = null);
    }
    for (; 0 < La.length && (a = La[0], a.blockedOn === null); )
      Hx(a), a.blockedOn === null && La.shift();
    if (a = (e.ownerDocument || e).$$reactFormReplay, a != null)
      for (r = 0; r < a.length; r += 3) {
        var c = a[r], u = a[r + 1], x = c[Vt] || null;
        if (typeof u == "function")
          x || Lx(a);
        else if (x) {
          var v = null;
          if (u && u.hasAttribute("formAction")) {
            if (c = u, x = u[Vt] || null)
              v = x.formAction;
            else if (Vd(c) !== null) continue;
          } else v = x.action;
          typeof v == "function" ? a[r + 1] = v : (a.splice(r, 3), r -= 3), Lx(a);
        }
      }
  }
  function Px() {
    function e(u) {
      u.canIntercept && u.info === "react-transition" && u.intercept({
        handler: function() {
          return new Promise(function(x) {
            return c = x;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      c !== null && (c(), c = null), r || setTimeout(a, 20);
    }
    function a() {
      if (!r && !navigation.transition) {
        var u = navigation.currentEntry;
        u && u.url != null && navigation.navigate(u.url, {
          state: u.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var r = !1, c = null;
      return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(a, 100), function() {
        r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), c !== null && (c(), c = null);
      };
    }
  }
  function Ud(e) {
    this._internalRoot = e;
  }
  Eo.prototype.render = Ud.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error(o(409));
    var a = t.current, r = tn();
    Rx(a, r, e, t, null, null);
  }, Eo.prototype.unmount = Ud.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      Rx(e.current, 2, null, e, null, null), lo(), t[Ui] = null;
    }
  };
  function Eo(e) {
    this._internalRoot = e;
  }
  Eo.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var t = zc();
      e = { blockedOn: null, target: e, priority: t };
      for (var a = 0; a < La.length && t !== 0 && t < La[a].priority; a++) ;
      La.splice(a, 0, e), a === 0 && Hx(e);
    }
  };
  var Ix = i.version;
  if (Ix !== "19.2.8")
    throw Error(
      o(
        527,
        Ix,
        "19.2.8"
      )
    );
  X.findDOMNode = function(e) {
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function" ? Error(o(188)) : (e = Object.keys(e).join(","), Error(o(268, e)));
    return e = m(t), e = e !== null ? b(e) : null, e = e === null ? null : e.stateNode, e;
  };
  var fj = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: O,
    reconcilerVersion: "19.2.8"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ko = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ko.isDisabled && ko.supportsFiber)
      try {
        ni = ko.inject(
          fj
        ), Mt = ko;
      } catch {
      }
  }
  return Dr.createRoot = function(e, t) {
    if (!d(e)) throw Error(o(299));
    var a = !1, r = "", c = Kp, u = $p, x = Wp;
    return t != null && (t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (c = t.onUncaughtError), t.onCaughtError !== void 0 && (u = t.onCaughtError), t.onRecoverableError !== void 0 && (x = t.onRecoverableError)), t = zx(
      e,
      1,
      !1,
      null,
      null,
      a,
      r,
      null,
      c,
      u,
      x,
      Px
    ), e[Ui] = t.current, wd(e), new Ud(t);
  }, Dr.hydrateRoot = function(e, t, a) {
    if (!d(e)) throw Error(o(299));
    var r = !1, c = "", u = Kp, x = $p, v = Wp, j = null;
    return a != null && (a.unstable_strictMode === !0 && (r = !0), a.identifierPrefix !== void 0 && (c = a.identifierPrefix), a.onUncaughtError !== void 0 && (u = a.onUncaughtError), a.onCaughtError !== void 0 && (x = a.onCaughtError), a.onRecoverableError !== void 0 && (v = a.onRecoverableError), a.formState !== void 0 && (j = a.formState)), t = zx(
      e,
      1,
      !0,
      t,
      a ?? null,
      r,
      c,
      j,
      u,
      x,
      v,
      Px
    ), t.context = Ox(null), a = t.current, r = tn(), r = Hi(r), c = Aa(r), c.callback = null, Ca(a, c, r), a = r, t.current.lanes = a, Ke(t, a), Hn(t), e[Ui] = t.current, wd(e), new Eo(t);
  }, Dr.version = "19.2.8", Dr;
}
var Jx;
function Sj() {
  if (Jx) return Pd.exports;
  Jx = 1;
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
      } catch (i) {
        console.error(i);
      }
  }
  return n(), Pd.exports = jj(), Pd.exports;
}
var Nj = Sj(), E = gc();
const Z = /* @__PURE__ */ ll(E), hv = /* @__PURE__ */ pj({
  __proto__: null,
  default: Z
}, [E]);
var Tj = (n, i, l, o, d, f, h, p) => {
  let g = document.documentElement, m = ["light", "dark"];
  function b(N) {
    (Array.isArray(n) ? n : [n]).forEach((T) => {
      let R = T === "class", _ = R && f ? d.map((z) => f[z] || z) : d;
      R ? (g.classList.remove(..._), g.classList.add(f && f[N] ? f[N] : N)) : g.setAttribute(T, N);
    }), y(N);
  }
  function y(N) {
    p && m.includes(N) && (g.style.colorScheme = N);
  }
  function w() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  if (o) b(o);
  else try {
    let N = localStorage.getItem(i) || l, T = h && N === "system" ? w() : N;
    b(T);
  } catch {
  }
}, Aj = E.createContext(void 0), Cj = { setTheme: (n) => {
}, themes: [] }, Ej = () => {
  var n;
  return (n = E.useContext(Aj)) != null ? n : Cj;
};
E.memo(({ forcedTheme: n, storageKey: i, attribute: l, enableSystem: o, enableColorScheme: d, defaultTheme: f, value: h, themes: p, nonce: g, scriptProps: m }) => {
  let b = JSON.stringify([l, i, f, n, p, h, o, d]).slice(1, -1);
  return E.createElement("script", { ...m, suppressHydrationWarning: !0, nonce: typeof window > "u" ? g : "", dangerouslySetInnerHTML: { __html: `(${Tj.toString()})(${b})` } });
});
var kj = dv();
const Mj = /* @__PURE__ */ ll(kj);
function zj(n) {
  if (typeof document > "u") return;
  let i = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.type = "text/css", i.appendChild(l), l.styleSheet ? l.styleSheet.cssText = n : l.appendChild(document.createTextNode(n));
}
const Oj = (n) => {
  switch (n) {
    case "success":
      return Dj;
    case "info":
      return Bj;
    case "warning":
      return Fj;
    case "error":
      return Vj;
    default:
      return null;
  }
}, Rj = Array(12).fill(0), _j = ({ visible: n, className: i }) => /* @__PURE__ */ Z.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    i
  ].filter(Boolean).join(" "),
  "data-visible": n
}, /* @__PURE__ */ Z.createElement("div", {
  className: "sonner-spinner"
}, Rj.map((l, o) => /* @__PURE__ */ Z.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${o}`
})))), Dj = /* @__PURE__ */ Z.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ Z.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), Fj = /* @__PURE__ */ Z.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ Z.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), Bj = /* @__PURE__ */ Z.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ Z.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), Vj = /* @__PURE__ */ Z.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ Z.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), Hj = /* @__PURE__ */ Z.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ Z.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ Z.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), Uj = () => {
  const [n, i] = Z.useState(document.hidden);
  return Z.useEffect(() => {
    const l = () => {
      i(document.hidden);
    };
    return document.addEventListener("visibilitychange", l), () => window.removeEventListener("visibilitychange", l);
  }, []), n;
};
let Eh = 1;
class Lj {
  constructor() {
    this.subscribe = (i) => (this.subscribers.push(i), () => {
      const l = this.subscribers.indexOf(i);
      this.subscribers.splice(l, 1);
    }), this.publish = (i) => {
      this.subscribers.forEach((l) => l(i));
    }, this.addToast = (i) => {
      this.publish(i), this.toasts = [
        ...this.toasts,
        i
      ];
    }, this.create = (i) => {
      var l;
      const { message: o, ...d } = i, f = typeof i?.id == "number" || ((l = i.id) == null ? void 0 : l.length) > 0 ? i.id : Eh++, h = this.toasts.find((g) => g.id === f), p = i.dismissible === void 0 ? !0 : i.dismissible;
      return this.dismissedToasts.has(f) && this.dismissedToasts.delete(f), h ? this.toasts = this.toasts.map((g) => g.id === f ? (this.publish({
        ...g,
        ...i,
        id: f,
        title: o
      }), {
        ...g,
        ...i,
        id: f,
        dismissible: p,
        title: o
      }) : g) : this.addToast({
        title: o,
        ...d,
        dismissible: p,
        id: f
      }), f;
    }, this.dismiss = (i) => (i ? (this.dismissedToasts.add(i), requestAnimationFrame(() => this.subscribers.forEach((l) => l({
      id: i,
      dismiss: !0
    })))) : this.toasts.forEach((l) => {
      this.subscribers.forEach((o) => o({
        id: l.id,
        dismiss: !0
      }));
    }), i), this.message = (i, l) => this.create({
      ...l,
      message: i
    }), this.error = (i, l) => this.create({
      ...l,
      message: i,
      type: "error"
    }), this.success = (i, l) => this.create({
      ...l,
      type: "success",
      message: i
    }), this.info = (i, l) => this.create({
      ...l,
      type: "info",
      message: i
    }), this.warning = (i, l) => this.create({
      ...l,
      type: "warning",
      message: i
    }), this.loading = (i, l) => this.create({
      ...l,
      type: "loading",
      message: i
    }), this.promise = (i, l) => {
      if (!l)
        return;
      let o;
      l.loading !== void 0 && (o = this.create({
        ...l,
        promise: i,
        type: "loading",
        message: l.loading,
        description: typeof l.description != "function" ? l.description : void 0
      }));
      const d = Promise.resolve(i instanceof Function ? i() : i);
      let f = o !== void 0, h;
      const p = d.then(async (m) => {
        if (h = [
          "resolve",
          m
        ], Z.isValidElement(m))
          f = !1, this.create({
            id: o,
            type: "default",
            message: m
          });
        else if (Ij(m) && !m.ok) {
          f = !1;
          const y = typeof l.error == "function" ? await l.error(`HTTP error! status: ${m.status}`) : l.error, w = typeof l.description == "function" ? await l.description(`HTTP error! status: ${m.status}`) : l.description, T = typeof y == "object" && !Z.isValidElement(y) ? y : {
            message: y
          };
          this.create({
            id: o,
            type: "error",
            description: w,
            ...T
          });
        } else if (m instanceof Error) {
          f = !1;
          const y = typeof l.error == "function" ? await l.error(m) : l.error, w = typeof l.description == "function" ? await l.description(m) : l.description, T = typeof y == "object" && !Z.isValidElement(y) ? y : {
            message: y
          };
          this.create({
            id: o,
            type: "error",
            description: w,
            ...T
          });
        } else if (l.success !== void 0) {
          f = !1;
          const y = typeof l.success == "function" ? await l.success(m) : l.success, w = typeof l.description == "function" ? await l.description(m) : l.description, T = typeof y == "object" && !Z.isValidElement(y) ? y : {
            message: y
          };
          this.create({
            id: o,
            type: "success",
            description: w,
            ...T
          });
        }
      }).catch(async (m) => {
        if (h = [
          "reject",
          m
        ], l.error !== void 0) {
          f = !1;
          const b = typeof l.error == "function" ? await l.error(m) : l.error, y = typeof l.description == "function" ? await l.description(m) : l.description, N = typeof b == "object" && !Z.isValidElement(b) ? b : {
            message: b
          };
          this.create({
            id: o,
            type: "error",
            description: y,
            ...N
          });
        }
      }).finally(() => {
        f && (this.dismiss(o), o = void 0), l.finally == null || l.finally.call(l);
      }), g = () => new Promise((m, b) => p.then(() => h[0] === "reject" ? b(h[1]) : m(h[1])).catch(b));
      return typeof o != "string" && typeof o != "number" ? {
        unwrap: g
      } : Object.assign(o, {
        unwrap: g
      });
    }, this.custom = (i, l) => {
      const o = l?.id || Eh++;
      return this.create({
        jsx: i(o),
        id: o,
        ...l
      }), o;
    }, this.getActiveToasts = () => this.toasts.filter((i) => !this.dismissedToasts.has(i.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Yt = new Lj(), Pj = (n, i) => {
  const l = i?.id || Eh++;
  return Yt.addToast({
    title: n,
    ...i,
    id: l
  }), l;
}, Ij = (n) => n && typeof n == "object" && "ok" in n && typeof n.ok == "boolean" && "status" in n && typeof n.status == "number", qj = Pj, Gj = () => Yt.toasts, Yj = () => Yt.getActiveToasts();
Object.assign(qj, {
  success: Yt.success,
  info: Yt.info,
  warning: Yt.warning,
  error: Yt.error,
  custom: Yt.custom,
  message: Yt.message,
  promise: Yt.promise,
  dismiss: Yt.dismiss,
  loading: Yt.loading
}, {
  getHistory: Gj,
  getToasts: Yj
});
zj("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function Mo(n) {
  return n.label !== void 0;
}
const Qj = 3, Zj = "24px", Xj = "16px", ey = 4e3, Kj = 356, $j = 14, Wj = 45, Jj = 200;
function Un(...n) {
  return n.filter(Boolean).join(" ");
}
function eS(n) {
  const [i, l] = n.split("-"), o = [];
  return i && o.push(i), l && o.push(l), o;
}
const tS = (n) => {
  var i, l, o, d, f, h, p, g, m;
  const { invert: b, toast: y, unstyled: w, interacting: N, setHeights: T, visibleToasts: R, heights: _, index: z, toasts: q, expanded: G, removeToast: Q, defaultRichColors: H, closeButton: W, style: $, cancelButtonStyle: k, actionButtonStyle: ee, className: ae = "", descriptionClassName: me = "", duration: xe, position: _e, gap: Be, expandByDefault: ze, classNames: O, icons: X, closeButtonAriaLabel: ne = "Close toast" } = n, [he, K] = Z.useState(null), [S, L] = Z.useState(null), [Y, J] = Z.useState(!1), [te, se] = Z.useState(!1), [ve, be] = Z.useState(!1), [pe, Qt] = Z.useState(!1), [_t, Ct] = Z.useState(!1), [pa, wt] = Z.useState(0), [Hs, Fi] = Z.useState(0), Ja = Z.useRef(y.duration || xe || ey), Us = Z.useRef(null), Zt = Z.useRef(null), Ls = z === 0, Ps = z + 1 <= R, Et = y.type, ga = y.dismissible !== !1, kt = y.className || "", kc = y.descriptionClassName || "", ei = Z.useMemo(() => _.findIndex((ge) => ge.toastId === y.id) || 0, [
    _,
    y.id
  ]), pl = Z.useMemo(() => {
    var ge;
    return (ge = y.closeButton) != null ? ge : W;
  }, [
    y.closeButton,
    W
  ]), ti = Z.useMemo(() => y.duration || xe || ey, [
    y.duration,
    xe
  ]), Is = Z.useRef(0), Zn = Z.useRef(0), gl = Z.useRef(0), xa = Z.useRef(null), [ni, Mt] = _e.split("-"), Nn = Z.useMemo(() => _.reduce((ge, Ze, ut) => ut >= ei ? ge : ge + Ze.height, 0), [
    _,
    ei
  ]), jt = Uj(), Mc = y.invert || b, qs = Et === "loading";
  Zn.current = Z.useMemo(() => ei * Be + Nn, [
    ei,
    Nn
  ]), Z.useEffect(() => {
    Ja.current = ti;
  }, [
    ti
  ]), Z.useEffect(() => {
    J(!0);
  }, []), Z.useEffect(() => {
    const ge = Zt.current;
    if (ge) {
      const Ze = ge.getBoundingClientRect().height;
      return Fi(Ze), T((ut) => [
        {
          toastId: y.id,
          height: Ze,
          position: y.position
        },
        ...ut
      ]), () => T((ut) => ut.filter((St) => St.toastId !== y.id));
    }
  }, [
    T,
    y.id
  ]), Z.useLayoutEffect(() => {
    if (!Y) return;
    const ge = Zt.current, Ze = ge.style.height;
    ge.style.height = "auto";
    const ut = ge.getBoundingClientRect().height;
    ge.style.height = Ze, Fi(ut), T((St) => St.find((Ke) => Ke.toastId === y.id) ? St.map((Ke) => Ke.toastId === y.id ? {
      ...Ke,
      height: ut
    } : Ke) : [
      {
        toastId: y.id,
        height: ut,
        position: y.position
      },
      ...St
    ]);
  }, [
    Y,
    y.title,
    y.description,
    T,
    y.id,
    y.jsx,
    y.action,
    y.cancel
  ]);
  const _n = Z.useCallback(() => {
    se(!0), wt(Zn.current), T((ge) => ge.filter((Ze) => Ze.toastId !== y.id)), setTimeout(() => {
      Q(y);
    }, Jj);
  }, [
    y,
    Q,
    T,
    Zn
  ]);
  Z.useEffect(() => {
    if (y.promise && Et === "loading" || y.duration === 1 / 0 || y.type === "loading") return;
    let ge;
    return G || N || jt ? (() => {
      if (gl.current < Is.current) {
        const St = (/* @__PURE__ */ new Date()).getTime() - Is.current;
        Ja.current = Ja.current - St;
      }
      gl.current = (/* @__PURE__ */ new Date()).getTime();
    })() : Ja.current !== 1 / 0 && (Is.current = (/* @__PURE__ */ new Date()).getTime(), ge = setTimeout(() => {
      y.onAutoClose == null || y.onAutoClose.call(y, y), _n();
    }, Ja.current)), () => clearTimeout(ge);
  }, [
    G,
    N,
    y,
    Et,
    jt,
    _n
  ]), Z.useEffect(() => {
    y.delete && (_n(), y.onDismiss == null || y.onDismiss.call(y, y));
  }, [
    _n,
    y.delete
  ]);
  function Bi() {
    var ge;
    if (X?.loading) {
      var Ze;
      return /* @__PURE__ */ Z.createElement("div", {
        className: Un(O?.loader, y == null || (Ze = y.classNames) == null ? void 0 : Ze.loader, "sonner-loader"),
        "data-visible": Et === "loading"
      }, X.loading);
    }
    return /* @__PURE__ */ Z.createElement(_j, {
      className: Un(O?.loader, y == null || (ge = y.classNames) == null ? void 0 : ge.loader),
      visible: Et === "loading"
    });
  }
  const Vi = y.icon || X?.[Et] || Oj(Et);
  var ai, Dn;
  return /* @__PURE__ */ Z.createElement("li", {
    tabIndex: 0,
    ref: Zt,
    className: Un(ae, kt, O?.toast, y == null || (i = y.classNames) == null ? void 0 : i.toast, O?.default, O?.[Et], y == null || (l = y.classNames) == null ? void 0 : l[Et]),
    "data-sonner-toast": "",
    "data-rich-colors": (ai = y.richColors) != null ? ai : H,
    "data-styled": !(y.jsx || y.unstyled || w),
    "data-mounted": Y,
    "data-promise": !!y.promise,
    "data-swiped": _t,
    "data-removed": te,
    "data-visible": Ps,
    "data-y-position": ni,
    "data-x-position": Mt,
    "data-index": z,
    "data-front": Ls,
    "data-swiping": ve,
    "data-dismissible": ga,
    "data-type": Et,
    "data-invert": Mc,
    "data-swipe-out": pe,
    "data-swipe-direction": S,
    "data-expanded": !!(G || ze && Y),
    "data-testid": y.testId,
    style: {
      "--index": z,
      "--toasts-before": z,
      "--z-index": q.length - z,
      "--offset": `${te ? pa : Zn.current}px`,
      "--initial-height": ze ? "auto" : `${Hs}px`,
      ...$,
      ...y.style
    },
    onDragEnd: () => {
      be(!1), K(null), xa.current = null;
    },
    onPointerDown: (ge) => {
      ge.button !== 2 && (qs || !ga || (Us.current = /* @__PURE__ */ new Date(), wt(Zn.current), ge.target.setPointerCapture(ge.pointerId), ge.target.tagName !== "BUTTON" && (be(!0), xa.current = {
        x: ge.clientX,
        y: ge.clientY
      })));
    },
    onPointerUp: () => {
      var ge, Ze, ut;
      if (pe || !ga) return;
      xa.current = null;
      const St = Number(((ge = Zt.current) == null ? void 0 : ge.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), ya = Number(((Ze = Zt.current) == null ? void 0 : Ze.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ke = (/* @__PURE__ */ new Date()).getTime() - ((ut = Us.current) == null ? void 0 : ut.getTime()), Dt = he === "x" ? St : ya, ii = Math.abs(Dt) / Ke;
      if (Math.abs(Dt) >= Wj || ii > 0.11) {
        wt(Zn.current), y.onDismiss == null || y.onDismiss.call(y, y), L(he === "x" ? St > 0 ? "right" : "left" : ya > 0 ? "down" : "up"), _n(), Qt(!0);
        return;
      } else {
        var Ft, Bt;
        (Ft = Zt.current) == null || Ft.style.setProperty("--swipe-amount-x", "0px"), (Bt = Zt.current) == null || Bt.style.setProperty("--swipe-amount-y", "0px");
      }
      Ct(!1), be(!1), K(null);
    },
    onPointerMove: (ge) => {
      var Ze, ut, St;
      if (!xa.current || !ga || ((Ze = window.getSelection()) == null ? void 0 : Ze.toString().length) > 0) return;
      const Ke = ge.clientY - xa.current.y, Dt = ge.clientX - xa.current.x;
      var ii;
      const Ft = (ii = n.swipeDirections) != null ? ii : eS(_e);
      !he && (Math.abs(Dt) > 1 || Math.abs(Ke) > 1) && K(Math.abs(Dt) > Math.abs(Ke) ? "x" : "y");
      let Bt = {
        x: 0,
        y: 0
      };
      const Hi = (Tn) => 1 / (1.5 + Math.abs(Tn) / 20);
      if (he === "y") {
        if (Ft.includes("top") || Ft.includes("bottom"))
          if (Ft.includes("top") && Ke < 0 || Ft.includes("bottom") && Ke > 0)
            Bt.y = Ke;
          else {
            const Tn = Ke * Hi(Ke);
            Bt.y = Math.abs(Tn) < Math.abs(Ke) ? Tn : Ke;
          }
      } else if (he === "x" && (Ft.includes("left") || Ft.includes("right")))
        if (Ft.includes("left") && Dt < 0 || Ft.includes("right") && Dt > 0)
          Bt.x = Dt;
        else {
          const Tn = Dt * Hi(Dt);
          Bt.x = Math.abs(Tn) < Math.abs(Dt) ? Tn : Dt;
        }
      (Math.abs(Bt.x) > 0 || Math.abs(Bt.y) > 0) && Ct(!0), (ut = Zt.current) == null || ut.style.setProperty("--swipe-amount-x", `${Bt.x}px`), (St = Zt.current) == null || St.style.setProperty("--swipe-amount-y", `${Bt.y}px`);
    }
  }, pl && !y.jsx && Et !== "loading" ? /* @__PURE__ */ Z.createElement("button", {
    "aria-label": ne,
    "data-disabled": qs,
    "data-close-button": !0,
    onClick: qs || !ga ? () => {
    } : () => {
      _n(), y.onDismiss == null || y.onDismiss.call(y, y);
    },
    className: Un(O?.closeButton, y == null || (o = y.classNames) == null ? void 0 : o.closeButton)
  }, (Dn = X?.close) != null ? Dn : Hj) : null, (Et || y.icon || y.promise) && y.icon !== null && (X?.[Et] !== null || y.icon) ? /* @__PURE__ */ Z.createElement("div", {
    "data-icon": "",
    className: Un(O?.icon, y == null || (d = y.classNames) == null ? void 0 : d.icon)
  }, y.promise || y.type === "loading" && !y.icon ? y.icon || Bi() : null, y.type !== "loading" ? Vi : null) : null, /* @__PURE__ */ Z.createElement("div", {
    "data-content": "",
    className: Un(O?.content, y == null || (f = y.classNames) == null ? void 0 : f.content)
  }, /* @__PURE__ */ Z.createElement("div", {
    "data-title": "",
    className: Un(O?.title, y == null || (h = y.classNames) == null ? void 0 : h.title)
  }, y.jsx ? y.jsx : typeof y.title == "function" ? y.title() : y.title), y.description ? /* @__PURE__ */ Z.createElement("div", {
    "data-description": "",
    className: Un(me, kc, O?.description, y == null || (p = y.classNames) == null ? void 0 : p.description)
  }, typeof y.description == "function" ? y.description() : y.description) : null), /* @__PURE__ */ Z.isValidElement(y.cancel) ? y.cancel : y.cancel && Mo(y.cancel) ? /* @__PURE__ */ Z.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: y.cancelButtonStyle || k,
    onClick: (ge) => {
      Mo(y.cancel) && ga && (y.cancel.onClick == null || y.cancel.onClick.call(y.cancel, ge), _n());
    },
    className: Un(O?.cancelButton, y == null || (g = y.classNames) == null ? void 0 : g.cancelButton)
  }, y.cancel.label) : null, /* @__PURE__ */ Z.isValidElement(y.action) ? y.action : y.action && Mo(y.action) ? /* @__PURE__ */ Z.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: y.actionButtonStyle || ee,
    onClick: (ge) => {
      Mo(y.action) && (y.action.onClick == null || y.action.onClick.call(y.action, ge), !ge.defaultPrevented && _n());
    },
    className: Un(O?.actionButton, y == null || (m = y.classNames) == null ? void 0 : m.actionButton)
  }, y.action.label) : null);
};
function ty() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const n = document.documentElement.getAttribute("dir");
  return n === "auto" || !n ? window.getComputedStyle(document.documentElement).direction : n;
}
function nS(n, i) {
  const l = {};
  return [
    n,
    i
  ].forEach((o, d) => {
    const f = d === 1, h = f ? "--mobile-offset" : "--offset", p = f ? Xj : Zj;
    function g(m) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((b) => {
        l[`${h}-${b}`] = typeof m == "number" ? `${m}px` : m;
      });
    }
    typeof o == "number" || typeof o == "string" ? g(o) : typeof o == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((m) => {
      o[m] === void 0 ? l[`${h}-${m}`] = p : l[`${h}-${m}`] = typeof o[m] == "number" ? `${o[m]}px` : o[m];
    }) : g(p);
  }), l;
}
const aS = /* @__PURE__ */ Z.forwardRef(function(i, l) {
  const { id: o, invert: d, position: f = "bottom-right", hotkey: h = [
    "altKey",
    "KeyT"
  ], expand: p, closeButton: g, className: m, offset: b, mobileOffset: y, theme: w = "light", richColors: N, duration: T, style: R, visibleToasts: _ = Qj, toastOptions: z, dir: q = ty(), gap: G = $j, icons: Q, containerAriaLabel: H = "Notifications" } = i, [W, $] = Z.useState([]), k = Z.useMemo(() => o ? W.filter((Y) => Y.toasterId === o) : W.filter((Y) => !Y.toasterId), [
    W,
    o
  ]), ee = Z.useMemo(() => Array.from(new Set([
    f
  ].concat(k.filter((Y) => Y.position).map((Y) => Y.position)))), [
    k,
    f
  ]), [ae, me] = Z.useState([]), [xe, _e] = Z.useState(!1), [Be, ze] = Z.useState(!1), [O, X] = Z.useState(w !== "system" ? w : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), ne = Z.useRef(null), he = h.join("+").replace(/Key/g, "").replace(/Digit/g, ""), K = Z.useRef(null), S = Z.useRef(!1), L = Z.useCallback((Y) => {
    $((J) => {
      var te;
      return (te = J.find((se) => se.id === Y.id)) != null && te.delete || Yt.dismiss(Y.id), J.filter(({ id: se }) => se !== Y.id);
    });
  }, []);
  return Z.useEffect(() => Yt.subscribe((Y) => {
    if (Y.dismiss) {
      requestAnimationFrame(() => {
        $((J) => J.map((te) => te.id === Y.id ? {
          ...te,
          delete: !0
        } : te));
      });
      return;
    }
    setTimeout(() => {
      Mj.flushSync(() => {
        $((J) => {
          const te = J.findIndex((se) => se.id === Y.id);
          return te !== -1 ? [
            ...J.slice(0, te),
            {
              ...J[te],
              ...Y
            },
            ...J.slice(te + 1)
          ] : [
            Y,
            ...J
          ];
        });
      });
    });
  }), [
    W
  ]), Z.useEffect(() => {
    if (w !== "system") {
      X(w);
      return;
    }
    if (w === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? X("dark") : X("light")), typeof window > "u") return;
    const Y = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      Y.addEventListener("change", ({ matches: J }) => {
        X(J ? "dark" : "light");
      });
    } catch {
      Y.addListener(({ matches: te }) => {
        try {
          X(te ? "dark" : "light");
        } catch (se) {
          console.error(se);
        }
      });
    }
  }, [
    w
  ]), Z.useEffect(() => {
    W.length <= 1 && _e(!1);
  }, [
    W
  ]), Z.useEffect(() => {
    const Y = (J) => {
      var te;
      if (h.every((be) => J[be] || J.code === be)) {
        var ve;
        _e(!0), (ve = ne.current) == null || ve.focus();
      }
      J.code === "Escape" && (document.activeElement === ne.current || (te = ne.current) != null && te.contains(document.activeElement)) && _e(!1);
    };
    return document.addEventListener("keydown", Y), () => document.removeEventListener("keydown", Y);
  }, [
    h
  ]), Z.useEffect(() => {
    if (ne.current)
      return () => {
        K.current && (K.current.focus({
          preventScroll: !0
        }), K.current = null, S.current = !1);
      };
  }, [
    ne.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ Z.createElement("section", {
    ref: l,
    "aria-label": `${H} ${he}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, ee.map((Y, J) => {
    var te;
    const [se, ve] = Y.split("-");
    return k.length ? /* @__PURE__ */ Z.createElement("ol", {
      key: Y,
      dir: q === "auto" ? ty() : q,
      tabIndex: -1,
      ref: ne,
      className: m,
      "data-sonner-toaster": !0,
      "data-sonner-theme": O,
      "data-y-position": se,
      "data-x-position": ve,
      style: {
        "--front-toast-height": `${((te = ae[0]) == null ? void 0 : te.height) || 0}px`,
        "--width": `${Kj}px`,
        "--gap": `${G}px`,
        ...R,
        ...nS(b, y)
      },
      onBlur: (be) => {
        S.current && !be.currentTarget.contains(be.relatedTarget) && (S.current = !1, K.current && (K.current.focus({
          preventScroll: !0
        }), K.current = null));
      },
      onFocus: (be) => {
        be.target instanceof HTMLElement && be.target.dataset.dismissible === "false" || S.current || (S.current = !0, K.current = be.relatedTarget);
      },
      onMouseEnter: () => _e(!0),
      onMouseMove: () => _e(!0),
      onMouseLeave: () => {
        Be || _e(!1);
      },
      onDragEnd: () => _e(!1),
      onPointerDown: (be) => {
        be.target instanceof HTMLElement && be.target.dataset.dismissible === "false" || ze(!0);
      },
      onPointerUp: () => ze(!1)
    }, k.filter((be) => !be.position && J === 0 || be.position === Y).map((be, pe) => {
      var Qt, _t;
      return /* @__PURE__ */ Z.createElement(tS, {
        key: be.id,
        icons: Q,
        index: pe,
        toast: be,
        defaultRichColors: N,
        duration: (Qt = z?.duration) != null ? Qt : T,
        className: z?.className,
        descriptionClassName: z?.descriptionClassName,
        invert: d,
        visibleToasts: _,
        closeButton: (_t = z?.closeButton) != null ? _t : g,
        interacting: Be,
        position: Y,
        style: z?.style,
        unstyled: z?.unstyled,
        classNames: z?.classNames,
        cancelButtonStyle: z?.cancelButtonStyle,
        actionButtonStyle: z?.actionButtonStyle,
        closeButtonAriaLabel: z?.closeButtonAriaLabel,
        removeToast: L,
        toasts: k.filter((Ct) => Ct.position == be.position),
        heights: ae.filter((Ct) => Ct.position == be.position),
        setHeights: me,
        expandByDefault: p,
        gap: G,
        expanded: xe,
        swipeDirections: i.swipeDirections
      });
    })) : null;
  }));
}), iS = ({ ...n }) => {
  const { theme: i = "system" } = Ej();
  return /* @__PURE__ */ s.jsx(
    aS,
    {
      theme: i,
      className: "toaster group",
      style: {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)"
      },
      ...n
    }
  );
};
var sS = Object.defineProperty, df = (n, i) => sS(n, "name", { value: i, configurable: !0 });
function kh(n, i) {
  if (typeof n == "function")
    return n(i);
  n != null && (n.current = i);
}
df(kh, "setRef");
function fv(...n) {
  return (i) => {
    let l = !1;
    const o = n.map((d) => {
      const f = kh(d, i);
      return !l && typeof f == "function" && (l = !0), f;
    });
    if (l)
      return () => {
        for (let d = 0; d < o.length; d++) {
          const f = o[d];
          typeof f == "function" ? f() : kh(n[d], null);
        }
      };
  };
}
df(fv, "composeRefs");
function mv(...n) {
  return E.useCallback(fv(...n), n);
}
df(mv, "useComposedRefs");
var rS = Object.defineProperty, wn = (n, i) => rS(n, "name", { value: i, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function lS(n, i) {
  const l = E.createContext(i);
  l.displayName = n + "Context";
  const o = /* @__PURE__ */ wn((f) => {
    const { children: h, ...p } = f, g = E.useMemo(() => p, Object.values(p));
    return /* @__PURE__ */ s.jsx(l.Provider, { value: g, children: h });
  }, "Provider");
  o.displayName = n + "Provider";
  function d(f, h = {}) {
    const { optional: p = !1 } = h, g = E.useContext(l);
    if (g) return g;
    if (i !== void 0) return i;
    if (!p)
      throw new Error(`\`${f}\` must be used within \`${n}\``);
  }
  return wn(d, "useContext"), [o, d];
}
wn(lS, "createContext");
// @__NO_SIDE_EFFECTS__
function hf(n, i = []) {
  let l = [];
  function o(f, h) {
    const p = E.createContext(h);
    p.displayName = f + "Context";
    const g = l.length;
    l = [...l, h];
    const m = /* @__PURE__ */ wn((y) => {
      const { scope: w, children: N, ...T } = y, R = w?.[n]?.[g] || p, _ = E.useMemo(() => T, Object.values(T));
      return /* @__PURE__ */ s.jsx(R.Provider, { value: _, children: N });
    }, "Provider");
    m.displayName = f + "Provider";
    function b(y, w, N = {}) {
      const { optional: T = !1 } = N, R = w?.[n]?.[g] || p, _ = E.useContext(R);
      if (_) return _;
      if (h !== void 0) return h;
      if (!T)
        throw new Error(`\`${y}\` must be used within \`${f}\``);
    }
    return wn(b, "useContext"), [m, b];
  }
  wn(o, "createContext");
  const d = /* @__PURE__ */ wn(() => {
    const f = l.map((h) => E.createContext(h));
    return /* @__PURE__ */ wn(function(p) {
      const g = p?.[n] || f;
      return E.useMemo(
        () => ({ [`__scope${n}`]: { ...p, [n]: g } }),
        [p, g]
      );
    }, "useScope");
  }, "createScope");
  return d.scopeName = n, [o, pv(d, ...i)];
}
wn(hf, "createContextScope");
function pv(...n) {
  const i = n[0];
  if (n.length === 1) return i;
  const l = /* @__PURE__ */ wn(() => {
    const o = n.map((d) => ({
      useScope: d(),
      scopeName: d.scopeName
    }));
    return /* @__PURE__ */ wn(function(f) {
      const h = o.reduce((p, { useScope: g, scopeName: m }) => {
        const y = g(f)[`__scope${m}`];
        return { ...p, ...y };
      }, {});
      return E.useMemo(() => ({ [`__scope${i.scopeName}`]: h }), [h]);
    }, "useComposedScopes");
  }, "createScope");
  return l.scopeName = i.scopeName, l;
}
wn(pv, "composeContextScopes");
var oS = Object.defineProperty, Rn = (n, i) => oS(n, "name", { value: i, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function gv(n) {
  const i = E.forwardRef((l, o) => {
    let { children: d, ...f } = l, h = null, p = !1;
    const g = [];
    Mh(d) && typeof zo == "function" && (d = zo(d._payload)), E.Children.forEach(d, (w) => {
      if (vv(w)) {
        p = !0;
        const N = w;
        let T = "child" in N.props ? N.props.child : N.props.children;
        Mh(T) && typeof zo == "function" && (T = zo(T._payload)), h = dS(N, T), g.push(h?.props?.children);
      } else
        g.push(w);
    }), h ? h = E.cloneElement(h, void 0, g) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !p && E.Children.count(d) === 1 && E.isValidElement(d) && (h = d)
    );
    const m = h ? bv(h) : void 0, b = mv(o, m);
    if (!h) {
      if (d || d === 0)
        throw new Error(
          p ? mS(n) : fS(n)
        );
      return d;
    }
    const y = yv(f, h.props ?? {});
    return h.type !== E.Fragment && (y.ref = o ? b : m), E.cloneElement(h, y);
  });
  return i.displayName = `${n}.Slot`, i;
}
Rn(gv, "createSlot");
var cS = /* @__PURE__ */ gv("Slot"), xv = /* @__PURE__ */ Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function uS(n) {
  const i = /* @__PURE__ */ Rn((l) => "child" in l ? l.children(l.child) : l.children, "Slottable");
  return i.displayName = `${n}.Slottable`, i.__radixId = xv, i;
}
Rn(uS, "createSlottable");
var dS = /* @__PURE__ */ Rn((n, i) => {
  if ("child" in n.props) {
    const l = n.props.child;
    return E.isValidElement(l) ? E.cloneElement(l, void 0, n.props.children(l.props.children)) : null;
  }
  return E.isValidElement(i) ? i : null;
}, "getSlottableElementFromSlottable");
function yv(n, i) {
  const l = { ...i };
  for (const o in i) {
    const d = n[o], f = i[o];
    /^on[A-Z]/.test(o) ? d && f ? l[o] = (...p) => {
      const g = f(...p);
      return d(...p), g;
    } : d && (l[o] = d) : o === "style" ? l[o] = { ...d, ...f } : o === "className" && (l[o] = [d, f].filter(Boolean).join(" "));
  }
  return { ...n, ...l };
}
Rn(yv, "mergeProps");
function bv(n) {
  let i = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, l = i && "isReactWarning" in i && i.isReactWarning;
  return l ? n.ref : (i = Object.getOwnPropertyDescriptor(n, "ref")?.get, l = i && "isReactWarning" in i && i.isReactWarning, l ? n.props.ref : n.props.ref || n.ref);
}
Rn(bv, "getElementRef");
function vv(n) {
  return E.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === xv;
}
Rn(vv, "isSlottable");
var hS = /* @__PURE__ */ Symbol.for("react.lazy");
function Mh(n) {
  return n != null && typeof n == "object" && "$$typeof" in n && n.$$typeof === hS && "_payload" in n && wv(n._payload);
}
Rn(Mh, "isLazyComponent");
function wv(n) {
  return typeof n == "object" && n !== null && "then" in n;
}
Rn(wv, "isPromiseLike");
var fS = /* @__PURE__ */ Rn((n) => `${n} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), mS = /* @__PURE__ */ Rn((n) => `${n} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), zo = hv[" use ".trim().toString()], pS = Object.defineProperty, jv = (n, i) => pS(n, "name", { value: i, configurable: !0 }), Sv = "Popper", [Nv, Tv] = /* @__PURE__ */ hf(Sv), [zE, OE] = Nv(Sv), gS = "PopperContent", [RE, _E] = Nv(gS);
function xS(n) {
  return n !== null;
}
jv(xS, "isNotNull");
function yS(n) {
  const [i, l = "center"] = n.split("-");
  return [i, l];
}
jv(yS, "getSideAndAlignFromPlacement");
var bS = Object.defineProperty, _i = (n, i) => bS(n, "name", { value: i, configurable: !0 }), [ff, DE] = /* @__PURE__ */ hf("Tooltip", [
  Tv
]);
Tv();
var vS = "TooltipProvider", wS = 700, [jS, FE] = ff(vS), SS = /* @__PURE__ */ _i((n) => {
  const {
    __scopeTooltip: i,
    delayDuration: l = wS,
    skipDelayDuration: o = 300,
    disableHoverableContent: d = !1,
    children: f
  } = n, h = E.useRef(!0), p = E.useRef(!1), g = E.useRef(0);
  return E.useEffect(() => {
    const m = g.current;
    return () => window.clearTimeout(m);
  }, []), /* @__PURE__ */ s.jsx(
    jS,
    {
      scope: i,
      isOpenDelayedRef: h,
      delayDuration: l,
      onOpen: E.useCallback(() => {
        o <= 0 || (window.clearTimeout(g.current), h.current = !1);
      }, [o]),
      onClose: E.useCallback(() => {
        o <= 0 || (window.clearTimeout(g.current), g.current = window.setTimeout(
          () => h.current = !0,
          o
        ));
      }, [o]),
      isPointerInTransitRef: p,
      onPointerInTransitChange: E.useCallback((m) => {
        p.current = m;
      }, []),
      disableHoverableContent: d,
      children: f
    }
  );
}, "TooltipProvider"), NS = "Tooltip", [BE, VE] = ff(NS), TS = "TooltipPortal", [HE, UE] = ff(TS, {
  forceMount: void 0
});
function AS(n, i) {
  const l = Math.abs(i.top - n.y), o = Math.abs(i.bottom - n.y), d = Math.abs(i.right - n.x), f = Math.abs(i.left - n.x);
  switch (Math.min(l, o, d, f)) {
    case f:
      return "left";
    case d:
      return "right";
    case l:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
_i(AS, "getExitSideFromRect");
function CS(n, i, l = 5) {
  const o = [];
  switch (i) {
    case "top":
      o.push(
        { x: n.x - l, y: n.y + l },
        { x: n.x + l, y: n.y + l }
      );
      break;
    case "bottom":
      o.push(
        { x: n.x - l, y: n.y - l },
        { x: n.x + l, y: n.y - l }
      );
      break;
    case "left":
      o.push(
        { x: n.x + l, y: n.y - l },
        { x: n.x + l, y: n.y + l }
      );
      break;
    case "right":
      o.push(
        { x: n.x - l, y: n.y - l },
        { x: n.x - l, y: n.y + l }
      );
      break;
  }
  return o;
}
_i(CS, "getPaddedExitPoints");
function ES(n) {
  const { top: i, right: l, bottom: o, left: d } = n;
  return [
    { x: d, y: i },
    { x: l, y: i },
    { x: l, y: o },
    { x: d, y: o }
  ];
}
_i(ES, "getPointsFromRect");
function kS(n, i) {
  const { x: l, y: o } = n;
  let d = !1;
  for (let f = 0, h = i.length - 1; f < i.length; h = f++) {
    const p = i[f], g = i[h], m = p.x, b = p.y, y = g.x, w = g.y;
    b > o != w > o && l < (y - m) * (o - b) / (w - b) + m && (d = !d);
  }
  return d;
}
_i(kS, "isPointInPolygon");
function MS(n) {
  const i = n.slice();
  return i.sort((l, o) => l.x < o.x ? -1 : l.x > o.x ? 1 : l.y < o.y ? -1 : l.y > o.y ? 1 : 0), Av(i);
}
_i(MS, "getHull");
function Av(n) {
  if (n.length <= 1) return n.slice();
  const i = [];
  for (let o = 0; o < n.length; o++) {
    const d = n[o];
    for (; i.length >= 2; ) {
      const f = i[i.length - 1], h = i[i.length - 2];
      if ((f.x - h.x) * (d.y - h.y) >= (f.y - h.y) * (d.x - h.x)) i.pop();
      else break;
    }
    i.push(d);
  }
  i.pop();
  const l = [];
  for (let o = n.length - 1; o >= 0; o--) {
    const d = n[o];
    for (; l.length >= 2; ) {
      const f = l[l.length - 1], h = l[l.length - 2];
      if ((f.x - h.x) * (d.y - h.y) >= (f.y - h.y) * (d.x - h.x)) l.pop();
      else break;
    }
    l.push(d);
  }
  return l.pop(), i.length === 1 && l.length === 1 && i[0].x === l[0].x && i[0].y === l[0].y ? i : i.concat(l);
}
_i(Av, "getHullPresorted");
var zS = SS;
function Cv(n) {
  var i, l, o = "";
  if (typeof n == "string" || typeof n == "number") o += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var d = n.length;
    for (i = 0; i < d; i++) n[i] && (l = Cv(n[i])) && (o && (o += " "), o += l);
  } else for (l in n) n[l] && (o && (o += " "), o += l);
  return o;
}
function Ev() {
  for (var n, i, l = 0, o = "", d = arguments.length; l < d; l++) (n = arguments[l]) && (i = Cv(n)) && (o && (o += " "), o += i);
  return o;
}
const OS = (n, i) => {
  const l = new Array(n.length + i.length);
  for (let o = 0; o < n.length; o++)
    l[o] = n[o];
  for (let o = 0; o < i.length; o++)
    l[n.length + o] = i[o];
  return l;
}, RS = (n, i) => ({
  classGroupId: n,
  validator: i
}), kv = (n = /* @__PURE__ */ new Map(), i = null, l) => ({
  nextPart: n,
  validators: i,
  classGroupId: l
}), ac = "-", ny = [], _S = "arbitrary..", DS = (n) => {
  const i = BS(n), {
    conflictingClassGroups: l,
    conflictingClassGroupModifiers: o
  } = n;
  return {
    getClassGroupId: (h) => {
      if (h.startsWith("[") && h.endsWith("]"))
        return FS(h);
      const p = h.split(ac), g = p[0] === "" && p.length > 1 ? 1 : 0;
      return Mv(p, g, i);
    },
    getConflictingClassGroupIds: (h, p) => {
      if (p) {
        const g = o[h], m = l[h];
        return g ? m ? OS(m, g) : g : m || ny;
      }
      return l[h] || ny;
    }
  };
}, Mv = (n, i, l) => {
  if (n.length - i === 0)
    return l.classGroupId;
  const d = n[i], f = l.nextPart.get(d);
  if (f) {
    const m = Mv(n, i + 1, f);
    if (m) return m;
  }
  const h = l.validators;
  if (h === null)
    return;
  const p = i === 0 ? n.join(ac) : n.slice(i).join(ac), g = h.length;
  for (let m = 0; m < g; m++) {
    const b = h[m];
    if (b.validator(p))
      return b.classGroupId;
  }
}, FS = (n) => n.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const i = n.slice(1, -1), l = i.indexOf(":"), o = i.slice(0, l);
  return o ? _S + o : void 0;
})(), BS = (n) => {
  const {
    theme: i,
    classGroups: l
  } = n;
  return VS(l, i);
}, VS = (n, i) => {
  const l = kv();
  for (const o in n) {
    const d = n[o];
    mf(d, l, o, i);
  }
  return l;
}, mf = (n, i, l, o) => {
  const d = n.length;
  for (let f = 0; f < d; f++) {
    const h = n[f];
    HS(h, i, l, o);
  }
}, HS = (n, i, l, o) => {
  if (typeof n == "string") {
    US(n, i, l);
    return;
  }
  if (typeof n == "function") {
    LS(n, i, l, o);
    return;
  }
  PS(n, i, l, o);
}, US = (n, i, l) => {
  const o = n === "" ? i : zv(i, n);
  o.classGroupId = l;
}, LS = (n, i, l, o) => {
  if (IS(n)) {
    mf(n(o), i, l, o);
    return;
  }
  i.validators === null && (i.validators = []), i.validators.push(RS(l, n));
}, PS = (n, i, l, o) => {
  const d = Object.entries(n), f = d.length;
  for (let h = 0; h < f; h++) {
    const [p, g] = d[h];
    mf(g, zv(i, p), l, o);
  }
}, zv = (n, i) => {
  let l = n;
  const o = i.split(ac), d = o.length;
  for (let f = 0; f < d; f++) {
    const h = o[f];
    let p = l.nextPart.get(h);
    p || (p = kv(), l.nextPart.set(h, p)), l = p;
  }
  return l;
}, IS = (n) => "isThemeGetter" in n && n.isThemeGetter === !0, qS = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let i = 0, l = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  const d = (f, h) => {
    l[f] = h, i++, i > n && (i = 0, o = l, l = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(f) {
      let h = l[f];
      if (h !== void 0)
        return h;
      if ((h = o[f]) !== void 0)
        return d(f, h), h;
    },
    set(f, h) {
      f in l ? l[f] = h : d(f, h);
    }
  };
}, zh = "!", ay = ":", GS = [], iy = (n, i, l, o, d) => ({
  modifiers: n,
  hasImportantModifier: i,
  baseClassName: l,
  maybePostfixModifierPosition: o,
  isExternal: d
}), YS = (n) => {
  const {
    prefix: i,
    experimentalParseClassName: l
  } = n;
  let o = (d) => {
    const f = [];
    let h = 0, p = 0, g = 0, m;
    const b = d.length;
    for (let R = 0; R < b; R++) {
      const _ = d[R];
      if (h === 0 && p === 0) {
        if (_ === ay) {
          f.push(d.slice(g, R)), g = R + 1;
          continue;
        }
        if (_ === "/") {
          m = R;
          continue;
        }
      }
      _ === "[" ? h++ : _ === "]" ? h-- : _ === "(" ? p++ : _ === ")" && p--;
    }
    const y = f.length === 0 ? d : d.slice(g);
    let w = y, N = !1;
    y.endsWith(zh) ? (w = y.slice(0, -1), N = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      y.startsWith(zh) && (w = y.slice(1), N = !0)
    );
    const T = m && m > g ? m - g : void 0;
    return iy(f, N, w, T);
  };
  if (i) {
    const d = i + ay, f = o;
    o = (h) => h.startsWith(d) ? f(h.slice(d.length)) : iy(GS, !1, h, void 0, !0);
  }
  if (l) {
    const d = o;
    o = (f) => l({
      className: f,
      parseClassName: d
    });
  }
  return o;
}, QS = (n) => {
  const i = /* @__PURE__ */ new Map();
  return n.orderSensitiveModifiers.forEach((l, o) => {
    i.set(l, 1e6 + o);
  }), (l) => {
    const o = [];
    let d = [];
    for (let f = 0; f < l.length; f++) {
      const h = l[f], p = h[0] === "[", g = i.has(h);
      p || g ? (d.length > 0 && (d.sort(), o.push(...d), d = []), o.push(h)) : d.push(h);
    }
    return d.length > 0 && (d.sort(), o.push(...d)), o;
  };
}, ZS = (n) => ({
  cache: qS(n.cacheSize),
  parseClassName: YS(n),
  sortModifiers: QS(n),
  postfixLookupClassGroupIds: XS(n),
  ...DS(n)
}), XS = (n) => {
  const i = /* @__PURE__ */ Object.create(null), l = n.postfixLookupClassGroups;
  if (l)
    for (let o = 0; o < l.length; o++)
      i[l[o]] = !0;
  return i;
}, KS = /\s+/, $S = (n, i) => {
  const {
    parseClassName: l,
    getClassGroupId: o,
    getConflictingClassGroupIds: d,
    sortModifiers: f,
    postfixLookupClassGroupIds: h
  } = i, p = [], g = n.trim().split(KS);
  let m = "";
  for (let b = g.length - 1; b >= 0; b -= 1) {
    const y = g[b], {
      isExternal: w,
      modifiers: N,
      hasImportantModifier: T,
      baseClassName: R,
      maybePostfixModifierPosition: _
    } = l(y);
    if (w) {
      m = y + (m.length > 0 ? " " + m : m);
      continue;
    }
    let z = !!_, q;
    if (z) {
      const $ = R.substring(0, _);
      q = o($);
      const k = q && h[q] ? o(R) : void 0;
      k && k !== q && (q = k, z = !1);
    } else
      q = o(R);
    if (!q) {
      if (!z) {
        m = y + (m.length > 0 ? " " + m : m);
        continue;
      }
      if (q = o(R), !q) {
        m = y + (m.length > 0 ? " " + m : m);
        continue;
      }
      z = !1;
    }
    const G = N.length === 0 ? "" : N.length === 1 ? N[0] : f(N).join(":"), Q = T ? G + zh : G, H = Q + q;
    if (p.indexOf(H) > -1)
      continue;
    p.push(H);
    const W = d(q, z);
    for (let $ = 0; $ < W.length; ++$) {
      const k = W[$];
      p.push(Q + k);
    }
    m = y + (m.length > 0 ? " " + m : m);
  }
  return m;
}, WS = (...n) => {
  let i = 0, l, o, d = "";
  for (; i < n.length; )
    (l = n[i++]) && (o = Ov(l)) && (d && (d += " "), d += o);
  return d;
}, Ov = (n) => {
  if (typeof n == "string")
    return n;
  let i, l = "";
  for (let o = 0; o < n.length; o++)
    n[o] && (i = Ov(n[o])) && (l && (l += " "), l += i);
  return l;
}, JS = (n, ...i) => {
  let l, o, d, f;
  const h = (g) => {
    const m = i.reduce((b, y) => y(b), n());
    return l = ZS(m), o = l.cache.get, d = l.cache.set, f = p, p(g);
  }, p = (g) => {
    const m = o(g);
    if (m)
      return m;
    const b = $S(g, l);
    return d(g, b), b;
  };
  return f = h, (...g) => f(WS(...g));
}, eN = [], ot = (n) => {
  const i = (l) => l[n] || eN;
  return i.isThemeGetter = !0, i;
}, Rv = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, _v = /^\((?:(\w[\w-]*):)?(.+)\)$/i, tN = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, nN = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, aN = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, iN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, sN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, rN = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Ia = (n) => tN.test(n), Se = (n) => !!n && !Number.isNaN(Number(n)), Ln = (n) => !!n && Number.isInteger(Number(n)), Qd = (n) => n.endsWith("%") && Se(n.slice(0, -1)), fa = (n) => nN.test(n), Dv = () => !0, lN = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  aN.test(n) && !iN.test(n)
), pf = () => !1, oN = (n) => sN.test(n), cN = (n) => rN.test(n), uN = (n) => !ie(n) && !re(n), dN = (n) => n.startsWith("@container") && (n[10] === "/" && n[11] !== void 0 || n[11] === "s" && n[16] !== void 0 && n.startsWith("-size/", 10) || n[11] === "n" && n[18] !== void 0 && n.startsWith("-normal/", 10)), hN = (n) => $a(n, Vv, pf), ie = (n) => Rv.test(n), ji = (n) => $a(n, Hv, lN), sy = (n) => $a(n, vN, Se), fN = (n) => $a(n, Lv, Dv), mN = (n) => $a(n, Uv, pf), ry = (n) => $a(n, Fv, pf), pN = (n) => $a(n, Bv, cN), Oo = (n) => $a(n, Pv, oN), re = (n) => _v.test(n), Fr = (n) => Di(n, Hv), gN = (n) => Di(n, Uv), ly = (n) => Di(n, Fv), xN = (n) => Di(n, Vv), yN = (n) => Di(n, Bv), Ro = (n) => Di(n, Pv, !0), bN = (n) => Di(n, Lv, !0), $a = (n, i, l) => {
  const o = Rv.exec(n);
  return o ? o[1] ? i(o[1]) : l(o[2]) : !1;
}, Di = (n, i, l = !1) => {
  const o = _v.exec(n);
  return o ? o[1] ? i(o[1]) : l : !1;
}, Fv = (n) => n === "position" || n === "percentage", Bv = (n) => n === "image" || n === "url", Vv = (n) => n === "length" || n === "size" || n === "bg-size", Hv = (n) => n === "length", vN = (n) => n === "number", Uv = (n) => n === "family-name", Lv = (n) => n === "number" || n === "weight", Pv = (n) => n === "shadow", wN = () => {
  const n = ot("color"), i = ot("font"), l = ot("text"), o = ot("font-weight"), d = ot("tracking"), f = ot("leading"), h = ot("breakpoint"), p = ot("container"), g = ot("spacing"), m = ot("radius"), b = ot("shadow"), y = ot("inset-shadow"), w = ot("text-shadow"), N = ot("drop-shadow"), T = ot("blur"), R = ot("perspective"), _ = ot("aspect"), z = ot("ease"), q = ot("animate"), G = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Q = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], H = () => [...Q(), re, ie], W = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", "contain", "none"], k = () => [re, ie, g], ee = () => [Ia, "full", "auto", ...k()], ae = () => [Ln, "none", "subgrid", re, ie], me = () => ["auto", {
    span: ["full", Ln, re, ie]
  }, Ln, re, ie], xe = () => [Ln, "auto", re, ie], _e = () => ["auto", "min", "max", "fr", re, ie], Be = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], ze = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], O = () => ["auto", ...k()], X = () => [Ia, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...k()], ne = () => [Ia, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...k()], he = () => [Ia, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...k()], K = () => [n, re, ie], S = () => [...Q(), ly, ry, {
    position: [re, ie]
  }], L = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Y = () => ["auto", "cover", "contain", xN, hN, {
    size: [re, ie]
  }], J = () => [Qd, Fr, ji], te = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    m,
    re,
    ie
  ], se = () => ["", Se, Fr, ji], ve = () => ["solid", "dashed", "dotted", "double"], be = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], pe = () => [Se, Qd, ly, ry], Qt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    T,
    re,
    ie
  ], _t = () => ["none", Se, re, ie], Ct = () => ["none", Se, re, ie], pa = () => [Se, re, ie], wt = () => [Ia, "full", ...k()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [fa],
      breakpoint: [fa],
      color: [Dv],
      container: [fa],
      "drop-shadow": [fa],
      ease: ["in", "out", "in-out"],
      font: [uN],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [fa],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [fa],
      shadow: [fa],
      spacing: ["px", Se],
      text: [fa],
      "text-shadow": [fa],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Ia, ie, re, _]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", re, ie]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [dN],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Se, ie, re, p]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": G()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": G()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: H()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: W()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": W()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": W()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: $()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": $()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": $()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: ee()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": ee()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": ee()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": ee(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: ee()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": ee(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: ee()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": ee()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": ee()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: ee()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: ee()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: ee()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: ee()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Ln, "auto", re, ie]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Ia, "full", "auto", p, ...k()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Se, Ia, "auto", "initial", "none", ie]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Se, re, ie]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Se, re, ie]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Ln, "first", "last", "none", re, ie]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": ae()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: me()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": xe()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": xe()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": ae()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: me()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": xe()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": xe()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": _e()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": _e()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: k()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": k()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": k()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...Be(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...ze(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...ze()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Be()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...ze(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...ze(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": Be()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...ze(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...ze()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: k()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: k()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: k()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: k()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: k()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: k()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: k()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: k()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: k()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: k()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: k()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: O()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: O()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: O()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: O()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: O()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: O()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: O()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: O()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: O()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: O()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: O()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": k()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": k()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: X()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...ne()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...ne()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...ne()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...he()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...he()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...he()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [p, "screen", ...X()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          p,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...X()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          p,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [h]
          },
          ...X()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...X()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...X()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...X()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", l, Fr, ji]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, bN, fN]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Qd, ie]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [gN, mN, i]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [ie]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [d, re, ie]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Se, "none", re, sy]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          f,
          ...k()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", re, ie]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", re, ie]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: K()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: K()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ve(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Se, "from-font", "auto", re, ji]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: K()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Se, "auto", re, ie]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [Ln, re, ie]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", re, ie]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", re, ie]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: S()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: L()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Y()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Ln, re, ie],
          radial: ["", re, ie],
          conic: [Ln, re, ie]
        }, yN, pN]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: K()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: J()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: J()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: J()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: K()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: K()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: K()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: te()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": te()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": te()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": te()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": te()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": te()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": te()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": te()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": te()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": te()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": te()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": te()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": te()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": te()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": te()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: se()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": se()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": se()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": se()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": se()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": se()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": se()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": se()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": se()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": se()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": se()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": se()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": se()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ve(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...ve(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: K()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": K()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": K()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": K()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": K()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": K()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": K()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": K()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": K()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": K()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": K()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: K()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...ve(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Se, re, ie]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Se, Fr, ji]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: K()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          b,
          Ro,
          Oo
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: K()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", y, Ro, Oo]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": K()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: se()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: K()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Se, ji]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": K()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": se()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": K()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", w, Ro, Oo]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": K()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Se, re, ie]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...be(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": be()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Se]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": pe()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": pe()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": K()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": K()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": pe()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": pe()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": K()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": K()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": pe()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": pe()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": K()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": K()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": pe()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": pe()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": K()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": K()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": pe()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": pe()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": K()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": K()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": pe()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": pe()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": K()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": K()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": pe()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": pe()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": K()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": K()
      }],
      "mask-image-radial": [{
        "mask-radial": [re, ie]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": pe()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": pe()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": K()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": K()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": Q()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Se]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": pe()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": pe()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": K()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": K()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: S()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: L()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Y()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", re, ie]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          re,
          ie
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Qt()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Se, re, ie]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Se, re, ie]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          N,
          Ro,
          Oo
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": K()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Se, re, ie]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Se, re, ie]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Se, re, ie]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Se, re, ie]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Se, re, ie]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          re,
          ie
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Qt()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Se, re, ie]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Se, re, ie]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Se, re, ie]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Se, re, ie]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Se, re, ie]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Se, re, ie]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Se, re, ie]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Se, re, ie]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": k()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": k()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": k()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", re, ie]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Se, "initial", re, ie]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", z, re, ie]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Se, re, ie]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", q, re, ie]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [R, re, ie]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": H()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: _t()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": _t()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": _t()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": _t()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Ct()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Ct()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Ct()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Ct()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: pa()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": pa()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": pa()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [re, ie, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: H()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: wt()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": wt()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": wt()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": wt()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [Ln, re, ie]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: K()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: K()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", re, ie]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": K()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": K()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": k()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": k()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", re, ie]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...K()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Se, Fr, ji, sy]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...K()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, jN = /* @__PURE__ */ JS(wN);
function xc(...n) {
  return jN(Ev(n));
}
function SN({
  delayDuration: n = 0,
  ...i
}) {
  return /* @__PURE__ */ s.jsx(
    zS,
    {
      "data-slot": "tooltip-provider",
      delayDuration: n,
      ...i
    }
  );
}
const oy = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, cy = Ev, NN = (n, i) => (l) => {
  var o;
  if (i?.variants == null) return cy(n, l?.class, l?.className);
  const { variants: d, defaultVariants: f } = i, h = Object.keys(d).map((m) => {
    const b = l?.[m], y = f?.[m];
    if (b === null) return null;
    const w = oy(b) || oy(y);
    return d[m][w];
  }), p = l && Object.entries(l).reduce((m, b) => {
    let [y, w] = b;
    return w === void 0 || (m[y] = w), m;
  }, {}), g = i == null || (o = i.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((m, b) => {
    let { class: y, className: w, ...N } = b;
    return Object.entries(N).every((T) => {
      let [R, _] = T;
      return Array.isArray(_) ? _.includes({
        ...f,
        ...p
      }[R]) : {
        ...f,
        ...p
      }[R] === _;
    }) ? [
      ...m,
      y,
      w
    ] : m;
  }, []);
  return cy(n, h, g, l?.class, l?.className);
}, TN = NN(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-transparent shadow-xs hover:bg-accent dark:bg-transparent dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
        "icon-sm": "size-8",
        "icon-lg": "size-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function AN({
  className: n,
  variant: i,
  size: l,
  asChild: o = !1,
  ...d
}) {
  const f = o ? cS : "button";
  return /* @__PURE__ */ s.jsx(
    f,
    {
      "data-slot": "button",
      className: xc(TN({ variant: i, size: l, className: n })),
      ...d
    }
  );
}
function CN({ className: n, ...i }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card",
      className: xc(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm",
        n
      ),
      ...i
    }
  );
}
function EN({ className: n, ...i }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-content",
      className: xc("px-6", n),
      ...i
    }
  );
}
const kN = (n) => n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Iv = (...n) => n.filter((i, l, o) => !!i && o.indexOf(i) === l).join(" ");
var MN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const zN = E.forwardRef(
  ({
    color: n = "currentColor",
    size: i = 24,
    strokeWidth: l = 2,
    absoluteStrokeWidth: o,
    className: d = "",
    children: f,
    iconNode: h,
    ...p
  }, g) => E.createElement(
    "svg",
    {
      ref: g,
      ...MN,
      width: i,
      height: i,
      stroke: n,
      strokeWidth: o ? Number(l) * 24 / Number(i) : l,
      className: Iv("lucide", d),
      ...p
    },
    [
      ...h.map(([m, b]) => E.createElement(m, b)),
      ...Array.isArray(f) ? f : [f]
    ]
  )
);
const le = (n, i) => {
  const l = E.forwardRef(
    ({ className: o, ...d }, f) => E.createElement(zN, {
      ref: f,
      iconNode: i,
      className: Iv(`lucide-${kN(n)}`, o),
      ...d
    })
  );
  return l.displayName = `${n}`, l;
};
const ON = le("Calculator", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
const RN = le("CalendarDays", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
const qv = le("CameraOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
const Wr = le("Camera", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
const Rs = le("ChartColumn", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
const Gv = le("ChartNoAxesCombined", [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
]);
const At = le("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
const Jr = le("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
const Gr = le("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
const Yv = le("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
const _N = le("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const Qv = le("Clock3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
const DN = le("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
const Oh = le("Cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
const FN = le("Cpu", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
const gf = le("Crosshair", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
const BN = le("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
const VN = le("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const Zv = le("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
const HN = le("Files", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
const yc = le("Film", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
const UN = le("Globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
const LN = le("Headphones", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
const PN = le("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
const IN = le("House", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
const qN = le("Image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const GN = le("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
const el = le("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
const Xv = le("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
const YN = le("MapPin", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
const QN = le("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
const ZN = le("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
const XN = le("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
const KN = le("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
const $N = le("MonitorSmartphone", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
const WN = le("Mountain", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
const tl = le("Package", [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["path", { d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7", key: "yx3hmr" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
]);
const Rh = le("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
const JN = le("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
const ic = le("Radio", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
const eT = le("RefreshCcw", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
const tT = le("Rocket", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
const Kv = le("RotateCcw", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
const ol = le("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
const nT = le("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const xf = le("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
const aT = le("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const iT = le("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
const uy = le("ShoppingBag", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
const nl = le("ShoppingCart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
const sT = le("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
const bc = le("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
const $v = le("Sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
const yf = le("Star", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]);
const sc = le("Target", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const rT = le("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
const lT = le("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
const oT = le("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const cT = le("Trophy", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
const uT = le("Truck", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
const dy = le("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
const bf = le("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
const Wv = le("VideoOff", [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Jv = le("Video", [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
]);
const vf = le("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
const e0 = le("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
function dT(n, i) {
  if (n instanceof RegExp) return { keys: !1, pattern: n };
  var l, o, d, f, h = [], p = "", g = n.split("/");
  for (g[0] || g.shift(); d = g.shift(); )
    l = d[0], l === "*" ? (h.push(l), p += d[1] === "?" ? "(?:/(.*))?" : "/(.*)") : l === ":" ? (o = d.indexOf("?", 1), f = d.indexOf(".", 1), h.push(d.substring(1, ~o ? o : ~f ? f : d.length)), p += ~o && !~f ? "(?:/([^/]+?))?" : "/([^/]+?)", ~f && (p += (~o ? "?" : "") + "\\" + d.substring(f))) : p += "/" + d;
  return {
    keys: h,
    pattern: new RegExp("^" + p + (i ? "(?=$|/)" : "/?$"), "i")
  };
}
var Zd = { exports: {} }, Xd = {};
var hy;
function hT() {
  if (hy) return Xd;
  hy = 1;
  var n = gc();
  function i(y, w) {
    return y === w && (y !== 0 || 1 / y === 1 / w) || y !== y && w !== w;
  }
  var l = typeof Object.is == "function" ? Object.is : i, o = n.useState, d = n.useEffect, f = n.useLayoutEffect, h = n.useDebugValue;
  function p(y, w) {
    var N = w(), T = o({ inst: { value: N, getSnapshot: w } }), R = T[0].inst, _ = T[1];
    return f(
      function() {
        R.value = N, R.getSnapshot = w, g(R) && _({ inst: R });
      },
      [y, N, w]
    ), d(
      function() {
        return g(R) && _({ inst: R }), y(function() {
          g(R) && _({ inst: R });
        });
      },
      [y]
    ), h(N), N;
  }
  function g(y) {
    var w = y.getSnapshot;
    y = y.value;
    try {
      var N = w();
      return !l(y, N);
    } catch {
      return !0;
    }
  }
  function m(y, w) {
    return w();
  }
  var b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? m : p;
  return Xd.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : b, Xd;
}
var fy;
function fT() {
  return fy || (fy = 1, Zd.exports = hT()), Zd.exports;
}
var mT = fT();
const pT = hv.useInsertionEffect, gT = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", xT = gT ? E.useLayoutEffect : E.useEffect, yT = pT || xT, t0 = (n) => {
  const i = E.useRef([n, (...l) => i[0](...l)]).current;
  return yT(() => {
    i[0] = n;
  }), i[1];
}, bT = "popstate", wf = "pushState", jf = "replaceState", vT = "hashchange", my = [
  bT,
  wf,
  jf,
  vT
], wT = (n) => {
  for (const i of my)
    addEventListener(i, n);
  return () => {
    for (const i of my)
      removeEventListener(i, n);
  };
}, n0 = (n, i) => mT.useSyncExternalStore(wT, n, i), py = () => location.search, jT = ({ ssrSearch: n } = {}) => n0(
  py,
  // != null checks for both null and undefined, but allows empty string ""
  // This allows proper hydration: server renders with ssrSearch="?foo",
  // client hydrates with just <Router /> and reads from location.search
  n != null ? () => n : py
), gy = () => location.pathname, ST = ({ ssrPath: n } = {}) => n0(
  gy,
  // != null checks for both null and undefined, but allows empty string ""
  // This allows proper hydration: server renders with ssrPath="/foo",
  // client hydrates with just <Router /> and reads from location.pathname
  n != null ? () => n : gy
), NT = (n, { replace: i = !1, state: l = null } = {}) => history[i ? jf : wf](l, "", n), TT = (n = {}) => [ST(n), NT], xy = /* @__PURE__ */ Symbol.for("wouter_v3");
if (typeof history < "u" && typeof window[xy] > "u") {
  for (const n of [wf, jf]) {
    const i = history[n];
    history[n] = function() {
      const l = i.apply(this, arguments), o = new Event(n);
      return o.arguments = arguments, dispatchEvent(o), l;
    };
  }
  Object.defineProperty(window, xy, { value: !0 });
}
const AT = (n, i) => i.toLowerCase().indexOf(n.toLowerCase()) ? "~" + i : i.slice(n.length) || "/", a0 = (n = "") => n === "/" ? "" : n, CT = (n, i) => n[0] === "~" ? n.slice(1) : a0(i) + n, ET = (n = "", i) => AT(yy(a0(n)), yy(i)), yy = (n) => {
  try {
    return decodeURI(n);
  } catch {
    return n;
  }
}, i0 = {
  hook: TT,
  searchHook: jT,
  parser: dT,
  base: "",
  // this option is used to override the current location during SSR
  ssrPath: void 0,
  ssrSearch: void 0,
  // optional context to track render state during SSR
  ssrContext: void 0,
  // customizes how `href` props are transformed for <Link />
  hrefs: (n) => n,
  // wraps navigate calls, useful for view transitions
  aroundNav: (n, i, l) => n(i, l)
}, s0 = E.createContext(i0), cl = () => E.useContext(s0), r0 = {}, l0 = E.createContext(r0), kT = () => E.useContext(l0), vc = (n) => {
  const [i, l] = n.hook(n);
  return [
    ET(n.base, i),
    t0(
      (o, d) => n.aroundNav(l, CT(o, n.base), d)
    )
  ];
}, o0 = () => vc(cl()), c0 = (n, i, l, o) => {
  const { pattern: d, keys: f } = i instanceof RegExp ? { keys: !1, pattern: i } : n(i || "*", o), h = d.exec(l) || [], [p, ...g] = h;
  return p !== void 0 ? [
    !0,
    (() => {
      const m = f !== !1 ? Object.fromEntries(f.map((y, w) => [y, g[w]])) : h.groups;
      let b = { ...g };
      return m && Object.assign(b, m), b;
    })(),
    // the third value if only present when parser is in "loose" mode,
    // so that we can extract the base path for nested routes
    ...o ? [p] : []
  ] : [!1, null];
}, MT = ({ children: n, ...i }) => {
  const l = cl(), o = i.hook ? i0 : l;
  let d = o;
  const [f, h = i.ssrSearch ?? ""] = i.ssrPath?.split("?") ?? [];
  f && (i.ssrSearch = h, i.ssrPath = f), i.hrefs = i.hrefs ?? i.hook?.hrefs, i.searchHook = i.searchHook ?? i.hook?.searchHook;
  let p = E.useRef({}), g = p.current, m = g;
  for (let b in o) {
    const y = b === "base" ? (
      /* base is special case, it is appended to the parent's base */
      o[b] + (i[b] ?? "")
    ) : i[b] ?? o[b];
    g === m && y !== m[b] && (p.current = m = { ...m }), m[b] = y, (y !== o[b] || y !== d[b]) && (d = m);
  }
  return E.createElement(s0.Provider, { value: d, children: n });
}, by = ({ children: n, component: i }, l) => i ? E.createElement(i, { params: l }) : typeof n == "function" ? n(l) : n, zT = (n) => {
  let i = E.useRef(r0);
  const l = i.current;
  return i.current = // Update cache if number of params changed or any value changed
  Object.keys(n).length !== Object.keys(l).length || Object.entries(n).some(([o, d]) => d !== l[o]) ? n : l;
}, Fe = ({ path: n, nest: i, match: l, ...o }) => {
  const d = cl(), [f] = vc(d), [h, p, g] = (
    // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    l ?? c0(d.parser, n, f, i)
  ), m = zT({ ...kT(), ...p });
  if (!h) return null;
  const b = g ? E.createElement(MT, { base: g }, by(o, m)) : by(o, m);
  return E.createElement(l0.Provider, { value: m, children: b });
}, Ne = E.forwardRef((n, i) => {
  const l = cl(), [o, d] = vc(l), {
    to: f = "",
    href: h = f,
    onClick: p,
    asChild: g,
    children: m,
    className: b,
    /* eslint-disable no-unused-vars */
    replace: y,
    state: w,
    transition: N,
    /* eslint-enable no-unused-vars */
    ...T
  } = n, R = t0((z) => {
    z.ctrlKey || z.metaKey || z.altKey || z.shiftKey || z.button !== 0 || (p?.(z), z.defaultPrevented || (z.preventDefault(), d(h, n)));
  }), _ = l.hrefs(
    h[0] === "~" ? h.slice(1) : l.base + h,
    l
    // pass router as a second argument for convinience
  );
  return g && E.isValidElement(m) ? E.cloneElement(m, { onClick: R, href: _ }) : E.createElement("a", {
    ...T,
    onClick: R,
    href: _,
    // `className` can be a function to apply the class if this link is active
    className: b?.call ? b(o === h) : b,
    children: m,
    ref: i
  });
}), u0 = (n) => Array.isArray(n) ? n.flatMap(
  (i) => u0(i && i.type === E.Fragment ? i.props.children : i)
) : [n], OT = ({ children: n, location: i }) => {
  const l = cl(), [o] = vc(l);
  for (const d of u0(n)) {
    let f = 0;
    if (E.isValidElement(d) && // we don't require an element to be of type Route,
    // but we do require it to contain a truthy `path` prop.
    // this allows to use different components that wrap Route
    // inside of a switch, for example <AnimatedRoute />.
    (f = c0(
      l.parser,
      d.props.path,
      i || o,
      d.props.nest
    ))[0])
      return E.cloneElement(d, { match: f });
  }
  return null;
};
function vy() {
  const [, n] = o0(), i = () => {
    n("/");
  };
  return /* @__PURE__ */ s.jsx("div", { className: "min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100", children: /* @__PURE__ */ s.jsx(CN, { className: "w-full max-w-lg mx-4 shadow-lg border-0 bg-white/80 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs(EN, { className: "pt-8 pb-8 text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex justify-center mb-6", children: /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-red-100 rounded-full animate-pulse" }),
      /* @__PURE__ */ s.jsx(_N, { className: "relative h-16 w-16 text-red-500" })
    ] }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-4xl font-bold text-slate-900 mb-2", children: "404" }),
    /* @__PURE__ */ s.jsx("h2", { className: "text-xl font-semibold text-slate-700 mb-4", children: "Page Not Found" }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-slate-600 mb-8 leading-relaxed", children: [
      "Sorry, the page you are looking for doesn't exist.",
      /* @__PURE__ */ s.jsx("br", {}),
      "It may have been moved or deleted."
    ] }),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        id: "not-found-button-group",
        className: "flex flex-col sm:flex-row gap-3 justify-center",
        children: /* @__PURE__ */ s.jsxs(
          AN,
          {
            onClick: i,
            className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg",
            children: [
              /* @__PURE__ */ s.jsx(IN, { className: "w-4 h-4 mr-2" }),
              "Go Home"
            ]
          }
        )
      }
    )
  ] }) }) });
}
class RT extends E.Component {
  constructor(i) {
    super(i), this.state = { hasError: !1, error: null };
  }
  static getDerivedStateFromError(i) {
    return { hasError: !0, error: i };
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center min-h-screen p-8 bg-background", children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center w-full max-w-2xl p-8", children: [
      /* @__PURE__ */ s.jsx(
        oT,
        {
          size: 48,
          className: "text-destructive mb-6 flex-shrink-0"
        }
      ),
      /* @__PURE__ */ s.jsx("h2", { className: "text-xl mb-4", children: "An unexpected error occurred." }),
      /* @__PURE__ */ s.jsx("div", { className: "p-4 w-full rounded bg-muted overflow-auto mb-6", children: /* @__PURE__ */ s.jsx("pre", { className: "text-sm text-muted-foreground whitespace-break-spaces", children: this.state.error?.stack }) }),
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: () => window.location.reload(),
          className: xc(
            "flex items-center gap-2 px-4 py-2 rounded-lg",
            "bg-primary text-primary-foreground",
            "hover:opacity-90 cursor-pointer"
          ),
          children: [
            /* @__PURE__ */ s.jsx(Kv, { size: 16 }),
            "Reload Page"
          ]
        }
      )
    ] }) }) : this.props.children;
  }
}
const _T = E.createContext(void 0);
function DT({
  children: n,
  defaultTheme: i = "light",
  switchable: l = !1
}) {
  const [o, d] = E.useState(() => l && localStorage.getItem("theme") || i);
  E.useEffect(() => {
    const h = document.documentElement;
    o === "dark" ? h.classList.add("dark") : h.classList.remove("dark"), l && localStorage.setItem("theme", o);
  }, [o, l]);
  const f = l ? () => {
    d((h) => h === "light" ? "dark" : "light");
  } : void 0;
  return /* @__PURE__ */ s.jsx(_T.Provider, { value: { theme: o, toggleTheme: f, switchable: l }, children: n });
}
const d0 = E.createContext(null);
function _o(n, i) {
  return { amount: (n / 100).toFixed(2), currencyCode: i };
}
function FT(n) {
  const i = n.currency || "USD", l = n.items.map((o) => ({
    lineId: o.key,
    variantId: String(o.variant_id),
    productHandle: o.product_handle || "",
    productTitle: o.product_title,
    variantTitle: o.variant_title || "Default Title",
    quantity: o.quantity,
    unitPrice: _o(o.final_price, i),
    lineTotal: _o(o.final_line_price, i),
    image: o.image || o.featured_image?.url ? { url: o.image || o.featured_image?.url || "", altText: o.product_title } : null
  }));
  return {
    id: n.token || "shopify-cart",
    checkoutUrl: "/checkout",
    itemCount: n.item_count,
    subtotal: _o(n.items_subtotal_price ?? n.total_price, i),
    total: _o(n.total_price, i),
    items: l
  };
}
async function Go(n, i) {
  const l = await fetch(n, {
    credentials: "same-origin",
    ...i,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...i?.headers || {}
    }
  });
  if (!l.ok) {
    const o = await l.text().catch(() => "");
    throw new Error(o || `Shopify cart request failed (${l.status})`);
  }
  return l.json();
}
async function Do() {
  return FT(await Go("/cart.js"));
}
function BT({ children: n }) {
  const [i, l] = E.useState(null), [o, d] = E.useState(!1), [f, h] = E.useState(!1);
  E.useEffect(() => {
    let _ = !1;
    return Do().then((z) => {
      _ || l(z);
    }).catch((z) => console.warn("[Shopify cart] Unable to hydrate cart", z)), () => {
      _ = !0;
    };
  }, []);
  const p = i?.itemCount ?? 0, g = E.useCallback(() => d(!0), []), m = E.useCallback(() => d(!1), []), b = E.useCallback(async (_, z = 1) => {
    h(!0);
    try {
      await Go("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({ items: [{ id: _, quantity: z }] })
      }), l(await Do()), d(!0);
    } finally {
      h(!1);
    }
  }, []), y = E.useCallback(async (_, z) => {
    h(!0);
    try {
      await Go("/cart/change.js", {
        method: "POST",
        body: JSON.stringify({ id: _, quantity: Math.max(0, z) })
      }), l(await Do());
    } finally {
      h(!1);
    }
  }, []), w = E.useCallback(
    async (_) => y(_, 0),
    [y]
  ), N = E.useCallback(() => {
    h(!0), Go("/cart/clear.js", { method: "POST", body: "{}" }).then(() => Do()).then(l).finally(() => h(!1));
  }, []), T = E.useCallback(() => {
    window.location.assign("/checkout");
  }, []), R = E.useMemo(
    () => ({
      cart: i,
      isOpen: o,
      loading: f,
      itemCount: p,
      openCart: g,
      closeCart: m,
      addItem: b,
      updateQuantity: y,
      removeItem: w,
      clearCart: N,
      proceedToCheckout: T
    }),
    [i, o, f, p, g, m, b, y, w, N, T]
  );
  return /* @__PURE__ */ s.jsx(d0.Provider, { value: R, children: n });
}
function ul() {
  const n = E.useContext(d0);
  if (!n) throw new Error("useCart must be used inside CartProvider");
  return n;
}
const Sf = E.createContext({});
function Nf(n) {
  const i = E.useRef(null);
  return i.current === null && (i.current = n()), i.current;
}
const VT = typeof window < "u", Tf = VT ? E.useLayoutEffect : E.useEffect, wc = /* @__PURE__ */ E.createContext(null);
function Af(n, i) {
  n.indexOf(i) === -1 && n.push(i);
}
function rc(n, i) {
  const l = n.indexOf(i);
  l > -1 && n.splice(l, 1);
}
const Qn = (n, i, l) => l > i ? i : l < n ? n : l;
let jc = () => {
};
const Xa = {}, h0 = (n) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(n), f0 = (n) => typeof n == "object" && n !== null, m0 = (n) => /^0[^.\s]+$/u.test(n);
// @__NO_SIDE_EFFECTS__
function p0(n) {
  let i;
  return () => (i === void 0 && (i = n()), i);
}
const Sn = /* @__NO_SIDE_EFFECTS__ */ (n) => n, dl = (...n) => n.reduce((i, l) => (o) => l(i(o))), al = /* @__NO_SIDE_EFFECTS__ */ (n, i, l) => {
  const o = i - n;
  return o ? (l - n) / o : 1;
};
class Cf {
  constructor() {
    this.subscriptions = [];
  }
  add(i) {
    return Af(this.subscriptions, i), () => rc(this.subscriptions, i);
  }
  notify(i, l, o) {
    const d = this.subscriptions.length;
    if (d)
      if (d === 1)
        this.subscriptions[0](i, l, o);
      else
        for (let f = 0; f < d; f++) {
          const h = this.subscriptions[f];
          h && h(i, l, o);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const sn = /* @__NO_SIDE_EFFECTS__ */ (n) => n * 1e3, jn = /* @__NO_SIDE_EFFECTS__ */ (n) => n / 1e3, g0 = /* @__NO_SIDE_EFFECTS__ */ (n, i) => i ? n * (1e3 / i) : 0, x0 = (n, i, l) => (((1 - 3 * l + 3 * i) * n + (3 * l - 6 * i)) * n + 3 * i) * n, HT = 1e-7, UT = 12;
function LT(n, i, l, o, d) {
  let f, h, p = 0;
  do
    h = i + (l - i) / 2, f = x0(h, o, d) - n, f > 0 ? l = h : i = h;
  while (Math.abs(f) > HT && ++p < UT);
  return h;
}
// @__NO_SIDE_EFFECTS__
function hl(n, i, l, o) {
  if (n === i && l === o)
    return Sn;
  const d = (f) => LT(f, 0, 1, n, l);
  return (f) => f === 0 || f === 1 ? f : x0(d(f), i, o);
}
const y0 = /* @__NO_SIDE_EFFECTS__ */ (n) => (i) => i <= 0.5 ? n(2 * i) / 2 : (2 - n(2 * (1 - i))) / 2, b0 = /* @__NO_SIDE_EFFECTS__ */ (n) => (i) => 1 - n(1 - i), v0 = /* @__PURE__ */ hl(0.33, 1.53, 0.69, 0.99), Ef = /* @__PURE__ */ b0(v0), w0 = /* @__PURE__ */ y0(Ef), j0 = (n) => n >= 1 ? 1 : (n *= 2) < 1 ? 0.5 * Ef(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1))), kf = (n) => 1 - Math.sin(Math.acos(n)), S0 = /* @__PURE__ */ b0(kf), N0 = /* @__PURE__ */ y0(kf), PT = /* @__PURE__ */ hl(0.42, 0, 1, 1), IT = /* @__PURE__ */ hl(0, 0, 0.58, 1), T0 = /* @__PURE__ */ hl(0.42, 0, 0.58, 1), qT = /* @__NO_SIDE_EFFECTS__ */ (n) => Array.isArray(n) && typeof n[0] != "number", A0 = /* @__NO_SIDE_EFFECTS__ */ (n) => Array.isArray(n) && typeof n[0] == "number", GT = {
  linear: Sn,
  easeIn: PT,
  easeInOut: T0,
  easeOut: IT,
  circIn: kf,
  circInOut: N0,
  circOut: S0,
  backIn: Ef,
  backInOut: w0,
  backOut: v0,
  anticipate: j0
}, YT = (n) => typeof n == "string", wy = (n) => {
  if (/* @__PURE__ */ A0(n)) {
    jc(n.length === 4);
    const [i, l, o, d] = n;
    return /* @__PURE__ */ hl(i, l, o, d);
  } else if (YT(n))
    return GT[n];
  return n;
}, Fo = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function QT(n) {
  let i = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), o = !1, d = !1;
  const f = /* @__PURE__ */ new WeakSet();
  let h = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function p(m) {
    f.has(m) && (g.schedule(m), n()), m(h);
  }
  const g = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (m, b = !1, y = !1) => {
      const N = y && o ? i : l;
      return b && f.add(m), N.add(m), m;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (m) => {
      l.delete(m), f.delete(m);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (m) => {
      if (h = m, o) {
        d = !0;
        return;
      }
      o = !0;
      const b = i;
      i = l, l = b, i.forEach(p), i.clear(), o = !1, d && (d = !1, g.process(m));
    }
  };
  return g;
}
const ZT = 40;
function C0(n, i) {
  let l = !1, o = !0;
  const d = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, f = () => l = !0, h = Fo.reduce((G, Q) => (G[Q] = QT(f), G), {}), { setup: p, read: g, resolveKeyframes: m, preUpdate: b, update: y, preRender: w, render: N, postRender: T } = h, R = () => {
    const G = Xa.useManualTiming, Q = G ? d.timestamp : performance.now();
    l = !1, G || (d.delta = o ? 1e3 / 60 : Math.max(Math.min(Q - d.timestamp, ZT), 1)), d.timestamp = Q, d.isProcessing = !0, p.process(d), g.process(d), m.process(d), b.process(d), y.process(d), w.process(d), N.process(d), T.process(d), d.isProcessing = !1, l && i && (o = !1, n(R));
  }, _ = () => {
    l = !0, o = !0, d.isProcessing || n(R);
  };
  return { schedule: Fo.reduce((G, Q) => {
    const H = h[Q];
    return G[Q] = (W, $ = !1, k = !1) => (l || _(), H.schedule(W, $, k)), G;
  }, {}), cancel: (G) => {
    for (let Q = 0; Q < Fo.length; Q++)
      h[Fo[Q]].cancel(G);
  }, state: d, steps: h };
}
const { schedule: Ge, cancel: Ka, state: bt, steps: Kd } = /* @__PURE__ */ C0(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Sn, !0);
let Yo;
function XT() {
  Yo = void 0;
}
const Ot = {
  now: () => (Yo === void 0 && Ot.set(bt.isProcessing || Xa.useManualTiming ? bt.timestamp : performance.now()), Yo),
  set: (n) => {
    Yo = n, queueMicrotask(XT);
  }
}, E0 = (n) => (i) => typeof i == "string" && i.startsWith(n), k0 = /* @__PURE__ */ E0("--"), KT = /* @__PURE__ */ E0("var(--"), Mf = (n) => KT(n) ? $T.test(n.split("/*")[0].trim()) : !1, $T = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function jy(n) {
  return typeof n != "string" ? !1 : n.split("/*")[0].includes("var(--");
}
const Fs = {
  test: (n) => typeof n == "number",
  parse: parseFloat,
  transform: (n) => n
}, il = {
  ...Fs,
  transform: (n) => Qn(0, 1, n)
}, Bo = {
  ...Fs,
  default: 1
}, Qr = (n) => Math.round(n * 1e5) / 1e5, zf = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function WT(n) {
  return n == null;
}
const JT = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Of = (n, i) => (l) => !!(typeof l == "string" && JT.test(l) && l.startsWith(n) || i && !WT(l) && Object.prototype.hasOwnProperty.call(l, i)), M0 = (n, i, l) => (o) => {
  if (typeof o != "string")
    return o;
  const [d, f, h, p] = o.match(zf);
  return {
    [n]: parseFloat(d),
    [i]: parseFloat(f),
    [l]: parseFloat(h),
    alpha: p !== void 0 ? parseFloat(p) : 1
  };
}, e5 = (n) => Qn(0, 255, n), $d = {
  ...Fs,
  transform: (n) => Math.round(e5(n))
}, Mi = {
  test: /* @__PURE__ */ Of("rgb", "red"),
  parse: /* @__PURE__ */ M0("red", "green", "blue"),
  transform: ({ red: n, green: i, blue: l, alpha: o = 1 }) => "rgba(" + $d.transform(n) + ", " + $d.transform(i) + ", " + $d.transform(l) + ", " + Qr(il.transform(o)) + ")"
};
function t5(n) {
  let i = "", l = "", o = "", d = "";
  return n.length > 5 ? (i = n.substring(1, 3), l = n.substring(3, 5), o = n.substring(5, 7), d = n.substring(7, 9)) : (i = n.substring(1, 2), l = n.substring(2, 3), o = n.substring(3, 4), d = n.substring(4, 5), i += i, l += l, o += o, d += d), {
    red: parseInt(i, 16),
    green: parseInt(l, 16),
    blue: parseInt(o, 16),
    alpha: d ? parseInt(d, 16) / 255 : 1
  };
}
const _h = {
  test: /* @__PURE__ */ Of("#"),
  parse: t5,
  transform: Mi.transform
}, fl = /* @__NO_SIDE_EFFECTS__ */ (n) => ({
  test: (i) => typeof i == "string" && i.endsWith(n) && i.split(" ").length === 1,
  parse: parseFloat,
  transform: (i) => `${i}${n}`
}), ma = /* @__PURE__ */ fl("deg"), Yn = /* @__PURE__ */ fl("%"), ce = /* @__PURE__ */ fl("px"), n5 = /* @__PURE__ */ fl("vh"), a5 = /* @__PURE__ */ fl("vw"), Sy = {
  ...Yn,
  parse: (n) => Yn.parse(n) / 100,
  transform: (n) => Yn.transform(n * 100)
}, Es = {
  test: /* @__PURE__ */ Of("hsl", "hue"),
  parse: /* @__PURE__ */ M0("hue", "saturation", "lightness"),
  transform: ({ hue: n, saturation: i, lightness: l, alpha: o = 1 }) => "hsla(" + Math.round(n) + ", " + Yn.transform(Qr(i)) + ", " + Yn.transform(Qr(l)) + ", " + Qr(il.transform(o)) + ")"
}, rt = {
  test: (n) => Mi.test(n) || _h.test(n) || Es.test(n),
  parse: (n) => Mi.test(n) ? Mi.parse(n) : Es.test(n) ? Es.parse(n) : _h.parse(n),
  transform: (n) => typeof n == "string" ? n : n.hasOwnProperty("red") ? Mi.transform(n) : Es.transform(n),
  getAnimatableNone: (n) => {
    const i = rt.parse(n);
    return i.alpha = 0, rt.transform(i);
  }
}, i5 = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function s5(n) {
  return isNaN(n) && typeof n == "string" && (n.match(zf)?.length || 0) + (n.match(i5)?.length || 0) > 0;
}
const z0 = "number", O0 = "color", r5 = "var", l5 = "var(", Ny = "${}", o5 = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function _s(n) {
  const i = n.toString(), l = [], o = {
    color: [],
    number: [],
    var: []
  }, d = [];
  let f = 0;
  const p = i.replace(o5, (g) => (rt.test(g) ? (o.color.push(f), d.push(O0), l.push(rt.parse(g))) : g.startsWith(l5) ? (o.var.push(f), d.push(r5), l.push(g)) : (o.number.push(f), d.push(z0), l.push(parseFloat(g))), ++f, Ny)).split(Ny);
  return { values: l, split: p, indexes: o, types: d };
}
function c5(n) {
  return _s(n).values;
}
function R0({ split: n, types: i }) {
  const l = n.length;
  return (o) => {
    let d = "";
    for (let f = 0; f < l; f++)
      if (d += n[f], o[f] !== void 0) {
        const h = i[f];
        h === z0 ? d += Qr(o[f]) : h === O0 ? d += rt.transform(o[f]) : d += o[f];
      }
    return d;
  };
}
function u5(n) {
  return R0(_s(n));
}
const d5 = (n) => typeof n == "number" ? 0 : rt.test(n) ? rt.getAnimatableNone(n) : n, h5 = (n, i) => typeof n == "number" ? i?.trim().endsWith("/") ? n : 0 : d5(n);
function f5(n) {
  const i = _s(n);
  return R0(i)(i.values.map((o, d) => h5(o, i.split[d])));
}
const On = {
  test: s5,
  parse: c5,
  createTransformer: u5,
  getAnimatableNone: f5
};
function Wd(n, i, l) {
  return l < 0 && (l += 1), l > 1 && (l -= 1), l < 1 / 6 ? n + (i - n) * 6 * l : l < 1 / 2 ? i : l < 2 / 3 ? n + (i - n) * (2 / 3 - l) * 6 : n;
}
function m5({ hue: n, saturation: i, lightness: l, alpha: o }) {
  n /= 360, i /= 100, l /= 100;
  let d = 0, f = 0, h = 0;
  if (!i)
    d = f = h = l;
  else {
    const p = l < 0.5 ? l * (1 + i) : l + i - l * i, g = 2 * l - p;
    d = Wd(g, p, n + 1 / 3), f = Wd(g, p, n), h = Wd(g, p, n - 1 / 3);
  }
  return {
    red: Math.round(d * 255),
    green: Math.round(f * 255),
    blue: Math.round(h * 255),
    alpha: o
  };
}
function lc(n, i) {
  return (l) => l > 0 ? i : n;
}
const qe = (n, i, l) => n + (i - n) * l, Jd = (n, i, l) => {
  const o = n * n, d = l * (i * i - o) + o;
  return d < 0 ? 0 : Math.sqrt(d);
}, p5 = [_h, Mi, Es], g5 = (n) => p5.find((i) => i.test(n));
function Ty(n) {
  const i = g5(n);
  if (!i)
    return !1;
  let l = i.parse(n);
  return i === Es && (l = m5(l)), l;
}
const Ay = (n, i) => {
  const l = Ty(n), o = Ty(i);
  if (!l || !o)
    return lc(n, i);
  const d = { ...l };
  return (f) => (d.red = Jd(l.red, o.red, f), d.green = Jd(l.green, o.green, f), d.blue = Jd(l.blue, o.blue, f), d.alpha = qe(l.alpha, o.alpha, f), Mi.transform(d));
}, Dh = /* @__PURE__ */ new Set(["none", "hidden"]);
function x5(n, i) {
  return Dh.has(n) ? (l) => l <= 0 ? n : i : (l) => l >= 1 ? i : n;
}
function y5(n, i) {
  return (l) => qe(n, i, l);
}
function Rf(n) {
  return typeof n == "number" ? y5 : typeof n == "string" ? Mf(n) ? lc : rt.test(n) ? Ay : w5 : Array.isArray(n) ? _0 : typeof n == "object" ? rt.test(n) ? Ay : b5 : lc;
}
function _0(n, i) {
  const l = [...n], o = l.length, d = n.map((f, h) => Rf(f)(f, i[h]));
  return (f) => {
    for (let h = 0; h < o; h++)
      l[h] = d[h](f);
    return l;
  };
}
function b5(n, i) {
  const l = { ...n, ...i }, o = {};
  for (const d in l)
    n[d] !== void 0 && i[d] !== void 0 && (o[d] = Rf(n[d])(n[d], i[d]));
  return (d) => {
    for (const f in o)
      l[f] = o[f](d);
    return l;
  };
}
function v5(n, i) {
  const l = [], o = { color: 0, var: 0, number: 0 };
  for (let d = 0; d < i.values.length; d++) {
    const f = i.types[d], h = n.indexes[f][o[f]], p = n.values[h] ?? 0;
    l[d] = p, o[f]++;
  }
  return l;
}
const w5 = (n, i) => {
  const l = On.createTransformer(i), o = _s(n), d = _s(i);
  return o.indexes.var.length === d.indexes.var.length && o.indexes.color.length === d.indexes.color.length && o.indexes.number.length >= d.indexes.number.length ? Dh.has(n) && !d.values.length || Dh.has(i) && !o.values.length ? x5(n, i) : dl(_0(v5(o, d), d.values), l) : lc(n, i);
};
function D0(n, i, l) {
  return typeof n == "number" && typeof i == "number" && typeof l == "number" ? qe(n, i, l) : Rf(n)(n, i);
}
const j5 = (n) => {
  const i = ({ timestamp: l }) => n(l);
  return {
    start: (l = !0) => Ge.update(i, l),
    stop: () => Ka(i),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => bt.isProcessing ? bt.timestamp : Ot.now()
  };
}, F0 = (n, i, l = 10) => {
  let o = "";
  const d = Math.max(Math.round(i / l), 2);
  for (let f = 0; f < d; f++)
    o += Math.round(n(f / (d - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${o.substring(0, o.length - 2)})`;
}, oc = 2e4;
function _f(n) {
  let i = 0;
  const l = 50;
  let o = n.next(i);
  for (; !o.done && i < oc; )
    i += l, o = n.next(i);
  return i >= oc ? 1 / 0 : i;
}
function S5(n, i = 100, l) {
  const o = l({ ...n, keyframes: [0, i] }), d = Math.min(_f(o), oc);
  return {
    type: "keyframes",
    ease: (f) => o.next(d * f).value / i,
    duration: /* @__PURE__ */ jn(d)
  };
}
const Je = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function Fh(n, i) {
  return n * Math.sqrt(1 - i * i);
}
const N5 = 12;
function T5(n, i, l) {
  let o = l;
  for (let d = 1; d < N5; d++)
    o = o - n(o) / i(o);
  return o;
}
const eh = 1e-3;
function A5({ duration: n = Je.duration, bounce: i = Je.bounce, velocity: l = Je.velocity, mass: o = Je.mass }) {
  let d, f, h = 1 - i;
  h = Qn(Je.minDamping, Je.maxDamping, h), n = Qn(Je.minDuration, Je.maxDuration, /* @__PURE__ */ jn(n)), h < 1 ? (d = (m) => {
    const b = m * h, y = b * n, w = b - l, N = Fh(m, h), T = Math.exp(-y);
    return eh - w / N * T;
  }, f = (m) => {
    const y = m * h * n, w = y * l + l, N = Math.pow(h, 2) * Math.pow(m, 2) * n, T = Math.exp(-y), R = Fh(Math.pow(m, 2), h);
    return (-d(m) + eh > 0 ? -1 : 1) * ((w - N) * T) / R;
  }) : (d = (m) => {
    const b = Math.exp(-m * n), y = (m - l) * n + 1;
    return -eh + b * y;
  }, f = (m) => {
    const b = Math.exp(-m * n), y = (l - m) * (n * n);
    return b * y;
  });
  const p = 5 / n, g = T5(d, f, p);
  if (n = /* @__PURE__ */ sn(n), isNaN(g))
    return {
      stiffness: Je.stiffness,
      damping: Je.damping,
      duration: n
    };
  {
    const m = Math.pow(g, 2) * o;
    return {
      stiffness: m,
      damping: h * 2 * Math.sqrt(o * m),
      duration: n
    };
  }
}
const C5 = ["duration", "bounce"], E5 = ["stiffness", "damping", "mass"];
function Cy(n, i) {
  return i.some((l) => n[l] !== void 0);
}
function k5(n) {
  let i = {
    velocity: Je.velocity,
    stiffness: Je.stiffness,
    damping: Je.damping,
    mass: Je.mass,
    isResolvedFromDuration: !1,
    ...n
  };
  if (!Cy(n, E5) && Cy(n, C5))
    if (i.velocity = 0, n.visualDuration) {
      const l = n.visualDuration, o = 2 * Math.PI / (l * 1.2), d = o * o, f = 2 * Qn(0.05, 1, 1 - (n.bounce || 0)) * Math.sqrt(d);
      i = {
        ...i,
        mass: Je.mass,
        stiffness: d,
        damping: f
      };
    } else {
      const l = A5({ ...n, velocity: 0 });
      i = {
        ...i,
        ...l,
        mass: Je.mass
      }, i.isResolvedFromDuration = !0;
    }
  return i;
}
function cc(n = Je.visualDuration, i = Je.bounce) {
  const l = typeof n != "object" ? {
    visualDuration: n,
    keyframes: [0, 1],
    bounce: i
  } : n;
  let { restSpeed: o, restDelta: d } = l;
  const f = l.keyframes[0], h = l.keyframes[l.keyframes.length - 1], p = { done: !1, value: f }, { stiffness: g, damping: m, mass: b, duration: y, velocity: w, isResolvedFromDuration: N } = k5({
    ...l,
    velocity: -/* @__PURE__ */ jn(l.velocity || 0)
  }), T = w || 0, R = m / (2 * Math.sqrt(g * b)), _ = h - f, z = /* @__PURE__ */ jn(Math.sqrt(g / b)), q = Math.abs(_) < 5;
  o || (o = q ? Je.restSpeed.granular : Je.restSpeed.default), d || (d = q ? Je.restDelta.granular : Je.restDelta.default);
  let G, Q, H, W, $, k;
  if (R < 1)
    H = Fh(z, R), W = (T + R * z * _) / H, G = (ae) => {
      const me = Math.exp(-R * z * ae);
      return h - me * (W * Math.sin(H * ae) + _ * Math.cos(H * ae));
    }, $ = R * z * W + _ * H, k = R * z * _ - W * H, Q = (ae) => Math.exp(-R * z * ae) * ($ * Math.sin(H * ae) + k * Math.cos(H * ae));
  else if (R === 1) {
    G = (me) => h - Math.exp(-z * me) * (_ + (T + z * _) * me);
    const ae = T + z * _;
    Q = (me) => Math.exp(-z * me) * (z * ae * me - T);
  } else {
    const ae = z * Math.sqrt(R * R - 1);
    G = (Be) => {
      const ze = Math.exp(-R * z * Be), O = Math.min(ae * Be, 300);
      return h - ze * ((T + R * z * _) * Math.sinh(O) + ae * _ * Math.cosh(O)) / ae;
    };
    const me = (T + R * z * _) / ae, xe = R * z * me - _ * ae, _e = R * z * _ - me * ae;
    Q = (Be) => {
      const ze = Math.exp(-R * z * Be), O = Math.min(ae * Be, 300);
      return ze * (xe * Math.sinh(O) + _e * Math.cosh(O));
    };
  }
  const ee = {
    calculatedDuration: N && y || null,
    velocity: (ae) => /* @__PURE__ */ sn(Q(ae)),
    next: (ae) => {
      if (!N && R < 1) {
        const xe = Math.exp(-R * z * ae), _e = Math.sin(H * ae), Be = Math.cos(H * ae), ze = h - xe * (W * _e + _ * Be), O = /* @__PURE__ */ sn(xe * ($ * _e + k * Be));
        return p.done = Math.abs(O) <= o && Math.abs(h - ze) <= d, p.value = p.done ? h : ze, p;
      }
      const me = G(ae);
      if (N)
        p.done = ae >= y;
      else {
        const xe = /* @__PURE__ */ sn(Q(ae));
        p.done = Math.abs(xe) <= o && Math.abs(h - me) <= d;
      }
      return p.value = p.done ? h : me, p;
    },
    toString: () => {
      const ae = Math.min(_f(ee), oc), me = F0((xe) => ee.next(ae * xe).value, ae, 30);
      return ae + "ms " + me;
    },
    toTransition: () => {
    }
  };
  return ee;
}
cc.applyToOptions = (n) => {
  const i = S5(n, 100, cc);
  return n.ease = i.ease, n.duration = /* @__PURE__ */ sn(i.duration), n.type = "keyframes", n;
};
const M5 = 5;
function B0(n, i, l) {
  const o = Math.max(i - M5, 0);
  return /* @__PURE__ */ g0(l - n(o), i - o);
}
function Bh({ keyframes: n, velocity: i = 0, power: l = 0.8, timeConstant: o = 325, bounceDamping: d = 10, bounceStiffness: f = 500, modifyTarget: h, min: p, max: g, restDelta: m = 0.5, restSpeed: b }) {
  const y = n[0], w = {
    done: !1,
    value: y
  }, N = (k) => p !== void 0 && k < p || g !== void 0 && k > g, T = (k) => p === void 0 ? g : g === void 0 || Math.abs(p - k) < Math.abs(g - k) ? p : g;
  let R = l * i;
  const _ = y + R, z = h === void 0 ? _ : h(_);
  z !== _ && (R = z - y);
  const q = (k) => -R * Math.exp(-k / o), G = (k) => z + q(k), Q = (k) => {
    const ee = q(k), ae = G(k);
    w.done = Math.abs(ee) <= m, w.value = w.done ? z : ae;
  };
  let H, W;
  const $ = (k) => {
    N(w.value) && (H = k, W = cc({
      keyframes: [w.value, T(w.value)],
      velocity: B0(G, k, w.value),
      // TODO: This should be passing * 1000
      damping: d,
      stiffness: f,
      restDelta: m,
      restSpeed: b
    }));
  };
  return $(0), {
    calculatedDuration: null,
    next: (k) => {
      let ee = !1;
      return !W && H === void 0 && (ee = !0, Q(k), $(k)), H !== void 0 && k >= H ? W.next(k - H) : (!ee && Q(k), w);
    }
  };
}
function z5(n, i, l) {
  const o = [], d = l || Xa.mix || D0, f = n.length - 1;
  for (let h = 0; h < f; h++) {
    let p = d(n[h], n[h + 1]);
    if (i) {
      const g = Array.isArray(i) ? i[h] || Sn : i;
      p = dl(g, p);
    }
    o.push(p);
  }
  return o;
}
function O5(n, i, { clamp: l = !0, ease: o, mixer: d } = {}) {
  const f = n.length;
  if (jc(f === i.length), f === 1)
    return () => i[0];
  if (f === 2 && i[0] === i[1])
    return () => i[1];
  const h = n[0] === n[1];
  n[0] > n[f - 1] && (n = [...n].reverse(), i = [...i].reverse());
  const p = z5(i, o, d), g = p.length, m = (b) => {
    if (h && b < n[0])
      return i[0];
    let y = 0;
    if (g > 1)
      for (; y < n.length - 2 && !(b < n[y + 1]); y++)
        ;
    const w = /* @__PURE__ */ al(n[y], n[y + 1], b);
    return p[y](w);
  };
  return l ? (b) => m(Qn(n[0], n[f - 1], b)) : m;
}
function R5(n, i) {
  const l = n[n.length - 1];
  for (let o = 1; o <= i; o++) {
    const d = /* @__PURE__ */ al(0, i, o);
    n.push(qe(l, 1, d));
  }
}
function _5(n) {
  const i = [0];
  return R5(i, n.length - 1), i;
}
function D5(n, i) {
  return n.map((l) => l * i);
}
function F5(n, i) {
  return n.map(() => i || T0).splice(0, n.length - 1);
}
function Zr({ duration: n = 300, keyframes: i, times: l, ease: o = "easeInOut" }) {
  const d = /* @__PURE__ */ qT(o) ? o.map(wy) : wy(o), f = {
    done: !1,
    value: i[0]
  }, h = D5(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    l && l.length === i.length ? l : _5(i),
    n
  ), p = O5(h, i, {
    ease: Array.isArray(d) ? d : F5(i, d)
  });
  return {
    calculatedDuration: n,
    next: (g) => (f.value = p(g), f.done = g >= n, f)
  };
}
const B5 = (n) => n !== null;
function Sc(n, { repeat: i, repeatType: l = "loop" }, o, d = 1) {
  const f = n.filter(B5), p = d < 0 || i && l !== "loop" && i % 2 === 1 ? 0 : f.length - 1;
  return !p || o === void 0 ? f[p] : o;
}
const V5 = {
  decay: Bh,
  inertia: Bh,
  tween: Zr,
  keyframes: Zr,
  spring: cc
};
function V0(n) {
  typeof n.type == "string" && (n.type = V5[n.type]);
}
class Df {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((i) => {
      this.resolve = i;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(i, l) {
    return this.finished.then(i, l);
  }
}
const H5 = (n) => n / 100;
class uc extends Df {
  constructor(i) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      const { motionValue: l } = this.options;
      l && l.updatedAt !== Ot.now() && this.tick(Ot.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = i, this.initAnimation(), this.play(), i.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: i } = this;
    V0(i);
    const { type: l = Zr, repeat: o = 0, repeatDelay: d = 0, repeatType: f, velocity: h = 0 } = i;
    let { keyframes: p } = i;
    const g = l || Zr;
    g !== Zr && typeof p[0] != "number" && (this.mixKeyframes = dl(H5, D0(p[0], p[1])), p = [0, 100]);
    const m = g({ ...i, keyframes: p });
    f === "mirror" && (this.mirroredGenerator = g({
      ...i,
      keyframes: [...p].reverse(),
      velocity: -h
    })), m.calculatedDuration === null && (m.calculatedDuration = _f(m));
    const { calculatedDuration: b } = m;
    this.calculatedDuration = b, this.resolvedDuration = b + d, this.totalDuration = this.resolvedDuration * (o + 1) - d, this.generator = m;
  }
  updateTime(i) {
    const l = Math.round(i - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = l;
  }
  tick(i, l = !1) {
    const { generator: o, totalDuration: d, mixKeyframes: f, mirroredGenerator: h, resolvedDuration: p, calculatedDuration: g } = this;
    if (this.startTime === null)
      return o.next(0);
    const { delay: m = 0, keyframes: b, repeat: y, repeatType: w, repeatDelay: N, type: T, onUpdate: R, finalKeyframe: _ } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, i) : this.speed < 0 && (this.startTime = Math.min(i - d / this.speed, this.startTime)), l ? this.currentTime = i : this.updateTime(i);
    const z = this.currentTime - m * (this.playbackSpeed >= 0 ? 1 : -1), q = this.playbackSpeed >= 0 ? z < 0 : z > d;
    this.currentTime = Math.max(z, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = d);
    let G = this.currentTime, Q = o;
    if (y) {
      const k = Math.min(this.currentTime, d) / p;
      let ee = Math.floor(k), ae = k % 1;
      !ae && k >= 1 && (ae = 1), ae === 1 && ee--, ee = Math.min(ee, y + 1), ee % 2 && (w === "reverse" ? (ae = 1 - ae, N && (ae -= N / p)) : w === "mirror" && (Q = h)), G = Qn(0, 1, ae) * p;
    }
    let H;
    q ? (this.delayState.value = b[0], H = this.delayState) : H = Q.next(G), f && !q && (H.value = f(H.value));
    let { done: W } = H;
    !q && g !== null && (W = this.playbackSpeed >= 0 ? this.currentTime >= d : this.currentTime <= 0);
    const $ = this.holdTime === null && (this.state === "finished" || this.state === "running" && W);
    return $ && T !== Bh && (H.value = Sc(b, this.options, _, this.speed)), R && R(H.value), $ && this.finish(), H;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(i, l) {
    return this.finished.then(i, l);
  }
  get duration() {
    return /* @__PURE__ */ jn(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: i = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ jn(i);
  }
  get time() {
    return /* @__PURE__ */ jn(this.currentTime);
  }
  set time(i) {
    i = /* @__PURE__ */ sn(i), this.currentTime = i, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = i : this.driver && (this.startTime = this.driver.now() - i / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = i, this.tick(i));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const i = this.currentTime;
    if (i <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(i);
    const l = this.generator.next(i).value;
    return B0((o) => this.generator.next(o).value, i, l);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(i) {
    const l = this.playbackSpeed !== i;
    l && this.driver && this.updateTime(Ot.now()), this.playbackSpeed = i, l && this.driver && (this.time = /* @__PURE__ */ jn(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: i = j5, startTime: l } = this.options;
    this.driver || (this.driver = i((d) => this.tick(d))), this.options.onPlay?.();
    const o = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = o) : this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime || (this.startTime = l ?? o), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Ot.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(i) {
    return this.startTime = 0, this.tick(i, !0);
  }
  attachTimeline(i) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), i.observe(this);
  }
}
function U5(n) {
  for (let i = 1; i < n.length; i++)
    n[i] ?? (n[i] = n[i - 1]);
}
const zi = (n) => n * 180 / Math.PI, Vh = (n) => {
  const i = zi(Math.atan2(n[1], n[0]));
  return Hh(i);
}, L5 = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (n) => (Math.abs(n[0]) + Math.abs(n[3])) / 2,
  rotate: Vh,
  rotateZ: Vh,
  skewX: (n) => zi(Math.atan(n[1])),
  skewY: (n) => zi(Math.atan(n[2])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[2])) / 2
}, Hh = (n) => (n = n % 360, n < 0 && (n += 360), n), Ey = Vh, ky = (n) => Math.sqrt(n[0] * n[0] + n[1] * n[1]), My = (n) => Math.sqrt(n[4] * n[4] + n[5] * n[5]), P5 = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: ky,
  scaleY: My,
  scale: (n) => (ky(n) + My(n)) / 2,
  rotateX: (n) => Hh(zi(Math.atan2(n[6], n[5]))),
  rotateY: (n) => Hh(zi(Math.atan2(-n[2], n[0]))),
  rotateZ: Ey,
  rotate: Ey,
  skewX: (n) => zi(Math.atan(n[4])),
  skewY: (n) => zi(Math.atan(n[1])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[4])) / 2
};
function Uh(n) {
  return n.includes("scale") ? 1 : 0;
}
function Lh(n, i) {
  if (!n || n === "none")
    return Uh(i);
  const l = n.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let o, d;
  if (l)
    o = P5, d = l;
  else {
    const p = n.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    o = L5, d = p;
  }
  if (!d)
    return Uh(i);
  const f = o[i], h = d[1].split(",").map(q5);
  return typeof f == "function" ? f(h) : h[f];
}
const I5 = (n, i) => {
  const { transform: l = "none" } = getComputedStyle(n);
  return Lh(l, i);
};
function q5(n) {
  return parseFloat(n.trim());
}
const Bs = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Vs = /* @__PURE__ */ new Set([...Bs, "pathRotation"]), zy = (n) => n === Fs || n === ce, G5 = /* @__PURE__ */ new Set(["x", "y", "z"]), Y5 = Bs.filter((n) => !G5.has(n));
function Q5(n) {
  const i = [];
  return Y5.forEach((l) => {
    const o = n.getValue(l);
    o !== void 0 && (i.push([l, o.get()]), o.set(l.startsWith("scale") ? 1 : 0));
  }), i;
}
const Za = {
  // Dimensions
  width: ({ x: n }, { paddingLeft: i = "0", paddingRight: l = "0", boxSizing: o }) => {
    const d = n.max - n.min;
    return o === "border-box" ? d : d - parseFloat(i) - parseFloat(l);
  },
  height: ({ y: n }, { paddingTop: i = "0", paddingBottom: l = "0", boxSizing: o }) => {
    const d = n.max - n.min;
    return o === "border-box" ? d : d - parseFloat(i) - parseFloat(l);
  },
  top: (n, { top: i }) => parseFloat(i),
  left: (n, { left: i }) => parseFloat(i),
  bottom: ({ y: n }, { top: i }) => parseFloat(i) + (n.max - n.min),
  right: ({ x: n }, { left: i }) => parseFloat(i) + (n.max - n.min),
  // Transform
  x: (n, { transform: i }) => Lh(i, "x"),
  y: (n, { transform: i }) => Lh(i, "y")
};
Za.translateX = Za.x;
Za.translateY = Za.y;
const Oi = /* @__PURE__ */ new Set();
let Ph = !1, Ih = !1, qh = !1;
function H0() {
  if (Ih) {
    const n = Array.from(Oi).filter((o) => o.needsMeasurement), i = new Set(n.map((o) => o.element)), l = /* @__PURE__ */ new Map();
    i.forEach((o) => {
      const d = Q5(o);
      d.length && (l.set(o, d), o.render());
    }), n.forEach((o) => o.measureInitialState()), i.forEach((o) => {
      o.render();
      const d = l.get(o);
      d && d.forEach(([f, h]) => {
        o.getValue(f)?.set(h);
      });
    }), n.forEach((o) => o.measureEndState()), n.forEach((o) => {
      o.suspendedScrollY !== void 0 && window.scrollTo(0, o.suspendedScrollY);
    });
  }
  Ih = !1, Ph = !1, Oi.forEach((n) => n.complete(qh)), Oi.clear();
}
function U0() {
  Oi.forEach((n) => {
    n.readKeyframes(), n.needsMeasurement && (Ih = !0);
  });
}
function Z5() {
  qh = !0, U0(), H0(), qh = !1;
}
class Ff {
  constructor(i, l, o, d, f, h = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...i], this.onComplete = l, this.name = o, this.motionValue = d, this.element = f, this.isAsync = h;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Oi.add(this), Ph || (Ph = !0, Ge.read(U0), Ge.resolveKeyframes(H0))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: i, name: l, element: o, motionValue: d } = this;
    if (i[0] === null) {
      const f = d?.get(), h = i[i.length - 1];
      if (f !== void 0)
        i[0] = f;
      else if (o && l) {
        const p = o.readValue(l, h);
        p != null && (i[0] = p);
      }
      i[0] === void 0 && (i[0] = h), d && f === void 0 && d.set(i[0]);
    }
    U5(i);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(i = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, i), Oi.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Oi.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const X5 = (n) => n.startsWith("--");
function L0(n, i, l) {
  X5(i) ? n.style.setProperty(i, l) : n.style[i] = l;
}
const K5 = {};
function P0(n, i) {
  const l = /* @__PURE__ */ p0(n);
  return () => K5[i] ?? l();
}
const $5 = /* @__PURE__ */ P0(() => window.ScrollTimeline !== void 0, "scrollTimeline"), I0 = /* @__PURE__ */ P0(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Yr = ([n, i, l, o]) => `cubic-bezier(${n}, ${i}, ${l}, ${o})`, Oy = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Yr([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Yr([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Yr([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Yr([0.33, 1.53, 0.69, 0.99])
};
function q0(n, i) {
  if (n)
    return typeof n == "function" ? I0() ? F0(n, i) : "ease-out" : /* @__PURE__ */ A0(n) ? Yr(n) : Array.isArray(n) ? n.map((l) => q0(l, i) || Oy.easeOut) : Oy[n];
}
function W5(n, i, l, { delay: o = 0, duration: d = 300, repeat: f = 0, repeatType: h = "loop", ease: p = "easeOut", times: g } = {}, m = void 0) {
  const b = {
    [i]: l
  };
  g && (b.offset = g);
  const y = q0(p, d);
  Array.isArray(y) && (b.easing = y);
  const w = {
    delay: o,
    duration: d,
    easing: Array.isArray(y) ? "linear" : y,
    fill: "both",
    iterations: f + 1,
    direction: h === "reverse" ? "alternate" : "normal"
  };
  return m && (w.pseudoElement = m), n.animate(b, w);
}
function G0(n) {
  return typeof n == "function" && "applyToOptions" in n;
}
function J5({ type: n, ...i }) {
  return G0(n) && I0() ? n.applyToOptions(i) : (i.duration ?? (i.duration = 300), i.ease ?? (i.ease = "easeOut"), i);
}
class Y0 extends Df {
  constructor(i) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !i)
      return;
    const { element: l, name: o, keyframes: d, pseudoElement: f, allowFlatten: h = !1, finalKeyframe: p, onComplete: g } = i;
    this.isPseudoElement = !!f, this.allowFlatten = h, this.options = i, jc(typeof i.type != "string");
    const m = J5(i);
    this.animation = W5(l, o, d, m, f), m.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !f) {
        const b = Sc(d, this.options, p, this.speed);
        this.updateMotionValue && this.updateMotionValue(b), L0(l, o, b), this.animation.cancel();
      }
      g?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: i } = this;
    i === "idle" || i === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const i = this.options?.element;
    !this.isPseudoElement && i?.isConnected && this.animation.commitStyles?.();
  }
  get duration() {
    const i = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ jn(Number(i));
  }
  get iterationDuration() {
    const { delay: i = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ jn(i);
  }
  get time() {
    return /* @__PURE__ */ jn(Number(this.animation.currentTime) || 0);
  }
  set time(i) {
    const l = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ sn(i), l && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(i) {
    i < 0 && (this.finishedTime = null), this.animation.playbackRate = i;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(i) {
    this.manualStartTime = this.animation.startTime = i;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: i, rangeStart: l, rangeEnd: o, observe: d }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, i && $5() ? (this.animation.timeline = i, l && (this.animation.rangeStart = l), o && (this.animation.rangeEnd = o), Sn) : d(this);
  }
}
const Q0 = {
  anticipate: j0,
  backInOut: w0,
  circInOut: N0
};
function e3(n) {
  return n in Q0;
}
function t3(n) {
  typeof n.ease == "string" && e3(n.ease) && (n.ease = Q0[n.ease]);
}
const th = 10;
class n3 extends Y0 {
  constructor(i) {
    t3(i), V0(i), super(i), i.startTime !== void 0 && i.autoplay !== !1 && (this.startTime = i.startTime), this.options = i;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(i) {
    const { motionValue: l, onUpdate: o, onComplete: d, element: f, ...h } = this.options;
    if (!l)
      return;
    if (i !== void 0) {
      l.set(i);
      return;
    }
    const p = new uc({
      ...h,
      autoplay: !1
    }), g = Math.max(th, Ot.now() - this.startTime), m = Qn(0, th, g - th), b = p.sample(g).value, { name: y } = this.options;
    f && y && L0(f, y, b), l.setWithVelocity(p.sample(Math.max(0, g - m)).value, b, m), p.stop();
  }
}
const Ry = (n, i) => i === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
(On.test(n) || n === "0") && // And it contains numbers and/or colors
!n.startsWith("url("));
function a3(n) {
  const i = n[0];
  if (n.length === 1)
    return !0;
  for (let l = 0; l < n.length; l++)
    if (n[l] !== i)
      return !0;
}
function i3(n, i, l, o) {
  const d = n[0];
  if (d === null)
    return !1;
  if (i === "display" || i === "visibility")
    return !0;
  const f = n[n.length - 1], h = Ry(d, i), p = Ry(f, i);
  return !h || !p ? !1 : a3(n) || (l === "spring" || G0(l)) && o;
}
function Gh(n) {
  n.duration = 0, n.type = "keyframes";
}
const Z0 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), s3 = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function r3(n) {
  for (let i = 0; i < n.length; i++)
    if (typeof n[i] == "string" && s3.test(n[i]))
      return !0;
  return !1;
}
const l3 = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), o3 = /* @__PURE__ */ p0(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function c3(n) {
  const { motionValue: i, name: l, repeatDelay: o, repeatType: d, damping: f, type: h, keyframes: p } = n, g = i?.owner?.current;
  if (!(g instanceof HTMLElement) && !(g instanceof SVGElement))
    return !1;
  const { onUpdate: m, transformTemplate: b } = i.owner.getProps();
  return o3() && l && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (Z0.has(l) || l3.has(l) && r3(p)) && (l !== "transform" || !b) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !m && !o && d !== "mirror" && f !== 0 && h !== "inertia";
}
const u3 = 40;
class d3 extends Df {
  constructor({ autoplay: i = !0, delay: l = 0, type: o = "keyframes", repeat: d = 0, repeatDelay: f = 0, repeatType: h = "loop", keyframes: p, name: g, motionValue: m, element: b, ...y }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = Ot.now();
    const w = {
      autoplay: i,
      delay: l,
      type: o,
      repeat: d,
      repeatDelay: f,
      repeatType: h,
      name: g,
      motionValue: m,
      element: b,
      ...y
    }, N = b?.KeyframeResolver || Ff;
    this.keyframeResolver = new N(p, (T, R, _) => this.onKeyframesResolved(T, R, w, !_), g, m, b), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(i, l, o, d) {
    this.keyframeResolver = void 0;
    const { name: f, type: h, velocity: p, delay: g, isHandoff: m, onUpdate: b } = o;
    this.resolvedAt = Ot.now();
    let y = !0;
    i3(i, f, h, p) || (y = !1, (Xa.instantAnimations || !g) && b?.(Sc(i, o, l)), i[0] = i[i.length - 1], Gh(o), o.repeat = 0);
    const N = {
      startTime: d ? this.resolvedAt ? this.resolvedAt - this.createdAt > u3 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: l,
      ...o,
      keyframes: i
    }, T = y && !m && c3(N), R = N.motionValue?.owner?.current;
    let _;
    if (T)
      try {
        _ = new n3({
          ...N,
          element: R
        });
      } catch {
        _ = new uc(N);
      }
    else
      _ = new uc(N);
    _.finished.then(() => {
      this.notifyFinished();
    }).catch(Sn), this.pendingTimeline && (this.stopTimeline = _.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = _;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(i, l) {
    return this.finished.finally(i).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), Z5()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(i) {
    this.animation.time = i;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(i) {
    this.animation.speed = i;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(i) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(i) : this.pendingTimeline = i, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
function X0(n, i, l, o = 0, d = 1) {
  const f = Array.from(n).sort((m, b) => m.sortNodePosition(b)).indexOf(i), h = n.size, p = (h - 1) * o;
  return typeof l == "function" ? l(f, h) : d === 1 ? f * o : p - f * o;
}
const _y = 30, h3 = (n) => !isNaN(parseFloat(n));
class f3 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(i, l = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (o) => {
      const d = Ot.now();
      if (this.updatedAt !== d && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(o), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const f of this.dependents)
          f.dirty();
    }, this.hasAnimated = !1, this.setCurrent(i), this.owner = l.owner;
  }
  setCurrent(i) {
    this.current = i, this.updatedAt = Ot.now(), this.canTrackVelocity === null && i !== void 0 && (this.canTrackVelocity = h3(this.current));
  }
  setPrevFrameValue(i = this.current) {
    this.prevFrameValue = i, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(i) {
    return this.on("change", i);
  }
  on(i, l) {
    this.events[i] || (this.events[i] = new Cf());
    const o = this.events[i].add(l);
    return i === "change" ? () => {
      o(), Ge.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : o;
  }
  clearListeners() {
    for (const i in this.events)
      this.events[i].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(i, l) {
    this.passiveEffect = i, this.stopPassiveEffect = l;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(i) {
    this.passiveEffect ? this.passiveEffect(i, this.updateAndNotify) : this.updateAndNotify(i);
  }
  setWithVelocity(i, l, o) {
    this.set(l), this.prev = void 0, this.prevFrameValue = i, this.prevUpdatedAt = this.updatedAt - o;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(i, l = !0) {
    this.updateAndNotify(i), this.prev = i, this.prevUpdatedAt = this.prevFrameValue = void 0, l && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(i) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(i);
  }
  removeDependent(i) {
    this.dependents && this.dependents.delete(i);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const i = Ot.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || i - this.updatedAt > _y)
      return 0;
    const l = Math.min(this.updatedAt - this.prevUpdatedAt, _y);
    return /* @__PURE__ */ g0(parseFloat(this.current) - parseFloat(this.prevFrameValue), l);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(i) {
    return this.stop(), new Promise((l) => {
      this.hasAnimated = !0, this.animation = i(l), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ds(n, i) {
  return new f3(n, i);
}
function K0(n, i) {
  if (n?.inherit && i) {
    const { inherit: l, ...o } = n;
    return { ...i, ...o };
  }
  return n;
}
function Bf(n, i) {
  const l = n?.[i] ?? n?.default ?? n;
  return l !== n ? K0(l, n) : l;
}
const m3 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, p3 = (n) => ({
  type: "spring",
  stiffness: 550,
  damping: n === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), g3 = {
  type: "keyframes",
  duration: 0.8
}, x3 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, y3 = (n, { keyframes: i }) => i.length > 2 ? g3 : Vs.has(n) ? n.startsWith("scale") ? p3(i[1]) : m3 : x3, b3 = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function v3(n) {
  for (const i in n)
    if (!b3.has(i))
      return !0;
  return !1;
}
const Vf = (n, i, l, o = {}, d, f) => (h) => {
  const p = Bf(o, n) || {}, g = p.delay || o.delay || 0;
  let { elapsed: m = 0 } = o;
  m = m - /* @__PURE__ */ sn(g);
  const b = {
    keyframes: Array.isArray(l) ? l : [null, l],
    ease: "easeOut",
    velocity: i.getVelocity(),
    ...p,
    delay: -m,
    onUpdate: (w) => {
      i.set(w), p.onUpdate && p.onUpdate(w);
    },
    onComplete: () => {
      h(), p.onComplete && p.onComplete();
    },
    name: n,
    motionValue: i,
    element: f ? void 0 : d
  };
  v3(p) || Object.assign(b, y3(n, b)), b.duration && (b.duration = /* @__PURE__ */ sn(b.duration)), b.repeatDelay && (b.repeatDelay = /* @__PURE__ */ sn(b.repeatDelay)), b.from !== void 0 && (b.keyframes[0] = b.from);
  let y = !1;
  if ((b.type === !1 || b.duration === 0 && !b.repeatDelay) && (Gh(b), b.delay === 0 && (y = !0)), (Xa.instantAnimations || Xa.skipAnimations || d?.shouldSkipAnimations || p.skipAnimations) && (y = !0, Gh(b), b.delay = 0), b.allowFlatten = !p.type && !p.ease, y && !f && i.get() !== void 0) {
    const w = Sc(b.keyframes, p);
    if (w !== void 0) {
      Ge.update(() => {
        b.onUpdate(w), b.onComplete();
      });
      return;
    }
  }
  return p.isSync ? new uc(b) : new d3(b);
}, w3 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function j3(n) {
  const i = w3.exec(n);
  if (!i)
    return [,];
  const [, l, o, d] = i;
  return [`--${l ?? o}`, d];
}
function $0(n, i, l = 1) {
  const [o, d] = j3(n);
  if (!o)
    return;
  const f = window.getComputedStyle(i).getPropertyValue(o);
  if (f) {
    const h = f.trim();
    return h0(h) ? parseFloat(h) : h;
  }
  return Mf(d) ? $0(d, i, l + 1) : d;
}
function Dy(n) {
  const i = [{}, {}];
  return n?.values.forEach((l, o) => {
    i[0][o] = l.get(), i[1][o] = l.getVelocity();
  }), i;
}
function Hf(n, i, l, o) {
  if (typeof i == "function") {
    const [d, f] = Dy(o);
    i = i(l !== void 0 ? l : n.custom, d, f);
  }
  if (typeof i == "string" && (i = n.variants && n.variants[i]), typeof i == "function") {
    const [d, f] = Dy(o);
    i = i(l !== void 0 ? l : n.custom, d, f);
  }
  return i;
}
function Ri(n, i, l) {
  const o = n.getProps();
  return Hf(o, i, l !== void 0 ? l : o.custom, n);
}
const W0 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Bs
]), Yh = (n) => Array.isArray(n);
function S3(n, i, l) {
  n.hasValue(i) ? n.getValue(i).set(l) : n.addValue(i, Ds(l));
}
function N3(n) {
  return Yh(n) ? n[n.length - 1] || 0 : n;
}
function T3(n, i) {
  const l = Ri(n, i);
  let { transitionEnd: o = {}, transition: d = {}, ...f } = l || {};
  f = { ...f, ...o };
  for (const h in f) {
    const p = N3(f[h]);
    S3(n, h, p);
  }
}
const vt = (n) => !!(n && n.getVelocity);
function A3(n) {
  return !!(vt(n) && n.add);
}
function Qh(n, i) {
  const l = n.getValue("willChange");
  if (A3(l))
    return l.add(i);
  if (!l && Xa.WillChange) {
    const o = new Xa.WillChange("auto");
    n.addValue("willChange", o), o.add(i);
  }
}
function Uf(n) {
  return n.replace(/([A-Z])/g, (i) => `-${i.toLowerCase()}`);
}
const C3 = "framerAppearId", J0 = "data-" + Uf(C3);
function e1(n) {
  return n.props[J0];
}
function E3({ protectedKeys: n, needsAnimating: i }, l) {
  const o = n.hasOwnProperty(l) && i[l] !== !0;
  return i[l] = !1, o;
}
function t1(n, i, { delay: l = 0, transitionOverride: o, type: d } = {}) {
  let { transition: f, transitionEnd: h, ...p } = i;
  const g = n.getDefaultTransition();
  f = f ? K0(f, g) : g;
  const m = f?.reduceMotion, b = f?.skipAnimations;
  o && (f = o);
  const y = [], w = d && n.animationState && n.animationState.getState()[d], N = f?.path;
  N && N.animateVisualElement(n, p, f, l, y);
  for (const T in p) {
    const R = n.getValue(T, n.latestValues[T] ?? null), _ = p[T];
    if (_ === void 0 || w && E3(w, T))
      continue;
    const z = {
      delay: l,
      ...Bf(f || {}, T)
    };
    b && (z.skipAnimations = !0);
    const q = R.get();
    if (q !== void 0 && !R.isAnimating() && !Array.isArray(_) && _ === q && !z.velocity) {
      Ge.update(() => R.set(_));
      continue;
    }
    let G = !1;
    if (window.MotionHandoffAnimation) {
      const W = e1(n);
      if (W) {
        const $ = window.MotionHandoffAnimation(W, T, Ge);
        $ !== null && (z.startTime = $, G = !0);
      }
    }
    Qh(n, T);
    const Q = m ?? n.shouldReduceMotion;
    R.start(Vf(T, R, _, Q && W0.has(T) ? { type: !1 } : z, n, G));
    const H = R.animation;
    H && y.push(H);
  }
  if (h) {
    const T = () => Ge.update(() => {
      h && T3(n, h);
    });
    y.length ? Promise.all(y).then(T) : T();
  }
  return y;
}
function Zh(n, i, l = {}) {
  const o = Ri(n, i, l.type === "exit" ? n.presenceContext?.custom : void 0);
  let { transition: d = n.getDefaultTransition() || {} } = o || {};
  l.transitionOverride && (d = l.transitionOverride);
  const f = o ? () => Promise.all(t1(n, o, l)) : () => Promise.resolve(), h = n.variantChildren && n.variantChildren.size ? (g = 0) => {
    const { delayChildren: m = 0, staggerChildren: b, staggerDirection: y } = d;
    return k3(n, i, g, m, b, y, l);
  } : () => Promise.resolve(), { when: p } = d;
  if (p) {
    const [g, m] = p === "beforeChildren" ? [f, h] : [h, f];
    return g().then(() => m());
  } else
    return Promise.all([f(), h(l.delay)]);
}
function k3(n, i, l = 0, o = 0, d = 0, f = 1, h) {
  const p = [];
  for (const g of n.variantChildren)
    g.notify("AnimationStart", i), p.push(Zh(g, i, {
      ...h,
      delay: l + (typeof o == "function" ? 0 : o) + X0(n.variantChildren, g, o, d, f)
    }).then(() => g.notify("AnimationComplete", i)));
  return Promise.all(p);
}
function M3(n, i, l = {}) {
  n.notify("AnimationStart", i);
  let o;
  if (Array.isArray(i)) {
    const d = i.map((f) => Zh(n, f, l));
    o = Promise.all(d);
  } else if (typeof i == "string")
    o = Zh(n, i, l);
  else {
    const d = typeof i == "function" ? Ri(n, i, l.custom) : i;
    o = Promise.all(t1(n, d, l));
  }
  return o.then(() => {
    n.notify("AnimationComplete", i);
  });
}
const z3 = {
  test: (n) => n === "auto",
  parse: (n) => n
}, n1 = (n) => (i) => i.test(n), a1 = [Fs, ce, Yn, ma, a5, n5, z3], Fy = (n) => a1.find(n1(n));
function O3(n) {
  return typeof n == "number" ? n === 0 : n !== null ? n === "none" || n === "0" || m0(n) : !0;
}
const R3 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function _3(n) {
  const [i, l] = n.slice(0, -1).split("(");
  if (i === "drop-shadow")
    return n;
  const [o] = l.match(zf) || [];
  if (!o)
    return n;
  const d = l.replace(o, "");
  let f = R3.has(i) ? 1 : 0;
  return o !== l && (f *= 100), i + "(" + f + d + ")";
}
const D3 = /\b([a-z-]*)\(.*?\)/gu, Xh = {
  ...On,
  getAnimatableNone: (n) => {
    const i = n.match(D3);
    return i ? i.map(_3).join(" ") : n;
  }
}, Kh = {
  ...On,
  getAnimatableNone: (n) => {
    const i = On.parse(n);
    return On.createTransformer(n)(i.map((o) => typeof o == "number" ? 0 : typeof o == "object" ? { ...o, alpha: 1 } : o));
  }
}, By = {
  ...Fs,
  transform: Math.round
}, F3 = {
  rotate: ma,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: ma,
  rotateX: ma,
  rotateY: ma,
  rotateZ: ma,
  scale: Bo,
  scaleX: Bo,
  scaleY: Bo,
  scaleZ: Bo,
  skew: ma,
  skewX: ma,
  skewY: ma,
  distance: ce,
  translateX: ce,
  translateY: ce,
  translateZ: ce,
  x: ce,
  y: ce,
  z: ce,
  perspective: ce,
  transformPerspective: ce,
  opacity: il,
  originX: Sy,
  originY: Sy,
  originZ: ce
}, dc = {
  // Border props
  borderWidth: ce,
  borderTopWidth: ce,
  borderRightWidth: ce,
  borderBottomWidth: ce,
  borderLeftWidth: ce,
  borderRadius: ce,
  borderTopLeftRadius: ce,
  borderTopRightRadius: ce,
  borderBottomRightRadius: ce,
  borderBottomLeftRadius: ce,
  // Positioning props
  width: ce,
  maxWidth: ce,
  height: ce,
  maxHeight: ce,
  top: ce,
  right: ce,
  bottom: ce,
  left: ce,
  inset: ce,
  insetBlock: ce,
  insetBlockStart: ce,
  insetBlockEnd: ce,
  insetInline: ce,
  insetInlineStart: ce,
  insetInlineEnd: ce,
  // Spacing props
  padding: ce,
  paddingTop: ce,
  paddingRight: ce,
  paddingBottom: ce,
  paddingLeft: ce,
  paddingBlock: ce,
  paddingBlockStart: ce,
  paddingBlockEnd: ce,
  paddingInline: ce,
  paddingInlineStart: ce,
  paddingInlineEnd: ce,
  margin: ce,
  marginTop: ce,
  marginRight: ce,
  marginBottom: ce,
  marginLeft: ce,
  marginBlock: ce,
  marginBlockStart: ce,
  marginBlockEnd: ce,
  marginInline: ce,
  marginInlineStart: ce,
  marginInlineEnd: ce,
  // Typography
  fontSize: ce,
  // Misc
  backgroundPositionX: ce,
  backgroundPositionY: ce,
  ...F3,
  zIndex: By,
  // SVG
  fillOpacity: il,
  strokeOpacity: il,
  numOctaves: By
}, B3 = {
  ...dc,
  // Color props
  color: rt,
  backgroundColor: rt,
  outlineColor: rt,
  fill: rt,
  stroke: rt,
  // Border props
  borderColor: rt,
  borderTopColor: rt,
  borderRightColor: rt,
  borderBottomColor: rt,
  borderLeftColor: rt,
  filter: Xh,
  WebkitFilter: Xh,
  mask: Kh,
  WebkitMask: Kh
}, i1 = (n) => B3[n], V3 = /* @__PURE__ */ new Set([Xh, Kh]);
function s1(n, i) {
  let l = i1(n);
  return V3.has(l) || (l = On), l.getAnimatableNone ? l.getAnimatableNone(i) : void 0;
}
const H3 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function U3(n, i, l) {
  let o = 0, d;
  for (; o < n.length && !d; ) {
    const f = n[o];
    typeof f == "string" && !H3.has(f) && _s(f).values.length && (d = n[o]), o++;
  }
  if (d && l)
    for (const f of i)
      n[f] = s1(l, d);
}
class L3 extends Ff {
  constructor(i, l, o, d, f) {
    super(i, l, o, d, f, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: i, element: l, name: o } = this;
    if (!l || !l.current)
      return;
    super.readKeyframes();
    for (let b = 0; b < i.length; b++) {
      let y = i[b];
      if (typeof y == "string" && (y = y.trim(), Mf(y))) {
        const w = $0(y, l.current);
        w !== void 0 && (i[b] = w), b === i.length - 1 && (this.finalKeyframe = y);
      }
    }
    if (this.resolveNoneKeyframes(), !W0.has(o) || i.length !== 2)
      return;
    const [d, f] = i, h = Fy(d), p = Fy(f), g = jy(d), m = jy(f);
    if (g !== m && Za[o]) {
      this.needsMeasurement = !0;
      return;
    }
    if (h !== p)
      if (zy(h) && zy(p))
        for (let b = 0; b < i.length; b++) {
          const y = i[b];
          typeof y == "string" && (i[b] = parseFloat(y));
        }
      else Za[o] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: i, name: l } = this, o = [];
    for (let d = 0; d < i.length; d++)
      (i[d] === null || O3(i[d])) && o.push(d);
    o.length && U3(i, o, l);
  }
  measureInitialState() {
    const { element: i, unresolvedKeyframes: l, name: o } = this;
    if (!i || !i.current)
      return;
    o === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Za[o](i.measureViewportBox(), window.getComputedStyle(i.current)), l[0] = this.measuredOrigin;
    const d = l[l.length - 1];
    d !== void 0 && i.getValue(o, d).jump(d, !1);
  }
  measureEndState() {
    const { element: i, name: l, unresolvedKeyframes: o } = this;
    if (!i || !i.current)
      return;
    const d = i.getValue(l);
    d && d.jump(this.measuredOrigin, !1);
    const f = o.length - 1, h = o[f];
    o[f] = Za[l](i.measureViewportBox(), window.getComputedStyle(i.current)), h !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = h), this.removedTransforms?.length && this.removedTransforms.forEach(([p, g]) => {
      i.getValue(p).set(g);
    }), this.resolveNoneKeyframes();
  }
}
const Lf = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];
function r1(n, i, l) {
  if (n == null)
    return [];
  if (n instanceof EventTarget)
    return [n];
  if (typeof n == "string") {
    let o = document;
    const d = l?.[n] ?? o.querySelectorAll(n);
    return d ? Array.from(d) : [];
  }
  return Array.from(n).filter((o) => o != null);
}
const $h = (n, i) => i && typeof n == "number" ? i.transform(n) : n;
function Qo(n) {
  return f0(n) && "offsetHeight" in n && !("ownerSVGElement" in n);
}
const { schedule: Pf } = /* @__PURE__ */ C0(queueMicrotask, !1), Mn = {
  x: !1,
  y: !1
};
function l1() {
  return Mn.x || Mn.y;
}
function P3(n) {
  return n === "x" || n === "y" ? Mn[n] ? null : (Mn[n] = !0, () => {
    Mn[n] = !1;
  }) : Mn.x || Mn.y ? null : (Mn.x = Mn.y = !0, () => {
    Mn.x = Mn.y = !1;
  });
}
function o1(n, i) {
  const l = r1(n), o = new AbortController(), d = {
    passive: !0,
    ...i,
    signal: o.signal
  };
  return [l, d, () => o.abort()];
}
function I3(n) {
  return !(n.pointerType === "touch" || l1());
}
function q3(n, i, l = {}) {
  const [o, d, f] = o1(n, l);
  return o.forEach((h) => {
    let p = !1, g = !1, m;
    const b = () => {
      h.removeEventListener("pointerleave", T);
    }, y = (_) => {
      m && (m(_), m = void 0), b();
    }, w = (_) => {
      p = !1, window.removeEventListener("pointerup", w), window.removeEventListener("pointercancel", w), g && (g = !1, y(_));
    }, N = () => {
      p = !0, window.addEventListener("pointerup", w, d), window.addEventListener("pointercancel", w, d);
    }, T = (_) => {
      if (_.pointerType !== "touch") {
        if (p) {
          g = !0;
          return;
        }
        y(_);
      }
    }, R = (_) => {
      if (!I3(_))
        return;
      g = !1;
      const z = i(h, _);
      typeof z == "function" && (m = z, h.addEventListener("pointerleave", T, d));
    };
    h.addEventListener("pointerenter", R, d), h.addEventListener("pointerdown", N, d);
  }), f;
}
const c1 = (n, i) => i ? n === i ? !0 : c1(n, i.parentElement) : !1, If = (n) => n.pointerType === "mouse" ? typeof n.button != "number" || n.button <= 0 : n.isPrimary !== !1, G3 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Y3(n) {
  return G3.has(n.tagName) || n.isContentEditable === !0;
}
const Q3 = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function Z3(n) {
  return Q3.has(n.tagName) || n.isContentEditable === !0;
}
const Zo = /* @__PURE__ */ new WeakSet();
function Vy(n) {
  return (i) => {
    i.key === "Enter" && n(i);
  };
}
function nh(n, i) {
  n.dispatchEvent(new PointerEvent("pointer" + i, { isPrimary: !0, bubbles: !0 }));
}
const X3 = (n, i) => {
  const l = n.currentTarget;
  if (!l)
    return;
  const o = Vy(() => {
    if (Zo.has(l))
      return;
    nh(l, "down");
    const d = Vy(() => {
      nh(l, "up");
    }), f = () => nh(l, "cancel");
    l.addEventListener("keyup", d, i), l.addEventListener("blur", f, i);
  });
  l.addEventListener("keydown", o, i), l.addEventListener("blur", () => l.removeEventListener("keydown", o), i);
};
function Hy(n) {
  return If(n) && !l1();
}
const Uy = /* @__PURE__ */ new WeakSet();
function K3(n, i, l = {}) {
  const [o, d, f] = o1(n, l), h = (p) => {
    const g = p.currentTarget;
    if (!Hy(p) || Uy.has(p))
      return;
    Zo.add(g), l.stopPropagation && Uy.add(p);
    const m = i(g, p), b = { ...d, capture: !0 }, y = (T, R) => {
      window.removeEventListener("pointerup", w, b), window.removeEventListener("pointercancel", N, b), Zo.has(g) && Zo.delete(g), Hy(T) && typeof m == "function" && m(T, { success: R });
    }, w = (T) => {
      y(T, g === window || g === document || l.useGlobalTarget || c1(g, T.target));
    }, N = (T) => {
      y(T, !1);
    };
    window.addEventListener("pointerup", w, b), window.addEventListener("pointercancel", N, b);
  };
  return o.forEach((p) => {
    (l.useGlobalTarget ? window : p).addEventListener("pointerdown", h, d), Qo(p) && (p.addEventListener("focus", (m) => X3(m, d)), !Y3(p) && !p.hasAttribute("tabindex") && (p.tabIndex = 0));
  }), f;
}
function qf(n) {
  return f0(n) && "ownerSVGElement" in n;
}
const Xo = /* @__PURE__ */ new WeakMap();
let Ko;
const u1 = (n, i, l) => (o, d) => d && d[0] ? d[0][n + "Size"] : qf(o) && "getBBox" in o ? o.getBBox()[i] : o[l], $3 = /* @__PURE__ */ u1("inline", "width", "offsetWidth"), W3 = /* @__PURE__ */ u1("block", "height", "offsetHeight");
function J3({ target: n, borderBoxSize: i }) {
  Xo.get(n)?.forEach((l) => {
    l(n, {
      get width() {
        return $3(n, i);
      },
      get height() {
        return W3(n, i);
      }
    });
  });
}
function eA(n) {
  n.forEach(J3);
}
function tA() {
  typeof ResizeObserver > "u" || (Ko = new ResizeObserver(eA));
}
function nA(n, i) {
  Ko || tA();
  const l = r1(n);
  return l.forEach((o) => {
    let d = Xo.get(o);
    d || (d = /* @__PURE__ */ new Set(), Xo.set(o, d)), d.add(i), Ko?.observe(o);
  }), () => {
    l.forEach((o) => {
      const d = Xo.get(o);
      d?.delete(i), d?.size || Ko?.unobserve(o);
    });
  };
}
const $o = /* @__PURE__ */ new Set();
let ks;
function aA() {
  ks = () => {
    const n = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    $o.forEach((i) => i(n));
  }, window.addEventListener("resize", ks);
}
function iA(n) {
  return $o.add(n), ks || aA(), () => {
    $o.delete(n), !$o.size && typeof ks == "function" && (window.removeEventListener("resize", ks), ks = void 0);
  };
}
function Ly(n, i) {
  return typeof n == "function" ? iA(n) : nA(n, i);
}
function sA(n) {
  return qf(n) && n.tagName === "svg";
}
const rA = [...a1, rt, On], lA = (n) => rA.find(n1(n)), Py = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Ms = () => ({
  x: Py(),
  y: Py()
}), Iy = () => ({ min: 0, max: 0 }), ct = () => ({
  x: Iy(),
  y: Iy()
}), oA = /* @__PURE__ */ new WeakMap();
function Nc(n) {
  return n !== null && typeof n == "object" && typeof n.start == "function";
}
function sl(n) {
  return typeof n == "string" || Array.isArray(n);
}
const Gf = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Yf = ["initial", ...Gf];
function Tc(n) {
  return Nc(n.animate) || Yf.some((i) => sl(n[i]));
}
function d1(n) {
  return !!(Tc(n) || n.variants);
}
function cA(n, i, l) {
  for (const o in i) {
    const d = i[o], f = l[o];
    if (vt(d))
      n.addValue(o, d);
    else if (vt(f))
      n.addValue(o, Ds(d, { owner: n }));
    else if (f !== d)
      if (n.hasValue(o)) {
        const h = n.getValue(o);
        h.liveStyle === !0 ? h.jump(d) : h.hasAnimated || h.set(d);
      } else {
        const h = n.getStaticValue(o);
        n.addValue(o, Ds(h !== void 0 ? h : d, { owner: n }));
      }
  }
  for (const o in l)
    i[o] === void 0 && n.removeValue(o);
  return i;
}
const Wh = { current: null }, h1 = { current: !1 }, uA = typeof window < "u";
function dA() {
  if (h1.current = !0, !!uA)
    if (window.matchMedia) {
      const n = window.matchMedia("(prefers-reduced-motion)"), i = () => Wh.current = n.matches;
      n.addEventListener("change", i), i();
    } else
      Wh.current = !1;
}
const qy = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let hc = {};
function f1(n) {
  hc = n;
}
function hA() {
  return hc;
}
class fA {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(i, l, o) {
    return {};
  }
  constructor({ parent: i, props: l, presenceContext: o, reducedMotionConfig: d, skipAnimations: f, blockInitialAnimation: h, visualState: p }, g = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Ff, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const N = Ot.now();
      this.renderScheduledAt < N && (this.renderScheduledAt = N, Ge.render(this.render, !1, !0));
    };
    const { latestValues: m, renderState: b } = p;
    this.latestValues = m, this.baseTarget = { ...m }, this.initialValues = l.initial ? { ...m } : {}, this.renderState = b, this.parent = i, this.props = l, this.presenceContext = o, this.depth = i ? i.depth + 1 : 0, this.reducedMotionConfig = d, this.skipAnimationsConfig = f, this.options = g, this.blockInitialAnimation = !!h, this.isControllingVariants = Tc(l), this.isVariantNode = d1(l), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(i && i.current);
    const { willChange: y, ...w } = this.scrapeMotionValuesFromProps(l, {}, this);
    for (const N in w) {
      const T = w[N];
      m[N] !== void 0 && vt(T) && T.set(m[N]);
    }
  }
  mount(i) {
    if (this.hasBeenMounted)
      for (const l in this.initialValues)
        this.values.get(l)?.jump(this.initialValues[l]), this.latestValues[l] = this.initialValues[l];
    this.current = i, oA.set(i, this), this.projection && !this.projection.instance && this.projection.mount(i), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((l, o) => this.bindToMotionValue(o, l)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (h1.current || dA(), this.shouldReduceMotion = Wh.current), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    this.projection && this.projection.unmount(), Ka(this.notifyUpdate), Ka(this.render), this.valueSubscriptions.forEach((i) => i()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const i in this.events)
      this.events[i].clear();
    for (const i in this.features) {
      const l = this.features[i];
      l && (l.unmount(), l.isMounted = !1);
    }
    this.current = null;
  }
  addChild(i) {
    this.children.add(i), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(i);
  }
  removeChild(i) {
    this.children.delete(i), this.enteringChildren && this.enteringChildren.delete(i);
  }
  bindToMotionValue(i, l) {
    if (this.valueSubscriptions.has(i) && this.valueSubscriptions.get(i)(), l.accelerate && Z0.has(i) && this.current instanceof HTMLElement) {
      const { factory: h, keyframes: p, times: g, ease: m, duration: b } = l.accelerate, y = new Y0({
        element: this.current,
        name: i,
        keyframes: p,
        times: g,
        ease: m,
        duration: /* @__PURE__ */ sn(b)
      }), w = h(y);
      this.valueSubscriptions.set(i, () => {
        w(), y.cancel();
      });
      return;
    }
    const o = Vs.has(i);
    o && this.onBindTransform && this.onBindTransform();
    const d = l.on("change", (h) => {
      this.latestValues[i] = h, this.props.onUpdate && Ge.preRender(this.notifyUpdate), o && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let f;
    typeof window < "u" && window.MotionCheckAppearSync && (f = window.MotionCheckAppearSync(this, i, l)), this.valueSubscriptions.set(i, () => {
      d(), f && f();
    });
  }
  sortNodePosition(i) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== i.type ? 0 : this.sortInstanceNodePosition(this.current, i.current);
  }
  updateFeatures() {
    let i = "animation";
    for (i in hc) {
      const l = hc[i];
      if (!l)
        continue;
      const { isEnabled: o, Feature: d } = l;
      if (!this.features[i] && d && o(this.props) && (this.features[i] = new d(this)), this.features[i]) {
        const f = this.features[i];
        f.isMounted ? f.update() : (f.mount(), f.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ct();
  }
  getStaticValue(i) {
    return this.latestValues[i];
  }
  setStaticValue(i, l) {
    this.latestValues[i] = l;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(i, l) {
    (i.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = i, this.prevPresenceContext = this.presenceContext, this.presenceContext = l;
    for (let o = 0; o < qy.length; o++) {
      const d = qy[o];
      this.propEventSubscriptions[d] && (this.propEventSubscriptions[d](), delete this.propEventSubscriptions[d]);
      const f = "on" + d, h = i[f];
      h && (this.propEventSubscriptions[d] = this.on(d, h));
    }
    this.prevMotionValues = cA(this, this.scrapeMotionValuesFromProps(i, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(i) {
    return this.props.variants ? this.props.variants[i] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(i) {
    const l = this.getClosestVariantNode();
    if (l)
      return l.variantChildren && l.variantChildren.add(i), () => l.variantChildren.delete(i);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(i, l) {
    const o = this.values.get(i);
    l !== o && (o && this.removeValue(i), this.bindToMotionValue(i, l), this.values.set(i, l), this.latestValues[i] = l.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(i) {
    this.values.delete(i);
    const l = this.valueSubscriptions.get(i);
    l && (l(), this.valueSubscriptions.delete(i)), delete this.latestValues[i], this.removeValueFromRenderState(i, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(i) {
    return this.values.has(i);
  }
  getValue(i, l) {
    if (this.props.values && this.props.values[i])
      return this.props.values[i];
    let o = this.values.get(i);
    return o === void 0 && l !== void 0 && (o = Ds(l === null ? void 0 : l, { owner: this }), this.addValue(i, o)), o;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(i, l) {
    let o = this.latestValues[i] !== void 0 || !this.current ? this.latestValues[i] : this.getBaseTargetFromProps(this.props, i) ?? this.readValueFromInstance(this.current, i, this.options);
    return o != null && (typeof o == "string" && (h0(o) || m0(o)) ? o = parseFloat(o) : !lA(o) && On.test(l) && (o = s1(i, l)), this.setBaseTarget(i, vt(o) ? o.get() : o)), vt(o) ? o.get() : o;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(i, l) {
    this.baseTarget[i] = l;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(i) {
    const { initial: l } = this.props;
    let o;
    if (typeof l == "string" || typeof l == "object") {
      const f = Hf(this.props, l, this.presenceContext?.custom);
      f && (o = f[i]);
    }
    if (l && o !== void 0)
      return o;
    const d = this.getBaseTargetFromProps(this.props, i);
    return d !== void 0 && !vt(d) ? d : this.initialValues[i] !== void 0 && o === void 0 ? void 0 : this.baseTarget[i];
  }
  on(i, l) {
    return this.events[i] || (this.events[i] = new Cf()), this.events[i].add(l);
  }
  notify(i, ...l) {
    this.events[i] && this.events[i].notify(...l);
  }
  scheduleRenderMicrotask() {
    Pf.render(this.render);
  }
}
class m1 extends fA {
  constructor() {
    super(...arguments), this.KeyframeResolver = L3;
  }
  sortInstanceNodePosition(i, l) {
    return i.compareDocumentPosition(l) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(i, l) {
    const o = i.style;
    return o ? o[l] : void 0;
  }
  removeValueFromRenderState(i, { vars: l, style: o }) {
    delete l[i], delete o[i];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: i } = this.props;
    vt(i) && (this.childSubscription = i.on("change", (l) => {
      this.current && (this.current.textContent = `${l}`);
    }));
  }
}
class Wa {
  constructor(i) {
    this.isMounted = !1, this.node = i;
  }
  update() {
  }
}
function p1({ top: n, left: i, right: l, bottom: o }) {
  return {
    x: { min: i, max: l },
    y: { min: n, max: o }
  };
}
function mA({ x: n, y: i }) {
  return { top: i.min, right: n.max, bottom: i.max, left: n.min };
}
function pA(n, i) {
  if (!i)
    return n;
  const l = i({ x: n.left, y: n.top }), o = i({ x: n.right, y: n.bottom });
  return {
    top: l.y,
    left: l.x,
    bottom: o.y,
    right: o.x
  };
}
function ah(n) {
  return n === void 0 || n === 1;
}
function Jh({ scale: n, scaleX: i, scaleY: l }) {
  return !ah(n) || !ah(i) || !ah(l);
}
function Ei(n) {
  return Jh(n) || g1(n) || n.z || n.rotate || n.rotateX || n.rotateY || n.skewX || n.skewY;
}
function g1(n) {
  return Gy(n.x) || Gy(n.y);
}
function Gy(n) {
  return n && n !== "0%";
}
function fc(n, i, l) {
  const o = n - l, d = i * o;
  return l + d;
}
function Yy(n, i, l, o, d) {
  return d !== void 0 && (n = fc(n, d, o)), fc(n, l, o) + i;
}
function ef(n, i = 0, l = 1, o, d) {
  n.min = Yy(n.min, i, l, o, d), n.max = Yy(n.max, i, l, o, d);
}
function x1(n, { x: i, y: l }) {
  ef(n.x, i.translate, i.scale, i.originPoint), ef(n.y, l.translate, l.scale, l.originPoint);
}
const Qy = 0.999999999999, Zy = 1.0000000000001;
function gA(n, i, l, o = !1) {
  const d = l.length;
  if (!d)
    return;
  i.x = i.y = 1;
  let f, h;
  for (let p = 0; p < d; p++) {
    f = l[p], h = f.projectionDelta;
    const { visualElement: g } = f.options;
    g && g.props.style && g.props.style.display === "contents" || (o && f.options.layoutScroll && f.scroll && f !== f.root && (Gn(n.x, -f.scroll.offset.x), Gn(n.y, -f.scroll.offset.y)), h && (i.x *= h.x.scale, i.y *= h.y.scale, x1(n, h)), o && Ei(f.latestValues) && Wo(n, f.latestValues, f.layout?.layoutBox));
  }
  i.x < Zy && i.x > Qy && (i.x = 1), i.y < Zy && i.y > Qy && (i.y = 1);
}
function Gn(n, i) {
  n.min += i, n.max += i;
}
function Xy(n, i, l, o, d = 0.5) {
  const f = qe(n.min, n.max, d);
  ef(n, i, l, f, o);
}
function Ky(n, i) {
  return typeof n == "string" ? parseFloat(n) / 100 * (i.max - i.min) : n;
}
function Wo(n, i, l) {
  const o = l ?? n;
  Xy(n.x, Ky(i.x, o.x), i.scaleX, i.scale, i.originX), Xy(n.y, Ky(i.y, o.y), i.scaleY, i.scale, i.originY);
}
function y1(n, i) {
  return p1(pA(n.getBoundingClientRect(), i));
}
function xA(n, i, l) {
  const o = y1(n, l), { scroll: d } = i;
  return d && (Gn(o.x, d.offset.x), Gn(o.y, d.offset.y)), o;
}
const yA = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, bA = Bs.length;
function vA(n, i, l) {
  let o = "", d = !0;
  for (let h = 0; h < bA; h++) {
    const p = Bs[h], g = n[p];
    if (g === void 0)
      continue;
    let m = !0;
    if (typeof g == "number")
      m = g === (p.startsWith("scale") ? 1 : 0);
    else {
      const b = parseFloat(g);
      m = p.startsWith("scale") ? b === 1 : b === 0;
    }
    if (!m || l) {
      const b = $h(g, dc[p]);
      if (!m) {
        d = !1;
        const y = yA[p] || p;
        o += `${y}(${b}) `;
      }
      l && (i[p] = b);
    }
  }
  const f = n.pathRotation;
  return f && (d = !1, o += `rotate(${$h(f, dc.pathRotation)}) `), o = o.trim(), l ? o = l(i, d ? "" : o) : d && (o = "none"), o;
}
function Qf(n, i, l) {
  const { style: o, vars: d, transformOrigin: f } = n;
  let h = !1, p = !1;
  for (const g in i) {
    const m = i[g];
    if (Vs.has(g)) {
      h = !0;
      continue;
    } else if (k0(g)) {
      d[g] = m;
      continue;
    } else {
      const b = $h(m, dc[g]);
      g.startsWith("origin") ? (p = !0, f[g] = b) : o[g] = b;
    }
  }
  if (i.transform || (h || l ? o.transform = vA(i, n.transform, l) : o.transform && (o.transform = "none")), p) {
    const { originX: g = "50%", originY: m = "50%", originZ: b = 0 } = f;
    o.transformOrigin = `${g} ${m} ${b}`;
  }
}
function b1(n, { style: i, vars: l }, o, d) {
  const f = n.style;
  let h;
  for (h in i)
    f[h] = i[h];
  d?.applyProjectionStyles(f, o);
  for (h in l)
    f.setProperty(h, l[h]);
}
function $y(n, i) {
  return i.max === i.min ? 0 : n / (i.max - i.min) * 100;
}
const Br = {
  correct: (n, i) => {
    if (!i.target)
      return n;
    if (typeof n == "string")
      if (ce.test(n))
        n = parseFloat(n);
      else
        return n;
    const l = $y(n, i.target.x), o = $y(n, i.target.y);
    return `${l}% ${o}%`;
  }
}, wA = {
  correct: (n, { treeScale: i, projectionDelta: l }) => {
    const o = n, d = On.parse(n);
    if (d.length > 5)
      return o;
    const f = On.createTransformer(n), h = typeof d[0] != "number" ? 1 : 0, p = l.x.scale * i.x, g = l.y.scale * i.y;
    d[0 + h] /= p, d[1 + h] /= g;
    const m = qe(p, g, 0.5);
    return typeof d[2 + h] == "number" && (d[2 + h] /= m), typeof d[3 + h] == "number" && (d[3 + h] /= m), f(d);
  }
}, tf = {
  borderRadius: {
    ...Br,
    applyTo: [...Lf]
  },
  borderTopLeftRadius: Br,
  borderTopRightRadius: Br,
  borderBottomLeftRadius: Br,
  borderBottomRightRadius: Br,
  boxShadow: wA
};
function v1(n, { layout: i, layoutId: l }) {
  return Vs.has(n) || n.startsWith("origin") || (i || l !== void 0) && (!!tf[n] || n === "opacity");
}
function Zf(n, i, l) {
  const o = n.style, d = i?.style, f = {};
  if (!o)
    return f;
  for (const h in o)
    (vt(o[h]) || d && vt(d[h]) || v1(h, n) || l?.getValue(h)?.liveStyle !== void 0) && (f[h] = o[h]);
  return f;
}
function jA(n) {
  return window.getComputedStyle(n);
}
class SA extends m1 {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = b1;
  }
  mount(i) {
    jc(!!i.style), super.mount(i);
  }
  readValueFromInstance(i, l) {
    if (Vs.has(l))
      return this.projection?.isProjecting ? Uh(l) : I5(i, l);
    {
      const o = jA(i), d = (k0(l) ? o.getPropertyValue(l) : o[l]) || 0;
      return typeof d == "string" ? d.trim() : d;
    }
  }
  measureInstanceViewportBox(i, { transformPagePoint: l }) {
    return y1(i, l);
  }
  build(i, l, o) {
    Qf(i, l, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(i, l, o) {
    return Zf(i, l, o);
  }
}
const NA = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, TA = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function AA(n, i, l = 1, o = 0, d = !0) {
  n.pathLength = 1;
  const f = d ? NA : TA;
  n[f.offset] = `${-o}`, n[f.array] = `${i} ${l}`;
}
const CA = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function w1(n, {
  attrX: i,
  attrY: l,
  attrScale: o,
  pathLength: d,
  pathSpacing: f = 1,
  pathOffset: h = 0,
  // This is object creation, which we try to avoid per-frame.
  ...p
}, g, m, b) {
  if (Qf(n, p, m), g) {
    n.style.viewBox && (n.attrs.viewBox = n.style.viewBox);
    return;
  }
  n.attrs = n.style, n.style = {};
  const { attrs: y, style: w } = n;
  y.transform && (w.transform = y.transform, delete y.transform), (w.transform || y.transformOrigin) && (w.transformOrigin = y.transformOrigin ?? "50% 50%", delete y.transformOrigin), w.transform && (w.transformBox = b?.transformBox ?? "fill-box", delete y.transformBox);
  for (const N of CA)
    y[N] !== void 0 && (w[N] = y[N], delete y[N]);
  i !== void 0 && (y.x = i), l !== void 0 && (y.y = l), o !== void 0 && (y.scale = o), d !== void 0 && AA(y, d, f, h, !1);
}
const j1 = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), S1 = (n) => typeof n == "string" && n.toLowerCase() === "svg";
function EA(n, i, l, o) {
  b1(n, i, void 0, o);
  for (const d in i.attrs)
    n.setAttribute(j1.has(d) ? d : Uf(d), i.attrs[d]);
}
function N1(n, i, l) {
  const o = Zf(n, i, l);
  for (const d in n)
    if (vt(n[d]) || vt(i[d])) {
      const f = Bs.indexOf(d) !== -1 ? "attr" + d.charAt(0).toUpperCase() + d.substring(1) : d;
      o[f] = n[d];
    }
  return o;
}
class kA extends m1 {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ct;
  }
  getBaseTargetFromProps(i, l) {
    return i[l];
  }
  readValueFromInstance(i, l) {
    if (Vs.has(l)) {
      const o = i1(l);
      return o && o.default || 0;
    }
    return l = j1.has(l) ? l : Uf(l), i.getAttribute(l);
  }
  scrapeMotionValuesFromProps(i, l, o) {
    return N1(i, l, o);
  }
  build(i, l, o) {
    w1(i, l, this.isSVGTag, o.transformTemplate, o.style);
  }
  renderInstance(i, l, o, d) {
    EA(i, l, o, d);
  }
  mount(i) {
    this.isSVGTag = S1(i.tagName), super.mount(i);
  }
}
const MA = Yf.length;
function T1(n) {
  if (!n)
    return;
  if (!n.isControllingVariants) {
    const l = n.parent ? T1(n.parent) || {} : {};
    return n.props.initial !== void 0 && (l.initial = n.props.initial), l;
  }
  const i = {};
  for (let l = 0; l < MA; l++) {
    const o = Yf[l], d = n.props[o];
    (sl(d) || d === !1) && (i[o] = d);
  }
  return i;
}
function A1(n, i) {
  if (!Array.isArray(i))
    return !1;
  const l = i.length;
  if (l !== n.length)
    return !1;
  for (let o = 0; o < l; o++)
    if (i[o] !== n[o])
      return !1;
  return !0;
}
const zA = [...Gf].reverse(), OA = Gf.length;
function RA(n) {
  return (i) => Promise.all(i.map(({ animation: l, options: o }) => M3(n, l, o)));
}
function _A(n) {
  let i = RA(n), l = Wy(), o = !0, d = !1;
  const f = (m) => (b, y) => {
    const w = Ri(n, y, m === "exit" ? n.presenceContext?.custom : void 0);
    if (w) {
      const { transition: N, transitionEnd: T, ...R } = w;
      b = { ...b, ...R, ...T };
    }
    return b;
  };
  function h(m) {
    i = m(n);
  }
  function p(m) {
    const { props: b } = n, y = T1(n.parent) || {}, w = [], N = /* @__PURE__ */ new Set();
    let T = {}, R = 1 / 0;
    for (let z = 0; z < OA; z++) {
      const q = zA[z], G = l[q], Q = b[q] !== void 0 ? b[q] : y[q], H = sl(Q), W = q === m ? G.isActive : null;
      W === !1 && (R = z);
      let $ = Q === y[q] && Q !== b[q] && H;
      if ($ && (o || d) && n.manuallyAnimateOnMount && ($ = !1), G.protectedKeys = { ...T }, // If it isn't active and hasn't *just* been set as inactive
      !G.isActive && W === null || // If we didn't and don't have any defined prop for this animation type
      !Q && !G.prevProp || // Or if the prop doesn't define an animation
      Nc(Q) || typeof Q == "boolean")
        continue;
      if (q === "exit" && G.isActive && W !== !0) {
        G.prevResolvedValues && (T = {
          ...T,
          ...G.prevResolvedValues
        });
        continue;
      }
      const k = DA(G.prevProp, Q);
      let ee = k || // If we're making this variant active, we want to always make it active
      q === m && G.isActive && !$ && H || // If we removed a higher-priority variant (i is in reverse order)
      z > R && H, ae = !1;
      const me = Array.isArray(Q) ? Q : [Q];
      let xe = me.reduce(f(q), {});
      W === !1 && (xe = {});
      const { prevResolvedValues: _e = {} } = G, Be = {
        ..._e,
        ...xe
      }, ze = (ne) => {
        ee = !0, N.has(ne) && (ae = !0, N.delete(ne)), G.needsAnimating[ne] = !0;
        const he = n.getValue(ne);
        he && (he.liveStyle = !1);
      };
      for (const ne in Be) {
        const he = xe[ne], K = _e[ne];
        if (T.hasOwnProperty(ne))
          continue;
        let S = !1;
        Yh(he) && Yh(K) ? S = !A1(he, K) || k : S = he !== K, S ? he != null ? ze(ne) : N.add(ne) : he !== void 0 && N.has(ne) ? ze(ne) : G.protectedKeys[ne] = !0;
      }
      G.prevProp = Q, G.prevResolvedValues = xe, G.isActive && (T = { ...T, ...xe }), (o || d) && n.blockInitialAnimation && (ee = !1);
      const O = $ && k;
      ee && (!O || ae) && w.push(...me.map((ne) => {
        const he = { type: q };
        if (typeof ne == "string" && (o || d) && !O && n.manuallyAnimateOnMount && n.parent) {
          const { parent: K } = n, S = Ri(K, ne);
          if (K.enteringChildren && S) {
            const { delayChildren: L } = S.transition || {};
            he.delay = X0(K.enteringChildren, n, L);
          }
        }
        return {
          animation: ne,
          options: he
        };
      }));
    }
    if (N.size) {
      const z = {};
      if (typeof b.initial != "boolean") {
        const q = Ri(n, Array.isArray(b.initial) ? b.initial[0] : b.initial);
        q && q.transition && (z.transition = q.transition);
      }
      N.forEach((q) => {
        const G = n.getBaseTarget(q), Q = n.getValue(q);
        Q && (Q.liveStyle = !0), z[q] = G ?? null;
      }), w.push({ animation: z });
    }
    let _ = !!w.length;
    return o && (b.initial === !1 || b.initial === b.animate) && !n.manuallyAnimateOnMount && (_ = !1), o = !1, d = !1, _ ? i(w) : Promise.resolve();
  }
  function g(m, b) {
    if (l[m].isActive === b)
      return Promise.resolve();
    n.variantChildren?.forEach((w) => w.animationState?.setActive(m, b)), l[m].isActive = b;
    const y = p(m);
    for (const w in l)
      l[w].protectedKeys = {};
    return y;
  }
  return {
    animateChanges: p,
    setActive: g,
    setAnimateFunction: h,
    getState: () => l,
    reset: () => {
      l = Wy(), d = !0;
    }
  };
}
function DA(n, i) {
  return typeof i == "string" ? i !== n : Array.isArray(i) ? !A1(i, n) : !1;
}
function Si(n = !1) {
  return {
    isActive: n,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Wy() {
  return {
    animate: Si(!0),
    whileInView: Si(),
    whileHover: Si(),
    whileTap: Si(),
    whileDrag: Si(),
    whileFocus: Si(),
    exit: Si()
  };
}
function nf(n, i) {
  n.min = i.min, n.max = i.max;
}
function kn(n, i) {
  nf(n.x, i.x), nf(n.y, i.y);
}
function Jy(n, i) {
  n.translate = i.translate, n.scale = i.scale, n.originPoint = i.originPoint, n.origin = i.origin;
}
const C1 = 1e-4, FA = 1 - C1, BA = 1 + C1, E1 = 0.01, VA = 0 - E1, HA = 0 + E1;
function Rt(n) {
  return n.max - n.min;
}
function UA(n, i, l) {
  return Math.abs(n - i) <= l;
}
function eb(n, i, l, o = 0.5) {
  n.origin = o, n.originPoint = qe(i.min, i.max, n.origin), n.scale = Rt(l) / Rt(i), n.translate = qe(l.min, l.max, n.origin) - n.originPoint, (n.scale >= FA && n.scale <= BA || isNaN(n.scale)) && (n.scale = 1), (n.translate >= VA && n.translate <= HA || isNaN(n.translate)) && (n.translate = 0);
}
function Xr(n, i, l, o) {
  eb(n.x, i.x, l.x, o ? o.originX : void 0), eb(n.y, i.y, l.y, o ? o.originY : void 0);
}
function tb(n, i, l, o = 0) {
  const d = o ? qe(l.min, l.max, o) : l.min;
  n.min = d + i.min, n.max = n.min + Rt(i);
}
function LA(n, i, l, o) {
  tb(n.x, i.x, l.x, o?.x), tb(n.y, i.y, l.y, o?.y);
}
function nb(n, i, l, o = 0) {
  const d = o ? qe(l.min, l.max, o) : l.min;
  n.min = i.min - d, n.max = n.min + Rt(i);
}
function mc(n, i, l, o) {
  nb(n.x, i.x, l.x, o?.x), nb(n.y, i.y, l.y, o?.y);
}
function ab(n, i, l, o, d) {
  return n -= i, n = fc(n, 1 / l, o), d !== void 0 && (n = fc(n, 1 / d, o)), n;
}
function PA(n, i = 0, l = 1, o = 0.5, d, f = n, h = n) {
  if (Yn.test(i) && (i = parseFloat(i), i = qe(h.min, h.max, i / 100) - h.min), typeof i != "number")
    return;
  let p = qe(f.min, f.max, o);
  n === f && (p -= i), n.min = ab(n.min, i, l, p, d), n.max = ab(n.max, i, l, p, d);
}
function ib(n, i, [l, o, d], f, h) {
  PA(n, i[l], i[o], i[d], i.scale, f, h);
}
const IA = ["x", "scaleX", "originX"], qA = ["y", "scaleY", "originY"];
function sb(n, i, l, o) {
  ib(n.x, i, IA, l ? l.x : void 0, o ? o.x : void 0), ib(n.y, i, qA, l ? l.y : void 0, o ? o.y : void 0);
}
function rb(n) {
  return n.translate === 0 && n.scale === 1;
}
function k1(n) {
  return rb(n.x) && rb(n.y);
}
function lb(n, i) {
  return n.min === i.min && n.max === i.max;
}
function GA(n, i) {
  return lb(n.x, i.x) && lb(n.y, i.y);
}
function ob(n, i) {
  return Math.round(n.min) === Math.round(i.min) && Math.round(n.max) === Math.round(i.max);
}
function M1(n, i) {
  return ob(n.x, i.x) && ob(n.y, i.y);
}
function cb(n) {
  return Rt(n.x) / Rt(n.y);
}
function ub(n, i) {
  return n.translate === i.translate && n.scale === i.scale && n.originPoint === i.originPoint;
}
function qn(n) {
  return [n("x"), n("y")];
}
function YA(n, i, l) {
  let o = "";
  const d = n.x.translate / i.x, f = n.y.translate / i.y, h = l?.z || 0;
  if ((d || f || h) && (o = `translate3d(${d}px, ${f}px, ${h}px) `), (i.x !== 1 || i.y !== 1) && (o += `scale(${1 / i.x}, ${1 / i.y}) `), l) {
    const { transformPerspective: m, rotate: b, pathRotation: y, rotateX: w, rotateY: N, skewX: T, skewY: R } = l;
    m && (o = `perspective(${m}px) ${o}`), b && (o += `rotate(${b}deg) `), y && (o += `rotate(${y}deg) `), w && (o += `rotateX(${w}deg) `), N && (o += `rotateY(${N}deg) `), T && (o += `skewX(${T}deg) `), R && (o += `skewY(${R}deg) `);
  }
  const p = n.x.scale * i.x, g = n.y.scale * i.y;
  return (p !== 1 || g !== 1) && (o += `scale(${p}, ${g})`), o || "none";
}
const QA = Lf.length, db = (n) => typeof n == "string" ? parseFloat(n) : n, hb = (n) => typeof n == "number" || ce.test(n);
function ZA(n, i, l, o, d, f) {
  d ? (n.opacity = qe(0, l.opacity ?? 1, XA(o)), n.opacityExit = qe(i.opacity ?? 1, 0, KA(o))) : f && (n.opacity = qe(i.opacity ?? 1, l.opacity ?? 1, o));
  for (let h = 0; h < QA; h++) {
    const p = Lf[h];
    let g = fb(i, p), m = fb(l, p);
    if (g === void 0 && m === void 0)
      continue;
    g || (g = 0), m || (m = 0), g === 0 || m === 0 || hb(g) === hb(m) ? (n[p] = Math.max(qe(db(g), db(m), o), 0), (Yn.test(m) || Yn.test(g)) && (n[p] += "%")) : n[p] = m;
  }
  (i.rotate || l.rotate) && (n.rotate = qe(i.rotate || 0, l.rotate || 0, o));
}
function fb(n, i) {
  return n[i] !== void 0 ? n[i] : n.borderRadius;
}
const XA = /* @__PURE__ */ z1(0, 0.5, S0), KA = /* @__PURE__ */ z1(0.5, 0.95, Sn);
function z1(n, i, l) {
  return (o) => o < n ? 0 : o > i ? 1 : l(/* @__PURE__ */ al(n, i, o));
}
function $A(n, i, l) {
  const o = vt(n) ? n : Ds(n);
  return o.start(Vf("", o, i, l)), o.animation;
}
function rl(n, i, l, o = { passive: !0 }) {
  return n.addEventListener(i, l, o), () => n.removeEventListener(i, l, o);
}
const WA = (n, i) => n.depth - i.depth;
class JA {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(i) {
    Af(this.children, i), this.isDirty = !0;
  }
  remove(i) {
    rc(this.children, i), this.isDirty = !0;
  }
  forEach(i) {
    this.isDirty && this.children.sort(WA), this.isDirty = !1, this.children.forEach(i);
  }
}
function e4(n, i) {
  const l = Ot.now(), o = ({ timestamp: d }) => {
    const f = d - l;
    f >= i && (Ka(o), n(f - i));
  };
  return Ge.setup(o, !0), () => Ka(o);
}
function Jo(n) {
  return vt(n) ? n.get() : n;
}
class t4 {
  constructor() {
    this.members = [];
  }
  add(i) {
    Af(this.members, i);
    for (let l = this.members.length - 1; l >= 0; l--) {
      const o = this.members[l];
      if (o === i || o === this.lead || o === this.prevLead)
        continue;
      const d = o.instance;
      (!d || d.isConnected === !1) && !o.snapshot && (rc(this.members, o), o.unmount());
    }
    i.scheduleRender();
  }
  remove(i) {
    if (rc(this.members, i), i === this.prevLead && (this.prevLead = void 0), i === this.lead) {
      const l = this.members[this.members.length - 1];
      l && this.promote(l);
    }
  }
  relegate(i) {
    for (let l = this.members.indexOf(i) - 1; l >= 0; l--) {
      const o = this.members[l];
      if (o.isPresent !== !1 && o.instance?.isConnected !== !1)
        return this.promote(o), !0;
    }
    return !1;
  }
  promote(i, l) {
    const o = this.lead;
    if (i !== o && (this.prevLead = o, this.lead = i, i.show(), o)) {
      o.updateSnapshot(), i.scheduleRender();
      const { layoutDependency: d } = o.options, { layoutDependency: f } = i.options;
      (d === void 0 || d !== f) && (i.resumeFrom = o, l && (o.preserveOpacity = !0), o.snapshot && (i.snapshot = o.snapshot, i.snapshot.latestValues = o.animationValues || o.latestValues), i.root?.isUpdating && (i.isLayoutDirty = !0)), i.options.crossfade === !1 && o.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((i) => {
      i.options.onExitComplete?.(), i.resumingFrom?.options.onExitComplete?.();
    });
  }
  scheduleRender() {
    this.members.forEach((i) => i.instance && i.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    this.lead?.snapshot && (this.lead.snapshot = void 0);
  }
}
const ec = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, ih = ["", "X", "Y", "Z"], n4 = 1e3;
let a4 = 0;
function sh(n, i, l, o) {
  const { latestValues: d } = i;
  d[n] && (l[n] = d[n], i.setStaticValue(n, 0), o && (o[n] = 0));
}
function O1(n) {
  if (n.hasCheckedOptimisedAppear = !0, n.root === n)
    return;
  const { visualElement: i } = n.options;
  if (!i)
    return;
  const l = e1(i);
  if (window.MotionHasOptimisedAnimation(l, "transform")) {
    const { layout: d, layoutId: f } = n.options;
    window.MotionCancelOptimisedAnimation(l, "transform", Ge, !(d || f));
  }
  const { parent: o } = n;
  o && !o.hasCheckedOptimisedAppear && O1(o);
}
function R1({ attachResizeListener: n, defaultParent: i, measureScroll: l, checkIsScrollRoot: o, resetTransform: d }) {
  return class {
    constructor(h = {}, p = i?.()) {
      this.id = a4++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(r4), this.nodes.forEach(h4), this.nodes.forEach(f4), this.nodes.forEach(l4);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = h, this.root = p ? p.root || p : this, this.path = p ? [...p.path, p] : [], this.parent = p, this.depth = p ? p.depth + 1 : 0;
      for (let g = 0; g < this.path.length; g++)
        this.path[g].shouldResetTransform = !0;
      this.root === this && (this.nodes = new JA());
    }
    addEventListener(h, p) {
      return this.eventHandlers.has(h) || this.eventHandlers.set(h, new Cf()), this.eventHandlers.get(h).add(p);
    }
    notifyListeners(h, ...p) {
      const g = this.eventHandlers.get(h);
      g && g.notify(...p);
    }
    hasListeners(h) {
      return this.eventHandlers.has(h);
    }
    /**
     * Lifecycles
     */
    mount(h) {
      if (this.instance)
        return;
      this.isSVG = qf(h) && !sA(h), this.instance = h;
      const { layoutId: p, layout: g, visualElement: m } = this.options;
      if (m && !m.current && m.mount(h), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (g || p) && (this.isLayoutDirty = !0), n) {
        let b, y = 0;
        const w = () => this.root.updateBlockedByResize = !1;
        Ge.read(() => {
          y = window.innerWidth;
        }), n(h, () => {
          const N = window.innerWidth;
          N !== y && (y = N, this.root.updateBlockedByResize = !0, b && b(), b = e4(w, 250), ec.hasAnimatedSinceResize && (ec.hasAnimatedSinceResize = !1, this.nodes.forEach(gb)));
        });
      }
      p && this.root.registerSharedNode(p, this), this.options.animate !== !1 && m && (p || g) && this.addEventListener("didUpdate", ({ delta: b, hasLayoutChanged: y, hasRelativeLayoutChanged: w, layout: N }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const T = this.options.transition || m.getDefaultTransition() || y4, { onLayoutAnimationStart: R, onLayoutAnimationComplete: _ } = m.getProps(), z = !this.targetLayout || !M1(this.targetLayout, N), q = !y && w;
        if (this.options.layoutRoot || this.resumeFrom || q || y && (z || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const G = {
            ...Bf(T, "layout"),
            onPlay: R,
            onComplete: _
          };
          (m.shouldReduceMotion || this.options.layoutRoot) && (G.delay = 0, G.type = !1), this.startAnimation(G), this.setAnimationOrigin(b, q, G.path);
        } else
          y || gb(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = N;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const h = this.getStack();
      h && h.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Ka(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(m4), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: h } = this.options;
      return h && h.getProps().transformTemplate;
    }
    willUpdate(h = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && O1(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let b = 0; b < this.path.length; b++) {
        const y = this.path[b];
        y.shouldResetTransform = !0, (typeof y.latestValues.x == "string" || typeof y.latestValues.y == "string") && (y.isLayoutDirty = !0), y.updateScroll("snapshot"), y.options.layoutRoot && y.willUpdate(!1);
      }
      const { layoutId: p, layout: g } = this.options;
      if (p === void 0 && !g)
        return;
      const m = this.getTransformTemplate();
      this.prevTransformTemplateValue = m ? m(this.latestValues, "") : void 0, this.updateSnapshot(), h && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const g = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), g && this.nodes.forEach(c4), this.nodes.forEach(mb);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(pb);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(u4), this.nodes.forEach(d4), this.nodes.forEach(i4), this.nodes.forEach(s4)) : this.nodes.forEach(pb), this.clearAllSnapshots();
      const p = Ot.now();
      bt.delta = Qn(0, 1e3 / 60, p - bt.timestamp), bt.timestamp = p, bt.isProcessing = !0, Kd.update.process(bt), Kd.preRender.process(bt), Kd.render.process(bt), bt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Pf.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(o4), this.sharedNodes.forEach(p4);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Ge.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Ge.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Rt(this.snapshot.measuredBox.x) && !Rt(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let g = 0; g < this.path.length; g++)
          this.path[g].updateScroll();
      const h = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = ct()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: p } = this.options;
      p && p.notify("LayoutMeasure", this.layout.layoutBox, h ? h.layoutBox : void 0);
    }
    updateScroll(h = "measure") {
      let p = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === h && (p = !1), p && this.instance) {
        const g = o(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: h,
          isRoot: g,
          offset: l(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : g
        };
      }
    }
    resetTransform() {
      if (!d)
        return;
      const h = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, p = this.projectionDelta && !k1(this.projectionDelta), g = this.getTransformTemplate(), m = g ? g(this.latestValues, "") : void 0, b = m !== this.prevTransformTemplateValue;
      h && this.instance && (p || Ei(this.latestValues) || b) && (d(this.instance, m), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(h = !0) {
      const p = this.measurePageBox();
      let g = this.removeElementScroll(p);
      return h && (g = this.removeTransform(g)), b4(g), {
        animationId: this.root.animationId,
        measuredBox: p,
        layoutBox: g,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: h } = this.options;
      if (!h)
        return ct();
      const p = h.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(v4))) {
        const { scroll: m } = this.root;
        m && (Gn(p.x, m.offset.x), Gn(p.y, m.offset.y));
      }
      return p;
    }
    removeElementScroll(h) {
      const p = ct();
      if (kn(p, h), this.scroll?.wasRoot)
        return p;
      for (let g = 0; g < this.path.length; g++) {
        const m = this.path[g], { scroll: b, options: y } = m;
        m !== this.root && b && y.layoutScroll && (b.wasRoot && kn(p, h), Gn(p.x, b.offset.x), Gn(p.y, b.offset.y));
      }
      return p;
    }
    applyTransform(h, p = !1, g) {
      const m = g || ct();
      kn(m, h);
      for (let b = 0; b < this.path.length; b++) {
        const y = this.path[b];
        !p && y.options.layoutScroll && y.scroll && y !== y.root && (Gn(m.x, -y.scroll.offset.x), Gn(m.y, -y.scroll.offset.y)), Ei(y.latestValues) && Wo(m, y.latestValues, y.layout?.layoutBox);
      }
      return Ei(this.latestValues) && Wo(m, this.latestValues, this.layout?.layoutBox), m;
    }
    removeTransform(h) {
      const p = ct();
      kn(p, h);
      for (let g = 0; g < this.path.length; g++) {
        const m = this.path[g];
        if (!Ei(m.latestValues))
          continue;
        let b;
        m.instance && (Jh(m.latestValues) && m.updateSnapshot(), b = ct(), kn(b, m.measurePageBox())), sb(p, m.latestValues, m.snapshot?.layoutBox, b);
      }
      return Ei(this.latestValues) && sb(p, this.latestValues), p;
    }
    setTargetDelta(h) {
      this.targetDelta = h, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(h) {
      this.options = {
        ...this.options,
        ...h,
        crossfade: h.crossfade !== void 0 ? h.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== bt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(h = !1) {
      const p = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = p.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = p.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = p.isSharedProjectionDirty);
      const g = !!this.resumingFrom || this !== p;
      if (!(h || g && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: b, layoutId: y } = this.options;
      if (!this.layout || !(b || y))
        return;
      this.resolvedRelativeTargetAt = bt.timestamp;
      const w = this.getClosestProjectingParent();
      w && this.linkedParentVersion !== w.layoutVersion && !w.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && w && w.layout ? this.createRelativeTarget(w, this.layout.layoutBox, w.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ct(), this.targetWithTransforms = ct()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), LA(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : kn(this.target, this.layout.layoutBox), x1(this.target, this.targetDelta)) : kn(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && w && !!w.resumingFrom == !!this.resumingFrom && !w.options.layoutScroll && w.target && this.animationProgress !== 1 ? this.createRelativeTarget(w, this.target, w.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Jh(this.parent.latestValues) || g1(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(h, p, g) {
      this.relativeParent = h, this.linkedParentVersion = h.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ct(), this.relativeTargetOrigin = ct(), mc(this.relativeTargetOrigin, p, g, this.options.layoutAnchor || void 0), kn(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const h = this.getLead(), p = !!this.resumingFrom || this !== h;
      let g = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (g = !1), p && (this.isSharedProjectionDirty || this.isTransformDirty) && (g = !1), this.resolvedRelativeTargetAt === bt.timestamp && (g = !1), g)
        return;
      const { layout: m, layoutId: b } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(m || b))
        return;
      kn(this.layoutCorrected, this.layout.layoutBox);
      const y = this.treeScale.x, w = this.treeScale.y;
      gA(this.layoutCorrected, this.treeScale, this.path, p), h.layout && !h.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (h.target = h.layout.layoutBox, h.targetWithTransforms = ct());
      const { target: N } = h;
      if (!N) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Jy(this.prevProjectionDelta.x, this.projectionDelta.x), Jy(this.prevProjectionDelta.y, this.projectionDelta.y)), Xr(this.projectionDelta, this.layoutCorrected, N, this.latestValues), (this.treeScale.x !== y || this.treeScale.y !== w || !ub(this.projectionDelta.x, this.prevProjectionDelta.x) || !ub(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", N));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(h = !0) {
      if (this.options.visualElement?.scheduleRender(), h) {
        const p = this.getStack();
        p && p.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Ms(), this.projectionDelta = Ms(), this.projectionDeltaWithTransform = Ms();
    }
    setAnimationOrigin(h, p = !1, g) {
      const m = this.snapshot, b = m ? m.latestValues : {}, y = { ...this.latestValues }, w = Ms();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !p;
      const N = ct(), T = m ? m.source : void 0, R = this.layout ? this.layout.source : void 0, _ = T !== R, z = this.getStack(), q = !z || z.members.length <= 1, G = !!(_ && !q && this.options.crossfade === !0 && !this.path.some(x4));
      this.animationProgress = 0;
      let Q;
      const H = g?.interpolateProjection(h);
      this.mixTargetDelta = (W) => {
        const $ = W / 1e3, k = H?.($);
        k ? (w.x.translate = k.x, w.x.scale = qe(h.x.scale, 1, $), w.x.origin = h.x.origin, w.x.originPoint = h.x.originPoint, w.y.translate = k.y, w.y.scale = qe(h.y.scale, 1, $), w.y.origin = h.y.origin, w.y.originPoint = h.y.originPoint) : (xb(w.x, h.x, $), xb(w.y, h.y, $)), this.setTargetDelta(w), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (mc(N, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), g4(this.relativeTarget, this.relativeTargetOrigin, N, $), Q && GA(this.relativeTarget, Q) && (this.isProjectionDirty = !1), Q || (Q = ct()), kn(Q, this.relativeTarget)), _ && (this.animationValues = y, ZA(y, b, this.latestValues, $, G, q)), k && k.rotate !== void 0 && (this.animationValues || (this.animationValues = y), this.animationValues.pathRotation = k.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = $;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(h) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (Ka(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Ge.update(() => {
        ec.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Ds(0)), this.motionValue.jump(0, !1), this.currentAnimation = $A(this.motionValue, [0, 1e3], {
          ...h,
          velocity: 0,
          isSync: !0,
          onUpdate: (p) => {
            this.mixTargetDelta(p), h.onUpdate && h.onUpdate(p);
          },
          onComplete: () => {
            h.onComplete && h.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const h = this.getStack();
      h && h.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(n4), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const h = this.getLead();
      let { targetWithTransforms: p, target: g, layout: m, latestValues: b } = h;
      if (!(!p || !g || !m)) {
        if (this !== h && this.layout && m && _1(this.options.animationType, this.layout.layoutBox, m.layoutBox)) {
          g = this.target || ct();
          const y = Rt(this.layout.layoutBox.x);
          g.x.min = h.target.x.min, g.x.max = g.x.min + y;
          const w = Rt(this.layout.layoutBox.y);
          g.y.min = h.target.y.min, g.y.max = g.y.min + w;
        }
        kn(p, g), Wo(p, b), Xr(this.projectionDeltaWithTransform, this.layoutCorrected, p, b);
      }
    }
    registerSharedNode(h, p) {
      this.sharedNodes.has(h) || this.sharedNodes.set(h, new t4()), this.sharedNodes.get(h).add(p);
      const m = p.options.initialPromotionConfig;
      p.promote({
        transition: m ? m.transition : void 0,
        preserveFollowOpacity: m && m.shouldPreserveFollowOpacity ? m.shouldPreserveFollowOpacity(p) : void 0
      });
    }
    isLead() {
      const h = this.getStack();
      return h ? h.lead === this : !0;
    }
    getLead() {
      const { layoutId: h } = this.options;
      return h ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: h } = this.options;
      return h ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: h } = this.options;
      if (h)
        return this.root.sharedNodes.get(h);
    }
    promote({ needsReset: h, transition: p, preserveFollowOpacity: g } = {}) {
      const m = this.getStack();
      m && m.promote(this, g), h && (this.projectionDelta = void 0, this.needsReset = !0), p && this.setOptions({ transition: p });
    }
    relegate() {
      const h = this.getStack();
      return h ? h.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: h } = this.options;
      if (!h)
        return;
      let p = !1;
      const { latestValues: g } = h;
      if ((g.z || g.rotate || g.rotateX || g.rotateY || g.rotateZ || g.skewX || g.skewY) && (p = !0), !p)
        return;
      const m = {};
      g.z && sh("z", h, m, this.animationValues);
      for (let b = 0; b < ih.length; b++)
        sh(`rotate${ih[b]}`, h, m, this.animationValues), sh(`skew${ih[b]}`, h, m, this.animationValues);
      h.render();
      for (const b in m)
        h.setStaticValue(b, m[b]), this.animationValues && (this.animationValues[b] = m[b]);
      h.scheduleRender();
    }
    applyProjectionStyles(h, p) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        h.visibility = "hidden";
        return;
      }
      const g = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, h.visibility = "", h.opacity = "", h.pointerEvents = Jo(p?.pointerEvents) || "", h.transform = g ? g(this.latestValues, "") : "none";
        return;
      }
      const m = this.getLead();
      if (!this.projectionDelta || !this.layout || !m.target) {
        this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = Jo(p?.pointerEvents) || ""), this.hasProjected && !Ei(this.latestValues) && (h.transform = g ? g({}, "") : "none", this.hasProjected = !1);
        return;
      }
      h.visibility = "";
      const b = m.animationValues || m.latestValues;
      this.applyTransformsToTarget();
      let y = YA(this.projectionDeltaWithTransform, this.treeScale, b);
      g && (y = g(b, y)), h.transform = y;
      const { x: w, y: N } = this.projectionDelta;
      h.transformOrigin = `${w.origin * 100}% ${N.origin * 100}% 0`, m.animationValues ? h.opacity = m === this ? b.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : b.opacityExit : h.opacity = m === this ? b.opacity !== void 0 ? b.opacity : "" : b.opacityExit !== void 0 ? b.opacityExit : 0;
      for (const T in tf) {
        if (b[T] === void 0)
          continue;
        const { correct: R, applyTo: _, isCSSVariable: z } = tf[T], q = y === "none" ? b[T] : R(b[T], m);
        if (_) {
          const G = _.length;
          for (let Q = 0; Q < G; Q++)
            h[_[Q]] = q;
        } else
          z ? this.options.visualElement.renderState.vars[T] = q : h[T] = q;
      }
      this.options.layoutId && (h.pointerEvents = m === this ? Jo(p?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((h) => h.currentAnimation?.stop()), this.root.nodes.forEach(mb), this.root.sharedNodes.clear();
    }
  };
}
function i4(n) {
  n.updateLayout();
}
function s4(n) {
  const i = n.resumeFrom?.snapshot || n.snapshot;
  if (n.isLead() && n.layout && i && n.hasListeners("didUpdate")) {
    const { layoutBox: l, measuredBox: o } = n.layout, { animationType: d } = n.options, f = i.source !== n.layout.source;
    if (d === "size")
      qn((b) => {
        const y = f ? i.measuredBox[b] : i.layoutBox[b], w = Rt(y);
        y.min = l[b].min, y.max = y.min + w;
      });
    else if (d === "x" || d === "y") {
      const b = d === "x" ? "y" : "x";
      nf(f ? i.measuredBox[b] : i.layoutBox[b], l[b]);
    } else _1(d, i.layoutBox, l) && qn((b) => {
      const y = f ? i.measuredBox[b] : i.layoutBox[b], w = Rt(l[b]);
      y.max = y.min + w, n.relativeTarget && !n.currentAnimation && (n.isProjectionDirty = !0, n.relativeTarget[b].max = n.relativeTarget[b].min + w);
    });
    const h = Ms();
    Xr(h, l, i.layoutBox);
    const p = Ms();
    f ? Xr(p, n.applyTransform(o, !0), i.measuredBox) : Xr(p, l, i.layoutBox);
    const g = !k1(h);
    let m = !1;
    if (!n.resumeFrom) {
      const b = n.getClosestProjectingParent();
      if (b && !b.resumeFrom) {
        const { snapshot: y, layout: w } = b;
        if (y && w) {
          const N = n.options.layoutAnchor || void 0, T = ct();
          mc(T, i.layoutBox, y.layoutBox, N);
          const R = ct();
          mc(R, l, w.layoutBox, N), M1(T, R) || (m = !0), b.options.layoutRoot && (n.relativeTarget = R, n.relativeTargetOrigin = T, n.relativeParent = b);
        }
      }
    }
    n.notifyListeners("didUpdate", {
      layout: l,
      snapshot: i,
      delta: p,
      layoutDelta: h,
      hasLayoutChanged: g,
      hasRelativeLayoutChanged: m
    });
  } else if (n.isLead()) {
    const { onExitComplete: l } = n.options;
    l && l();
  }
  n.options.transition = void 0;
}
function r4(n) {
  n.parent && (n.isProjecting() || (n.isProjectionDirty = n.parent.isProjectionDirty), n.isSharedProjectionDirty || (n.isSharedProjectionDirty = !!(n.isProjectionDirty || n.parent.isProjectionDirty || n.parent.isSharedProjectionDirty)), n.isTransformDirty || (n.isTransformDirty = n.parent.isTransformDirty));
}
function l4(n) {
  n.isProjectionDirty = n.isSharedProjectionDirty = n.isTransformDirty = !1;
}
function o4(n) {
  n.clearSnapshot();
}
function mb(n) {
  n.clearMeasurements();
}
function c4(n) {
  n.isLayoutDirty = !0, n.updateLayout();
}
function pb(n) {
  n.isLayoutDirty = !1;
}
function u4(n) {
  n.isAnimationBlocked && n.layout && !n.isLayoutDirty && (n.snapshot = n.layout, n.isLayoutDirty = !0);
}
function d4(n) {
  const { visualElement: i } = n.options;
  i && i.getProps().onBeforeLayoutMeasure && i.notify("BeforeLayoutMeasure"), n.resetTransform();
}
function gb(n) {
  n.finishAnimation(), n.targetDelta = n.relativeTarget = n.target = void 0, n.isProjectionDirty = !0;
}
function h4(n) {
  n.resolveTargetDelta();
}
function f4(n) {
  n.calcProjection();
}
function m4(n) {
  n.resetSkewAndRotation();
}
function p4(n) {
  n.removeLeadSnapshot();
}
function xb(n, i, l) {
  n.translate = qe(i.translate, 0, l), n.scale = qe(i.scale, 1, l), n.origin = i.origin, n.originPoint = i.originPoint;
}
function yb(n, i, l, o) {
  n.min = qe(i.min, l.min, o), n.max = qe(i.max, l.max, o);
}
function g4(n, i, l, o) {
  yb(n.x, i.x, l.x, o), yb(n.y, i.y, l.y, o);
}
function x4(n) {
  return n.animationValues && n.animationValues.opacityExit !== void 0;
}
const y4 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, bb = (n) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(n), vb = bb("applewebkit/") && !bb("chrome/") ? Math.round : Sn;
function wb(n) {
  n.min = vb(n.min), n.max = vb(n.max);
}
function b4(n) {
  wb(n.x), wb(n.y);
}
function _1(n, i, l) {
  return n === "position" || n === "preserve-aspect" && !UA(cb(i), cb(l), 0.2);
}
function v4(n) {
  return n !== n.root && n.scroll?.wasRoot;
}
const w4 = R1({
  attachResizeListener: (n, i) => rl(n, "resize", i),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
    y: document.documentElement.scrollTop || document.body?.scrollTop || 0
  }),
  checkIsScrollRoot: () => !0
}), rh = {
  current: void 0
}, D1 = R1({
  measureScroll: (n) => ({
    x: n.scrollLeft,
    y: n.scrollTop
  }),
  defaultParent: () => {
    if (!rh.current) {
      const n = new w4({});
      n.mount(window), n.setOptions({ layoutScroll: !0 }), rh.current = n;
    }
    return rh.current;
  },
  resetTransform: (n, i) => {
    n.style.transform = i !== void 0 ? i : "none";
  },
  checkIsScrollRoot: (n) => window.getComputedStyle(n).position === "fixed"
}), Xf = E.createContext({
  transformPagePoint: (n) => n,
  isStatic: !1,
  reducedMotion: "never"
});
function jb(n, i) {
  if (typeof n == "function")
    return n(i);
  n != null && (n.current = i);
}
function j4(...n) {
  return (i) => {
    let l = !1;
    const o = n.map((d) => {
      const f = jb(d, i);
      return !l && typeof f == "function" && (l = !0), f;
    });
    if (l)
      return () => {
        for (let d = 0; d < o.length; d++) {
          const f = o[d];
          typeof f == "function" ? f() : jb(n[d], null);
        }
      };
  };
}
function S4(...n) {
  return E.useCallback(j4(...n), n);
}
class N4 extends E.Component {
  getSnapshotBeforeUpdate(i) {
    const l = this.props.childRef.current;
    if (Qo(l) && i.isPresent && !this.props.isPresent && this.props.pop !== !1) {
      const o = l.offsetParent, d = Qo(o) && o.offsetWidth || 0, f = Qo(o) && o.offsetHeight || 0, h = getComputedStyle(l), p = this.props.sizeRef.current;
      p.height = parseFloat(h.height), p.width = parseFloat(h.width), p.top = l.offsetTop, p.left = l.offsetLeft, p.right = d - p.width - p.left, p.bottom = f - p.height - p.top, p.direction = h.direction;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function T4({ children: n, isPresent: i, anchorX: l, anchorY: o, root: d, pop: f }) {
  const h = E.useId(), p = E.useRef(null), g = E.useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    direction: "ltr"
  }), { nonce: m } = E.useContext(Xf), b = f !== !1 ? n.props?.ref ?? n?.ref : void 0, y = S4(p, b);
  return E.useInsertionEffect(() => {
    const { width: w, height: N, top: T, left: R, right: _, bottom: z, direction: q } = g.current;
    if (i || f === !1 || !p.current || !w || !N)
      return;
    const G = q === "rtl", Q = l === "left" ? G ? `right: ${_}` : `left: ${R}` : G ? `left: ${R}` : `right: ${_}`, H = o === "bottom" ? `bottom: ${z}` : `top: ${T}`;
    p.current.dataset.motionPopId = h;
    const W = document.createElement("style");
    m && (W.nonce = m);
    const $ = d ?? document.head;
    return $.appendChild(W), W.sheet && W.sheet.insertRule(`
          [data-motion-pop-id="${h}"] {
            position: absolute !important;
            width: ${w}px !important;
            height: ${N}px !important;
            ${Q}px !important;
            ${H}px !important;
          }
        `), () => {
      p.current?.removeAttribute("data-motion-pop-id"), $.contains(W) && $.removeChild(W);
    };
  }, [i]), s.jsx(N4, { isPresent: i, childRef: p, sizeRef: g, pop: f, children: f === !1 ? n : E.cloneElement(n, { ref: y }) });
}
const A4 = ({ children: n, initial: i, isPresent: l, onExitComplete: o, custom: d, presenceAffectsLayout: f, mode: h, anchorX: p, anchorY: g, root: m }) => {
  const b = Nf(C4), y = E.useId(), w = E.useRef(l), N = E.useRef(o);
  Tf(() => {
    w.current = l, N.current = o;
  });
  let T = !0, R = E.useMemo(() => (T = !1, {
    id: y,
    initial: i,
    isPresent: l,
    custom: d,
    onExitComplete: (_) => {
      b.set(_, !0);
      for (const z of b.values())
        if (!z)
          return;
      o && o();
    },
    register: (_) => (b.set(_, !1), () => {
      b.delete(_), !w.current && !b.size && N.current?.();
    })
  }), [l, b, o]);
  return f && T && (R = { ...R }), E.useMemo(() => {
    b.forEach((_, z) => b.set(z, !1));
  }, [l]), E.useEffect(() => {
    !l && !b.size && o && o();
  }, [l]), n = s.jsx(T4, { pop: h === "popLayout", isPresent: l, anchorX: p, anchorY: g, root: m, children: n }), s.jsx(wc.Provider, { value: R, children: n });
};
function C4() {
  return /* @__PURE__ */ new Map();
}
function F1(n = !0) {
  const i = E.useContext(wc);
  if (i === null)
    return [!0, null];
  const { isPresent: l, onExitComplete: o, register: d } = i, f = E.useId();
  E.useEffect(() => {
    if (n)
      return d(f);
  }, [n]);
  const h = E.useCallback(() => n && o && o(f), [f, o, n]);
  return !l && o ? [!1, h] : [!0];
}
const Vo = (n) => n.key || "";
function Sb(n) {
  const i = [];
  return E.Children.forEach(n, (l) => {
    E.isValidElement(l) && i.push(l);
  }), i;
}
const Kr = ({ children: n, custom: i, initial: l = !0, onExitComplete: o, presenceAffectsLayout: d = !0, mode: f = "sync", propagate: h = !1, anchorX: p = "left", anchorY: g = "top", root: m }) => {
  const [b, y] = F1(h), w = E.useMemo(() => Sb(n), [n]), N = h && !b ? [] : w.map(Vo), T = E.useRef(!0), R = E.useRef(w), _ = Nf(() => /* @__PURE__ */ new Map()), z = E.useRef(/* @__PURE__ */ new Set()), [q, G] = E.useState(w), [Q, H] = E.useState(w);
  Tf(() => {
    T.current = !1, R.current = w;
    for (let k = 0; k < Q.length; k++) {
      const ee = Vo(Q[k]);
      N.includes(ee) ? (_.delete(ee), z.current.delete(ee)) : _.get(ee) !== !0 && _.set(ee, !1);
    }
  }, [Q, N.length, N.join("-")]);
  const W = [];
  if (w !== q) {
    let k = [...w];
    for (let ee = 0; ee < Q.length; ee++) {
      const ae = Q[ee], me = Vo(ae);
      N.includes(me) || (k.splice(ee, 0, ae), W.push(ae));
    }
    return f === "wait" && W.length && (k = W), H(Sb(k)), G(w), null;
  }
  const { forceRender: $ } = E.useContext(Sf);
  return s.jsx(s.Fragment, { children: Q.map((k) => {
    const ee = Vo(k), ae = h && !b ? !1 : w === Q || N.includes(ee), me = () => {
      if (z.current.has(ee))
        return;
      if (_.has(ee))
        z.current.add(ee), _.set(ee, !0);
      else
        return;
      let xe = !0;
      _.forEach((_e) => {
        _e || (xe = !1);
      }), xe && ($?.(), H(R.current), h && y?.(), o && o());
    };
    return s.jsx(A4, { isPresent: ae, initial: !T.current || l ? void 0 : !1, custom: i, presenceAffectsLayout: d, mode: f, root: m, onExitComplete: ae ? void 0 : me, anchorX: p, anchorY: g, children: k }, ee);
  }) });
}, B1 = E.createContext({ strict: !1 }), Nb = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Tb = !1;
function E4() {
  if (Tb)
    return;
  const n = {};
  for (const i in Nb)
    n[i] = {
      isEnabled: (l) => Nb[i].some((o) => !!l[o])
    };
  f1(n), Tb = !0;
}
function V1() {
  return E4(), hA();
}
function k4(n) {
  const i = V1();
  for (const l in n)
    i[l] = {
      ...i[l],
      ...n[l]
    };
  f1(i);
}
const M4 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function pc(n) {
  return n.startsWith("while") || n.startsWith("drag") && n !== "draggable" || n.startsWith("layout") || n.startsWith("onTap") || n.startsWith("onPan") || n.startsWith("onLayout") || M4.has(n);
}
let H1 = (n) => !pc(n);
function z4(n) {
  typeof n == "function" && (H1 = (i) => i.startsWith("on") ? !pc(i) : n(i));
}
try {
  z4(require("@emotion/is-prop-valid").default);
} catch {
}
function O4(n, i, l) {
  const o = {};
  for (const d in n)
    d === "values" && typeof n.values == "object" || vt(n[d]) || (H1(d) || l === !0 && pc(d) || !i && !pc(d) || // If trying to use native HTML drag events, forward drag listeners
    n.draggable && d.startsWith("onDrag")) && (o[d] = n[d]);
  return o;
}
const Ac = /* @__PURE__ */ E.createContext({});
function R4(n, i) {
  if (Tc(n)) {
    const { initial: l, animate: o } = n;
    return {
      initial: l === !1 || sl(l) ? l : void 0,
      animate: sl(o) ? o : void 0
    };
  }
  return n.inherit !== !1 ? i : {};
}
function _4(n) {
  const { initial: i, animate: l } = R4(n, E.useContext(Ac));
  return E.useMemo(() => ({ initial: i, animate: l }), [Ab(i), Ab(l)]);
}
function Ab(n) {
  return Array.isArray(n) ? n.join(" ") : n;
}
const Kf = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function U1(n, i, l) {
  for (const o in i)
    !vt(i[o]) && !v1(o, l) && (n[o] = i[o]);
}
function D4({ transformTemplate: n }, i) {
  return E.useMemo(() => {
    const l = Kf();
    return Qf(l, i, n), Object.assign({}, l.vars, l.style);
  }, [i]);
}
function F4(n, i) {
  const l = n.style || {}, o = {};
  return U1(o, l, n), Object.assign(o, D4(n, i)), o;
}
function B4(n, i) {
  const l = {}, o = F4(n, i);
  return n.drag && n.dragListener !== !1 && (l.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = n.drag === !0 ? "none" : `pan-${n.drag === "x" ? "y" : "x"}`), n.tabIndex === void 0 && (n.onTap || n.onTapStart || n.whileTap) && (l.tabIndex = 0), l.style = o, l;
}
const L1 = () => ({
  ...Kf(),
  attrs: {}
});
function V4(n, i, l, o) {
  const d = E.useMemo(() => {
    const f = L1();
    return w1(f, i, S1(o), n.transformTemplate, n.style), {
      ...f.attrs,
      style: { ...f.style }
    };
  }, [i]);
  if (n.style) {
    const f = {};
    U1(f, n.style, n), d.style = { ...f, ...d.style };
  }
  return d;
}
const H4 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function $f(n) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof n != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    n.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(H4.indexOf(n) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(n))
    )
  );
}
function U4(n, i, l, { latestValues: o }, d, f = !1, h) {
  const g = (h ?? $f(n) ? V4 : B4)(i, o, d, n), m = O4(i, typeof n == "string", f), b = n !== E.Fragment ? { ...m, ...g, ref: l } : {}, { children: y } = i, w = E.useMemo(() => vt(y) ? y.get() : y, [y]);
  return E.createElement(n, {
    ...b,
    children: w
  });
}
function L4({ scrapeMotionValuesFromProps: n, createRenderState: i }, l, o, d) {
  return {
    latestValues: P4(l, o, d, n),
    renderState: i()
  };
}
function P4(n, i, l, o) {
  const d = {}, f = o(n, {});
  for (const w in f)
    d[w] = Jo(f[w]);
  let { initial: h, animate: p } = n;
  const g = Tc(n), m = d1(n);
  i && m && !g && n.inherit !== !1 && (h === void 0 && (h = i.initial), p === void 0 && (p = i.animate));
  let b = l ? l.initial === !1 : !1;
  b = b || h === !1;
  const y = b ? p : h;
  if (y && typeof y != "boolean" && !Nc(y)) {
    const w = Array.isArray(y) ? y : [y];
    for (let N = 0; N < w.length; N++) {
      const T = Hf(n, w[N]);
      if (T) {
        const { transitionEnd: R, transition: _, ...z } = T;
        for (const q in z) {
          let G = z[q];
          if (Array.isArray(G)) {
            const Q = b ? G.length - 1 : 0;
            G = G[Q];
          }
          G !== null && (d[q] = G);
        }
        for (const q in R)
          d[q] = R[q];
      }
    }
  }
  return d;
}
const P1 = (n) => (i, l) => {
  const o = E.useContext(Ac), d = E.useContext(wc), f = () => L4(n, i, o, d);
  return l ? f() : Nf(f);
}, I4 = /* @__PURE__ */ P1({
  scrapeMotionValuesFromProps: Zf,
  createRenderState: Kf
}), q4 = /* @__PURE__ */ P1({
  scrapeMotionValuesFromProps: N1,
  createRenderState: L1
}), G4 = /* @__PURE__ */ Symbol.for("motionComponentSymbol");
function Y4(n, i, l) {
  const o = E.useRef(l);
  E.useInsertionEffect(() => {
    o.current = l;
  });
  const d = E.useRef(null);
  return E.useCallback((f) => {
    f && n.onMount?.(f), i && (f ? i.mount(f) : i.unmount());
    const h = o.current;
    if (typeof h == "function")
      if (f) {
        const p = h(f);
        typeof p == "function" && (d.current = p);
      } else d.current ? (d.current(), d.current = null) : h(f);
    else h && (h.current = f);
  }, [i]);
}
const I1 = E.createContext({});
function Cs(n) {
  return n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current");
}
function Q4(n, i, l, o, d, f) {
  const { visualElement: h } = E.useContext(Ac), p = E.useContext(B1), g = E.useContext(wc), m = E.useContext(Xf), b = m.reducedMotion, y = m.skipAnimations, w = E.useRef(null), N = E.useRef(!1);
  o = o || p.renderer, !w.current && o && (w.current = o(n, {
    visualState: i,
    parent: h,
    props: l,
    presenceContext: g,
    blockInitialAnimation: g ? g.initial === !1 : !1,
    reducedMotionConfig: b,
    skipAnimations: y,
    isSVG: f
  }), N.current && w.current && (w.current.manuallyAnimateOnMount = !0));
  const T = w.current, R = E.useContext(I1);
  T && !T.projection && d && (T.type === "html" || T.type === "svg") && Z4(w.current, l, d, R);
  const _ = E.useRef(!1);
  E.useInsertionEffect(() => {
    T && _.current && T.update(l, g);
  });
  const z = l[J0], q = E.useRef(!!z && typeof window < "u" && !window.MotionHandoffIsComplete?.(z) && window.MotionHasOptimisedAnimation?.(z));
  return Tf(() => {
    N.current = !0, T && (_.current = !0, window.MotionIsMounted = !0, T.updateFeatures(), T.scheduleRenderMicrotask(), q.current && T.animationState && T.animationState.animateChanges());
  }), E.useEffect(() => {
    T && (!q.current && T.animationState && T.animationState.animateChanges(), q.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(z);
    }), q.current = !1), T.enteringChildren = void 0);
  }), T;
}
function Z4(n, i, l, o) {
  const { layoutId: d, layout: f, drag: h, dragConstraints: p, layoutScroll: g, layoutRoot: m, layoutAnchor: b, layoutCrossfade: y } = i;
  n.projection = new l(n.latestValues, i["data-framer-portal-id"] ? void 0 : q1(n.parent)), n.projection.setOptions({
    layoutId: d,
    layout: f,
    alwaysMeasureLayout: !!h || p && Cs(p),
    visualElement: n,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof f == "string" ? f : "both",
    initialPromotionConfig: o,
    crossfade: y,
    layoutScroll: g,
    layoutRoot: m,
    layoutAnchor: b
  });
}
function q1(n) {
  if (n)
    return n.options.allowProjection !== !1 ? n.projection : q1(n.parent);
}
function lh(n, { forwardMotionProps: i = !1, type: l } = {}, o, d) {
  o && k4(o);
  const f = l ? l === "svg" : $f(n), h = f ? q4 : I4;
  function p(m, b) {
    let y;
    const w = {
      ...E.useContext(Xf),
      ...m,
      layoutId: X4(m)
    }, { isStatic: N } = w, T = _4(m), R = h(m, N);
    if (!N && typeof window < "u") {
      K4();
      const _ = $4(w);
      y = _.MeasureLayout, T.visualElement = Q4(n, R, w, d, _.ProjectionNode, f);
    }
    return s.jsxs(Ac.Provider, { value: T, children: [y && T.visualElement ? s.jsx(y, { visualElement: T.visualElement, ...w }) : null, U4(n, m, Y4(R, T.visualElement, b), R, N, i, f)] });
  }
  p.displayName = `motion.${typeof n == "string" ? n : `create(${n.displayName ?? n.name ?? ""})`}`;
  const g = E.forwardRef(p);
  return g[G4] = n, g;
}
function X4({ layoutId: n }) {
  const i = E.useContext(Sf).id;
  return i && n !== void 0 ? i + "-" + n : n;
}
function K4(n, i) {
  E.useContext(B1).strict;
}
function $4(n) {
  const i = V1(), { drag: l, layout: o } = i;
  if (!l && !o)
    return {};
  const d = { ...l, ...o };
  return {
    MeasureLayout: l?.isEnabled(n) || o?.isEnabled(n) ? d.MeasureLayout : void 0,
    ProjectionNode: d.ProjectionNode
  };
}
function W4(n, i) {
  if (typeof Proxy > "u")
    return lh;
  const l = /* @__PURE__ */ new Map(), o = (f, h) => lh(f, h, n, i), d = (f, h) => o(f, h);
  return new Proxy(d, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (f, h) => h === "create" ? o : (l.has(h) || l.set(h, lh(h, void 0, n, i)), l.get(h))
  });
}
const J4 = (n, i) => i.isSVG ?? $f(n) ? new kA(i) : new SA(i, {
  allowProjection: n !== E.Fragment
});
class e6 extends Wa {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(i) {
    super(i), i.animationState || (i.animationState = _A(i));
  }
  updateAnimationControlsSubscription() {
    const { animate: i } = this.node.getProps();
    Nc(i) && (this.unmountControls = i.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: i } = this.node.getProps(), { animate: l } = this.node.prevProps || {};
    i !== l && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let t6 = 0;
class n6 extends Wa {
  constructor() {
    super(...arguments), this.id = t6++, this.isExitComplete = !1;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: i, onExitComplete: l } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || i === o)
      return;
    if (i && o === !1) {
      if (this.isExitComplete) {
        const { initial: f, custom: h } = this.node.getProps();
        if (typeof f == "string" || typeof f == "object" && f !== null && !Array.isArray(f)) {
          const p = Ri(this.node, f, h);
          if (p) {
            const { transition: g, transitionEnd: m, ...b } = p;
            for (const y in b)
              this.node.getValue(y)?.jump(b[y]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const d = this.node.animationState.setActive("exit", !i);
    l && !i && d.then(() => {
      this.isExitComplete = !0, l(this.id);
    });
  }
  mount() {
    const { register: i, onExitComplete: l } = this.node.presenceContext || {};
    l && l(this.id), i && (this.unmount = i(this.id));
  }
  unmount() {
  }
}
const a6 = {
  animation: {
    Feature: e6
  },
  exit: {
    Feature: n6
  }
};
function ml(n) {
  return {
    point: {
      x: n.pageX,
      y: n.pageY
    }
  };
}
const i6 = (n) => (i) => If(i) && n(i, ml(i));
function $r(n, i, l, o) {
  return rl(n, i, i6(l), o);
}
const G1 = ({ current: n }) => n ? n.ownerDocument.defaultView : null, Cb = (n, i) => Math.abs(n - i);
function s6(n, i) {
  const l = Cb(n.x, i.x), o = Cb(n.y, i.y);
  return Math.sqrt(l ** 2 + o ** 2);
}
const Eb = /* @__PURE__ */ new Set(["auto", "scroll"]);
class Y1 {
  constructor(i, l, { transformPagePoint: o, contextWindow: d = window, dragSnapToOrigin: f = !1, distanceThreshold: h = 3, element: p } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (T) => {
      this.handleScroll(T.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = Ho(this.lastRawMoveEventInfo, this.transformPagePoint));
      const T = oh(this.lastMoveEventInfo, this.history), R = this.startEvent !== null, _ = s6(T.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!R && !_)
        return;
      const { point: z } = T, { timestamp: q } = bt;
      this.history.push({ ...z, timestamp: q });
      const { onStart: G, onMove: Q } = this.handlers;
      R || (G && G(this.lastMoveEvent, T), this.startEvent = this.lastMoveEvent), Q && Q(this.lastMoveEvent, T);
    }, this.handlePointerMove = (T, R) => {
      this.lastMoveEvent = T, this.lastRawMoveEventInfo = R, this.lastMoveEventInfo = Ho(R, this.transformPagePoint), Ge.update(this.updatePoint, !0);
    }, this.handlePointerUp = (T, R) => {
      this.end();
      const { onEnd: _, onSessionEnd: z, resumeAnimation: q } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && q && q(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const G = oh(T.type === "pointercancel" ? this.lastMoveEventInfo : Ho(R, this.transformPagePoint), this.history);
      this.startEvent && _ && _(T, G), z && z(T, G);
    }, !If(i))
      return;
    this.dragSnapToOrigin = f, this.handlers = l, this.transformPagePoint = o, this.distanceThreshold = h, this.contextWindow = d || window;
    const g = ml(i), m = Ho(g, this.transformPagePoint), { point: b } = m, { timestamp: y } = bt;
    this.history = [{ ...b, timestamp: y }];
    const { onSessionStart: w } = l;
    w && w(i, oh(m, this.history));
    const N = { passive: !0, capture: !0 };
    this.removeListeners = dl($r(this.contextWindow, "pointermove", this.handlePointerMove, N), $r(this.contextWindow, "pointerup", this.handlePointerUp, N), $r(this.contextWindow, "pointercancel", this.handlePointerUp, N)), p && this.startScrollTracking(p);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(i) {
    let l = i.parentElement;
    for (; l; ) {
      const o = getComputedStyle(l);
      (Eb.has(o.overflowX) || Eb.has(o.overflowY)) && this.scrollPositions.set(l, {
        x: l.scrollLeft,
        y: l.scrollTop
      }), l = l.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(i) {
    const l = this.scrollPositions.get(i);
    if (!l)
      return;
    const o = i === window, d = o ? { x: window.scrollX, y: window.scrollY } : {
      x: i.scrollLeft,
      y: i.scrollTop
    }, f = { x: d.x - l.x, y: d.y - l.y };
    f.x === 0 && f.y === 0 || (o ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += f.x, this.lastMoveEventInfo.point.y += f.y) : this.history.length > 0 && (this.history[0].x -= f.x, this.history[0].y -= f.y), this.scrollPositions.set(i, d), Ge.update(this.updatePoint, !0));
  }
  updateHandlers(i) {
    this.handlers = i;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Ka(this.updatePoint);
  }
}
function Ho(n, i) {
  return i ? { point: i(n.point) } : n;
}
function kb(n, i) {
  return { x: n.x - i.x, y: n.y - i.y };
}
function oh({ point: n }, i) {
  return {
    point: n,
    delta: kb(n, Q1(i)),
    offset: kb(n, r6(i)),
    velocity: l6(i, 0.1)
  };
}
function r6(n) {
  return n[0];
}
function Q1(n) {
  return n[n.length - 1];
}
function l6(n, i) {
  if (n.length < 2)
    return { x: 0, y: 0 };
  let l = n.length - 1, o = null;
  const d = Q1(n);
  for (; l >= 0 && (o = n[l], !(d.timestamp - o.timestamp > /* @__PURE__ */ sn(i))); )
    l--;
  if (!o)
    return { x: 0, y: 0 };
  o === n[0] && n.length > 2 && d.timestamp - o.timestamp > /* @__PURE__ */ sn(i) * 2 && (o = n[1]);
  const f = /* @__PURE__ */ jn(d.timestamp - o.timestamp);
  if (f === 0)
    return { x: 0, y: 0 };
  const h = {
    x: (d.x - o.x) / f,
    y: (d.y - o.y) / f
  };
  return h.x === 1 / 0 && (h.x = 0), h.y === 1 / 0 && (h.y = 0), h;
}
function o6(n, { min: i, max: l }, o) {
  return i !== void 0 && n < i ? n = o ? qe(i, n, o.min) : Math.max(n, i) : l !== void 0 && n > l && (n = o ? qe(l, n, o.max) : Math.min(n, l)), n;
}
function Mb(n, i, l) {
  return {
    min: i !== void 0 ? n.min + i : void 0,
    max: l !== void 0 ? n.max + l - (n.max - n.min) : void 0
  };
}
function c6(n, { top: i, left: l, bottom: o, right: d }) {
  return {
    x: Mb(n.x, l, d),
    y: Mb(n.y, i, o)
  };
}
function zb(n, i) {
  let l = i.min - n.min, o = i.max - n.max;
  return i.max - i.min < n.max - n.min && ([l, o] = [o, l]), { min: l, max: o };
}
function u6(n, i) {
  return {
    x: zb(n.x, i.x),
    y: zb(n.y, i.y)
  };
}
function d6(n, i) {
  let l = 0.5;
  const o = Rt(n), d = Rt(i);
  return d > o ? l = /* @__PURE__ */ al(i.min, i.max - o, n.min) : o > d && (l = /* @__PURE__ */ al(n.min, n.max - d, i.min)), Qn(0, 1, l);
}
function h6(n, i) {
  const l = {};
  return i.min !== void 0 && (l.min = i.min - n.min), i.max !== void 0 && (l.max = i.max - n.min), l;
}
const af = 0.35;
function f6(n = af) {
  return n === !1 ? n = 0 : n === !0 && (n = af), {
    x: Ob(n, "left", "right"),
    y: Ob(n, "top", "bottom")
  };
}
function Ob(n, i, l) {
  return {
    min: Rb(n, i),
    max: Rb(n, l)
  };
}
function Rb(n, i) {
  return typeof n == "number" ? n : n[i] || 0;
}
const m6 = /* @__PURE__ */ new WeakMap();
class p6 {
  constructor(i) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ct(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = i;
  }
  start(i, { snapToCursor: l = !1, distanceThreshold: o } = {}) {
    const { presenceContext: d } = this.visualElement;
    if (d && d.isPresent === !1)
      return;
    const f = (y) => {
      l && this.snapToCursor(ml(y).point), this.stopAnimation();
    }, h = (y, w) => {
      const { drag: N, dragPropagation: T, onDragStart: R } = this.getProps();
      if (N && !T && (this.openDragLock && this.openDragLock(), this.openDragLock = P3(N), !this.openDragLock))
        return;
      this.latestPointerEvent = y, this.latestPanInfo = w, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), qn((z) => {
        let q = this.getAxisMotionValue(z).get() || 0;
        if (Yn.test(q)) {
          const { projection: G } = this.visualElement;
          if (G && G.layout) {
            const Q = G.layout.layoutBox[z];
            Q && (q = Rt(Q) * (parseFloat(q) / 100));
          }
        }
        this.originPoint[z] = q;
      }), R && Ge.update(() => R(y, w), !1, !0), Qh(this.visualElement, "transform");
      const { animationState: _ } = this.visualElement;
      _ && _.setActive("whileDrag", !0);
    }, p = (y, w) => {
      this.latestPointerEvent = y, this.latestPanInfo = w;
      const { dragPropagation: N, dragDirectionLock: T, onDirectionLock: R, onDrag: _ } = this.getProps();
      if (!N && !this.openDragLock)
        return;
      const { offset: z } = w;
      if (T && this.currentDirection === null) {
        this.currentDirection = x6(z), this.currentDirection !== null && R && R(this.currentDirection);
        return;
      }
      this.updateAxis("x", w.point, z), this.updateAxis("y", w.point, z), this.visualElement.render(), _ && Ge.update(() => _(y, w), !1, !0);
    }, g = (y, w) => {
      this.latestPointerEvent = y, this.latestPanInfo = w, this.stop(y, w), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, m = () => {
      const { dragSnapToOrigin: y } = this.getProps();
      (y || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: b } = this.getProps();
    this.panSession = new Y1(i, {
      onSessionStart: f,
      onStart: h,
      onMove: p,
      onSessionEnd: g,
      resumeAnimation: m
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: b,
      distanceThreshold: o,
      contextWindow: G1(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(i, l) {
    const o = i || this.latestPointerEvent, d = l || this.latestPanInfo, f = this.isDragging;
    if (this.cancel(), !f || !d || !o)
      return;
    const { velocity: h } = d;
    this.startAnimation(h);
    const { onDragEnd: p } = this.getProps();
    p && Ge.postRender(() => p(o, d));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: i, animationState: l } = this.visualElement;
    i && (i.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: o } = this.getProps();
    !o && this.openDragLock && (this.openDragLock(), this.openDragLock = null), l && l.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(i, l, o) {
    const { drag: d } = this.getProps();
    if (!o || !Uo(i, d, this.currentDirection))
      return;
    const f = this.getAxisMotionValue(i);
    let h = this.originPoint[i] + o[i];
    this.constraints && this.constraints[i] && (h = o6(h, this.constraints[i], this.elastic[i])), f.set(h);
  }
  resolveConstraints() {
    const { dragConstraints: i, dragElastic: l } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, d = this.constraints;
    i && Cs(i) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : i && o ? this.constraints = c6(o.layoutBox, i) : this.constraints = !1, this.elastic = f6(l), d !== this.constraints && !Cs(i) && o && this.constraints && !this.hasMutatedConstraints && qn((f) => {
      this.constraints !== !1 && this.getAxisMotionValue(f) && (this.constraints[f] = h6(o.layoutBox[f], this.constraints[f]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: i, onMeasureDragConstraints: l } = this.getProps();
    if (!i || !Cs(i))
      return !1;
    const o = i.current, { projection: d } = this.visualElement;
    if (!d || !d.layout)
      return !1;
    d.root && (d.root.scroll = void 0, d.root.updateScroll());
    const f = xA(o, d.root, this.visualElement.getTransformPagePoint());
    let h = u6(d.layout.layoutBox, f);
    if (l) {
      const p = l(mA(h));
      this.hasMutatedConstraints = !!p, p && (h = p1(p));
    }
    return h;
  }
  startAnimation(i) {
    const { drag: l, dragMomentum: o, dragElastic: d, dragTransition: f, dragSnapToOrigin: h, onDragTransitionEnd: p } = this.getProps(), g = this.constraints || {}, m = qn((b) => {
      if (!Uo(b, l, this.currentDirection))
        return;
      let y = g && g[b] || {};
      (h === !0 || h === b) && (y = { min: 0, max: 0 });
      const w = d ? 200 : 1e6, N = d ? 40 : 1e7, T = {
        type: "inertia",
        velocity: o ? i[b] : 0,
        bounceStiffness: w,
        bounceDamping: N,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...f,
        ...y
      };
      return this.startAxisValueAnimation(b, T);
    });
    return Promise.all(m).then(p);
  }
  startAxisValueAnimation(i, l) {
    const o = this.getAxisMotionValue(i);
    return Qh(this.visualElement, i), o.start(Vf(i, o, 0, l, this.visualElement, !1));
  }
  stopAnimation() {
    qn((i) => this.getAxisMotionValue(i).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(i) {
    const l = `_drag${i.toUpperCase()}`, d = this.visualElement.getProps()[l];
    return d || this.visualElement.getValue(i, this.visualElement.latestValues[i] ?? 0);
  }
  snapToCursor(i) {
    qn((l) => {
      const { drag: o } = this.getProps();
      if (!Uo(l, o, this.currentDirection))
        return;
      const { projection: d } = this.visualElement, f = this.getAxisMotionValue(l);
      if (d && d.layout) {
        const { min: h, max: p } = d.layout.layoutBox[l], g = f.get() || 0;
        f.set(i[l] - qe(h, p, 0.5) + g);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: i, dragConstraints: l } = this.getProps(), { projection: o } = this.visualElement;
    if (!Cs(l) || !o || !this.constraints)
      return;
    this.stopAnimation();
    const d = { x: 0, y: 0 };
    qn((h) => {
      const p = this.getAxisMotionValue(h);
      if (p && this.constraints !== !1) {
        const g = p.get();
        d[h] = d6({ min: g, max: g }, this.constraints[h]);
      }
    });
    const { transformTemplate: f } = this.visualElement.getProps();
    this.visualElement.current.style.transform = f ? f({}, "") : "none", o.root && o.root.updateScroll(), o.updateLayout(), this.constraints = !1, this.resolveConstraints(), qn((h) => {
      if (!Uo(h, i, null))
        return;
      const p = this.getAxisMotionValue(h), { min: g, max: m } = this.constraints[h];
      p.set(qe(g, m, d[h]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    m6.set(this.visualElement, this);
    const i = this.visualElement.current, l = $r(i, "pointerdown", (m) => {
      const { drag: b, dragListener: y = !0 } = this.getProps(), w = m.target, N = w !== i && Z3(w);
      b && y && !N && this.start(m);
    });
    let o;
    const d = () => {
      const { dragConstraints: m } = this.getProps();
      Cs(m) && m.current && (this.constraints = this.resolveRefConstraints(), o || (o = g6(i, m.current, () => this.scalePositionWithinConstraints())));
    }, { projection: f } = this.visualElement, h = f.addEventListener("measure", d);
    f && !f.layout && (f.root && f.root.updateScroll(), f.updateLayout()), Ge.read(d);
    const p = rl(window, "resize", () => this.scalePositionWithinConstraints()), g = f.addEventListener("didUpdate", (({ delta: m, hasLayoutChanged: b }) => {
      this.isDragging && b && (qn((y) => {
        const w = this.getAxisMotionValue(y);
        w && (this.originPoint[y] += m[y].translate, w.set(w.get() + m[y].translate));
      }), this.visualElement.render());
    }));
    return () => {
      p(), l(), h(), g && g(), o && o();
    };
  }
  getProps() {
    const i = this.visualElement.getProps(), { drag: l = !1, dragDirectionLock: o = !1, dragPropagation: d = !1, dragConstraints: f = !1, dragElastic: h = af, dragMomentum: p = !0 } = i;
    return {
      ...i,
      drag: l,
      dragDirectionLock: o,
      dragPropagation: d,
      dragConstraints: f,
      dragElastic: h,
      dragMomentum: p
    };
  }
}
function _b(n) {
  let i = !0;
  return () => {
    if (i) {
      i = !1;
      return;
    }
    n();
  };
}
function g6(n, i, l) {
  const o = Ly(n, _b(l)), d = Ly(i, _b(l));
  return () => {
    o(), d();
  };
}
function Uo(n, i, l) {
  return (i === !0 || i === n) && (l === null || l === n);
}
function x6(n, i = 10) {
  let l = null;
  return Math.abs(n.y) > i ? l = "y" : Math.abs(n.x) > i && (l = "x"), l;
}
class y6 extends Wa {
  constructor(i) {
    super(i), this.removeGroupControls = Sn, this.removeListeners = Sn, this.controls = new p6(i);
  }
  mount() {
    const { dragControls: i } = this.node.getProps();
    i && (this.removeGroupControls = i.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Sn;
  }
  update() {
    const { dragControls: i } = this.node.getProps(), { dragControls: l } = this.node.prevProps || {};
    i !== l && (this.removeGroupControls(), i && (this.removeGroupControls = i.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const ch = (n) => (i, l) => {
  n && Ge.update(() => n(i, l), !1, !0);
};
class b6 extends Wa {
  constructor() {
    super(...arguments), this.removePointerDownListener = Sn;
  }
  onPointerDown(i) {
    this.session = new Y1(i, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: G1(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: i, onPanStart: l, onPan: o, onPanEnd: d } = this.node.getProps();
    return {
      onSessionStart: ch(i),
      onStart: ch(l),
      onMove: ch(o),
      onEnd: (f, h) => {
        delete this.session, d && Ge.postRender(() => d(f, h));
      }
    };
  }
  mount() {
    this.removePointerDownListener = $r(this.node.current, "pointerdown", (i) => this.onPointerDown(i));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let uh = !1;
class v6 extends E.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: i, layoutGroup: l, switchLayoutGroup: o, layoutId: d } = this.props, { projection: f } = i;
    f && (l.group && l.group.add(f), o && o.register && d && o.register(f), uh && f.root.didUpdate(), f.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), f.setOptions({
      ...f.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), ec.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(i) {
    const { layoutDependency: l, visualElement: o, drag: d, isPresent: f } = this.props, { projection: h } = o;
    return h && (h.isPresent = f, i.layoutDependency !== l && h.setOptions({
      ...h.options,
      layoutDependency: l
    }), uh = !0, d || i.layoutDependency !== l || l === void 0 || i.isPresent !== f ? h.willUpdate() : this.safeToRemove(), i.isPresent !== f && (f ? h.promote() : h.relegate() || Ge.postRender(() => {
      const p = h.getStack();
      (!p || !p.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: i, layoutAnchor: l } = this.props, { projection: o } = i;
    o && (o.options.layoutAnchor = l, o.root.didUpdate(), Pf.postRender(() => {
      !o.currentAnimation && o.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: i, layoutGroup: l, switchLayoutGroup: o } = this.props, { projection: d } = i;
    uh = !0, d && (d.scheduleCheckAfterUnmount(), l && l.group && l.group.remove(d), o && o.deregister && o.deregister(d));
  }
  safeToRemove() {
    const { safeToRemove: i } = this.props;
    i && i();
  }
  render() {
    return null;
  }
}
function Z1(n) {
  const [i, l] = F1(), o = E.useContext(Sf);
  return s.jsx(v6, { ...n, layoutGroup: o, switchLayoutGroup: E.useContext(I1), isPresent: i, safeToRemove: l });
}
const w6 = {
  pan: {
    Feature: b6
  },
  drag: {
    Feature: y6,
    ProjectionNode: D1,
    MeasureLayout: Z1
  }
};
function Db(n, i, l) {
  const { props: o } = n;
  n.animationState && o.whileHover && n.animationState.setActive("whileHover", l === "Start");
  const d = "onHover" + l, f = o[d];
  f && Ge.postRender(() => f(i, ml(i)));
}
class j6 extends Wa {
  mount() {
    const { current: i } = this.node;
    i && (this.unmount = q3(i, (l, o) => (Db(this.node, o, "Start"), (d) => Db(this.node, d, "End"))));
  }
  unmount() {
  }
}
class S6 extends Wa {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let i = !1;
    try {
      i = this.node.current.matches(":focus-visible");
    } catch {
      i = !0;
    }
    !i || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = dl(rl(this.node.current, "focus", () => this.onFocus()), rl(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Fb(n, i, l) {
  const { props: o } = n;
  if (n.current instanceof HTMLButtonElement && n.current.disabled)
    return;
  n.animationState && o.whileTap && n.animationState.setActive("whileTap", l === "Start");
  const d = "onTap" + (l === "End" ? "" : l), f = o[d];
  f && Ge.postRender(() => f(i, ml(i)));
}
class N6 extends Wa {
  mount() {
    const { current: i } = this.node;
    if (!i)
      return;
    const { globalTapTarget: l, propagate: o } = this.node.props;
    this.unmount = K3(i, (d, f) => (Fb(this.node, f, "Start"), (h, { success: p }) => Fb(this.node, h, p ? "End" : "Cancel")), {
      useGlobalTarget: l,
      stopPropagation: o?.tap === !1
    });
  }
  unmount() {
  }
}
const sf = /* @__PURE__ */ new WeakMap(), dh = /* @__PURE__ */ new WeakMap(), T6 = (n) => {
  const i = sf.get(n.target);
  i && i(n);
}, A6 = (n) => {
  n.forEach(T6);
};
function C6({ root: n, ...i }) {
  const l = n || document;
  dh.has(l) || dh.set(l, {});
  const o = dh.get(l), d = JSON.stringify(i);
  return o[d] || (o[d] = new IntersectionObserver(A6, { root: n, ...i })), o[d];
}
function E6(n, i, l) {
  const o = C6(i);
  return sf.set(n, l), o.observe(n), () => {
    sf.delete(n), o.unobserve(n);
  };
}
const k6 = {
  some: 0,
  all: 1
};
class M6 extends Wa {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.stopObserver?.();
    const { viewport: i = {} } = this.node.getProps(), { root: l, margin: o, amount: d = "some", once: f } = i, h = {
      root: l ? l.current : void 0,
      rootMargin: o,
      threshold: typeof d == "number" ? d : k6[d]
    }, p = (g) => {
      const { isIntersecting: m } = g;
      if (this.isInView === m || (this.isInView = m, f && !m && this.hasEnteredView))
        return;
      m && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", m);
      const { onViewportEnter: b, onViewportLeave: y } = this.node.getProps(), w = m ? b : y;
      w && w(g);
    };
    this.stopObserver = E6(this.node.current, h, p);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: i, prevProps: l } = this.node;
    ["amount", "margin", "root"].some(z6(i, l)) && this.startObserver();
  }
  unmount() {
    this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function z6({ viewport: n = {} }, { viewport: i = {} } = {}) {
  return (l) => n[l] !== i[l];
}
const O6 = {
  inView: {
    Feature: M6
  },
  tap: {
    Feature: N6
  },
  focus: {
    Feature: S6
  },
  hover: {
    Feature: j6
  }
}, R6 = {
  layout: {
    ProjectionNode: D1,
    MeasureLayout: Z1
  }
}, _6 = {
  ...a6,
  ...O6,
  ...w6,
  ...R6
}, C = /* @__PURE__ */ W4(_6, J4);
function D6() {
  const {
    cart: n,
    isOpen: i,
    loading: l,
    itemCount: o,
    closeCart: d,
    updateQuantity: f,
    removeItem: h,
    proceedToCheckout: p
  } = ul();
  return /* @__PURE__ */ s.jsx(Kr, { children: i && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      C.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.2 },
        className: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50",
        onClick: d
      }
    ),
    /* @__PURE__ */ s.jsxs(
      C.div,
      {
        initial: { x: "100%" },
        animate: { x: 0 },
        exit: { x: "100%" },
        transition: { type: "spring", damping: 25, stiffness: 300 },
        className: "fixed right-0 top-0 h-full w-full max-w-md bg-[#111] border-l border-white/10 z-50 flex flex-col",
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-6 border-b border-white/10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ s.jsx(uy, { size: 20, className: "text-[#FF6B35]" }),
              /* @__PURE__ */ s.jsxs("h2", { className: "text-white font-semibold text-lg", children: [
                "Your Cart (",
                o,
                ")"
              ] })
            ] }),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: d,
                className: "p-2 rounded-lg hover:bg-white/5 transition-colors",
                children: /* @__PURE__ */ s.jsx(vf, { size: 20, className: "text-white/60" })
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "flex-1 overflow-y-auto p-6", children: !n || n.items.length === 0 ? /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center justify-center h-full text-center", children: [
            /* @__PURE__ */ s.jsx(uy, { size: 48, className: "text-white/10 mb-4" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm", children: "Your cart is empty" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/20 text-xs mt-1", children: "Add items from our product pages" })
          ] }) : /* @__PURE__ */ s.jsx("div", { className: "space-y-4", children: n.items.map((g) => /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: "flex gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5",
              children: [
                g.image && /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 rounded-lg overflow-hidden bg-white/5 flex-shrink-0", children: /* @__PURE__ */ s.jsx(
                  "img",
                  {
                    src: g.image.url,
                    alt: g.productTitle,
                    className: "w-full h-full object-cover"
                  }
                ) }),
                /* @__PURE__ */ s.jsxs("div", { className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ s.jsx("h3", { className: "text-white text-sm font-medium truncate", children: g.productTitle }),
                  g.variantTitle !== "Default Title" && /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-0.5", children: g.variantTitle }),
                  /* @__PURE__ */ s.jsxs("p", { className: "text-[#FF6B35] text-sm font-semibold mt-1", children: [
                    "$",
                    parseFloat(g.unitPrice.amount).toFixed(2)
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 mt-2", children: [
                    /* @__PURE__ */ s.jsx(
                      "button",
                      {
                        onClick: () => f(g.lineId, g.quantity - 1),
                        disabled: l,
                        className: "w-6 h-6 rounded bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors disabled:opacity-50",
                        children: /* @__PURE__ */ s.jsx(KN, { size: 12, className: "text-white/60" })
                      }
                    ),
                    /* @__PURE__ */ s.jsx("span", { className: "text-white text-sm w-6 text-center", children: g.quantity }),
                    /* @__PURE__ */ s.jsx(
                      "button",
                      {
                        onClick: () => f(g.lineId, g.quantity + 1),
                        disabled: l,
                        className: "w-6 h-6 rounded bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors disabled:opacity-50",
                        children: /* @__PURE__ */ s.jsx(JN, { size: 12, className: "text-white/60" })
                      }
                    ),
                    /* @__PURE__ */ s.jsx(
                      "button",
                      {
                        onClick: () => h(g.lineId),
                        disabled: l,
                        className: "ml-auto p-1 rounded hover:bg-red-500/10 transition-colors disabled:opacity-50",
                        children: /* @__PURE__ */ s.jsx(rT, { size: 14, className: "text-red-400/60" })
                      }
                    )
                  ] })
                ] })
              ]
            },
            g.lineId
          )) }) }),
          n && n.items.length > 0 && /* @__PURE__ */ s.jsxs("div", { className: "p-6 border-t border-white/10 space-y-4", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between items-center", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/60 text-sm", children: "Subtotal" }),
              /* @__PURE__ */ s.jsxs("span", { className: "text-white font-semibold", children: [
                "$",
                parseFloat(n.subtotal.amount).toFixed(2),
                " ",
                n.subtotal.currencyCode
              ] })
            ] }),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: p,
                disabled: l,
                className: "w-full py-4 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2",
                children: l ? /* @__PURE__ */ s.jsx(el, { size: 18, className: "animate-spin" }) : "Checkout with Shopify"
              }
            ),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs text-center", children: "Secure checkout powered by Shopify" })
          ] })
        ]
      }
    )
  ] }) });
}
var hh, Bb;
function F6() {
  if (Bb) return hh;
  Bb = 1;
  var n = typeof Element < "u", i = typeof Map == "function", l = typeof Set == "function", o = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function d(f, h) {
    if (f === h) return !0;
    if (f && h && typeof f == "object" && typeof h == "object") {
      if (f.constructor !== h.constructor) return !1;
      var p, g, m;
      if (Array.isArray(f)) {
        if (p = f.length, p != h.length) return !1;
        for (g = p; g-- !== 0; )
          if (!d(f[g], h[g])) return !1;
        return !0;
      }
      var b;
      if (i && f instanceof Map && h instanceof Map) {
        if (f.size !== h.size) return !1;
        for (b = f.entries(); !(g = b.next()).done; )
          if (!h.has(g.value[0])) return !1;
        for (b = f.entries(); !(g = b.next()).done; )
          if (!d(g.value[1], h.get(g.value[0]))) return !1;
        return !0;
      }
      if (l && f instanceof Set && h instanceof Set) {
        if (f.size !== h.size) return !1;
        for (b = f.entries(); !(g = b.next()).done; )
          if (!h.has(g.value[0])) return !1;
        return !0;
      }
      if (o && ArrayBuffer.isView(f) && ArrayBuffer.isView(h)) {
        if (p = f.length, p != h.length) return !1;
        for (g = p; g-- !== 0; )
          if (f[g] !== h[g]) return !1;
        return !0;
      }
      if (f.constructor === RegExp) return f.source === h.source && f.flags === h.flags;
      if (f.valueOf !== Object.prototype.valueOf && typeof f.valueOf == "function" && typeof h.valueOf == "function") return f.valueOf() === h.valueOf();
      if (f.toString !== Object.prototype.toString && typeof f.toString == "function" && typeof h.toString == "function") return f.toString() === h.toString();
      if (m = Object.keys(f), p = m.length, p !== Object.keys(h).length) return !1;
      for (g = p; g-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(h, m[g])) return !1;
      if (n && f instanceof Element) return !1;
      for (g = p; g-- !== 0; )
        if (!((m[g] === "_owner" || m[g] === "__v" || m[g] === "__o") && f.$$typeof) && !d(f[m[g]], h[m[g]]))
          return !1;
      return !0;
    }
    return f !== f && h !== h;
  }
  return hh = function(h, p) {
    try {
      return d(h, p);
    } catch (g) {
      if ((g.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw g;
    }
  }, hh;
}
var B6 = F6();
const V6 = /* @__PURE__ */ ll(B6);
var fh, Vb;
function H6() {
  if (Vb) return fh;
  Vb = 1;
  var n = function(i, l, o, d, f, h, p, g) {
    if (!i) {
      var m;
      if (l === void 0)
        m = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var b = [o, d, f, h, p, g], y = 0;
        m = new Error(
          l.replace(/%s/g, function() {
            return b[y++];
          })
        ), m.name = "Invariant Violation";
      }
      throw m.framesToPop = 1, m;
    }
  };
  return fh = n, fh;
}
var U6 = H6();
const Hb = /* @__PURE__ */ ll(U6);
var mh, Ub;
function L6() {
  return Ub || (Ub = 1, mh = function(i, l, o, d) {
    var f = o ? o.call(d, i, l) : void 0;
    if (f !== void 0)
      return !!f;
    if (i === l)
      return !0;
    if (typeof i != "object" || !i || typeof l != "object" || !l)
      return !1;
    var h = Object.keys(i), p = Object.keys(l);
    if (h.length !== p.length)
      return !1;
    for (var g = Object.prototype.hasOwnProperty.bind(l), m = 0; m < h.length; m++) {
      var b = h[m];
      if (!g(b))
        return !1;
      var y = i[b], w = l[b];
      if (f = o ? o.call(d, y, w, b) : void 0, f === !1 || f === void 0 && y !== w)
        return !1;
    }
    return !0;
  }), mh;
}
var P6 = L6();
const I6 = /* @__PURE__ */ ll(P6);
var X1 = /* @__PURE__ */ ((n) => (n.BASE = "base", n.BODY = "body", n.HEAD = "head", n.HTML = "html", n.LINK = "link", n.META = "meta", n.NOSCRIPT = "noscript", n.SCRIPT = "script", n.STYLE = "style", n.TITLE = "title", n.FRAGMENT = "Symbol(react.fragment)", n))(X1 || {}), ph = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
}, Lb = Object.values(X1), Cc = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
}, K1 = Object.entries(Cc).reduce(
  (n, [i, l]) => (n[l] = i, n),
  {}
), zn = "data-rh", zs = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
}, Os = (n, i) => {
  for (let l = n.length - 1; l >= 0; l -= 1) {
    const o = n[l];
    if (Object.prototype.hasOwnProperty.call(o, i))
      return o[i];
  }
  return null;
}, q6 = (n) => {
  let i = Os(
    n,
    "title"
    /* TITLE */
  );
  const l = Os(n, zs.TITLE_TEMPLATE);
  if (Array.isArray(i) && (i = i.join("")), l && i)
    return l.replace(/%s/g, () => i);
  const o = Os(n, zs.DEFAULT_TITLE);
  return i || o || void 0;
}, G6 = (n) => Os(n, zs.ON_CHANGE_CLIENT_STATE) || (() => {
}), gh = (n, i) => i.filter((l) => typeof l[n] < "u").map((l) => l[n]).reduce((l, o) => ({ ...l, ...o }), {}), Y6 = (n, i) => i.filter((l) => typeof l.base < "u").map((l) => l.base).reverse().reduce((l, o) => {
  if (!l.length) {
    const d = Object.keys(o);
    for (let f = 0; f < d.length; f += 1) {
      const p = d[f].toLowerCase();
      if (n.indexOf(p) !== -1 && o[p])
        return l.concat(o);
    }
  }
  return l;
}, []), Q6 = (n) => console && typeof console.warn == "function" && console.warn(n), Vr = (n, i, l) => {
  const o = {};
  return l.filter((d) => Array.isArray(d[n]) ? !0 : (typeof d[n] < "u" && Q6(
    `Helmet: ${n} should be of type "Array". Instead found type "${typeof d[n]}"`
  ), !1)).map((d) => d[n]).reverse().reduce((d, f) => {
    const h = {};
    f.filter((g) => {
      let m;
      const b = Object.keys(g);
      for (let w = 0; w < b.length; w += 1) {
        const N = b[w], T = N.toLowerCase();
        i.indexOf(T) !== -1 && !(m === "rel" && g[m].toLowerCase() === "canonical") && !(T === "rel" && g[T].toLowerCase() === "stylesheet") && (m = T), i.indexOf(N) !== -1 && (N === "innerHTML" || N === "cssText" || N === "itemprop") && (m = N);
      }
      if (!m || !g[m])
        return !1;
      const y = g[m].toLowerCase();
      return o[m] || (o[m] = {}), h[m] || (h[m] = {}), o[m][y] ? !1 : (h[m][y] = !0, !0);
    }).reverse().forEach((g) => d.push(g));
    const p = Object.keys(h);
    for (let g = 0; g < p.length; g += 1) {
      const m = p[g], b = {
        ...o[m],
        ...h[m]
      };
      o[m] = b;
    }
    return d;
  }, []).reverse();
}, Z6 = (n, i) => {
  if (Array.isArray(n) && n.length) {
    for (let l = 0; l < n.length; l += 1)
      if (n[l][i])
        return !0;
  }
  return !1;
}, X6 = (n) => ({
  baseTag: Y6([
    "href"
    /* HREF */
  ], n),
  bodyAttributes: gh("bodyAttributes", n),
  defer: Os(n, zs.DEFER),
  encode: Os(n, zs.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: gh("htmlAttributes", n),
  linkTags: Vr(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    n
  ),
  metaTags: Vr(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    n
  ),
  noscriptTags: Vr("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], n),
  onChangeClientState: G6(n),
  scriptTags: Vr(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    n
  ),
  styleTags: Vr("style", [
    "cssText"
    /* CSS_TEXT */
  ], n),
  title: q6(n),
  titleAttributes: gh("titleAttributes", n),
  prioritizeSeoTags: Z6(n, zs.PRIORITIZE_SEO_TAGS)
}), $1 = (n) => Array.isArray(n) ? n.join("") : n, K6 = (n, i) => {
  const l = Object.keys(n);
  for (let o = 0; o < l.length; o += 1)
    if (i[l[o]] && i[l[o]].includes(n[l[o]]))
      return !0;
  return !1;
}, xh = (n, i) => Array.isArray(n) ? n.reduce(
  (l, o) => (K6(o, i) ? l.priority.push(o) : l.default.push(o), l),
  { priority: [], default: [] }
) : { default: n, priority: [] }, Pb = (n, i) => ({
  ...n,
  [i]: void 0
}), $6 = [
  "noscript",
  "script",
  "style"
  /* STYLE */
], rf = (n, i = !0) => i === !1 ? String(n) : String(n).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;"), W1 = (n) => Object.keys(n).reduce((i, l) => {
  const o = typeof n[l] < "u" ? `${l}="${n[l]}"` : `${l}`;
  return i ? `${i} ${o}` : o;
}, ""), W6 = (n, i, l, o) => {
  const d = W1(l), f = $1(i);
  return d ? `<${n} ${zn}="true" ${d}>${rf(
    f,
    o
  )}</${n}>` : `<${n} ${zn}="true">${rf(
    f,
    o
  )}</${n}>`;
}, J6 = (n, i, l = !0) => i.reduce((o, d) => {
  const f = d, h = Object.keys(f).filter(
    (m) => !(m === "innerHTML" || m === "cssText")
  ).reduce((m, b) => {
    const y = typeof f[b] > "u" ? b : `${b}="${rf(f[b], l)}"`;
    return m ? `${m} ${y}` : y;
  }, ""), p = f.innerHTML || f.cssText || "", g = $6.indexOf(n) === -1;
  return `${o}<${n} ${zn}="true" ${h}${g ? "/>" : `>${p}</${n}>`}`;
}, ""), J1 = (n, i = {}) => Object.keys(n).reduce((l, o) => {
  const d = Cc[o];
  return l[d || o] = n[o], l;
}, i), eC = (n, i, l) => {
  const o = {
    key: i,
    [zn]: !0
  }, d = J1(l, o);
  return [Z.createElement("title", d, i)];
}, tc = (n, i) => i.map((l, o) => {
  const d = {
    key: o,
    [zn]: !0
  };
  return Object.keys(l).forEach((f) => {
    const p = Cc[f] || f;
    if (p === "innerHTML" || p === "cssText") {
      const g = l.innerHTML || l.cssText;
      d.dangerouslySetInnerHTML = { __html: g };
    } else
      d[p] = l[f];
  }), Z.createElement(n, d);
}), vn = (n, i, l = !0) => {
  switch (n) {
    case "title":
      return {
        toComponent: () => eC(n, i.title, i.titleAttributes),
        toString: () => W6(n, i.title, i.titleAttributes, l)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => J1(i),
        toString: () => W1(i)
      };
    default:
      return {
        toComponent: () => tc(n, i),
        toString: () => J6(n, i, l)
      };
  }
}, tC = ({ metaTags: n, linkTags: i, scriptTags: l, encode: o }) => {
  const d = xh(n, ph.meta), f = xh(i, ph.link), h = xh(l, ph.script);
  return {
    priorityMethods: {
      toComponent: () => [
        ...tc("meta", d.priority),
        ...tc("link", f.priority),
        ...tc("script", h.priority)
      ],
      toString: () => (
        // generate all the tags as strings and concatenate them
        `${vn("meta", d.priority, o)} ${vn(
          "link",
          f.priority,
          o
        )} ${vn("script", h.priority, o)}`
      )
    },
    metaTags: d.default,
    linkTags: f.default,
    scriptTags: h.default
  };
}, nC = (n) => {
  const {
    baseTag: i,
    bodyAttributes: l,
    encode: o = !0,
    htmlAttributes: d,
    noscriptTags: f,
    styleTags: h,
    title: p = "",
    titleAttributes: g,
    prioritizeSeoTags: m
  } = n;
  let { linkTags: b, metaTags: y, scriptTags: w } = n, N = {
    toComponent: () => [],
    toString: () => ""
  };
  return m && ({ priorityMethods: N, linkTags: b, metaTags: y, scriptTags: w } = tC(n)), {
    priority: N,
    base: vn("base", i, o),
    bodyAttributes: vn("bodyAttributes", l, o),
    htmlAttributes: vn("htmlAttributes", d, o),
    link: vn("link", b, o),
    meta: vn("meta", y, o),
    noscript: vn("noscript", f, o),
    script: vn("script", w, o),
    style: vn("style", h, o),
    title: vn("title", { title: p, titleAttributes: g }, o)
  };
}, lf = nC, Lo = [], Wf = !!(typeof window < "u" && window.document && window.document.createElement), of = class {
  instances = [];
  canUseDOM = Wf;
  context;
  value = {
    setHelmet: (n) => {
      this.context.helmet = n;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? Lo : this.instances,
      add: (n) => {
        (this.canUseDOM ? Lo : this.instances).push(n);
      },
      remove: (n) => {
        const i = (this.canUseDOM ? Lo : this.instances).indexOf(n);
        (this.canUseDOM ? Lo : this.instances).splice(i, 1);
      }
    }
  };
  constructor(n, i) {
    this.context = n, this.canUseDOM = i || !1, i || (n.helmet = lf({
      baseTag: [],
      bodyAttributes: {},
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    }));
  }
}, aC = parseInt(Z.version.split(".")[0], 10), cf = aC >= 19, iC = {}, ew = Z.createContext(iC), tw = class nw extends E.Component {
  static canUseDOM = Wf;
  helmetData;
  constructor(i) {
    super(i), cf ? this.helmetData = null : this.helmetData = new of(this.props.context || {}, nw.canUseDOM);
  }
  render() {
    return cf ? /* @__PURE__ */ Z.createElement(Z.Fragment, null, this.props.children) : /* @__PURE__ */ Z.createElement(ew.Provider, { value: this.helmetData.value }, this.props.children);
  }
}, Ns = (n, i) => {
  const l = document.head || document.querySelector(
    "head"
    /* HEAD */
  ), o = l.querySelectorAll(`${n}[${zn}]`), d = [].slice.call(o), f = [];
  let h;
  return i && i.length && i.forEach((p) => {
    const g = document.createElement(n);
    for (const m in p)
      if (Object.prototype.hasOwnProperty.call(p, m))
        if (m === "innerHTML")
          g.innerHTML = p.innerHTML;
        else if (m === "cssText") {
          const b = p.cssText;
          g.appendChild(document.createTextNode(b));
        } else {
          const b = m, y = typeof p[b] > "u" ? "" : p[b];
          g.setAttribute(m, y);
        }
    g.setAttribute(zn, "true"), d.some((m, b) => (h = b, g.isEqualNode(m))) ? d.splice(h, 1) : f.push(g);
  }), d.forEach((p) => p.parentNode?.removeChild(p)), f.forEach((p) => l.appendChild(p)), {
    oldTags: d,
    newTags: f
  };
}, uf = (n, i) => {
  const l = document.getElementsByTagName(n)[0];
  if (!l)
    return;
  const o = l.getAttribute(zn), d = o ? o.split(",") : [], f = [...d], h = Object.keys(i);
  for (const p of h) {
    const g = i[p] || "";
    l.getAttribute(p) !== g && l.setAttribute(p, g), d.indexOf(p) === -1 && d.push(p);
    const m = f.indexOf(p);
    m !== -1 && f.splice(m, 1);
  }
  for (let p = f.length - 1; p >= 0; p -= 1)
    l.removeAttribute(f[p]);
  d.length === f.length ? l.removeAttribute(zn) : l.getAttribute(zn) !== h.join(",") && l.setAttribute(zn, h.join(","));
}, sC = (n, i) => {
  typeof n < "u" && document.title !== n && (document.title = $1(n)), uf("title", i);
}, Ib = (n, i) => {
  const {
    baseTag: l,
    bodyAttributes: o,
    htmlAttributes: d,
    linkTags: f,
    metaTags: h,
    noscriptTags: p,
    onChangeClientState: g,
    scriptTags: m,
    styleTags: b,
    title: y,
    titleAttributes: w
  } = n;
  uf("body", o), uf("html", d), sC(y, w);
  const N = {
    baseTag: Ns("base", l),
    linkTags: Ns("link", f),
    metaTags: Ns("meta", h),
    noscriptTags: Ns("noscript", p),
    scriptTags: Ns("script", m),
    styleTags: Ns("style", b)
  }, T = {}, R = {};
  Object.keys(N).forEach((_) => {
    const { newTags: z, oldTags: q } = N[_];
    z.length && (T[_] = z), q.length && (R[_] = N[_].oldTags);
  }), i && i(), g(n, T, R);
}, Hr = null, rC = (n) => {
  Hr && cancelAnimationFrame(Hr), n.defer ? Hr = requestAnimationFrame(() => {
    Ib(n, () => {
      Hr = null;
    });
  }) : (Ib(n), Hr = null);
}, lC = rC, qb = class extends E.Component {
  rendered = !1;
  shouldComponentUpdate(n) {
    return !I6(n, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances: n } = this.props.context;
    n.remove(this), this.emitChange();
  }
  emitChange() {
    const { helmetInstances: n, setHelmet: i } = this.props.context;
    let l = null;
    const o = X6(
      n.get().map((d) => {
        const { context: f, ...h } = d.props;
        return h;
      })
    );
    tw.canUseDOM ? lC(o) : lf && (l = lf(o)), i(l);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered)
      return;
    this.rendered = !0;
    const { helmetInstances: n } = this.props.context;
    n.add(this), this.emitChange();
  }
  render() {
    return this.init(), null;
  }
}, nc = [], Gb = (n) => {
  const i = {};
  for (const l of Object.keys(n))
    i[K1[l] || l] = n[l];
  return i;
}, Ni = (n) => {
  const i = {};
  for (const l of Object.keys(n)) {
    const o = Cc[l];
    i[o || l] = n[l];
  }
  return i;
}, Yb = (n, i) => {
  if (!Wf)
    return;
  const l = document.getElementsByTagName(n)[0];
  if (!l)
    return;
  const o = "data-rh-managed", d = l.getAttribute(o), f = d ? d.split(",") : [], h = Object.keys(i);
  for (const p of f)
    h.includes(p) || l.removeAttribute(p);
  for (const p of h) {
    const g = i[p];
    g == null || g === !1 ? l.removeAttribute(p) : g === !0 ? l.setAttribute(p, "") : l.setAttribute(p, String(g));
  }
  h.length > 0 ? l.setAttribute(o, h.join(",")) : l.removeAttribute(o);
}, yh = () => {
  const n = {}, i = {};
  for (const l of nc) {
    const { htmlAttributes: o, bodyAttributes: d } = l.props;
    o && Object.assign(n, Gb(o)), d && Object.assign(i, Gb(d));
  }
  Yb("html", n), Yb("body", i);
}, oC = class extends E.Component {
  componentDidMount() {
    nc.push(this), yh();
  }
  componentDidUpdate() {
    yh();
  }
  componentWillUnmount() {
    const n = nc.indexOf(this);
    n !== -1 && nc.splice(n, 1), yh();
  }
  resolveTitle() {
    const { title: n, titleTemplate: i, defaultTitle: l } = this.props;
    return n && i ? i.replace(/%s/g, () => Array.isArray(n) ? n.join("") : n) : n || l || void 0;
  }
  renderTitle() {
    const n = this.resolveTitle();
    if (n === void 0)
      return null;
    const i = this.props.titleAttributes || {};
    return Z.createElement("title", Ni(i), n);
  }
  renderBase() {
    const { base: n } = this.props;
    return n ? Z.createElement("base", Ni(n)) : null;
  }
  renderMeta() {
    const { meta: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map(
      (i, l) => Z.createElement("meta", {
        key: l,
        ...Ni(i)
      })
    );
  }
  renderLink() {
    const { link: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map(
      (i, l) => Z.createElement("link", {
        key: l,
        ...Ni(i)
      })
    );
  }
  renderScript() {
    const { script: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map((i, l) => {
      const { innerHTML: o, ...d } = i, f = Ni(d);
      return o && (f.dangerouslySetInnerHTML = { __html: o }), Z.createElement("script", { key: l, ...f });
    });
  }
  renderStyle() {
    const { style: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map((i, l) => {
      const { cssText: o, ...d } = i, f = Ni(d);
      return o && (f.dangerouslySetInnerHTML = { __html: o }), Z.createElement("style", { key: l, ...f });
    });
  }
  renderNoscript() {
    const { noscript: n } = this.props;
    return !n || !Array.isArray(n) ? null : n.map((i, l) => {
      const { innerHTML: o, ...d } = i, f = Ni(d);
      return o && (f.dangerouslySetInnerHTML = { __html: o }), Z.createElement("noscript", { key: l, ...f });
    });
  }
  render() {
    return Z.createElement(
      Z.Fragment,
      null,
      this.renderTitle(),
      this.renderBase(),
      this.renderMeta(),
      this.renderLink(),
      this.renderScript(),
      this.renderStyle(),
      this.renderNoscript()
    );
  }
}, cC = class extends E.Component {
  static defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
  };
  shouldComponentUpdate(n) {
    return !V6(Pb(this.props, "helmetData"), Pb(n, "helmetData"));
  }
  mapNestedChildrenToProps(n, i) {
    if (!i)
      return null;
    switch (n.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: i
        };
      case "style":
        return {
          cssText: i
        };
      default:
        throw new Error(
          `<${n.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(n, i, l, o) {
    return {
      ...i,
      [n.type]: [
        ...i[n.type] || [],
        {
          ...l,
          ...this.mapNestedChildrenToProps(n, o)
        }
      ]
    };
  }
  mapObjectTypeChildren(n, i, l, o) {
    switch (n.type) {
      case "title":
        return {
          ...i,
          [n.type]: o,
          titleAttributes: { ...l }
        };
      case "body":
        return {
          ...i,
          bodyAttributes: { ...l }
        };
      case "html":
        return {
          ...i,
          htmlAttributes: { ...l }
        };
      default:
        return {
          ...i,
          [n.type]: { ...l }
        };
    }
  }
  mapArrayTypeChildrenToProps(n, i) {
    let l = { ...i };
    return Object.keys(n).forEach((o) => {
      l = {
        ...l,
        [o]: n[o]
      };
    }), l;
  }
  warnOnInvalidChildren(n, i) {
    return Hb(
      Lb.some((l) => n.type === l),
      typeof n.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : `Only elements types ${Lb.join(
        ", "
      )} are allowed. Helmet does not support rendering <${n.type}> elements. Refer to our API for more information.`
    ), Hb(
      !i || typeof i == "string" || Array.isArray(i) && !i.some((l) => typeof l != "string"),
      `Helmet expects a string as a child of <${n.type}>. Did you forget to wrap your children in braces? ( <${n.type}>{\`\`}</${n.type}> ) Refer to our API for more information.`
    ), !0;
  }
  mapChildrenToProps(n, i) {
    let l = {};
    return Z.Children.forEach(n, (o) => {
      if (!o || !o.props)
        return;
      const { children: d, ...f } = o.props, h = Object.keys(f).reduce((g, m) => (g[K1[m] || m] = f[m], g), {});
      let { type: p } = o;
      switch (typeof p == "symbol" ? p = p.toString() : this.warnOnInvalidChildren(o, d), p) {
        case "Symbol(react.fragment)":
          i = this.mapChildrenToProps(d, i);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          l = this.flattenArrayTypeChildren(
            o,
            l,
            h,
            d
          );
          break;
        default:
          i = this.mapObjectTypeChildren(o, i, h, d);
          break;
      }
    }), this.mapArrayTypeChildrenToProps(l, i);
  }
  render() {
    const { children: n, ...i } = this.props;
    let l = { ...i }, { helmetData: o } = i;
    if (n && (l = this.mapChildrenToProps(n, l)), o && !(o instanceof of)) {
      const d = o;
      o = new of(d.context, !0), delete l.helmetData;
    }
    return cf ? /* @__PURE__ */ Z.createElement(oC, { ...l }) : o ? /* @__PURE__ */ Z.createElement(qb, { ...l, context: o.value }) : /* @__PURE__ */ Z.createElement(ew.Consumer, null, (d) => /* @__PURE__ */ Z.createElement(qb, { ...l, context: d }));
  }
};
const uC = E.lazy(() => Promise.resolve().then(() => TC)), dC = E.lazy(() => Promise.resolve().then(() => kC)), hC = E.lazy(() => Promise.resolve().then(() => RC)), Qb = E.lazy(() => Promise.resolve().then(() => HC)), Zb = E.lazy(() => Promise.resolve().then(() => GC)), Xb = E.lazy(() => Promise.resolve().then(() => XC)), Kb = E.lazy(() => Promise.resolve().then(() => WC)), $b = E.lazy(() => Promise.resolve().then(() => nE)), bh = E.lazy(() => Promise.resolve().then(() => rE)), Wb = E.lazy(() => Promise.resolve().then(() => dE)), Jb = E.lazy(() => Promise.resolve().then(() => pE)), ev = E.lazy(() => Promise.resolve().then(() => yE)), tv = E.lazy(() => Promise.resolve().then(() => vE)), nv = E.lazy(() => Promise.resolve().then(() => jE)), av = E.lazy(() => Promise.resolve().then(() => NE)), iv = E.lazy(() => Promise.resolve().then(() => ME));
function fC() {
  return /* @__PURE__ */ s.jsx("div", { className: "min-h-screen flex items-center justify-center bg-[#0a0a0a]", children: /* @__PURE__ */ s.jsx("div", { className: "w-8 h-8 border-2 border-[#FF6B35] border-t-transparent rounded-full animate-spin" }) });
}
function mC() {
  const n = window.__SHOOTZ_PRODUCT__, i = window.__SHOOTZ_PRODUCTS__?.tripod;
  return !!(n && i && n.id === i.id || n?.handle === "shootzinsight-r1-professional-tripod" || window.location.pathname.includes("shootzinsight-r1-professional-tripod")) ? /* @__PURE__ */ s.jsx(hC, {}) : /* @__PURE__ */ s.jsx(dC, {});
}
function pC() {
  return /* @__PURE__ */ s.jsx(E.Suspense, { fallback: /* @__PURE__ */ s.jsx(fC, {}), children: /* @__PURE__ */ s.jsxs(OT, { children: [
    /* @__PURE__ */ s.jsx(Fe, { path: "/", component: uC }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/products/:handle", component: mC }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/sports/basketball", component: Qb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/basketball", component: Qb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/users/parents", component: Zb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/parents", component: Zb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/users/coaches", component: Xb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/coaches", component: Xb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/users/players", component: $b }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/players", component: $b }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/users/clubs", component: Kb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/clubs", component: Kb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/about", component: bh }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/about", component: bh }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/about-us", component: bh }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/help/guide", component: Wb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/user-guide", component: Wb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/help/faq", component: Jb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/faq", component: Jb }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/help/contact", component: ev }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/contact", component: ev }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/privacy", component: tv }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/privacy-policy", component: tv }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/terms", component: nv }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/terms-of-service", component: nv }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/refund", component: av }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/refund-policy", component: av }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pricing", component: iv }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/pages/pricing", component: iv }),
    /* @__PURE__ */ s.jsx(Fe, { path: "/404", component: vy }),
    /* @__PURE__ */ s.jsx(Fe, { component: vy })
  ] }) });
}
function gC() {
  return /* @__PURE__ */ s.jsx(RT, { children: /* @__PURE__ */ s.jsx(tw, { children: /* @__PURE__ */ s.jsx(DT, { defaultTheme: "dark", children: /* @__PURE__ */ s.jsx(BT, { children: /* @__PURE__ */ s.jsxs(SN, { children: [
    /* @__PURE__ */ s.jsx(iS, {}),
    /* @__PURE__ */ s.jsx(pC, {}),
    /* @__PURE__ */ s.jsx(D6, {})
  ] }) }) }) }) });
}
const sv = document.getElementById("root");
sv && Nj.createRoot(sv).render(/* @__PURE__ */ s.jsx(gC, {}));
const xC = window.__SHOOTZ_CONFIG__?.logoUrl || "/shootzinsight-logo-light.png", rv = [
  {
    label: "Products",
    groups: [
      { links: [
        { href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", label: "ShootzInsight Q1" }
      ] }
    ]
  },
  {
    label: "Accessories",
    groups: [
      { links: [
        { href: window.__SHOOTZ_CONFIG__?.r1Url || "/products/shootzinsight-r1-professional-tripod", label: "ShootzInsight R1 Tripod" }
      ] }
    ]
  },
  {
    label: "Sports & Users",
    groups: [
      { title: "Sports", links: [{ href: "/pages/basketball", label: "Basketball" }] },
      {
        title: "Users",
        links: [
          { href: "/pages/parents", label: "Parents" },
          { href: "/pages/coaches", label: "Coaches" },
          { href: "/pages/players", label: "Players" },
          { href: "/pages/clubs", label: "Clubs & Leagues" }
        ]
      }
    ]
  },
  {
    label: "Explore",
    groups: [
      { links: [
        { href: "/pages/about-us", label: "About Us" }
      ] }
    ]
  },
  { label: "Pricing & Plans", href: "/pricing" },
  {
    label: "Help Center",
    groups: [
      {
        links: [
          { href: "/pages/user-guide", label: "User Guide" },
          { href: "/pages/faq", label: "FAQ" },
          { href: "/pages/contact", label: "Contact Us" }
        ]
      }
    ]
  }
];
function lv(n) {
  return "groups" in n;
}
function yC() {
  const { openCart: n, itemCount: i } = ul();
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: n,
      className: "relative p-2 rounded-lg hover:bg-white/5 transition-colors",
      "aria-label": "Open cart",
      children: [
        /* @__PURE__ */ s.jsx(nl, { size: 20, className: "text-white/80" }),
        i > 0 && /* @__PURE__ */ s.jsx("span", { className: "absolute -top-0.5 -right-0.5 w-4 h-4 bg-[#FF6B35] text-white text-[10px] font-bold rounded-full flex items-center justify-center", children: i > 9 ? "9+" : i })
      ]
    }
  );
}
function rn() {
  const [n, i] = E.useState(!1), [l, o] = E.useState(null), [d, f] = E.useState(null), [h] = o0(), p = E.useRef(null), g = (b) => {
    p.current && clearTimeout(p.current), o(b);
  }, m = () => {
    p.current = setTimeout(() => o(null), 150);
  };
  return E.useEffect(() => {
    i(!1), o(null);
  }, [h]), /* @__PURE__ */ s.jsxs("nav", { className: "fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-white/5", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto flex items-center justify-between h-16 lg:h-[72px]", children: [
      /* @__PURE__ */ s.jsx(Ne, { href: "/", className: "flex items-center gap-2.5 shrink-0", children: /* @__PURE__ */ s.jsx("img", { src: xC, alt: "ShootzInsight", className: "h-10 w-auto max-w-[210px] object-contain invert" }) }),
      /* @__PURE__ */ s.jsx("div", { className: "hidden lg:flex items-center gap-1", children: rv.map((b) => lv(b) ? /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: "relative",
          onMouseEnter: () => g(b.label),
          onMouseLeave: m,
          children: [
            /* @__PURE__ */ s.jsxs(
              "button",
              {
                className: `flex items-center gap-1 px-4 py-2 text-sm font-medium transition-colors hover:text-[#FF6B35] ${l === b.label ? "text-[#FF6B35]" : "text-white/80"}`,
                children: [
                  b.label,
                  /* @__PURE__ */ s.jsx(
                    Jr,
                    {
                      size: 14,
                      className: `transition-transform duration-200 ${l === b.label ? "rotate-180" : ""}`
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx(Kr, { children: l === b.label && /* @__PURE__ */ s.jsx(
              C.div,
              {
                initial: { opacity: 0, y: 8 },
                animate: { opacity: 1, y: 0 },
                exit: { opacity: 0, y: 8 },
                transition: { duration: 0.18, ease: [0.23, 1, 0.32, 1] },
                className: "absolute top-full left-0 mt-1 min-w-[200px] bg-[#141414] border border-white/10 rounded-xl shadow-2xl overflow-hidden",
                children: /* @__PURE__ */ s.jsx("div", { className: "p-3", children: b.groups.map((y, w) => /* @__PURE__ */ s.jsxs("div", { children: [
                  y.title && /* @__PURE__ */ s.jsx("p", { className: "px-3 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40", children: y.title }),
                  y.links.map((N) => /* @__PURE__ */ s.jsx(
                    Ne,
                    {
                      href: N.href,
                      className: `block px-3 py-2 text-sm rounded-lg transition-colors hover:bg-white/5 hover:text-[#FF6B35] ${h === N.href ? "text-[#FF6B35]" : "text-white/70"}`,
                      children: N.label
                    },
                    N.href
                  ))
                ] }, w)) })
              }
            ) })
          ]
        },
        b.label
      ) : /* @__PURE__ */ s.jsx(
        Ne,
        {
          href: b.href,
          className: `px-4 py-2 text-sm font-medium transition-colors hover:text-[#FF6B35] ${h === b.href ? "text-[#FF6B35]" : "text-white/80"}`,
          children: b.label
        },
        b.label
      )) }),
      /* @__PURE__ */ s.jsxs("div", { className: "hidden lg:flex items-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          "a",
          {
            href: window.__SHOOTZ_CONFIG__?.accountUrl || "/account",
            className: "p-2 rounded-lg hover:bg-white/5 transition-colors",
            "aria-label": "My Account",
            title: "My Account",
            children: /* @__PURE__ */ s.jsx(dy, { size: 20, className: "text-white/80" })
          }
        ),
        /* @__PURE__ */ s.jsx(yC, {}),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
            className: "flex h-11 w-[120px] items-center justify-center bg-[#FF6B35] text-white text-xs font-semibold rounded-lg hover:bg-[#D94F22] transition-all active:scale-[0.97]",
            children: "Buy Q1 - $199"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: "lg:hidden text-white p-2",
          onClick: () => i(!n),
          "aria-label": "Toggle menu",
          children: n ? /* @__PURE__ */ s.jsx(vf, { size: 24 }) : /* @__PURE__ */ s.jsx(ZN, { size: 24 })
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(Kr, { children: n && /* @__PURE__ */ s.jsx(
      C.div,
      {
        initial: { opacity: 0, height: 0 },
        animate: { opacity: 1, height: "auto" },
        exit: { opacity: 0, height: 0 },
        transition: { duration: 0.25, ease: [0.23, 1, 0.32, 1] },
        className: "lg:hidden bg-[#0a0a0a]/98 backdrop-blur-xl border-b border-white/5 overflow-hidden",
        children: /* @__PURE__ */ s.jsxs("div", { className: "container py-4 flex flex-col gap-1", children: [
          rv.map((b) => {
            if (!lv(b))
              return /* @__PURE__ */ s.jsx(
                Ne,
                {
                  href: b.href,
                  className: "py-3 px-2 text-base font-medium text-white/80 hover:text-[#FF6B35] transition-colors",
                  onClick: () => i(!1),
                  children: b.label
                },
                b.label
              );
            const y = d === b.label;
            return /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs(
                "button",
                {
                  className: "w-full flex items-center justify-between py-3 px-2 text-base font-medium text-white/80 hover:text-[#FF6B35] transition-colors",
                  onClick: () => f(y ? null : b.label),
                  children: [
                    b.label,
                    /* @__PURE__ */ s.jsx(
                      Jr,
                      {
                        size: 16,
                        className: `transition-transform duration-200 ${y ? "rotate-180" : ""}`
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ s.jsx(Kr, { children: y && /* @__PURE__ */ s.jsx(
                C.div,
                {
                  initial: { opacity: 0, height: 0 },
                  animate: { opacity: 1, height: "auto" },
                  exit: { opacity: 0, height: 0 },
                  className: "overflow-hidden",
                  children: /* @__PURE__ */ s.jsx("div", { className: "pl-4 pb-2", children: b.groups.map((w, N) => /* @__PURE__ */ s.jsxs("div", { children: [
                    w.title && /* @__PURE__ */ s.jsx("p", { className: "px-2 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-white/40", children: w.title }),
                    w.links.map((T) => /* @__PURE__ */ s.jsx(
                      Ne,
                      {
                        href: T.href,
                        className: "block px-2 py-2 text-sm text-white/60 hover:text-[#FF6B35] transition-colors",
                        onClick: () => i(!1),
                        children: T.label
                      },
                      T.href
                    ))
                  ] }, N)) })
                }
              ) })
            ] }, b.label);
          }),
          /* @__PURE__ */ s.jsxs(
            "a",
            {
              href: window.__SHOOTZ_CONFIG__?.accountUrl || "/account",
              className: "py-3 px-2 text-base font-medium text-white/80 hover:text-[#FF6B35] transition-colors flex items-center gap-2",
              children: [
                /* @__PURE__ */ s.jsx(dy, { size: 18 }),
                " My Account"
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(
            Ne,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
              className: "mt-3 px-5 py-3 bg-[#FF6B35] text-white text-sm font-semibold rounded-lg text-center",
              onClick: () => i(!1),
              children: "Buy Q1 - $199"
            }
          )
        ] })
      }
    ) })
  ] });
}
const bC = window.__SHOOTZ_CONFIG__?.logoUrl || "/shootzinsight-logo-light.png", vC = {
  Products: [
    { href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", label: "ShootzInsight Q1" },
    { href: window.__SHOOTZ_CONFIG__?.r1Url || "/products/shootzinsight-r1-professional-tripod", label: "R1 Tripod" },
    { href: "/pricing", label: "Pricing & Plans" }
  ],
  Support: [
    { href: "/pages/user-guide", label: "User Guide" },
    { href: "/pages/faq", label: "FAQ" },
    { href: "/pages/refund-policy", label: "Shipping & Returns" },
    { href: "/pages/contact", label: "Contact Us" }
  ],
  Resources: [
    { href: "/pages/faq#accuracy-test-methodology", label: "Accuracy & Test Methodology" },
    { href: "/pricing#credits-billing", label: "Credits & Billing" },
    { href: "/pages/basketball", label: "Basketball" },
    { href: "/pages/about-us", label: "Our Story" }
  ],
  Company: [
    { href: "/pages/parents", label: "Parents" },
    { href: "/pages/players", label: "Players" },
    { href: "/pages/coaches", label: "Coaches" },
    { href: "/pages/clubs", label: "Clubs & Leagues" }
  ]
}, wC = [
  { icon: uT, title: "Free Shipping", detail: "Available in the US" },
  { icon: eT, title: "30-Day Returns", detail: "Hassle-free returns" },
  { icon: aT, title: "Secure Payments", detail: "Protected checkout" },
  { icon: LN, title: "Customer Support", detail: "Help when you need it" }
];
function ln() {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("section", { id: "newsletter", className: "border-y border-white/[0.08] bg-[#202020]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto grid gap-8 py-10 md:grid-cols-[0.8fr_1.2fr] md:items-center md:py-12", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-2xl font-bold text-white md:text-3xl", children: "Don't Miss the Action" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-sm text-white/50", children: "Get product updates, game-film tips, and ShootzInsight news." })
      ] }),
      /* @__PURE__ */ s.jsxs("form", { method: "post", action: "/contact#newsletter", acceptCharset: "UTF-8", className: "flex flex-col gap-3 sm:flex-row", children: [
        /* @__PURE__ */ s.jsx("input", { type: "hidden", name: "form_type", value: "customer" }),
        /* @__PURE__ */ s.jsx("input", { type: "hidden", name: "contact[tags]", value: "newsletter" }),
        /* @__PURE__ */ s.jsx("label", { htmlFor: "footer-email", className: "sr-only", children: "Email address" }),
        /* @__PURE__ */ s.jsxs("div", { className: "relative flex-1", children: [
          /* @__PURE__ */ s.jsx(Xv, { size: 18, className: "pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-white/35" }),
          /* @__PURE__ */ s.jsx("input", { id: "footer-email", name: "contact[email]", type: "email", autoComplete: "email", required: !0, placeholder: "Enter your email", className: "h-12 w-full rounded-lg border border-white/15 bg-[#151515] pl-12 pr-4 text-sm text-white outline-none placeholder:text-white/35 focus:border-[#FF6B35]" })
        ] }),
        /* @__PURE__ */ s.jsx("button", { type: "submit", className: "h-12 rounded-lg bg-[#FF6B35] px-7 text-sm font-semibold text-white transition-colors hover:bg-[#D94F22]", children: "Subscribe" })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("footer", { className: "bg-[#0d0d0d]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto py-14 md:py-16", children: [
      /* @__PURE__ */ s.jsx("div", { className: "grid gap-6 border-b border-white/[0.08] pb-10 sm:grid-cols-2 lg:grid-cols-4", children: wC.map((n) => {
        const i = n.icon;
        return /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-4", children: [
          /* @__PURE__ */ s.jsx(i, { size: 24, className: "shrink-0 text-[#FF6B35]", "aria-hidden": "true" }),
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-sm font-semibold text-white", children: n.title }),
            /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-white/40", children: n.detail })
          ] })
        ] }, n.title);
      }) }),
      /* @__PURE__ */ s.jsxs("div", { className: "grid gap-10 py-12 md:grid-cols-2 lg:grid-cols-6", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "lg:col-span-2", children: [
          /* @__PURE__ */ s.jsx(Ne, { href: "/", className: "inline-flex", children: /* @__PURE__ */ s.jsx("img", { src: bC, alt: "ShootzInsight", className: "h-11 w-auto max-w-[220px] object-contain invert" }) }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-5 max-w-sm text-sm leading-relaxed text-white/50", children: "Q1 is built for basketball today and uses your iPhone to record. Soccer, tennis and badminton are planned for late 2026." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-xs font-semibold uppercase tracking-[0.16em] text-[#FF6B35]", children: "iPhone app coming soon" })
        ] }),
        Object.entries(vC).map(([n, i]) => /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-semibold text-white", children: n }),
          /* @__PURE__ */ s.jsx("ul", { className: "mt-5 space-y-3", children: i.map((l) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(Ne, { href: l.href, className: "text-sm text-white/45 transition-colors hover:text-[#FF6B35]", children: l.label }) }, l.href)) })
        ] }, n))
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-4 border-t border-white/[0.08] pt-7 text-xs text-white/30 md:flex-row md:items-center md:justify-between", children: [
        /* @__PURE__ */ s.jsxs("p", { children: [
          "© ",
          (/* @__PURE__ */ new Date()).getFullYear(),
          " ShootzInsight. All rights reserved."
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex flex-wrap gap-x-6 gap-y-3", children: [
          /* @__PURE__ */ s.jsx(Ne, { href: "/pages/privacy-policy", className: "hover:text-white/60", children: "Privacy" }),
          /* @__PURE__ */ s.jsx(Ne, { href: "/pages/terms-of-service", className: "hover:text-white/60", children: "Terms" }),
          /* @__PURE__ */ s.jsx(Ne, { href: "/pages/refund-policy", className: "hover:text-white/60", children: "Returns" })
        ] })
      ] })
    ] }) })
  ] });
}
const Ti = {
  siteName: "ShootzInsight",
  title: "ShootzInsight - Know Your Game",
  description: "AI-powered basketball recording system. AI Moments, Game Analytics, and One-Tap Highlights — delivered seconds after the buzzer. Know your game.",
  image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/hero_basketball_court-TdZ5WUpkXHUqGR6j6NFpFr.webp",
  baseUrl: typeof window < "u" ? window.location.origin : ""
};
function on({
  title: n,
  description: i,
  keywords: l,
  image: o,
  url: d
}) {
  const f = n ? `${n} | ${Ti.siteName}` : Ti.title, h = i || Ti.description, p = o || Ti.image, g = d ? `${Ti.baseUrl}${d}` : Ti.baseUrl;
  return /* @__PURE__ */ s.jsxs(cC, { children: [
    /* @__PURE__ */ s.jsx("title", { children: f }),
    /* @__PURE__ */ s.jsx("meta", { name: "description", content: h }),
    l && /* @__PURE__ */ s.jsx("meta", { name: "keywords", content: l }),
    /* @__PURE__ */ s.jsx("link", { rel: "canonical", href: g }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:type", content: "website" }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:site_name", content: Ti.siteName }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:title", content: f }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:description", content: h }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:image", content: p }),
    /* @__PURE__ */ s.jsx("meta", { property: "og:url", content: g }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:card", content: "summary_large_image" }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:title", content: f }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:description", content: h }),
    /* @__PURE__ */ s.jsx("meta", { name: "twitter:image", content: p })
  ] });
}
const Gt = window.__SHOOTZ_CONFIG__?.media, jC = window.__SHOOTZ_CONFIG__?.heroUrl || Gt?.homeRecord || "/q1-pricing.png", SC = "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/feature_game_analytics-9wEawaZenTiVzuxVtfHT3C.webp", ke = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
}, bn = {
  visible: { transition: { staggerChildren: 0.15 } }
};
function vh({ icon: n, title: i, description: l, accentColor: o = "#FF6B35" }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[color:var(--accent)]/20 transition-all group", style: { "--accent": o }, children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg flex items-center justify-center mb-4", style: { backgroundColor: `${o}15` }, children: /* @__PURE__ */ s.jsx(n, { size: 20, style: { color: o } }) }),
    /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-2", children: i }),
    /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: l })
  ] });
}
function NC() {
  const [n, i] = E.useState(null);
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { description: "AI-powered basketball recording system. Mount your phone, record every play, analyze with AI Moments and Game Analytics, share one-tap Highlights — delivered seconds after the buzzer. Know your game.", keywords: "basketball recording system, AI sports tracking, automatic highlights, game analytics, sports video analysis, basketball moments", url: "/" }),
    /* @__PURE__ */ s.jsxs("section", { className: "relative min-h-screen flex items-center justify-center overflow-hidden", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "absolute inset-0", children: [
        /* @__PURE__ */ s.jsx("img", { src: jC, alt: "", className: "w-full h-full object-cover opacity-40" }),
        /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/60 via-[#0a0a0a]/30 to-[#0a0a0a]" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "relative z-10 container mx-auto text-center pt-20",
          initial: "hidden",
          animate: "visible",
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(
              C.p,
              {
                variants: ke,
                className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-4",
                children: "Q1 + iPhone + Basketball AI"
              }
            ),
            /* @__PURE__ */ s.jsxs(
              C.h1,
              {
                variants: ke,
                className: "font-[family-name:var(--font-display)] text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-[0.95] tracking-tight",
                children: [
                  "Record the Game.",
                  /* @__PURE__ */ s.jsx("br", {}),
                  /* @__PURE__ */ s.jsx("span", { className: "text-gradient-orange", children: "Know the Scorers." })
                ]
              }
            ),
            /* @__PURE__ */ s.jsx(
              C.p,
              {
                variants: ke,
                className: "mt-6 text-white/60 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed",
                children: "ShootzInsight Q1 works with your iPhone to record full-court basketball. Together, Q1 and the ShootzInsight app track the action, detect made baskets at 99% accuracy, and deliver scoring clips, player highlights and game analytics after processing."
              }
            ),
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "mt-10 flex flex-col sm:flex-row items-center justify-center gap-4", children: [
              /* @__PURE__ */ s.jsx(
                Ne,
                {
                  href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
                  className: "px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg glow-orange hover:scale-105 transition-transform text-base",
                  children: "Buy Q1 - $199"
                }
              ),
              /* @__PURE__ */ s.jsxs(
                Ne,
                {
                  href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
                  className: "px-8 py-4 border border-white/20 text-white font-medium rounded-lg hover:border-[#FF6B35]/50 hover:text-[#FF6B35] transition-all text-base flex items-center gap-2",
                  children: [
                    /* @__PURE__ */ s.jsx(Rh, { size: 18 }),
                    " Watch the 30-sec Scoring Moments Demo"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx(
              C.div,
              {
                variants: ke,
                className: "mt-16 grid grid-cols-2 gap-6 max-w-2xl mx-auto sm:grid-cols-4 sm:gap-8",
                children: [
                  { value: "20,000", label: "Court Test Environments*" },
                  { value: "97%", label: "Full-Court Tracking*" },
                  { value: "99%", label: "Made-Basket Detection" },
                  { value: "INCLUDED", label: "AI Moments" }
                ].map((l) => /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
                  /* @__PURE__ */ s.jsx("p", { className: "font-[family-name:var(--font-mono)] text-2xl md:text-3xl font-bold text-[#FF6B35]", children: l.value }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-1", children: l.label })
                ] }, l.label))
              }
            ),
            /* @__PURE__ */ s.jsxs(
              C.div,
              {
                variants: ke,
                className: "mt-10 flex flex-wrap items-center justify-center gap-6 text-white/50 text-sm",
                children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "Free AI Moments" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "30-Day Money-Back" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "1-Year Warranty" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ s.jsx("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ s.jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }),
                    /* @__PURE__ */ s.jsx("span", { children: "Free Shipping (US)" })
                  ] })
                ]
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce", children: /* @__PURE__ */ s.jsx("div", { className: "w-6 h-10 border-2 border-white/20 rounded-full flex items-start justify-center pt-2", children: /* @__PURE__ */ s.jsx("div", { className: "w-1.5 h-3 bg-[#FF6B35] rounded-full" }) }) })
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "border-b border-white/[0.07] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-12 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "From Buzzer to Box Score" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: "One connected result chain" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "grid gap-5 md:grid-cols-2 lg:grid-cols-4", children: [
        { step: "01", title: "Record", desc: "Set up Q1 with your iPhone and record the basketball game hands-free.", image: Gt?.homeRecord },
        { step: "02", title: "Detect", desc: "Made-basket moments are identified and clipped automatically after processing.", image: Gt?.aiMoments },
        { step: "03", title: "Understand", desc: "Review points, FG%, and 3PT / 2PT / FT breakdowns linked to video.", image: Gt?.gameAnalytics },
        { step: "04", title: "Share", desc: "Turn selected plays into a share-ready highlight.", image: Gt?.oneTapHighlight }
      ].map((l) => /* @__PURE__ */ s.jsxs("article", { className: "overflow-hidden rounded-lg border border-white/10 bg-white/[0.02]", children: [
        l.image && /* @__PURE__ */ s.jsx("img", { src: l.image, alt: `ShootzInsight ${l.title.toLowerCase()} workflow example`, loading: "lazy", className: "aspect-[14/9] w-full object-cover" }),
        /* @__PURE__ */ s.jsxs("div", { className: "p-5", children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold text-[#FF6B35]", children: l.step }),
          /* @__PURE__ */ s.jsx("h3", { className: "mt-2 text-lg font-semibold text-white", children: l.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-sm leading-relaxed text-white/50", children: l.desc }),
          l.step !== "01" && l.image && /* @__PURE__ */ s.jsx("button", { type: "button", onClick: () => i({ src: l.image, title: `${l.title} example` }), className: "mt-4 inline-flex text-xs font-semibold text-[#FF6B35] hover:text-[#FF8A5C]", children: "View an example" })
        ] })
      ] }, l.title)) }),
      /* @__PURE__ */ s.jsx("p", { className: "mt-5 text-xs text-white/35", children: "*Based on internal testing. Results may vary by venue, lighting, iPhone placement and game conditions." })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 md:py-32 relative", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Act 1" }),
            /* @__PURE__ */ s.jsx(C.h2, { variants: ke, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "RECORD" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-white/50 text-lg max-w-2xl mx-auto", children: "Set up in 30 seconds. Capture every play automatically. Sit back and enjoy the game." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "mb-16 rounded-2xl overflow-hidden border border-white/5 aspect-[21/9] bg-white/[0.01]",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: ke,
          children: Gt?.homeRecord ? /* @__PURE__ */ s.jsx("img", { src: Gt.homeRecord, alt: "ShootzInsight Q1 recording a basketball game", className: "w-full h-full object-cover" }) : /* @__PURE__ */ s.jsx("div", { className: "h-full flex items-center justify-center text-center", children: /* @__PURE__ */ s.jsx(Wr, { size: 48, className: "text-[#FF6B35]/30 mx-auto mb-3" }) })
        }
      ),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "grid md:grid-cols-3 gap-6",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(C.div, { variants: ke, children: /* @__PURE__ */ s.jsx(
              vh,
              {
                icon: Wr,
                title: "Full-Court AI Tracking",
                description: "97% tracking accuracy across the full court — fast breaks, outlet passes, and off-ball screens won't throw it off. No blind spots, no manual panning."
              }
            ) }),
            /* @__PURE__ */ s.jsx(C.div, { variants: ke, children: /* @__PURE__ */ s.jsx(
              vh,
              {
                icon: sc,
                title: "Never Miss a Play",
                description: "Our AI-powered follow-cam keeps every play in focus throughout the match. Relive every moment in a true broadcast-style experience in the ShootzInsight App."
              }
            ) }),
            /* @__PURE__ */ s.jsx(C.div, { variants: ke, children: /* @__PURE__ */ s.jsx(
              vh,
              {
                icon: ic,
                title: "Free Live Streaming",
                description: "Stream to YouTube, Facebook, or any RTMP destination — free and unlimited. Share the game with family and fans who can't be there in person."
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "mt-12 text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: ke,
          children: /* @__PURE__ */ s.jsxs(
            Ne,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
              className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:scale-105 transition-transform text-sm",
              children: [
                "Buy ShootzInsight Q1 — $199 ",
                /* @__PURE__ */ s.jsx(Gr, { size: 16 })
              ]
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 md:py-32 relative bg-gradient-to-b from-[#0a0a0a] to-[#0a0f14]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-[#22c55e] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Act 2" }),
            /* @__PURE__ */ s.jsx(C.h2, { variants: ke, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "ANALYZE" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-white/50 text-lg max-w-2xl mx-auto", children: "AI does the work, you get the insight. Automatic events, instant stats, and personalized game breakdowns." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "mb-20",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#22c55e]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(e0, { size: 20, className: "text-[#22c55e]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "bg-green-500/10 text-green-400 text-xs font-semibold px-3 py-1 rounded-full", children: "FREE FOREVER" })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "AI MOMENTS" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Rewatch and share your best moments" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "Every made basket — automatically detected at 99% accuracy. Threes, mid-range, putbacks, and-ones — if it goes through the net, it's a Moment." })
              ] }),
              /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-white/[0.01]", children: Gt?.aiMoments && /* @__PURE__ */ s.jsx("img", { src: Gt.aiMoments, alt: "ShootzInsight AI Moments interface", className: "w-full h-full object-cover", loading: "lazy" }) })
            ] }),
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid md:grid-cols-2 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Find yourself. Find your Moments." }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "After the game, browse snapshot thumbnails of every scoring play. Find your photo, tap it, and all your Moments appear instantly — no scrubbing through hours of film." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Automatic events" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Every bucket — threes, twos, free throws — captured and organized before you leave the gym. No manual tagging required." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsx("div", { className: "order-2 lg:order-1 rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-[#070707] flex items-center justify-center", children: /* @__PURE__ */ s.jsx(
                "img",
                {
                  src: Gt?.gameAnalytics || window.__SHOOTZ_CONFIG__?.analyticsImageUrl || SC,
                  alt: "ShootzInsight game analytics dashboard",
                  className: "w-full h-full object-contain",
                  loading: "lazy"
                }
              ) }),
              /* @__PURE__ */ s.jsxs("div", { className: "order-1 lg:order-2", children: [
                /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-3 mb-4", children: /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#eab308]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Rs, { size: 20, className: "text-[#eab308]" }) }) }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "GAME ANALYTICS" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Match data on autopilot" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "Get an AI-generated box score after every game — team totals, individual scoring, and a full 3PT / 2PT / FT breakdown with FG% for every player on the floor." })
              ] })
            ] }),
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid md:grid-cols-3 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Advanced match stats, instantly" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Points, FG%, and a 3PT / 2PT / FT split for every player — each stat linked to the exact video clip. Tap a number, watch that play." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Connect Players" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "See each player's scoring line on your game film — points, FG%, threes made — real numbers tied to real plays." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Coach Assist" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Pull up any player's scoring breakdown instantly — who's hitting threes, who's getting to the line, who needs more touches. Film don't lie." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "mt-12 text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: ke,
          children: /* @__PURE__ */ s.jsxs(
            Ne,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
              className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:scale-105 transition-transform text-sm",
              children: [
                "Buy ShootzInsight Q1 — $199 ",
                /* @__PURE__ */ s.jsx(Gr, { size: 16 })
              ]
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 md:py-32 relative bg-gradient-to-b from-[#0a0f14] to-[#0a0a0a]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Act 3" }),
            /* @__PURE__ */ s.jsx(C.h2, { variants: ke, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "SHARE" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-white/50 text-lg max-w-2xl mx-auto", children: "From footage to social in one tap. Your Highlight, your recruiting tape, your live stream — delivered." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "mb-20",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#FF6B35]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Jv, { size: 20, className: "text-[#FF6B35]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-semibold px-3 py-1 rounded-full font-[family-name:var(--font-mono)]", children: "ONE-TAP" })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "PLAYER HIGHLIGHTS" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Track individual player growth" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "Individual Highlights for every player, automatically delivered from your ShootzInsight Q1 recording. One tap turns your Moments into a cinematic Highlight — landscape to vertical, slow-mo on the clutch plays, music synced to the beat." })
              ] }),
              /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-white/[0.01]", children: Gt?.oneTapHighlight && /* @__PURE__ */ s.jsx("img", { src: Gt.oneTapHighlight, alt: "ShootzInsight one-tap player highlights", className: "w-full h-full object-cover", loading: "lazy" }) })
            ] }),
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid md:grid-cols-2 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Player tracking, powered by visual detection" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Player Highlights uses visual detection — jersey numbers, apparel, and physical features — to identify every player on the court and build a playlist of their key Moments automatically." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Turn your Highlights into opportunities" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Add your best Moments, stats, and key info to a personalized profile, and share it directly with scouts, recruiters, and coaches. Your recruiting tape — done." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0, margin: "-100px" },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid lg:grid-cols-2 gap-12 items-center mb-12", children: [
              /* @__PURE__ */ s.jsx("div", { className: "order-2 lg:order-1 rounded-2xl overflow-hidden border border-white/5 shadow-2xl aspect-[4/3] bg-white/[0.01]", children: Gt?.liveStreaming && /* @__PURE__ */ s.jsx("img", { src: Gt.liveStreaming, alt: "ShootzInsight live streaming interface", className: "w-full h-full object-cover", loading: "lazy" }) }),
              /* @__PURE__ */ s.jsxs("div", { className: "order-1 lg:order-2", children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#FF6B35]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(ic, { size: 20, className: "text-[#FF6B35]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "bg-green-500/10 text-green-400 text-xs font-semibold px-3 py-1 rounded-full", children: "FREE" })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-4xl font-bold text-white mb-4", children: "SHOOTZINSIGHT LIVE" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm uppercase tracking-wider mb-4 font-[family-name:var(--font-mono)]", children: "Stream the action in real time" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-lg leading-relaxed", children: "Nothing beats watching live sports. Share every win, every loss, every moment as they happen. Stream to Facebook, YouTube, and more — instantly connecting with your fans where they already are." })
              ] })
            ] }),
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "grid md:grid-cols-2 gap-6", children: [
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Livestream to social media" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Livestream your matches on Facebook, YouTube, and more, instantly connecting with your fans where they already are. One tap to go live — no extra equipment needed." })
              ] }),
              /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-white font-semibold text-lg mb-3", children: "Keep track of score and time" }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: "Add score and time displays to your streams in just a few clicks, giving your audience the full match overview for a true live sports broadcast feel." })
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "mt-12 text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: ke,
          children: /* @__PURE__ */ s.jsxs(
            Ne,
            {
              href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
              className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:scale-105 transition-transform text-sm",
              children: [
                "Buy ShootzInsight Q1 — $199 ",
                /* @__PURE__ */ s.jsx(Gr, { size: 16 })
              ]
            }
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0f0f1a]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-sm tracking-widest uppercase mb-3", children: "Built For Everyone" }),
            /* @__PURE__ */ s.jsx(C.h2, { variants: ke, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: "WHO IS IT FOR?" })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-6",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: bn,
          children: [
            { icon: sc, title: "Parents", desc: "Find your child's made-basket moments and share the plays that matter.", href: "/pages/parents" },
            { icon: Rs, title: "Coaches", desc: "Review points, FG%, and shooting breakdowns with every result linked to film.", href: "/pages/coaches" },
            { icon: $v, title: "Clubs", desc: "Build a repeatable recording and scoring-clip workflow across your program.", href: "/pages/clubs" },
            { icon: Rh, title: "Players", desc: "Find scoring clips, review linked stats, and create a share-ready highlight.", href: "/pages/players" }
          ].map((l) => /* @__PURE__ */ s.jsx(C.div, { variants: ke, children: /* @__PURE__ */ s.jsx(Ne, { href: l.href, className: "block group", children: /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/30 transition-all h-full", children: [
            /* @__PURE__ */ s.jsx(l.icon, { size: 28, className: "text-[#FF6B35] mb-4 group-hover:scale-110 transition-transform" }),
            /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-xl font-semibold text-white mb-2", children: l.title }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: l.desc }),
            /* @__PURE__ */ s.jsxs("div", { className: "mt-4 flex items-center gap-1 text-[#FF6B35] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity", children: [
              "Learn more ",
              /* @__PURE__ */ s.jsx(Gr, { size: 14 })
            ] })
          ] }) }) }, l.title))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.07] bg-[#111318] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-10 max-w-3xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#55D681]", children: "No subscription required to start" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: "Start Recording Without a Subscription" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-base leading-relaxed text-white/50", children: "Every Q1 includes 800 bonus credits - enough for one Full Game Analysis of a video up to 80 minutes." })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "overflow-x-auto rounded-lg border border-white/10", children: /* @__PURE__ */ s.jsxs("table", { className: "w-full min-w-[680px] border-collapse text-left text-sm", children: [
        /* @__PURE__ */ s.jsx("thead", { className: "bg-white/[0.04] text-white", children: /* @__PURE__ */ s.jsxs("tr", { children: [
          /* @__PURE__ */ s.jsx("th", { className: "p-4 font-semibold", children: "Feature" }),
          /* @__PURE__ */ s.jsx("th", { className: "p-4 font-semibold", children: "Q1 included" }),
          /* @__PURE__ */ s.jsx("th", { className: "p-4 font-semibold", children: "Shootz Cloud credits" })
        ] }) }),
        /* @__PURE__ */ s.jsx("tbody", { className: "divide-y divide-white/[0.07] text-white/55", children: [
          ["Full-court tracking", !0, !1],
          ["Full-game recording, download and local storage", !0, !1],
          ["AI Moments / made-basket clips", !0, !1],
          ["Live streaming + scoreboard", !0, !1],
          ["Full video data analysis", "800 bonus credits to start", !0],
          ["Player highlight generation", "800 bonus credits to start", !0],
          ["One-Tap Highlight reel", "800 bonus credits to start", !0]
        ].map(([l, o, d]) => /* @__PURE__ */ s.jsxs("tr", { children: [
          /* @__PURE__ */ s.jsx("td", { className: "p-4 text-white/75", children: l }),
          /* @__PURE__ */ s.jsx("td", { className: "p-4", children: o === !0 ? /* @__PURE__ */ s.jsx(At, { size: 18, className: "text-[#55D681]" }) : o }),
          /* @__PURE__ */ s.jsx("td", { className: "p-4", children: d ? /* @__PURE__ */ s.jsx(At, { size: 18, className: "text-[#FF6B35]" }) : "" })
        ] }, String(l))) })
      ] }) })
    ] }) }),
    /* @__PURE__ */ s.jsxs("section", { className: "py-24 relative overflow-hidden", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-r from-[#FF6B35]/5 to-[#FFD700]/5" }),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "container mx-auto text-center relative z-10",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: bn,
          children: [
            /* @__PURE__ */ s.jsx(C.h2, { variants: ke, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-6", children: "READY TO KNOW YOUR GAME?" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: ke, className: "text-white/60 text-lg max-w-xl mx-auto mb-10", children: "AI Moments are free forever. Premium features unlock in the ShootzInsight App. Get started with Q1 — starting at $199 with free shipping, 30-day money-back guarantee, and 1-year warranty." }),
            /* @__PURE__ */ s.jsxs(C.div, { variants: ke, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
              /* @__PURE__ */ s.jsx(
                Ne,
                {
                  href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
                  className: "px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg glow-orange hover:scale-105 transition-transform text-base",
                  children: "View Product"
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ne,
                {
                  href: "/pages/user-guide",
                  className: "px-8 py-4 border border-white/20 text-white font-medium rounded-lg hover:border-[#FF6B35]/50 transition-all text-base",
                  children: "How It Works"
                }
              )
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(ln, {}),
    n && /* @__PURE__ */ s.jsx("div", { role: "dialog", "aria-modal": "true", "aria-label": n.title, className: "fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-4 backdrop-blur-sm", onClick: () => i(null), children: /* @__PURE__ */ s.jsxs("div", { className: "relative w-full max-w-5xl", onClick: (l) => l.stopPropagation(), children: [
      /* @__PURE__ */ s.jsx("button", { type: "button", onClick: () => i(null), "aria-label": "Close example", className: "absolute right-3 top-3 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/70 text-white hover:border-[#FF6B35]/70", children: /* @__PURE__ */ s.jsx(vf, { size: 20 }) }),
      /* @__PURE__ */ s.jsx("img", { src: n.src, alt: n.title, className: "max-h-[85vh] w-full rounded-lg border border-white/10 bg-[#111318] object-contain" })
    ] }) })
  ] });
}
const TC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NC
}, Symbol.toStringTag, { value: "Module" })), Pn = window.__SHOOTZ_CONFIG__?.media?.q1Gallery?.length ? window.__SHOOTZ_CONFIG__.media.q1Gallery : [
  "https://cdn.shopify.com/s/files/1/0720/0168/3530/files/UpsMejoSJxIpnZiw.png?v=1784347644",
  "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/hero_basketball_court-TdZ5WUpkXHUqGR6j6NFpFr.webp"
], nn = window.__SHOOTZ_CONFIG__?.media, ov = [
  {
    id: "q1",
    name: "Q1 Only",
    subtitle: "ShootzInsight Q1 AI Tracking System",
    price: 199,
    originalPrice: 199,
    items: ["ShootzInsight Q1 Unit", "Phone Mount Clamp", "RC1 Remote Control", "USB-C Cable"],
    badge: null
  },
  {
    id: "bundle",
    name: "Q1 + R1 Bundle",
    subtitle: "Q1 + R1 Professional Tripod",
    price: 249,
    originalPrice: 249,
    items: ["ShootzInsight Q1 Unit", "Phone Mount Clamp", "RC1 Remote Control", "R1 Professional Tripod (200cm)", "USB-C Cable"],
    badge: null
  }
], cv = [
  { label: "AI processing", value: "Q1 and the ShootzInsight iPhone App work together; no standalone AI Processor specification published" },
  { label: "Runtime", value: "Approx. 13 hours balanced and stationary without AI tracking; approx. 4 hours with AI tracking and fill light" },
  { label: "Battery", value: "7.4V / 1400mAh" },
  { label: "Charging", value: "Approx. 2.5 hours, 5V-2A" },
  { label: "Controllable angles", value: "Heading -120° to 210°; Roll -195° to 135°; Pitch -35° to 45°" },
  { label: "Expanded size", value: "127 × 65 × 312 mm" },
  { label: "Folded size", value: "98 × 44 × 160.5 mm" },
  { label: "Gimbal weight", value: "420g ±5g" },
  { label: "Magnetic tracking module", value: "13.6g" },
  { label: "Working temperature", value: "-10°C to 45°C / 14°F to 113°F" },
  { label: "Compatibility", value: "iPhone only at launch; exact models and minimum iOS version will be listed with the App Store release" }
], AC = [
  {
    q: "What's included with the ShootzInsight Q1?",
    a: "Every Q1 comes with the RC1 Bluetooth remote control (with score +/- buttons), a USB-C charging cable, and a carry pouch. The R1 tripod is available in bundle options."
  },
  {
    q: "Is AI Moments really free?",
    a: "Yes! AI Moments are free forever for all Q1 owners. Our AI automatically detects every made basket with 99% accuracy and generates your personal Moments. No subscription needed."
  },
  {
    q: "How do One-Tap Highlight and Game Analytics work?",
    a: "One-Tap Highlight and Game Analytics are premium features available through the ShootzInsight App. Subscribe to a plan in-app to unlock full access to creating cinematic Highlights and deep game analysis with detailed stats."
  },
  {
    q: "What makes ShootzInsight different from other sports recording systems?",
    a: "Most sports recording systems only record and track. ShootzInsight Q1 goes further — it automatically detects made baskets with 99% accuracy and generates free AI Moments, creates One-Tap Highlights with smart landscape-to-vertical conversion, and provides Game Analytics with a full scoring breakdown — points, FG%, and 3PT / 2PT / FT splits linked to video clips."
  },
  {
    q: "What phones are compatible?",
    a: "Q1 is iPhone-only at launch. Exact compatible models and the minimum iOS version will be published with the App Store release."
  },
  {
    q: "How long does setup take?",
    a: "Under 30 seconds. Mount Q1 on a tripod, clamp your phone, open the ShootzInsight App, connect via Bluetooth, select basketball mode, and hit record."
  },
  {
    q: "What sports does Q1 support?",
    a: "Q1 is built for basketball today. Soccer, tennis and badminton are planned for late 2026."
  },
  {
    q: "Can I use Q1 without a subscription?",
    a: "Absolutely. Q1 auto-tracks the full court and generates free AI Moments with no subscription. Recording quality depends on your phone. Subscribe only when you want One-Tap Highlights or Game Analytics."
  },
  {
    q: "How does the landscape-to-portrait conversion work?",
    a: "Our AI analyzes the action in each clip and intelligently reframes the horizontal recording into a vertical format optimized for TikTok, Instagram Reels, and Shorts — keeping the key action centered without manual cropping."
  },
  {
    q: "What is the shipping policy?",
    a: "We offer free standard shipping within the United States (5-7 business days). Expedited shipping (2-3 business days) is available for $9.99. International shipping is available to select countries — rates are calculated at checkout."
  },
  {
    q: "What is the return policy?",
    a: "We offer a 30-day money-back guarantee. If you're not satisfied with your ShootzInsight Q1, return it within 30 days of delivery in its original packaging for a full refund. Return shipping is free for US customers."
  },
  {
    q: "What does the warranty cover?",
    a: "ShootzInsight Q1 comes with a 1-year limited warranty covering manufacturing defects and hardware malfunctions under normal use. This includes the tracking motor, Bluetooth module, and phone clamp mechanism. Accidental damage and water damage are not covered."
  }
], ki = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};
function CC({ q: n, a: i }) {
  const [l, o] = E.useState(!1);
  return /* @__PURE__ */ s.jsxs("div", { className: "border-b border-white/10", children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        onClick: () => o(!l),
        className: "w-full flex items-center justify-between py-5 text-left",
        children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium pr-4", children: n }),
          l ? /* @__PURE__ */ s.jsx(Yv, { size: 18, className: "text-white/40 shrink-0" }) : /* @__PURE__ */ s.jsx(Jr, { size: 18, className: "text-white/40 shrink-0" })
        ]
      }
    ),
    l && /* @__PURE__ */ s.jsx("div", { className: "pb-5 text-white/60 text-sm leading-relaxed", children: i })
  ] });
}
function qa({
  title: n,
  subtitle: i,
  description: l,
  bullets: o,
  imagePlaceholder: d,
  imageAlt: f,
  imageSrc: h,
  reversed: p,
  accentColor: g = "#FF6B35"
}) {
  return /* @__PURE__ */ s.jsx(C.div, { variants: ki, className: "mb-20 last:mb-0", children: /* @__PURE__ */ s.jsxs("div", { className: "grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ", children: [
    /* @__PURE__ */ s.jsxs("div", { className: p ? "order-1 lg:order-2" : "order-1", children: [
      i && /* @__PURE__ */ s.jsx("p", { className: "text-sm font-semibold tracking-widest uppercase mb-3", style: { color: g }, children: i }),
      /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-2xl md:text-3xl font-bold text-white mb-4", children: n }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-base leading-relaxed mb-5", children: l }),
      o && o.length > 0 && /* @__PURE__ */ s.jsx("ul", { className: "space-y-2.5", children: o.map((m) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-3 text-white/70 text-sm", children: [
        /* @__PURE__ */ s.jsx(At, { size: 14, className: "mt-0.5 shrink-0", style: { color: g } }),
        m
      ] }, m)) })
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: `aspect-[4/3] rounded-2xl overflow-hidden bg-white/[0.02] border border-white/10 flex items-center justify-center ${p ? "order-2 lg:order-1" : "order-2"}`, children: h ? /* @__PURE__ */ s.jsx("img", { src: h, alt: f, className: "w-full h-full object-cover", loading: "lazy" }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center p-8", children: [
      /* @__PURE__ */ s.jsx(qN, { size: 40, className: "mx-auto mb-3 opacity-30", style: { color: g } }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-sm", children: d }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/20 text-xs mt-1", children: f })
    ] }) })
  ] }) });
}
function EC() {
  const n = window.__SHOOTZ_PRODUCTS__, i = window.__SHOOTZ_PRODUCT__, l = n?.q1 ?? (i?.handle !== "shootzinsight-q1-r1-bundle" ? i : null), o = n?.bundle ?? (i?.handle === "shootzinsight-q1-r1-bundle" ? i : null), d = i && o && i.id === o.id ? "bundle" : "q1", [f, h] = E.useState(d), [p, g] = E.useState("overview"), [m, b] = E.useState(0), [y, w] = E.useState(!0), { addItem: N, loading: T } = ul(), R = f === "bundle" ? o : l, _ = f === "q1" ? Pn : R?.images.length ? R.images.map((H) => H.url) : Pn, z = R?.variants.find((H) => H.availableForSale) ?? R?.variants[0], q = E.useMemo(() => {
    const H = ov.find((k) => k.id === f);
    if (!z) return H;
    const W = Number.parseFloat(z.price.amount), $ = z.compareAtPrice ? Number.parseFloat(z.compareAtPrice.amount) : H.originalPrice;
    return {
      ...H,
      price: Number.isFinite(W) ? W : H.price,
      originalPrice: Number.isFinite($) ? $ : H.originalPrice
    };
  }, [f, z]), G = async () => {
    z?.availableForSale && await N(z.id, 1);
  }, Q = [
    { id: "overview", label: "Overview" },
    { id: "specs", label: "Specs" },
    { id: "faq", label: "FAQs" }
  ];
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(
      on,
      {
        title: "Buy ShootzInsight Q1 - AI Sports Recording System",
        description: "ShootzInsight Q1: AI Moments, one-tap Highlights, and game Analytics — delivered seconds after the buzzer. Know your game. Starting at $199.",
        keywords: "buy ShootzInsight Q1, AI sports recording system, basketball tracking, auto tracking, game moments, Highlight",
        url: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1"
      }
    ),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[80px] pb-12", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs("div", { className: "grid min-w-0 lg:grid-cols-2 gap-10 lg:gap-16 items-start", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "w-full min-w-0 lg:sticky lg:top-24", children: [
        /* @__PURE__ */ s.jsx("div", { className: "aspect-square rounded-2xl overflow-hidden bg-white/[0.03] border border-white/10 mb-4", children: /* @__PURE__ */ s.jsx(
          "img",
          {
            src: _[m] || _[0],
            alt: "ShootzInsight Q1",
            className: "w-full max-w-full h-full object-contain p-8"
          }
        ) }),
        /* @__PURE__ */ s.jsx("div", { className: "flex gap-3", children: _.map((H, W) => /* @__PURE__ */ s.jsx(
          "button",
          {
            onClick: () => b(W),
            className: `w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${m === W ? "border-[#FF6B35]" : "border-white/10 hover:border-white/30"}`,
            children: /* @__PURE__ */ s.jsx("img", { src: H, alt: "", className: "w-full h-full object-cover" })
          },
          W
        )) })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "space-y-8", children: [
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] text-sm font-semibold tracking-widest uppercase mb-2", children: "SHOOTZINSIGHT Q1" }),
          /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-3", children: "ShootzInsight Q1" }),
          /* @__PURE__ */ s.jsxs("p", { className: "mb-4 text-sm font-medium text-[#55D681]", children: [
            "iPhone-only at launch · ",
            z?.availableForSale ? "In Stock" : "Sold Out"
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm leading-relaxed mb-4", children: "Basketball AI tracking, scoring moments and player highlights - Q1 works with your iPhone." }),
          /* @__PURE__ */ s.jsxs("ul", { className: "space-y-2.5 text-white/70 text-sm", children: [
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(At, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " Free AI Moments — 99% scoring detection, find yourself by snapshot"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(At, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " One-Tap Highlight — landscape-to-vertical, slow-mo, beat-synced music"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(At, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " Game Analytics — points, FG%, 3PT / 2PT / FT breakdown + linked video clips"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(At, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " Full-Court AI Tracking & Free Live Streaming"
            ] }),
            /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
              /* @__PURE__ */ s.jsx(At, { size: 14, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
              " RC1 Remote with Live Score +/- Tracking"
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsxs("p", { className: "text-white font-semibold mb-3 flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(tl, { size: 16, className: "text-[#FF6B35]" }),
            " Choose Your Setup"
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: ov.map((H) => {
            const W = H.id === "bundle" ? o : l, $ = W?.variants.find((xe) => xe.availableForSale) ?? W?.variants[0], k = !W || !$?.availableForSale, ee = $ ? Number.parseFloat($.price.amount) : H.price, ae = $?.compareAtPrice ? Number.parseFloat($.compareAtPrice.amount) : H.originalPrice, me = ae > ee ? `SAVE $${(ae - ee).toFixed(0)}` : H.badge;
            return /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: () => {
                  k || (h(H.id), b(0));
                },
                disabled: k,
                className: `w-full text-left p-4 rounded-xl border transition-all ${k ? "border-white/5 bg-white/[0.01] opacity-50 cursor-not-allowed" : f === H.id ? "border-[#FF6B35] bg-[#FF6B35]/5" : "border-white/10 bg-white/[0.02] hover:border-white/20"}`,
                children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ s.jsx("div", { className: `w-4 h-4 rounded-full border-2 flex items-center justify-center ${f === H.id ? "border-[#FF6B35]" : "border-white/30"}`, children: f === H.id && /* @__PURE__ */ s.jsx("div", { className: "w-2 h-2 rounded-full bg-[#FF6B35]" }) }),
                    /* @__PURE__ */ s.jsxs("div", { children: [
                      /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium", children: H.name }),
                      me && /* @__PURE__ */ s.jsx("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white rounded-full bg-[#FF6B35]", children: me }),
                      k && /* @__PURE__ */ s.jsx("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white/60 bg-white/10 rounded-full", children: W ? "SOLD OUT" : "NOT CONFIGURED" }),
                      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-0.5", children: H.subtitle })
                    ] })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "text-right", children: [
                    /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold", children: [
                      "$",
                      ee.toFixed(2)
                    ] }),
                    ae > ee && /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-sm line-through ml-2", children: [
                      "$",
                      ae.toFixed(2)
                    ] })
                  ] })
                ] })
              },
              H.id
            );
          }) })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "p-5 rounded-xl bg-white/[0.03] border border-white/10 space-y-3", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
            /* @__PURE__ */ s.jsx("span", { className: "text-white/60", children: q.name }),
            /* @__PURE__ */ s.jsxs("span", { className: "text-white font-medium", children: [
              "$",
              q.price.toFixed(2)
            ] })
          ] }),
          q.originalPrice > q.price && /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
            /* @__PURE__ */ s.jsxs("span", { className: "text-green-400 text-xs", children: [
              "You save $",
              (q.originalPrice - q.price).toFixed(2)
            ] }),
            /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-xs line-through", children: [
              "$",
              q.originalPrice.toFixed(2)
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "border-t border-white/10 pt-3 flex justify-between items-center", children: [
            /* @__PURE__ */ s.jsx("span", { className: "text-white font-semibold", children: "Total" }),
            /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold text-2xl", children: [
              "$",
              q.price.toFixed(2)
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: G,
              disabled: !z?.availableForSale || T,
              className: "w-full py-4 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 mt-2",
              children: [
                T ? /* @__PURE__ */ s.jsx(el, { size: 20, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(nl, { size: 20 }),
                R ? z?.availableForSale ? `Add to Cart — $${q.price.toFixed(2)}` : "Sold Out" : "Configure product in Shopify"
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs text-center", children: "30-day money-back guarantee · 1-year warranty · Free shipping (US)" })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm font-medium mb-2", children: "What's in the box:" }),
          /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap gap-2", children: q.items.map((H) => /* @__PURE__ */ s.jsx("span", { className: "px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/10 text-white/60 text-xs", children: H }, H)) })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "rounded-xl border border-white/10 overflow-hidden", children: [
          /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: () => w(!y),
              className: "w-full flex items-center justify-between p-4 bg-white/[0.03] hover:bg-white/[0.05] transition-colors",
              children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ s.jsx(Oh, { size: 18, className: "text-[#FF6B35]" }),
                  /* @__PURE__ */ s.jsx("span", { className: "text-white font-semibold text-sm", children: "Shootz Cloud — Optional AI Subscription" })
                ] }),
                y ? /* @__PURE__ */ s.jsx(Yv, { size: 16, className: "text-white/40" }) : /* @__PURE__ */ s.jsx(Jr, { size: 16, className: "text-white/40" })
              ]
            }
          ),
          y && /* @__PURE__ */ s.jsxs("div", { className: "p-4 space-y-4 border-t border-white/10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 px-3 py-2 rounded-lg bg-[#FF6B35]/10 border border-[#FF6B35]/20", children: [
              /* @__PURE__ */ s.jsx(yf, { size: 14, className: "text-[#FF6B35]" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] text-xs font-semibold", children: "Purchase includes 800 free credits to get started!" })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-white/80 text-sm font-medium mb-2", children: "Unlock the full AI experience:" }),
              /* @__PURE__ */ s.jsxs("ul", { className: "space-y-1.5", children: [
                /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2 text-white/60 text-xs", children: [
                  /* @__PURE__ */ s.jsx(At, { size: 12, className: "text-green-400 mt-0.5 shrink-0" }),
                  /* @__PURE__ */ s.jsx("span", { children: "Game Analytics — full stat reports with linked video clips (from 500 credits)" })
                ] }),
                /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2 text-white/60 text-xs", children: [
                  /* @__PURE__ */ s.jsx(At, { size: 12, className: "text-green-400 mt-0.5 shrink-0" }),
                  /* @__PURE__ */ s.jsx("span", { children: "AI Highlight Clips — auto-cut key plays (5 credits/min)" })
                ] }),
                /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2 text-white/60 text-xs", children: [
                  /* @__PURE__ */ s.jsx(At, { size: 12, className: "text-green-400 mt-0.5 shrink-0" }),
                  /* @__PURE__ */ s.jsx("span", { children: "Highlight Reel Compilation — beat-synced vertical video (2 credits/clip)" })
                ] }),
                /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2 text-white/60 text-xs", children: [
                  /* @__PURE__ */ s.jsx(At, { size: 12, className: "text-green-400 mt-0.5 shrink-0" }),
                  /* @__PURE__ */ s.jsx("span", { children: "Cloud storage, sharing links & family access" })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-white/80 text-sm font-medium mb-2", children: "Subscription Plans:" }),
              /* @__PURE__ */ s.jsxs("div", { className: "grid grid-cols-3 gap-2", children: [
                /* @__PURE__ */ s.jsxs("div", { className: "p-2.5 rounded-lg bg-white/[0.03] border border-white/10 text-center", children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/80 text-xs font-semibold", children: "Lite" }),
                  /* @__PURE__ */ s.jsxs("p", { className: "text-white font-bold text-sm mt-1", children: [
                    "$9.6",
                    /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-[10px]", children: "/mo" })
                  ] }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-[10px] mt-0.5", children: "120 credits/mo" })
                ] }),
                /* @__PURE__ */ s.jsxs("div", { className: "p-2.5 rounded-lg bg-white/[0.03] border border-[#FF6B35]/30 text-center", children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] text-xs font-semibold", children: "Plus" }),
                  /* @__PURE__ */ s.jsxs("p", { className: "text-white font-bold text-sm mt-1", children: [
                    "$88.8",
                    /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-[10px]", children: "/mo" })
                  ] }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-[10px] mt-0.5", children: "1,200 credits/mo" })
                ] }),
                /* @__PURE__ */ s.jsxs("div", { className: "p-2.5 rounded-lg bg-white/[0.03] border border-white/10 text-center", children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/80 text-xs font-semibold", children: "Max" }),
                  /* @__PURE__ */ s.jsxs("p", { className: "text-white font-bold text-sm mt-1", children: [
                    "$196.2",
                    /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-[10px]", children: "/mo" })
                  ] }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-[10px] mt-0.5", children: "3,600 credits/mo" })
                ] })
              ] }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-[10px] mt-1.5 text-center", children: "Prices shown are annual plan rates. Monthly plans also available." })
            ] }),
            /* @__PURE__ */ s.jsxs(
              "button",
              {
                type: "button",
                disabled: !0,
                className: "flex w-full cursor-not-allowed items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] py-3 text-sm font-medium text-white/45",
                children: [
                  /* @__PURE__ */ s.jsx(bc, { size: 16 }),
                  "iPhone app coming soon"
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs("p", { className: "text-white/40 text-[11px] text-center leading-relaxed", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/60 font-medium", children: "Q1 works standalone." }),
              " AI Moments are free forever. Subscription is optional for advanced cloud features."
            ] })
          ] })
        ] })
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-t border-white/10 sticky top-[64px] z-30 bg-[#0a0a0a]/95 backdrop-blur-sm", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx("div", { className: "flex overflow-x-auto", children: Q.map((H) => /* @__PURE__ */ s.jsx(
      "button",
      {
        onClick: () => g(H.id),
        className: `px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-all ${p === H.id ? "border-[#FF6B35] text-[#FF6B35]" : "border-transparent text-white/50 hover:text-white/70"}`,
        children: H.label
      },
      H.id
    )) }) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-5xl", children: [
      p === "overview" && /* @__PURE__ */ s.jsxs(C.div, { initial: "hidden", animate: "visible", variants: { visible: { transition: { staggerChildren: 0.1 } } }, children: [
        /* @__PURE__ */ s.jsxs(C.div, { variants: ki, className: "mb-20 text-center", children: [
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: [
            "WHAT SHOOTZINSIGHT Q1 IS ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "BUILT FOR" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 max-w-2xl mx-auto mb-12", children: "More than a tracker. A complete system that records every play, analyzes your performance, and delivers shareable Highlights — automatically." }),
          /* @__PURE__ */ s.jsx("div", { className: "grid md:grid-cols-3 gap-6 max-w-3xl mx-auto", children: [
            { step: "1", label: "RECORD", desc: "Full-court AI tracking captures every play automatically." },
            { step: "2", label: "ANALYZE", desc: "AI Moments and Game Analytics — delivered automatically." },
            { step: "3", label: "SHARE", desc: "One-tap Highlights and live streaming — instantly." }
          ].map((H, W) => /* @__PURE__ */ s.jsxs("div", { className: "relative p-6 rounded-2xl bg-white/[0.02] border border-white/5", children: [
            /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-full bg-[#FF6B35]/10 border border-[#FF6B35]/30 flex items-center justify-center mx-auto mb-4", children: /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-bold text-lg", children: H.step }) }),
            /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-xl font-bold text-white mb-2", children: H.label }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: H.desc }),
            W < 2 && /* @__PURE__ */ s.jsx("div", { className: "hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-white/10" })
          ] }, H.step)) })
        ] }),
        /* @__PURE__ */ s.jsxs(C.div, { variants: ki, className: "mb-8 mt-8", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-r from-transparent to-white/10" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-xs tracking-widest uppercase", children: "Record" }),
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-l from-transparent to-white/10" })
          ] }),
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4 text-center", children: [
            "CAPTURE ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "EVERY PLAY" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center mb-16 max-w-2xl mx-auto", children: "Set up in 30 seconds. Full-court AI tracking captures every play in stunning detail — hands-free, worry-free." })
        ] }),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "AI AUTO-TRACKING",
            title: "Full-court tracking, every play captured",
            description: "Q1's AI tracks the entire flow of the game across the full court — following the ball, player movement, and action zones. It adapts to different court sizes and game formats, keeping the action in frame from tip-off to final buzzer.",
            bullets: [
              "Full-court coverage — no blind spots",
              "Adapts to indoor and outdoor courts",
              "Smooth pan and tilt — no jerky movements",
              "Works for all age groups and skill levels"
            ],
            imagePlaceholder: "[Full-Court Tracking Demo]",
            imageAlt: "Show: Wide shot of basketball court with tracking overlay showing system movement path",
            imageSrc: nn?.fullCourtTracking || Pn[0],
            reversed: !0
          }
        ),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "REMOTE MONITORING",
            title: "Full control from courtside",
            description: "Preview the live footage, monitor recording status, and control Q1 directly from the ShootzInsight App on your phone. Start, stop, and adjust — all without leaving your seat.",
            bullets: [
              "Real-time live preview on your phone",
              "Start/stop recording remotely",
              "Monitor battery, storage, and connection status",
              "RC1 remote for quick physical control"
            ],
            imagePlaceholder: "[Monitor & Control Interface]",
            imageAlt: "Show: Phone screen showing live feed with recording controls overlay",
            imageSrc: nn?.monitorControl || Pn[0]
          }
        ),
        /* @__PURE__ */ s.jsxs(C.div, { variants: ki, className: "mb-8 mt-24", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-r from-transparent to-white/10" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-xs tracking-widest uppercase", children: "Analyze" }),
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-l from-transparent to-white/10" })
          ] }),
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4 text-center", children: [
            "AI DOES THE ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "ANALYSIS" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center mb-16 max-w-2xl mx-auto", children: "After the game, AI automatically detects every key event, identifies players, and generates complete game stats — delivered to your phone." })
        ] }),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "AI MOMENTS — FREE FOREVER",
            title: "Every key play, captured and sorted",
            description: "Every made basket — automatically detected at 99% accuracy. For each scoring play, AI captures a player snapshot. Find yourself in those photos, tap, and every Moment that belongs to you is right there. Free forever.",
            bullets: [
              "99% scoring detection accuracy",
              "Player snapshot by body features — find yourself instantly",
              "Moments ready before you leave the gym",
              "Browse Moments visually with thumbnail previews",
              "Free forever — no subscription required"
            ],
            imagePlaceholder: "[AI Moments Interface Screenshot]",
            imageAlt: "Show: App screen with grid of Moments thumbnails, player snapshots for selection",
            imageSrc: nn?.aiMoments || Pn[0],
            accentColor: "#22c55e"
          }
        ),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "GAME ANALYTICS",
            title: "Game data on autopilot",
            description: "Points, FG%, and a 3PT / 2PT / FT split for every player — each stat linked to the exact video clip. Tap a number, watch that play. Coaches break down film with real numbers.",
            bullets: [
              "Team stats: points, FG%, 3PT made/%, 2PT made/%, FT made/%",
              "Individual player stats with per-game tracking",
              "Every stat linked to its video clip — tap to jump to that play",
              "Coach Assist — AI-powered tactical suggestions",
              "Export reports for coaches and recruiting profiles"
            ],
            imagePlaceholder: "[Game Analytics Dashboard Screenshot]",
            imageAlt: "Show: Analytics dashboard with team comparison stats and linked video clips",
            imageSrc: nn?.gameAnalytics || Pn[0],
            reversed: !0,
            accentColor: "#eab308"
          }
        ),
        /* @__PURE__ */ s.jsxs(C.div, { variants: ki, className: "mb-8 mt-24", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-r from-transparent to-white/10" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-[family-name:var(--font-mono)] text-xs tracking-widest uppercase", children: "Share" }),
            /* @__PURE__ */ s.jsx("div", { className: "h-px flex-1 bg-gradient-to-l from-transparent to-white/10" })
          ] }),
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4 text-center", children: [
            "SHARE YOUR ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "HIGHLIGHTS" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center mb-16 max-w-2xl mx-auto", children: "From raw footage to share-ready content — your Highlight, your social media posts, your recruiting tape. Done in one tap." })
        ] }),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "ONE-TAP HIGHLIGHT",
            title: "Your Moments, one cinematic Highlight",
            description: "One tap turns your Moments into a Highlight — landscape to vertical, slow-mo on the clutch plays, music synced to the beat. Your recruiting tape, your social content — done. On TikTok and Instagram before you leave the court.",
            bullets: [
              "Smart landscape-to-vertical reframe — AI keeps the action centered",
              "Slow-mo on key plays, beat-synced music",
              "Dynamic transitions & cinematic effects",
              "Export in HD — perfect for recruiting or social media",
              "Build a season-long Highlight portfolio automatically"
            ],
            imagePlaceholder: "[One-Tap Highlight Interface Screenshot]",
            imageAlt: "Show: Before/after of landscape game footage converted to vertical Highlight with effects",
            imageSrc: nn?.oneTapHighlight || Pn[0],
            accentColor: "#FF6B35"
          }
        ),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "FREE LIVE STREAMING",
            title: "Stream every game, free and unlimited",
            description: "ShootzInsight Live delivers free, seamless streaming with one-tap broadcasting to YouTube, Facebook, and full RTMP support. Share the game with family and fans who can't be there in person — no subscription, no limits.",
            bullets: [
              "One-tap streaming to YouTube, Facebook, and custom RTMP",
              "Free and unlimited — no monthly fees",
              "Share a link with family and friends instantly",
              "Stream while recording — no compromise"
            ],
            imagePlaceholder: "[Live Streaming Interface]",
            imageAlt: "Show: App streaming UI with YouTube/Facebook icons and live viewer count",
            imageSrc: nn?.liveStreaming || Pn[0],
            reversed: !0
          }
        ),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "INSTANT SOCIAL SHARING",
            title: "Everywhere your fans are",
            description: "Livestream to YouTube, Facebook, TikTok, and any custom RTMP destination. Post your Highlight directly to Instagram, TikTok, or YouTube. Keep track of every game with your personal video library — organized by date, team, and player.",
            bullets: [
              "Direct share to TikTok, Instagram, YouTube",
              "Personal video library — organized by game and player",
              "Season-long Highlight portfolio for recruiting",
              "Download full game footage anytime"
            ],
            imagePlaceholder: "[Social Sharing Interface]",
            imageAlt: "Show: Share screen with social media icons and video library grid",
            imageSrc: nn?.socialSharing || Pn[0]
          }
        ),
        /* @__PURE__ */ s.jsxs(C.div, { variants: ki, className: "mt-24 mb-20", children: [
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-12 text-center", children: [
            "READY IN ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "30 SECONDS" })
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "grid md:grid-cols-3 gap-8", children: [
            { step: "1", title: "Mount & Power On", desc: "Place Q1 on any tripod (or the R1), mount your phone, power on, and open the ShootzInsight App.", img: nn?.setupInstall },
            { step: "2", title: "Connect & Select", desc: "Auto-connect via Bluetooth. Select basketball mode and confirm the court view.", img: nn?.setupConnect },
            { step: "3", title: "Hit Record", desc: "Tap record. Q1 handles tracking, recording, and highlight detection automatically.", img: nn?.setupRecord }
          ].map((H) => /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
            /* @__PURE__ */ s.jsx("div", { className: "aspect-[4/3] rounded-xl overflow-hidden bg-white/[0.02] border border-white/5 flex items-center justify-center mb-5", children: H.img ? /* @__PURE__ */ s.jsx("img", { src: H.img, alt: `${H.title} setup`, className: "w-full h-full object-cover", loading: "lazy" }) : /* @__PURE__ */ s.jsx("p", { className: "text-white/20 text-xs", children: "[Setup step 3 photo]" }) }),
            /* @__PURE__ */ s.jsx("div", { className: "w-12 h-12 rounded-full bg-[#FF6B35]/10 border border-[#FF6B35]/30 flex items-center justify-center mx-auto mb-4", children: /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] font-bold text-xl", children: H.step }) }),
            /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: H.title }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: H.desc })
          ] }, H.step)) })
        ] }),
        /* @__PURE__ */ s.jsxs(C.div, { variants: ki, className: "mb-20", children: [
          /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-12 text-center", children: [
            "WHAT'S ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "INCLUDED" })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "grid md:grid-cols-2 gap-10 items-center", children: [
            /* @__PURE__ */ s.jsx("div", { className: "aspect-square rounded-2xl overflow-hidden bg-white/[0.02] border border-white/10 flex items-center justify-center", children: nn?.inTheBox ? /* @__PURE__ */ s.jsx("img", { src: nn.inTheBox, alt: "What's included with ShootzInsight Q1", className: "w-full h-full object-cover", loading: "lazy" }) : /* @__PURE__ */ s.jsx(tl, { size: 48, className: "text-[#FF6B35]/30" }) }),
            /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
              [
                { name: "ShootzInsight Q1 Unit", desc: "AI-powered recording system with full-court tracking" },
                { name: "RC1 Remote Control", desc: "Bluetooth remote with record start/stop and score +/- buttons" },
                { name: "USB-C Charging Cable", desc: "Fast charging cable for Q1" },
                { name: "Carry Pouch", desc: "Protective carrying pouch for transport" },
                { name: "Quick Start Guide", desc: "Get recording in under 30 seconds" }
              ].map((H) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5", children: [
                /* @__PURE__ */ s.jsx(At, { size: 16, className: "text-[#FF6B35] mt-0.5 shrink-0" }),
                /* @__PURE__ */ s.jsxs("div", { children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-white font-medium text-sm", children: H.name }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs", children: H.desc })
                ] })
              ] }, H.name)),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs mt-4 pl-4", children: "* R1 Professional Tripod included with the Q1 + R1 Bundle" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsx(
          qa,
          {
            subtitle: "INCLUDED WITH EVERY Q1",
            title: "RC1 Remote — Control from courtside",
            description: "Start, stop, and control recording without touching your phone. The RC1 connects via Bluetooth and includes dedicated score +/- buttons — so the scoreboard is always synced with your footage for accurate AI analysis.",
            bullets: [
              "One-press record start/stop",
              "Score +/- buttons for live game tracking",
              "Bluetooth 5.2 — 30m range, instant response",
              "Compact clip-on design — attach to clipboard or pocket"
            ],
            imagePlaceholder: "[RC1 Remote Control Photo]",
            imageAlt: "Show: Close-up of RC1 remote with buttons labeled",
            imageSrc: nn?.remoteControl || Pn[0],
            reversed: !0
          }
        )
      ] }),
      p === "specs" && /* @__PURE__ */ s.jsxs(C.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, children: [
        /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white mb-8 text-center", children: [
          "TECHNICAL ",
          /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "SPECIFICATIONS" })
        ] }),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-center text-sm mb-8", children: "ShootzInsight Q1 AI Tracking System — recording resolution depends on your phone" }),
        /* @__PURE__ */ s.jsx("div", { className: "max-w-2xl mx-auto", children: /* @__PURE__ */ s.jsx("table", { className: "w-full", children: /* @__PURE__ */ s.jsx("tbody", { children: cv.map((H, W) => /* @__PURE__ */ s.jsxs("tr", { className: W < cv.length - 1 ? "border-b border-white/5" : "", children: [
          /* @__PURE__ */ s.jsx("td", { className: "py-4 text-white/50 text-sm", children: H.label }),
          /* @__PURE__ */ s.jsx("td", { className: "py-4 text-white text-sm font-medium text-right", children: H.value })
        ] }, H.label)) }) }) }),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-16 max-w-2xl mx-auto", children: [
          /* @__PURE__ */ s.jsxs("h3", { className: "font-[family-name:var(--font-display)] text-2xl font-bold text-white mb-6 text-center", children: [
            "R1 PROFESSIONAL ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "TRIPOD" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-center text-sm mb-6", children: "Included with the Q1 + R1 Bundle" }),
          /* @__PURE__ */ s.jsx("table", { className: "w-full", children: /* @__PURE__ */ s.jsx("tbody", { children: [
            { label: "Max Height", value: "200 cm (6.56 ft)" },
            { label: "Min Height", value: "0.6m (2 ft)" },
            { label: "Material", value: "Carbon fiber + aluminum alloy" },
            { label: "Weight", value: "1.8 kg (3.97 lbs)" },
            { label: "Load Capacity", value: "5 kg (11 lbs)" },
            { label: "Folded Length", value: "58 cm (22.8 in)" },
            { label: "Mount", value: '1/4" universal screw' }
          ].map((H, W) => /* @__PURE__ */ s.jsxs("tr", { className: W < 6 ? "border-b border-white/5" : "", children: [
            /* @__PURE__ */ s.jsx("td", { className: "py-3 text-white/50 text-sm", children: H.label }),
            /* @__PURE__ */ s.jsx("td", { className: "py-3 text-white text-sm font-medium text-right", children: H.value })
          ] }, H.label)) }) })
        ] })
      ] }),
      p === "faq" && /* @__PURE__ */ s.jsxs(C.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, children: [
        /* @__PURE__ */ s.jsxs("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white mb-8 text-center", children: [
          "FREQUENTLY ASKED ",
          /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "QUESTIONS" })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "max-w-3xl mx-auto", children: AC.map((H) => /* @__PURE__ */ s.jsx(CC, { q: H.q, a: H.a }, H.q)) })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(ln, {}),
    /* @__PURE__ */ s.jsxs("div", { className: "fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0a0a0a]/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold text-lg", children: [
          "$",
          q.price.toFixed(2)
        ] }),
        /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-xs", children: q.name })
      ] }),
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: G,
          disabled: !z?.availableForSale || T,
          className: "px-6 py-3 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2",
          children: [
            T ? /* @__PURE__ */ s.jsx(el, { size: 18, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(nl, { size: 18 }),
            "Add to Cart"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "h-[72px] md:hidden" })
  ] });
}
const kC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EC
}, Symbol.toStringTag, { value: "Module" }));
function MC({
  product: n,
  galleryImages: i = [],
  eyebrow: l,
  fallbackTitle: o = "ShootzInsight Q1",
  descriptionFallback: d,
  bullets: f = [],
  trustText: h = "Free shipping • 30-day returns • 1-year warranty",
  boxItems: p,
  accentColor: g = "#FF6B35",
  selectedVariantId: m,
  onVariantChange: b
}) {
  const { addItem: y, loading: w } = ul(), [N, T] = E.useState(0), [R, _] = E.useState(null), z = m !== void 0 ? m : R, q = (k) => {
    b ? b(k) : _(k);
  }, G = E.useMemo(
    () => i.length ? i.map((k) => ({
      url: k,
      alt: n?.title ?? o
    })) : n?.images.length ? n.images.map((k) => ({ url: k.url, alt: k.altText })) : [],
    [o, i, n]
  ), Q = E.useMemo(() => {
    if (n?.variants?.length)
      return n.variants.find((k) => k.id === z) ?? n.variants.find((k) => k.availableForSale) ?? n.variants[0];
  }, [n, z]), H = !!(n && n.variants.length > 1), W = E.useMemo(() => {
    if (!Q) return null;
    const k = Number.parseFloat(Q.price.amount), ee = Q.compareAtPrice ? Number.parseFloat(Q.compareAtPrice.amount) : null;
    return {
      amount: Number.isFinite(k) ? k : 0,
      compareAt: ee !== null && Number.isFinite(ee) ? ee : null
    };
  }, [Q]), $ = async () => {
    Q?.availableForSale && await y(Q.id, 1);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "grid min-w-0 lg:grid-cols-2 gap-10 lg:gap-16 items-start", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "w-full min-w-0 lg:sticky lg:top-24", children: [
      /* @__PURE__ */ s.jsx("div", { className: "aspect-square rounded-2xl overflow-hidden bg-white/[0.03] border border-white/10 mb-4", children: G.length > 0 ? /* @__PURE__ */ s.jsx(
        "img",
        {
          src: G[N]?.url ?? G[0]?.url,
          alt: G[N]?.alt ?? n?.title ?? o,
          className: "w-full max-w-full h-full object-contain p-8"
        }
      ) : /* @__PURE__ */ s.jsx("div", { className: "w-full h-full flex items-center justify-center", children: /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
        /* @__PURE__ */ s.jsx(tl, { size: 48, className: "mx-auto mb-3 opacity-30", style: { color: g } }),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-sm", children: "Product Image" })
      ] }) }) }),
      G.length > 1 && /* @__PURE__ */ s.jsx("div", { className: "flex gap-3", children: G.map((k, ee) => /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: () => T(ee),
          className: `w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${N === ee ? "border-[#FF6B35]" : "border-white/10 hover:border-white/30"}`,
          children: /* @__PURE__ */ s.jsx("img", { src: k.url, alt: "", className: "w-full h-full object-cover" })
        },
        ee
      )) })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-8", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        l && /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] text-sm font-semibold tracking-widest uppercase mb-2", children: l }),
        /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-3", children: n?.title || o }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
          /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-1", children: [1, 2, 3, 4, 5].map((k) => /* @__PURE__ */ s.jsx(yf, { size: 14, className: "text-[#FFD700] fill-[#FFD700]" }, k)) }),
          /* @__PURE__ */ s.jsx("span", { className: "text-white/50 text-sm", children: n ? Q?.availableForSale ? "In Stock" : "Sold Out" : "Not configured" })
        ] }),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm leading-relaxed mb-4", children: n?.description || d }),
        f.length > 0 && /* @__PURE__ */ s.jsx("ul", { className: "space-y-2.5 text-white/70 text-sm", children: f.map((k) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
          /* @__PURE__ */ s.jsx(At, { size: 14, className: "mt-0.5 shrink-0", style: { color: g } }),
          " ",
          k
        ] }, k)) })
      ] }),
      H && n && /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsxs("p", { className: "text-white font-semibold mb-3 flex items-center gap-2", children: [
          /* @__PURE__ */ s.jsx(tl, { size: 16, style: { color: g } }),
          " Choose Your Option"
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: n.variants.map((k) => {
          const ee = Q?.id === k.id, ae = k.compareAtPrice && Number.parseFloat(k.compareAtPrice.amount) > Number.parseFloat(k.price.amount) ? Number.parseFloat(k.compareAtPrice.amount) - Number.parseFloat(k.price.amount) : null;
          return /* @__PURE__ */ s.jsx(
            "button",
            {
              onClick: () => {
                k.availableForSale && q(k.id);
              },
              disabled: !k.availableForSale,
              className: `w-full text-left p-4 rounded-xl border transition-all ${k.availableForSale ? ee ? "border-[#FF6B35] bg-[#FF6B35]/5" : "border-white/10 bg-white/[0.02] hover:border-white/20" : "border-white/5 bg-white/[0.01] opacity-50 cursor-not-allowed"}`,
              children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: `w-4 h-4 rounded-full border-2 flex items-center justify-center ${ee ? "border-[#FF6B35]" : "border-white/30"}`,
                      children: ee && /* @__PURE__ */ s.jsx("div", { className: "w-2 h-2 rounded-full bg-[#FF6B35]" })
                    }
                  ),
                  /* @__PURE__ */ s.jsxs("div", { children: [
                    /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium", children: k.title }),
                    ae !== null && /* @__PURE__ */ s.jsxs("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white rounded-full bg-[#FF6B35]", children: [
                      "SAVE $",
                      ae.toFixed(0)
                    ] }),
                    !k.availableForSale && /* @__PURE__ */ s.jsx("span", { className: "ml-2 px-2 py-0.5 text-[10px] font-bold text-white/60 bg-white/10 rounded-full", children: "SOLD OUT" }),
                    /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs mt-0.5", children: k.selectedOptions.map((me) => `${me.name}: ${me.value}`).join(" · ") })
                  ] })
                ] }),
                /* @__PURE__ */ s.jsxs("div", { className: "text-right", children: [
                  /* @__PURE__ */ s.jsxs("span", { className: "text-white font-bold", children: [
                    "$",
                    Number.parseFloat(k.price.amount).toFixed(2)
                  ] }),
                  ae !== null && /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-sm line-through ml-2", children: [
                    "$",
                    Number.parseFloat(k.compareAtPrice.amount).toFixed(2)
                  ] })
                ] })
              ] })
            },
            k.id
          );
        }) })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "p-5 rounded-xl bg-white/[0.03] border border-white/10 space-y-3", children: [
        H && Q && /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white/60", children: Q.title }),
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium", children: W ? `$${W.amount.toFixed(2)}` : "—" })
        ] }),
        H && W?.compareAt !== null && /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between text-sm", children: [
          /* @__PURE__ */ s.jsxs("span", { className: "text-green-400 text-xs", children: [
            "You save $",
            ((W?.compareAt ?? 0) - (W?.amount ?? 0)).toFixed(2)
          ] }),
          /* @__PURE__ */ s.jsxs("span", { className: "text-white/30 text-xs line-through", children: [
            "$",
            (W?.compareAt ?? 0).toFixed(2)
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "border-t border-white/10 pt-3 flex justify-between items-center", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-semibold", children: "Total" }),
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-bold text-2xl", children: W ? `$${W.amount.toFixed(2)}` : "—" })
        ] }),
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            onClick: $,
            disabled: !Q?.availableForSale || w,
            className: "w-full py-4 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 mt-2",
            children: [
              w ? /* @__PURE__ */ s.jsx(el, { size: 20, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(nl, { size: 20 }),
              n ? Q?.availableForSale ? `Add to Cart — ${W ? `$${W.amount.toFixed(2)}` : ""}` : "Sold Out" : "Configure product in Shopify"
            ]
          }
        ),
        /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs text-center", children: h })
      ] }),
      p && p.length > 0 && /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-white/60 text-sm font-medium mb-2", children: "What's in the box:" }),
        /* @__PURE__ */ s.jsx("div", { className: "space-y-2.5", children: p.map((k) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 p-3 rounded-xl bg-white/[0.02] border border-white/5", children: [
          /* @__PURE__ */ s.jsx(At, { size: 14, className: "mt-0.5 shrink-0", style: { color: g } }),
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-medium text-sm", children: k.name }),
            k.desc && /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-xs", children: k.desc })
          ] })
        ] }, k.name)) })
      ] })
    ] })
  ] });
}
const Ai = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
}, Po = { hidden: {}, visible: { transition: { staggerChildren: 0.1 } } }, zC = [
  {
    icon: QN,
    title: "Adjustable Height",
    desc: "Extends from 60cm to 200cm. Find the perfect angle whether you're courtside, in the bleachers, or on the sideline."
  },
  {
    icon: iT,
    title: "Rock-Solid Stability",
    desc: "Anti-vibration base with weighted center column. Your Q1 stays steady even when the crowd goes wild."
  },
  {
    icon: Kv,
    title: "360° Ball Head",
    desc: "Smooth pan and tilt adjustment. Lock into position with a single twist. Quick-release plate for fast setup."
  },
  {
    icon: WN,
    title: "Built for Outdoors",
    desc: "Aluminum alloy construction, weather-resistant finish. Handles rain, dust, and extreme temperatures from -10°C to 50°C."
  }
], uv = [
  { label: "Model", value: "ShootzInsight R1" },
  { label: "Material", value: "Aerospace-grade Aluminum Alloy" },
  { label: "Min Height", value: "60 cm (23.6 in)" },
  { label: "Max Height", value: "200 cm (78.7 in)" },
  { label: "Folded Length", value: "48 cm (18.9 in)" },
  { label: "Weight", value: "1.2 kg (2.6 lbs)" },
  { label: "Max Load", value: "5 kg (11 lbs)" },
  { label: "Leg Sections", value: "4" },
  { label: "Compatibility", value: 'ShootzInsight Q1, standard 1/4" mount' },
  { label: "Color", value: "Matte Black" }
];
function OC() {
  const n = window.__SHOOTZ_PRODUCTS__?.tripod ?? window.__SHOOTZ_PRODUCT__, i = window.__SHOOTZ_CONFIG__?.media?.r1Gallery ?? [], [l, o] = E.useState(null), { addItem: d, loading: f } = ul(), h = E.useMemo(() => {
    if (n?.variants?.length)
      return n.variants.find((m) => m.id === l) ?? n.variants.find((m) => m.availableForSale) ?? n.variants[0];
  }, [n, l]), p = h ? `$${Number.parseFloat(h.price.amount).toFixed(2)}` : null, g = async () => {
    h?.availableForSale && await d(h.id, 1);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(
      on,
      {
        title: n?.title || "ShootzInsight R1 Tripod - Purpose-Built Sports Mount",
        description: n?.description || "The purpose-built mount for your ShootzInsight Q1. Adjustable height, rock-solid stability, and 30-second setup. Designed for courts, fields, and gyms.",
        keywords: "ShootzInsight R1, sports tripod, Q1 mount, basketball recording tripod",
        url: window.__SHOOTZ_CONFIG__?.r1Url || "/products/shootzinsight-r1-professional-tripod"
      }
    ),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[80px] pb-12", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      MC,
      {
        product: n,
        galleryImages: i,
        eyebrow: "ACCESSORY",
        fallbackTitle: "ShootzInsight R1 Tripod",
        descriptionFallback: "The purpose-built mount for your ShootzInsight Q1. Set up in seconds, capture every angle. Designed for courts, fields, and gyms.",
        bullets: [
          "Adjustable height — 60cm to 200cm for any courtside angle",
          "Rock-solid anti-vibration base for steady AI tracking",
          "360° ball head with quick-release plate",
          "Weather-resistant, built for outdoor courts"
        ],
        boxItems: [
          { name: "ShootzInsight R1 Tripod", desc: "Aluminum alloy, extends to 200cm" },
          { name: "Quick-Release Plate", desc: "One-click Q1 mounting" },
          { name: "Carry Bag", desc: "Padded storage for transport" },
          { name: "Quick Start Guide", desc: "Setup in 30 seconds" }
        ],
        selectedVariantId: l,
        onVariantChange: o
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 px-4", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-4xl", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-14",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: [
            /* @__PURE__ */ s.jsxs(C.h2, { variants: Ai, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: [
              "ENGINEERED FOR ",
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME DAY" })
            ] }),
            /* @__PURE__ */ s.jsx(C.p, { variants: Ai, className: "text-white/50 mt-3 max-w-lg mx-auto", children: "Not just any tripod. R1 is designed specifically for sports recording environments." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid sm:grid-cols-2 gap-6",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: zC.map((m) => /* @__PURE__ */ s.jsxs(
            C.div,
            {
              variants: Ai,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(m.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: m.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: m.desc })
              ]
            },
            m.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 px-4 border-t border-white/5", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-4xl", children: [
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "text-center mb-14",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: /* @__PURE__ */ s.jsxs(C.h2, { variants: Ai, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: [
            "SETUP IN ",
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "30 SECONDS" })
          ] })
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid md:grid-cols-3 gap-8",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Po,
          children: [
            { step: "1", title: "Extend & Lock", desc: "Pull legs to desired height. Flip-lock clamps secure each section instantly." },
            { step: "2", title: "Mount Q1", desc: "Slide Q1 onto the quick-release plate. One click and it's locked in place." },
            { step: "3", title: "Aim & Record", desc: "Adjust the ball head to frame the court. Tighten the lock knob. You're live." }
          ].map((m) => /* @__PURE__ */ s.jsxs(C.div, { variants: Ai, className: "text-center", children: [
            /* @__PURE__ */ s.jsx("div", { className: "w-12 h-12 rounded-full bg-[#FF6B35] text-white font-bold text-lg flex items-center justify-center mx-auto mb-4", children: m.step }),
            /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-lg font-semibold text-white mb-2", children: m.title }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: m.desc })
          ] }, m.step))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 px-4 border-t border-white/5", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-3xl", children: [
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "text-center mb-10",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ai,
          children: /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "SPECIFICATIONS" })
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "rounded-xl border border-white/10 overflow-hidden",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ai,
          children: uv.map((m, b) => /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: `flex justify-between items-center px-6 py-4 ${b < uv.length - 1 ? "border-b border-white/5" : ""}`,
              children: [
                /* @__PURE__ */ s.jsx("span", { className: "text-white/50 text-sm", children: m.label }),
                /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium text-sm", children: m.value })
              ]
            },
            m.label
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx(ln, {}),
    /* @__PURE__ */ s.jsxs("div", { className: "fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0a0a0a]/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ s.jsx("span", { className: "text-white font-bold text-lg", children: p || "—" }),
        /* @__PURE__ */ s.jsx("span", { className: "text-white/40 text-xs", children: n?.title || "R1 Tripod" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: g,
          disabled: !h?.availableForSale || f,
          className: "px-6 py-3 bg-[#FF6B35] text-white font-bold rounded-xl hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2",
          children: [
            f ? /* @__PURE__ */ s.jsx(el, { size: 18, className: "animate-spin" }) : /* @__PURE__ */ s.jsx(nl, { size: 18 }),
            "Add to Cart"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "h-[72px] md:hidden" })
  ] });
}
const RC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OC
}, Symbol.toStringTag, { value: "Module" })), _C = "https://d2xsxph8kpxj0f.cloudfront.net/310519663318184546/U6JEbU8JFoPtHgYKwBz6Rr/hero_basketball_court-TdZ5WUpkXHUqGR6j6NFpFr.webp", Tt = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ga = { visible: { transition: { staggerChildren: 0.1 } } }, DC = [
  {
    icon: gf,
    title: "Ball & Player Tracking",
    desc: "Our AI simultaneously tracks ball movement and player positions, keeping the action centered and smooth — even during fast breaks."
  },
  {
    icon: VN,
    title: "Court-Aware Framing",
    desc: "Intelligent framing adapts to basketball court geometry. Wide shots for half-court sets, tight follow for drives and transitions."
  },
  {
    icon: sc,
    title: "Shot Detection",
    desc: "Automatically detects every made basket at 99% accuracy — threes, twos, free throws — creating instant Moments for each scoring play."
  },
  {
    icon: lT,
    title: "Fast Break Recognition",
    desc: "AI recognizes transition plays and fast breaks, ensuring the system keeps pace with the fastest moments of the game."
  }
], FC = [
  {
    icon: ol,
    title: "AI Moments",
    badge: "FREE",
    desc: "AI detects every made basket at 99% accuracy. It grabs a snapshot of who scored — find yourself, tap, and your Moments are right there."
  },
  {
    icon: yc,
    title: "One-Tap Highlight",
    badge: "PREMIUM",
    desc: "One tap turns your Moments into a Highlight — landscape to vertical, slow-mo on key plays, music synced to the beat. Your recruiting tape, done."
  },
  {
    icon: Rs,
    title: "Game Analytics",
    badge: "PREMIUM",
    desc: "Points, FG%, and a 3PT / 2PT / FT split — every stat linked to the exact video clip. Tap a number, watch that play. Coaches break down film with real numbers."
  }
], BC = [
  { label: "Player Points", desc: "Individual and team scoring totals for every game" },
  { label: "Field Goal Percentage", desc: "Made shots and FG% for every player on the floor" },
  { label: "3PT / 2PT Split", desc: "A clear breakdown of threes and twos made and attempted" },
  { label: "Free Throws", desc: "Free throws made, attempted, and percentage" }
];
function VC() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "Basketball - AI Recording for Every Game", description: "Capture every basketball game with AI auto-tracking. Get AI Moments, shot charts, player stats, and One-Tap Highlights automatically.", keywords: "basketball recording system, basketball highlights, basketball analytics, youth basketball recording", url: "/pages/basketball" }),
    /* @__PURE__ */ s.jsxs("section", { className: "relative pt-[72px] min-h-[85vh] flex items-center overflow-hidden", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "absolute inset-0", children: [
        /* @__PURE__ */ s.jsx("img", { src: _C, alt: "", className: "w-full h-full object-cover opacity-30" }),
        /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/50 via-[#0a0a0a]/30 to-[#0a0a0a]" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "container mx-auto relative z-10 py-20",
          initial: "hidden",
          animate: "visible",
          variants: Ga,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: Tt, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Basketball" }),
            /* @__PURE__ */ s.jsxs(C.h1, { variants: Tt, className: "font-[family-name:var(--font-display)] text-5xl md:text-7xl font-bold text-white leading-[1.05]", children: [
              "EVERY SHOT.",
              /* @__PURE__ */ s.jsx("br", {}),
              "EVERY PLAY.",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "EVERY INSIGHT." })
            ] }),
            /* @__PURE__ */ s.jsx(C.p, { variants: Tt, className: "text-white/60 text-lg md:text-xl max-w-2xl leading-relaxed mt-6 mb-10", children: "ShootzInsight is built for basketball. AI tracking that understands the game, automatic AI Moments after every session, and deep analytics that reveal what the eye can't see." }),
            /* @__PURE__ */ s.jsxs(C.div, { variants: Tt, className: "flex flex-wrap gap-4", children: [
              /* @__PURE__ */ s.jsx(Ne, { href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", className: "px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]", children: "Get ShootzInsight Q1" }),
              /* @__PURE__ */ s.jsx("a", { href: "#analytics", className: "px-8 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all", children: "See Analytics Demo" })
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: [
            /* @__PURE__ */ s.jsxs(C.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: [
              "AI BUILT FOR",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "BASKETBALL" })
            ] }),
            /* @__PURE__ */ s.jsx(C.p, { variants: Tt, className: "text-white/50 mt-4 max-w-2xl mx-auto text-lg", children: "Our Sports Video AI is trained specifically on basketball — understanding court geometry, player movement patterns, and game events in real-time." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: DC.map((n) => /* @__PURE__ */ s.jsxs(
            C.div,
            {
              variants: Tt,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(n.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: n.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: n.desc })
              ]
            },
            n.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: [
            /* @__PURE__ */ s.jsxs(C.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: [
              "FROM RAW FOOTAGE TO",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME INTELLIGENCE" })
            ] }),
            /* @__PURE__ */ s.jsx(C.p, { variants: Tt, className: "text-white/50 mt-4 max-w-xl mx-auto", children: "Three AI engines work together — turning hours of footage into highlights, reels, and actionable data." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid md:grid-cols-3 gap-8",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: FC.map((n) => /* @__PURE__ */ s.jsxs(
            C.div,
            {
              variants: Tt,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-all",
              children: [
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
                  /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 rounded-lg bg-[#FF6B35]/10 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(n.icon, { size: 20, className: "text-[#FF6B35]" }) }),
                  /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35] text-xs font-bold uppercase tracking-wider bg-[#FF6B35]/10 px-2 py-1 rounded", children: n.badge })
                ] }),
                /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-xl font-bold text-white mb-2", children: n.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: n.desc })
              ]
            },
            n.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { id: "analytics", className: "py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: [
            /* @__PURE__ */ s.jsx(C.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "DEEP BASKETBALL ANALYTICS" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: Tt, className: "text-white/50 mt-3 max-w-lg mx-auto", children: "Insights that were once only available to pro teams — now accessible from a single system." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ga,
          children: BC.map((n) => /* @__PURE__ */ s.jsxs(
            C.div,
            {
              variants: Tt,
              className: "p-6 rounded-xl bg-white/[0.02] border border-white/5",
              children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-[#FF6B35] font-semibold mb-1", children: n.label }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm", children: n.desc })
              ]
            },
            n.label
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(C.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ga, children: [
      /* @__PURE__ */ s.jsx(C.h2, { variants: Tt, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white mb-4", children: "ELEVATE YOUR GAME." }),
      /* @__PURE__ */ s.jsx(C.p, { variants: Tt, className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "From pickup games to competitive leagues — ShootzInsight turns every session into an opportunity to improve." }),
      /* @__PURE__ */ s.jsxs(C.div, { variants: Tt, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "Buy ShootzInsight Q1 — $199"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/coaches",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "For Coaches"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const HC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VC
}, Symbol.toStringTag, { value: "Module" })), Ur = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, UC = { visible: { transition: { staggerChildren: 0.1 } } };
function LC({
  eyebrow: n,
  title: i,
  accentTitle: l,
  description: o,
  imageSrc: d,
  imageAlt: f,
  contentSide: h = "left",
  objectPosition: p = "center",
  primaryLabel: g,
  primaryHref: m,
  secondaryLabel: b,
  secondaryHref: y,
  note: w
}) {
  const N = h === "right";
  return /* @__PURE__ */ s.jsxs("section", { className: "relative flex min-h-[620px] items-end overflow-hidden border-b border-white/5 pt-[72px] sm:min-h-[680px] lg:min-h-[720px]", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "absolute inset-0", children: [
      d && /* @__PURE__ */ s.jsx(
        "img",
        {
          src: d,
          alt: f,
          className: "h-full w-full object-cover",
          style: { objectPosition: p }
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-[#0a0a0a]/25" }),
      /* @__PURE__ */ s.jsx(
        "div",
        {
          className: `absolute inset-0 ${N ? "bg-gradient-to-l from-[#0a0a0a]/95 via-[#0a0a0a]/65 to-[#0a0a0a]/10" : "bg-gradient-to-r from-[#0a0a0a]/95 via-[#0a0a0a]/65 to-[#0a0a0a]/10"}`
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/35" })
    ] }),
    /* @__PURE__ */ s.jsx(
      C.div,
      {
        className: "container relative z-10 mx-auto pb-16 pt-28 sm:pb-20",
        initial: "hidden",
        animate: "visible",
        variants: UC,
        children: /* @__PURE__ */ s.jsxs("div", { className: `max-w-2xl ${N ? "ml-auto" : ""}`, children: [
          /* @__PURE__ */ s.jsx(C.p, { variants: Ur, className: "mb-4 text-sm font-semibold uppercase tracking-widest text-[#FF6B35]", children: n }),
          /* @__PURE__ */ s.jsxs(C.h1, { variants: Ur, className: "font-[family-name:var(--font-display)] text-4xl font-bold leading-[1.1] text-white md:text-6xl", children: [
            i,
            l && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: l })
            ] })
          ] }),
          /* @__PURE__ */ s.jsx(C.p, { variants: Ur, className: "mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg", children: o }),
          /* @__PURE__ */ s.jsxs(C.div, { variants: Ur, className: "mt-8 flex flex-col gap-3 sm:flex-row", children: [
            /* @__PURE__ */ s.jsx("a", { href: m, className: "inline-flex min-h-12 items-center justify-center rounded-lg bg-[#FF6B35] px-7 text-sm font-semibold text-white hover:bg-[#D94F22]", children: g }),
            /* @__PURE__ */ s.jsx("a", { href: y, className: "inline-flex min-h-12 items-center justify-center rounded-lg border border-white/25 bg-black/15 px-7 text-sm font-semibold text-white backdrop-blur-sm hover:border-[#FF6B35]/70", children: b })
          ] }),
          w && /* @__PURE__ */ s.jsx(C.p, { variants: Ur, className: "mt-4 text-xs text-white/45", children: w })
        ] })
      }
    )
  ] });
}
const Io = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, wh = { visible: { transition: { staggerChildren: 0.08 } } };
function Ec({ config: n }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#080808]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { ...n.seo }),
    /* @__PURE__ */ s.jsx(LC, { ...n.hero }),
    /* @__PURE__ */ s.jsx("section", { className: "border-b border-white/[0.07] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs(C.div, { className: "container mx-auto max-w-6xl", initial: "hidden", whileInView: "visible", viewport: { once: !0, margin: "-80px" }, variants: wh, children: [
      /* @__PURE__ */ s.jsxs(C.div, { variants: Io, className: "mb-10 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "The challenge" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: n.painTitle }),
        n.painIntro && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-base leading-relaxed text-white/55", children: n.painIntro })
      ] }),
      /* @__PURE__ */ s.jsx(C.div, { variants: wh, className: `grid gap-4 ${n.painPoints.length === 3 ? "md:grid-cols-3" : "sm:grid-cols-2 lg:grid-cols-4"}`, children: n.painPoints.map((i) => {
        const l = i.icon;
        return /* @__PURE__ */ s.jsxs(C.article, { variants: Io, className: "border-t border-white/15 px-1 py-6", children: [
          /* @__PURE__ */ s.jsx(l, { size: 30, className: "mb-5 text-[#FF6B35]", "aria-hidden": "true" }),
          /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-white", children: i.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-sm leading-relaxed text-white/50", children: i.description })
        ] }, i.title);
      }) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { id: "scoring-moments", className: "py-20 md:py-28", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-14 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "How ShootzInsight helps" }),
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-5xl", children: "From full-game film to the plays that matter" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "space-y-20 md:space-y-28", children: n.features.map((i, l) => /* @__PURE__ */ s.jsxs(C.article, { initial: "hidden", whileInView: "visible", viewport: { once: !0, margin: "-80px" }, variants: wh, className: "grid items-center gap-8 lg:grid-cols-2 lg:gap-16", children: [
        /* @__PURE__ */ s.jsxs(C.div, { variants: Io, className: l % 2 === 1 ? "lg:order-2" : "", children: [
          /* @__PURE__ */ s.jsx("p", { className: "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: i.eyebrow }),
          /* @__PURE__ */ s.jsx("h3", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: i.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-5 text-base leading-relaxed text-white/60", children: i.description }),
          i.note && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-xs leading-relaxed text-white/35", children: i.note })
        ] }),
        /* @__PURE__ */ s.jsx(C.div, { variants: Io, className: l % 2 === 1 ? "lg:order-1" : "", children: i.image ? /* @__PURE__ */ s.jsx("img", { src: i.image, alt: i.imageAlt, loading: "lazy", className: "aspect-[3/2] w-full rounded-lg border border-white/10 object-cover" }) : /* @__PURE__ */ s.jsx("div", { className: "flex aspect-[3/2] items-center justify-center rounded-lg border border-white/10 bg-[#111318] px-8 text-center text-sm text-white/35", children: i.imageAlt }) })
      ] }, i.title)) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.07] bg-[#111318] py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: n.scenariosTitle }),
      /* @__PURE__ */ s.jsx("div", { className: `mt-10 grid gap-px overflow-hidden rounded-lg border border-white/10 bg-white/10 ${n.scenarios.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"}`, children: n.scenarios.map((i) => /* @__PURE__ */ s.jsxs("article", { className: "bg-[#111318] p-7 md:p-9", children: [
        /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-white", children: i.title }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-3 text-sm leading-relaxed text-white/50", children: i.description })
      ] }, i.title)) })
    ] }) }),
    n.choices && n.choicesTitle && /* @__PURE__ */ s.jsx("section", { className: "py-20 md:py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: n.choicesTitle }),
        n.choicesIntro && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-white/50", children: n.choicesIntro })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "mt-10 grid gap-5 md:grid-cols-2", children: n.choices.map((i) => /* @__PURE__ */ s.jsxs(Ne, { href: i.href, className: `group flex min-h-64 flex-col justify-between rounded-lg border p-7 transition-colors md:p-9 ${i.featured ? "border-[#FF6B35]/70 bg-[#FF6B35]/[0.06]" : "border-white/10 bg-white/[0.02] hover:border-white/25"}`, children: [
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-sm font-semibold text-[#55D681]", children: "800 bonus credits included" }),
          /* @__PURE__ */ s.jsx("h3", { className: "mt-4 text-2xl font-bold text-white", children: i.title }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-3 max-w-md text-sm leading-relaxed text-white/50", children: i.description })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-8 flex items-end justify-between gap-4", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-3xl font-bold text-white", children: i.price }),
          /* @__PURE__ */ s.jsxs("span", { className: "flex items-center gap-1 text-sm font-semibold text-[#FF6B35]", children: [
            "Choose setup ",
            /* @__PURE__ */ s.jsx(Gr, { size: 16 })
          ] })
        ] })
      ] }, i.title)) })
    ] }) }),
    n.consultation && /* @__PURE__ */ s.jsx("section", { className: "py-20 md:py-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs("div", { className: "grid gap-10 border-y border-white/10 py-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-center", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-white md:text-4xl", children: n.consultation.title }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-4 max-w-2xl text-base leading-relaxed text-white/55", children: n.consultation.description })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("ul", { className: "space-y-3", children: n.consultation.items.map((i) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-center gap-3 text-sm text-white/65", children: [
          /* @__PURE__ */ s.jsx(At, { size: 16, className: "text-[#55D681]" }),
          i
        ] }, i)) }),
        /* @__PURE__ */ s.jsx(Ne, { href: n.consultation.ctaHref, className: "mt-7 inline-flex min-h-12 items-center justify-center rounded-lg bg-[#FF6B35] px-6 text-sm font-semibold text-white hover:bg-[#D94F22]", children: n.consultation.ctaLabel })
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsxs("section", { className: "relative overflow-hidden border-t border-white/[0.07] py-24 md:py-32", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-[radial-gradient(circle_at_80%_50%,rgba(255,107,53,0.12),transparent_38%)]" }),
      /* @__PURE__ */ s.jsxs("div", { className: "container relative mx-auto max-w-5xl text-center", children: [
        /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white md:text-6xl", children: n.finalCta.title }),
        /* @__PURE__ */ s.jsx("p", { className: "mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/55 md:text-lg", children: n.finalCta.description }),
        /* @__PURE__ */ s.jsxs("div", { className: "mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row", children: [
          /* @__PURE__ */ s.jsx(Ne, { href: n.finalCta.primaryHref, className: "inline-flex min-h-12 items-center justify-center rounded-lg bg-[#FF6B35] px-8 text-sm font-semibold text-white hover:bg-[#D94F22]", children: n.finalCta.primaryLabel }),
          n.finalCta.secondaryLabel && n.finalCta.secondaryHref && /* @__PURE__ */ s.jsx(Ne, { href: n.finalCta.secondaryHref, className: "inline-flex min-h-12 items-center justify-center rounded-lg border border-white/20 px-8 text-sm font-semibold text-white hover:border-[#FF6B35]/60", children: n.finalCta.secondaryLabel })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const Lr = window.__SHOOTZ_CONFIG__?.media, jh = window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", PC = window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", IC = {
  seo: { title: "For Parents - Capture the Game. Cheer Freely.", description: "Record youth basketball with your iPhone and Q1, find automatic scoring clips, and share the moments that matter.", keywords: "AI basketball camera, automatic scoring clips, youth basketball recording, player highlights", url: "/pages/parents" },
  hero: { eyebrow: "For Parents", title: "Capture the Game. Cheer Freely.", description: "Set up your iPhone with ShootzInsight Q1 and enjoy the game. Q1 follows the full court, detects your child's made baskets, and helps you find and share the moments that matter.", imageSrc: Lr?.userParents, imageAlt: "Parents watching their child play basketball from the stands", contentSide: "right", objectPosition: "38% center", primaryLabel: "Shop Q1 - $199", primaryHref: jh, secondaryLabel: "Watch the Parent Demo", secondaryHref: "#scoring-moments", note: "Basketball today. More sports planned for late 2026." },
  painTitle: "Enjoy the game. Keep the moments.",
  painPoints: [
    { icon: Wr, title: "No more holding your phone", description: "Keep your eyes on the game." },
    { icon: nT, title: "No more scrubbing", description: "Jump to scoring moments instead of searching hours of video." },
    { icon: xf, title: "No more missed shares", description: "Find a play and send it to family in a few taps." }
  ],
  features: [
    { eyebrow: "Full-court tracking", title: "Keep the Game in Frame While You Cheer", description: "Set up Q1 with your iPhone and record the basketball game hands-free. Basketball-specific tracking helps keep the live action in frame, with a 97% tracking result from data covering 20,000 basketball-court environments.*", image: Lr?.fullCourtTracking, imageAlt: "ShootzInsight Q1 tracking a full basketball court with an iPhone", note: "*Based on internal testing. Results may vary by venue, lighting, iPhone placement and game conditions." },
    { eyebrow: "99% made-basket detection", title: "Find Your Child's Scoring Moments Faster", description: "After processing, ShootzInsight identifies made baskets and creates scoring clips. Browse the visual thumbnails, find your child, and open the exact play instead of searching through the full game.", image: Lr?.aiMoments, imageAlt: "ShootzInsight iPhone app showing automatic basketball scoring clips" },
    { eyebrow: "Highlights", title: "Share the Moment, Not the Whole Game", description: "Select the plays you want to keep, create a share-ready highlight, and send it to grandparents, teammates or social media. Advanced highlight creation uses Shootz Cloud credits.", image: Lr?.socialSharing || Lr?.oneTapHighlight, imageAlt: "ShootzInsight app sharing a selected basketball highlight" }
  ],
  scenariosTitle: "A simpler game-day workflow",
  scenarios: [
    { title: "Before the game", description: "Mount your iPhone on Q1 at half court and connect the ShootzInsight app." },
    { title: "During the game", description: "Watch and cheer while Q1 keeps the basketball action in frame." },
    { title: "After the game", description: "Browse made-basket clips, choose the plays you want, and share the highlight." }
  ],
  choicesTitle: "Choose the Setup for Your Family",
  choicesIntro: "Both options include 800 bonus credits for premium processing.",
  choices: [
    { title: "Q1 Only", price: "$199", description: "For families with a compatible tripod.", href: jh },
    { title: "Q1 + R1", price: "$249", description: "Q1 plus the R1 tripod - a ready-to-record setup for game day.", href: PC, featured: !0 }
  ],
  finalCta: { title: "Keep the game. Keep the memory.", description: "Record the game, find made-basket moments, and share the plays your family will talk about.", primaryLabel: "Shop Q1 - $199", primaryHref: jh }
};
function qC() {
  return /* @__PURE__ */ s.jsx(Ec, { config: IC });
}
const GC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qC
}, Symbol.toStringTag, { value: "Module" })), Pr = window.__SHOOTZ_CONFIG__?.media, Sh = window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", YC = window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", QC = {
  seo: { title: "For Coaches - Review the Game, Not the Camera.", description: "Capture consistent basketball film, start review with automatic scoring clips, and connect shooting data to video.", keywords: "AI basketball camera, automatic scoring clips, basketball game analytics, coaching film review", url: "/pages/coaches" },
  hero: { eyebrow: "For Coaches", title: "Review the Game, Not the Camera.", description: "Capture consistent basketball film with your iPhone and Q1. After processing, start with made-basket moments and review player and team shooting data linked to video.", imageSrc: Pr?.userCoaches, imageAlt: "Basketball coach talking with players during a game", primaryLabel: "Shop Q1 for Your Team", primaryHref: Sh, secondaryLabel: "Request a Team Demo", secondaryHref: "/pages/contact", note: "Built for basketball coaches." },
  painTitle: "Coaching Is Already Demanding Enough",
  painPoints: [
    { icon: qv, title: "No dedicated camera operator", description: "Your staff should be able to focus on the team." },
    { icon: Wv, title: "Inconsistent handheld footage", description: "Film is harder to review when the action leaves the frame." },
    { icon: Qv, title: "Too much scrubbing", description: "Finding a few scoring plays should not take hours." },
    { icon: Gv, title: "Stats take time to organize", description: "Review is faster when the number and the play stay connected." }
  ],
  features: [
    { eyebrow: "Game Analytics", title: "Data-Driven Feedback, Linked to Film", description: "Get points, FG%, and a 3PT / 2PT / FT breakdown from your game film. Each result is connected to the play so you can review the number and the video together.", image: Pr?.gameAnalytics, imageAlt: "Basketball shooting data linked to game video in ShootzInsight" },
    { eyebrow: "Full-game film", title: "See the Possessions Around the Ball", description: "Record the basketball game with Q1 and your iPhone, then use the film to review spacing, transitions and off-ball movement.", image: Pr?.fullCourtTracking, imageAlt: "Full-court basketball film recorded by ShootzInsight Q1", note: "97% full-court tracking result based on internal testing. Results may vary." },
    { eyebrow: "Player moments", title: "Give Players a Clear Starting Point", description: "Use scoring moments and player highlight reels to start individual feedback. Select the plays you need, then share targeted clips instead of sending the whole game.", image: Pr?.aiMoments, imageAlt: "ShootzInsight automatic scoring clips for player feedback" },
    { eyebrow: "Faster review", title: "Start Review with the Scoring Plays", description: "Start with automatically created scoring clips, select the moments you need, and create clips for team review using your Cloud credits.", image: Pr?.oneTapHighlight, imageAlt: "Selected scoring clips prepared for basketball team review" }
  ],
  scenariosTitle: "A repeatable film-review workflow",
  scenarios: [
    { title: "Record", description: "Set up Q1 with an iPhone at half court and capture consistent full-game film." },
    { title: "Review", description: "Start with made-basket moments and shooting data linked to the source video." },
    { title: "Share", description: "Select the clips each player or group needs for the next session." }
  ],
  choicesTitle: "Equip your team",
  choices: [
    { title: "Q1 Only", price: "$199", description: "For teams that already have a compatible tripod.", href: Sh },
    { title: "Q1 + R1", price: "$249", description: "Q1 plus the R1 tripod - a ready-to-record setup.", href: YC, featured: !0 }
  ],
  consultation: { title: "Need more than one setup?", description: "Tell us how many teams, venues and games you record. We will discuss a workflow and pricing based on your actual program needs.", items: ["Team demo", "Volume pricing discussion", "Recording workflow review"], ctaLabel: "Request Team Pricing", ctaHref: "/pages/contact" },
  finalCta: { title: "Start review with better film.", description: "Capture the game consistently, find scoring moments faster, and keep every shooting number connected to video.", primaryLabel: "Shop Q1 for Your Team", primaryHref: Sh, secondaryLabel: "Request a Team Demo", secondaryHref: "/pages/contact" }
};
function ZC() {
  return /* @__PURE__ */ s.jsx(Ec, { config: QC });
}
const XC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ZC
}, Symbol.toStringTag, { value: "Module" })), Ir = window.__SHOOTZ_CONFIG__?.media, KC = {
  seo: { title: "For Clubs & Leagues - A Repeatable Basketball Video Workflow", description: "Give basketball teams a consistent way to record games, find scoring moments, and create shareable content.", keywords: "AI basketball camera, club basketball video, automatic scoring clips, basketball program content", url: "/pages/clubs" },
  hero: { eyebrow: "For Clubs & Leagues", title: "A Better Starting Point for Basketball Programs.", description: "Give your teams a consistent way to record games, find scoring moments and create shareable content. Start with Q1 for basketball today; talk to us about program needs as your organization grows.", imageSrc: Ir?.userClubs, imageAlt: "Youth basketball club team together on the court", primaryLabel: "Request Club Pricing", primaryHref: "/pages/contact", secondaryLabel: "Book a Program Demo", secondaryHref: "/pages/contact", note: "Consultation is based on your number of teams, games and venues." },
  painTitle: "Managing Game Video Across Teams Is Hard",
  painPoints: [
    { icon: Wv, title: "Different recording quality", description: "Every team needs a repeatable way to capture the game." },
    { icon: HN, title: "No consistent scoring clips", description: "Staff should be able to start review from the same kind of result." },
    { icon: sT, title: "Too much manual review", description: "Searching full-game files does not scale across a program." },
    { icon: xf, title: "Content is hard to share", description: "Families and teams need selected plays, not another raw file." }
  ],
  features: [
    { eyebrow: "Consistent scoring moments", title: "Start with the Same Scoring-Moment Workflow", description: "Use Q1 to capture basketball games and automatically identify made baskets. Your staff can start reviews with scoring clips instead of searching through full-game files.", image: Ir?.aiMoments, imageAlt: "Automatic basketball scoring clips in the ShootzInsight app" },
    { eyebrow: "Full-game film", title: "A Repeatable Game-Recording Workflow", description: "Set up an iPhone and Q1 at each game, then keep the full recording available for coaches, families and players.", image: Ir?.fullCourtTracking, imageAlt: "ShootzInsight Q1 recording full-court basketball with an iPhone" },
    { eyebrow: "Program content", title: "Turn Selected Plays into Program Content", description: "Create player highlights and share selected plays with families, teams and your community. Cloud processing uses credits; contact us for a program workflow.", image: Ir?.oneTapHighlight, imageAlt: "Basketball highlight assembled from selected ShootzInsight clips" },
    { eyebrow: "Live sharing", title: "Help Families Follow the Game", description: "Use ShootzInsight Live to share games through supported streaming destinations. Confirm your venue network and streaming setup before a tournament.", image: Ir?.liveStreaming, imageAlt: "ShootzInsight Live streaming interface for a basketball game" }
  ],
  scenariosTitle: "Start with a workflow your teams can repeat",
  scenarios: [
    { title: "Set up", description: "Place an iPhone and Q1 at the game using the same courtside setup." },
    { title: "Process", description: "Keep the full recording and begin review with made-basket clips." },
    { title: "Distribute", description: "Share selected film and content with the people who need it." }
  ],
  consultation: { title: "Plan the right program workflow", description: "We will confirm what can be supported for your organization before making a deployment promise.", items: ["Program onboarding", "Shared content workflow", "Volume pricing discussion"], ctaLabel: "Request Club Pricing", ctaHref: "/pages/contact" },
  finalCta: { title: "Build a more consistent game-video workflow.", description: "Tell us how many teams, games and venues you support, and what outputs your program needs.", primaryLabel: "Request Club Pricing", primaryHref: "/pages/contact", secondaryLabel: "Book a Program Demo", secondaryHref: "/pages/contact" }
};
function $C() {
  return /* @__PURE__ */ s.jsx(Ec, { config: KC });
}
const WC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $C
}, Symbol.toStringTag, { value: "Module" })), qr = window.__SHOOTZ_CONFIG__?.media, Nh = window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", JC = window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", eE = {
  seo: { title: "For Players - See Your Game. Build Your Next Level.", description: "Find automatic basketball scoring clips, review linked game analytics, and create player highlights with ShootzInsight Q1.", keywords: "AI basketball camera, automatic scoring clips, basketball game analytics, player highlights", url: "/pages/players" },
  hero: { eyebrow: "For Players", title: "See Your Game. Build Your Next Level.", description: "Get the full game on film, find your scoring moments automatically, and turn selected plays into highlights you can share with teammates, coaches and recruiters.", imageSrc: qr?.userPlayers, imageAlt: "Basketball player making a pass during a game", primaryLabel: "Start with Q1 - $199", primaryHref: Nh, secondaryLabel: "See How It Works", secondaryHref: "#scoring-moments", note: "Q1 works with your iPhone and is built for basketball today." },
  painTitle: "Can You Find Your Best Plays?",
  painPoints: [
    { icon: qv, title: "No one filming", description: "Your game should not depend on someone holding a phone." },
    { icon: Qv, title: "Hours of footage", description: "The play you need can be buried in a full-game recording." },
    { icon: Gv, title: "No clear game data", description: "Numbers are more useful when they link back to the play." },
    { icon: ol, title: "Editing takes too long", description: "Building a useful reel should start with clips already found." }
  ],
  features: [
    { eyebrow: "99% made-basket detection", title: "Your Scoring Moments, Already Found", description: "ShootzInsight detects made baskets at 99% accuracy and creates scoring clips after processing. Browse the visual thumbnails, open the exact clip, and save the plays you want to build on.", image: qr?.aiMoments, imageAlt: "ShootzInsight app displaying automatic basketball scoring moments" },
    { eyebrow: "Uses credits", title: "One Tap to a Share-Ready Highlight", description: "Choose your clips and create a polished highlight with the ShootzInsight app. Highlight creation uses credits; Q1 includes 800 credits to get started.", image: qr?.oneTapHighlight, imageAlt: "ShootzInsight app creating a basketball highlight from selected clips" },
    { eyebrow: "Game Analytics", title: "Stats Connected to the Plays", description: "Review points, FG%, and the 3PT / 2PT / FT breakdown - then tap a number to jump to the video behind it.", image: qr?.gameAnalytics, imageAlt: "ShootzInsight basketball game analytics linked to video", note: "Video Data Analysis uses Shootz Cloud credits." },
    { eyebrow: "97% tracking result", title: "Play. Q1 Keeps the Game in Frame.", description: "Set up your iPhone with Q1 and play without asking someone to hold the camera. ShootzInsight is built for basketball today, with more sports planned for late 2026.", image: qr?.fullCourtTracking, imageAlt: "Full-court basketball action recorded by ShootzInsight Q1", note: "Based on internal testing. Results may vary by venue, lighting, iPhone placement and game conditions." }
  ],
  scenariosTitle: "Use Q1 for training and game day",
  scenarios: [
    { title: "Training", description: "Record a drill or scrimmage, then review the film with your coach." },
    { title: "Game Day", description: "Capture the full game and start post-game review with automatic scoring clips." }
  ],
  choicesTitle: "Choose your setup",
  choices: [
    { title: "Q1 Only", price: "$199", description: "For players who already have a compatible tripod.", href: Nh },
    { title: "Q1 + R1", price: "$249", description: "Q1 plus the R1 tripod - ready for practice or game day.", href: JC, featured: !0 }
  ],
  finalCta: { title: "Your game deserves to be seen.", description: "Record the full game, find the scoring plays, and build the highlight you want to share.", primaryLabel: "Start with Q1 - $199", primaryHref: Nh, secondaryLabel: "See a Real Game Demo", secondaryHref: "/pages/basketball" }
};
function tE() {
  return /* @__PURE__ */ s.jsx(Ec, { config: eE });
}
const nE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tE
}, Symbol.toStringTag, { value: "Module" })), ft = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ya = { visible: { transition: { staggerChildren: 0.1 } } }, aE = [
  { value: "2024", label: "Founded" },
  { value: "AI", label: "Core Technology" },
  { value: "10+", label: "Sports Supported" },
  { value: "Global", label: "Vision" }
], iE = [
  {
    icon: FN,
    title: "AI-First Engineering",
    desc: "Built on proprietary sports video AI models trained on thousands of hours of game footage. Our technology understands the game — not just the pixels."
  },
  {
    icon: sc,
    title: "Athlete-Centered Design",
    desc: "Every feature is designed with athletes, coaches, and families in mind. We build tools that serve the game, not the other way around."
  },
  {
    icon: UN,
    title: "Global Accessibility",
    desc: "Professional-level game intelligence shouldn't be reserved for elite programs. We're making it accessible to every court, every community, worldwide."
  },
  {
    icon: tT,
    title: "Continuous Innovation",
    desc: "Our AI gets smarter with every game processed. New features ship monthly based on direct feedback from our community of coaches, parents, and players."
  }
];
function sE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "About Us - Our Story", description: "ShootzInsight was born from a simple belief: every athlete deserves to see their game the way the pros do. Meet the team behind the AI sports recording revolution.", keywords: "ShootzInsight about, sports AI company, basketball technology", url: "/about" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        className: "container mx-auto pt-16",
        initial: "hidden",
        animate: "visible",
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Our Story" }),
          /* @__PURE__ */ s.jsxs(C.h1, { variants: ft, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
            "WE BELIEVE EVERY",
            /* @__PURE__ */ s.jsx("br", {}),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "GAME MATTERS" })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        className: "max-w-3xl",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/70 text-lg leading-relaxed mb-6", children: "ShootzInsight was born from a simple observation: professional sports teams have entire departments dedicated to video analysis, highlight creation, and performance data. Youth athletes, weekend warriors, and community programs have nothing." }),
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/70 text-lg leading-relaxed mb-6", children: "Founded by a team of AI engineers and basketball enthusiasts in China, we set out to bridge that gap. Our mission: bring NBA-level game intelligence to every court through the power of AI — at a price anyone can afford." }),
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/70 text-lg leading-relaxed", children: "Today, ShootzInsight combines hardware innovation with deep learning to deliver automatic game recording, AI Moments, One-Tap Highlights, and comprehensive Game Analytics — all from a single system that anyone can set up in 30 seconds." })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      C.div,
      {
        className: "grid grid-cols-2 md:grid-cols-4 gap-6",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: aE.map((n) => /* @__PURE__ */ s.jsxs(
          C.div,
          {
            variants: ft,
            className: "p-6 rounded-2xl bg-white/[0.02] border border-white/5 text-center",
            children: [
              /* @__PURE__ */ s.jsx("p", { className: "font-[family-name:var(--font-display)] text-3xl font-bold text-[#FF6B35] mb-1", children: n.value }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm", children: n.label })
            ]
          },
          n.label
        ))
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        className: "max-w-3xl mx-auto text-center",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsx(C.div, { variants: ft, className: "flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(PN, { size: 28, className: "text-[#FF6B35]" }) }),
          /* @__PURE__ */ s.jsx(C.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-6", children: "OUR MISSION" }),
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/60 text-lg leading-relaxed", children: "To democratize sports intelligence. Every player — regardless of their level, budget, or location — deserves access to the same quality of game analysis and content creation tools that professional teams use. Through AI, we're making that possible." })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "text-center mb-16",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ya,
          children: /* @__PURE__ */ s.jsx(C.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "WHAT DRIVES US" })
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: Ya,
          children: iE.map((n) => /* @__PURE__ */ s.jsxs(
            C.div,
            {
              variants: ft,
              className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-[#FF6B35]/20 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(n.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-2", children: n.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: n.desc })
              ]
            },
            n.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        className: "max-w-3xl mx-auto text-center",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ya,
        children: [
          /* @__PURE__ */ s.jsx(C.div, { variants: ft, className: "flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(bf, { size: 28, className: "text-[#FF6B35]" }) }),
          /* @__PURE__ */ s.jsx(C.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-6", children: "OUR TEAM" }),
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/60 text-lg leading-relaxed mb-4", children: "We're a team of AI researchers, computer vision engineers, and sports enthusiasts based in China with a global outlook. Our backgrounds span deep learning, video processing, sports analytics, and product design." }),
          /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/60 text-lg leading-relaxed", children: "United by a shared passion for sports and technology, we're building the future of game intelligence — one algorithm at a time." })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(C.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ya, children: [
      /* @__PURE__ */ s.jsx(C.h2, { variants: ft, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: "JOIN THE MOVEMENT" }),
      /* @__PURE__ */ s.jsx(C.p, { variants: ft, className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "Be part of the revolution in sports video intelligence. Whether you're a parent, coach, player, or club — we built this for you." }),
      /* @__PURE__ */ s.jsxs(C.div, { variants: ft, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "Get Started — $199"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/contact",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "Contact Us"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const rE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sE
}, Symbol.toStringTag, { value: "Module" })), In = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, qo = { visible: { transition: { staggerChildren: 0.08 } } }, aw = [
  {
    id: "setup",
    title: "Quick Setup",
    desc: "Mount ShootzInsight Q1 on any tripod, clamp your phone, power on, and connect via Bluetooth in under 30 seconds.",
    icon: Wr,
    videoDuration: "1:30"
  },
  {
    id: "tracking",
    title: "Full-Court AI Tracking",
    desc: "How the AI automatically follows all players across the full court with smooth 180° rotation.",
    icon: gf,
    videoDuration: "2:00"
  },
  {
    id: "remote",
    title: "RC1 Remote Control",
    desc: "Pair the Bluetooth remote to start/stop recording, switch modes, and control score overlay.",
    icon: $N,
    videoDuration: "1:15"
  },
  {
    id: "monitor",
    title: "Live Monitor & Framing",
    desc: "Use your phone as a real-time monitor to check framing and adjust the angle during the game.",
    icon: bc,
    videoDuration: "1:00"
  },
  {
    id: "landscape-portrait",
    title: "Landscape & Portrait Mode",
    desc: "Switch between horizontal (full-court) and vertical (single-player) recording modes.",
    icon: Jv,
    videoDuration: "0:45"
  }
], lE = [
  {
    id: "moments",
    title: "AI Moments",
    desc: "How the AI automatically detects every made basket (threes, twos, free throws) and creates 10-second Moments clips.",
    icon: e0,
    videoDuration: "2:30"
  },
  {
    id: "find-yourself",
    title: "Find Your Moments",
    desc: "Browse player snapshots captured at each key play, tap yours, and all your personal Moments appear instantly.",
    icon: bf,
    videoDuration: "1:45"
  },
  {
    id: "analytics",
    title: "Game Analytics Dashboard",
    desc: "View team and player stats — points, FG%, 3PT / 2PT / FT breakdown — with linked video clips for each stat.",
    icon: Rs,
    videoDuration: "3:00"
  },
  {
    id: "coach-assist",
    title: "Coach Assist",
    desc: "Tag plays, annotate key possessions, and export tactical breakdowns for team film sessions.",
    icon: Zv,
    videoDuration: "2:00"
  }
], oE = [
  {
    id: "highlight",
    title: "One-Tap Highlight",
    desc: "Generate a share-ready Highlight reel from your Moments — AI handles transitions, music sync, and slow-mo.",
    icon: yc,
    videoDuration: "2:00"
  },
  {
    id: "smart-reframe",
    title: "Smart Reframe (Landscape → Vertical)",
    desc: "AI intelligently crops and zooms your horizontal footage into vertical format optimized for TikTok and Reels.",
    icon: ol,
    videoDuration: "1:30"
  },
  {
    id: "live-stream",
    title: "ShootzInsight Live",
    desc: "Stream your game in real-time to YouTube, Facebook, or any RTMP platform directly from the app.",
    icon: ic,
    videoDuration: "2:30"
  },
  {
    id: "score-overlay",
    title: "Live Score Overlay",
    desc: "Add real-time score display to your stream or recording using the RC1 remote's +/- buttons.",
    icon: cT,
    videoDuration: "1:00"
  },
  {
    id: "share-social",
    title: "Share to Social Media",
    desc: "Export and share your Highlights directly to Instagram, TikTok, YouTube, or download for later.",
    icon: xf,
    videoDuration: "0:45"
  }
], Th = [
  { key: "record", label: "Record", tutorials: aw },
  { key: "analyze", label: "Analyze", tutorials: lE },
  { key: "share", label: "Share", tutorials: oE }
];
function cE({ tutorial: n }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "aspect-video w-full rounded-xl bg-white/[0.03] border border-white/10 flex flex-col items-center justify-center gap-3 group hover:border-[#FF6B35]/30 transition-colors cursor-pointer", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 rounded-full bg-[#FF6B35]/10 flex items-center justify-center group-hover:bg-[#FF6B35]/20 transition-colors", children: /* @__PURE__ */ s.jsx(Rh, { size: 28, className: "text-[#FF6B35] ml-1" }) }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-white/40 text-sm", children: [
      n.title,
      " Tutorial"
    ] }),
    n.videoDuration && /* @__PURE__ */ s.jsx("span", { className: "text-white/20 text-xs", children: n.videoDuration })
  ] });
}
function uE() {
  const [n, i] = E.useState("record"), [l, o] = E.useState(aw[0].id), d = Th.find((p) => p.key === n), f = d.tutorials.find((p) => p.id === l) || d.tutorials[0], h = (p) => {
    i(p);
    const g = Th.find((m) => m.key === p).tutorials[0];
    o(g.id);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(
      on,
      {
        title: "How to Use - Tutorial Center",
        description: "Explore ShootzInsight product manuals, video tutorials, App setup and features. From unboxing to your first Highlight in under 5 minutes.",
        keywords: "ShootzInsight tutorial, how to use, setup guide, AI sports recording system guide",
        url: "/pages/user-guide"
      }
    ),
    /* @__PURE__ */ s.jsxs("section", { className: "pt-[72px] relative overflow-hidden", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 bg-gradient-to-b from-[#FF6B35]/5 via-transparent to-transparent" }),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "container mx-auto pt-20 pb-16 relative z-10",
          initial: "hidden",
          animate: "visible",
          variants: qo,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: In, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Help Center" }),
            /* @__PURE__ */ s.jsxs(C.h1, { variants: In, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
              "HOW TO USE",
              /* @__PURE__ */ s.jsx("br", {}),
              /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "SHOOTZINSIGHT" })
            ] }),
            /* @__PURE__ */ s.jsxs(C.p, { variants: In, className: "text-white/60 text-lg max-w-2xl leading-relaxed mt-6", children: [
              "Explore product manuals, video tutorials, App setup and features.",
              /* @__PURE__ */ s.jsx("br", {}),
              "From unboxing to your first Highlight — everything you need in under 5 minutes."
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsxs("div", { className: "grid md:grid-cols-2 gap-8", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 flex flex-col items-center text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: In,
          children: [
            /* @__PURE__ */ s.jsx(Zv, { size: 40, className: "text-[#FF6B35] mb-4" }),
            /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl mb-2", children: "User Manual" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm mb-6 max-w-xs", children: "Download the complete ShootzInsight Q1 product manual for detailed setup instructions and specifications." }),
            /* @__PURE__ */ s.jsxs(
              "a",
              {
                href: "#",
                className: "inline-flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
                children: [
                  /* @__PURE__ */ s.jsx(BN, { size: 18 }),
                  "Download PDF"
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs mt-3", children: "PDF • Coming Soon" })
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5 flex flex-col items-center text-center",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: In,
          children: [
            /* @__PURE__ */ s.jsx(bc, { size: 40, className: "text-[#FF6B35] mb-4" }),
            /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl mb-2", children: "App Download" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm mb-6 max-w-xs", children: "Download the ShootzInsight app to connect your Q1, view Moments, generate Highlights, and access Analytics." }),
            /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row gap-3", children: [
              /* @__PURE__ */ s.jsxs(
                "a",
                {
                  href: "#",
                  className: "inline-flex items-center gap-2 px-5 py-3 bg-white/10 border border-white/20 text-white font-medium rounded-lg hover:bg-white/15 transition-all",
                  children: [
                    /* @__PURE__ */ s.jsx("svg", { viewBox: "0 0 24 24", className: "w-5 h-5 fill-current", children: /* @__PURE__ */ s.jsx("path", { d: "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" }) }),
                    "App Store"
                  ]
                }
              ),
              /* @__PURE__ */ s.jsx("span", { className: "inline-flex items-center gap-2 px-5 py-3 bg-white/5 border border-white/10 text-white/45 font-medium rounded-lg", children: "iPhone app coming soon" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { className: "text-white/30 text-xs mt-3", children: "Links coming soon" })
          ]
        }
      )
    ] }) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: qo,
          children: [
            /* @__PURE__ */ s.jsx(C.h2, { variants: In, className: "font-[family-name:var(--font-display)] text-3xl md:text-5xl font-bold text-white", children: "APP TUTORIALS" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: In, className: "text-white/50 mt-3 text-lg", children: "Step-by-step video guides for every feature." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center gap-1 mb-10", children: Th.map((p) => /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: () => h(p.key),
          className: `px-8 py-3 rounded-lg font-semibold text-sm transition-all ${n === p.key ? "bg-[#FF6B35] text-white" : "bg-white/5 text-white/50 hover:text-white hover:bg-white/10"}`,
          children: p.label
        },
        p.key
      )) }),
      /* @__PURE__ */ s.jsx(Kr, { mode: "wait", children: /* @__PURE__ */ s.jsxs(
        C.div,
        {
          initial: { opacity: 0, y: 10 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: -10 },
          transition: { duration: 0.25 },
          children: [
            /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap items-center justify-center gap-3 mb-12", children: d.tutorials.map((p) => /* @__PURE__ */ s.jsxs(
              "button",
              {
                onClick: () => o(p.id),
                className: `inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all ${l === p.id ? "bg-white text-[#0a0a0a]" : "bg-white/5 text-white/60 hover:bg-white/10 hover:text-white border border-white/10"}`,
                children: [
                  /* @__PURE__ */ s.jsx(p.icon, { size: 16 }),
                  p.title
                ]
              },
              p.id
            )) }),
            /* @__PURE__ */ s.jsxs("div", { className: "max-w-4xl mx-auto", children: [
              /* @__PURE__ */ s.jsx(cE, { tutorial: f }),
              /* @__PURE__ */ s.jsxs("div", { className: "mt-6 text-center", children: [
                /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl mb-2", children: f.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-base max-w-2xl mx-auto", children: f.desc })
              ] })
            ] })
          ]
        },
        n
      ) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "text-center mb-12",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: qo,
          children: [
            /* @__PURE__ */ s.jsx(C.h2, { variants: In, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white", children: "PRO TIPS" }),
            /* @__PURE__ */ s.jsx(C.p, { variants: In, className: "text-white/50 mt-3", children: "Get the best results from your ShootzInsight Q1." })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        C.div,
        {
          className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto",
          initial: "hidden",
          whileInView: "visible",
          viewport: { once: !0 },
          variants: qo,
          children: [
            {
              title: "Best Position",
              desc: "Place at half-court, elevated 8-12 feet if possible. Higher angles improve AI tracking accuracy."
            },
            {
              title: "Lighting",
              desc: "Works indoors and outdoors. Avoid shooting directly into strong backlighting for best results."
            },
            {
              title: "Battery Life",
              desc: "Records up to 3 hours per charge. Bring a USB-C power bank for tournament days."
            },
            {
              title: "Storage",
              desc: "Footage records to your phone. Transfer games to cloud via the app after each session."
            }
          ].map((p) => /* @__PURE__ */ s.jsxs(
            C.div,
            {
              variants: In,
              className: "p-6 rounded-xl bg-white/[0.02] border border-white/5",
              children: [
                /* @__PURE__ */ s.jsx("h4", { className: "text-[#FF6B35] font-semibold text-sm mb-2", children: p.title }),
                /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: p.desc })
              ]
            },
            p.title
          ))
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16 border-t border-white/5", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto", children: [
      /* @__PURE__ */ s.jsx("h3", { className: "text-white font-bold text-xl text-center mb-8", children: "Buy on the ShootzInsight Store" }),
      /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap items-center justify-center gap-8 mb-10", children: [
        { icon: "🚚", label: "Free Shipping" },
        { icon: "↩️", label: "30-Day Hassle-Free Return" },
        { icon: "🔒", label: "Secure Payments" },
        { icon: "🌍", label: "Global Customer Support" }
      ].map((p) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 text-white/60 text-sm", children: [
        /* @__PURE__ */ s.jsx("span", { className: "text-lg", children: p.icon }),
        /* @__PURE__ */ s.jsx("span", { children: p.label })
      ] }, p.label)) }),
      /* @__PURE__ */ s.jsx("div", { className: "text-center", children: /* @__PURE__ */ s.jsx(
        Ne,
        {
          href: "/products/shootzinsight-q1",
          className: "inline-flex items-center gap-2 px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
          children: "Shop Now"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-16 bg-gradient-to-b from-[#0d0d14] to-[#0a0a0a]", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto text-center", children: [
      /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-2xl md:text-3xl font-bold text-white mb-4", children: "NEED MORE HELP?" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "Check our FAQ or reach out to our support team." }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/faq",
            className: "px-10 py-4 bg-white/5 border border-white/20 text-white font-semibold rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "View FAQ"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/contact",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "Contact Support"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const dE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uE
}, Symbol.toStringTag, { value: "Module" })), Ci = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ah = { visible: { transition: { staggerChildren: 0.08 } } }, hE = [
  {
    category: "Product & Hardware",
    questions: [
      {
        q: "What is ShootzInsight Q1?",
        a: "ShootzInsight Q1 is an AI-powered sports recording system. Mount your phone on the Q1, and it automatically tracks and records basketball games. It combines smart hardware (3-axis AI tracking) with software (free AI Moments, One-Tap Highlights, and Game Analytics)."
      },
      {
        q: "What sports does it support?",
        a: "Q1 is built for basketball today. Soccer, tennis and badminton are planned for late 2026."
      },
      {
        q: "How long does the battery last?",
        a: "Q1 runs for approximately 13 hours when balanced and stationary without AI tracking, or approximately 4 hours with AI tracking and the fill light in use."
      },
      {
        q: "What's the video resolution?",
        a: "Recording quality depends on your iPhone. Exact supported models and recording options will be published with the App Store release."
      },
      {
        q: "Where is the footage stored?",
        a: "Footage is recorded directly to your phone's storage. Transfer to cloud via the ShootzInsight App for AI processing."
      }
    ]
  },
  {
    category: "AI Features",
    questions: [
      {
        q: "What is AI Moments?",
        a: "AI Moments is our free feature that automatically detects key plays and generates your personal Moments. After each game, you can browse clips by thumbnail to quickly find specific plays. No subscription needed."
      },
      {
        q: "How does One-Tap Highlight work?",
        a: "Select your favorite clips from AI Moments, choose a music track and style, then tap 'Generate'. Our AI creates a cinematic highlight video with professional transitions and music — ready to share on social media."
      },
      {
        q: "What does Game Analytics include?",
        a: "Game Analytics provides team totals and individual scoring — points, FG%, and a full 3PT / 2PT / FT breakdown — with every stat linked to the exact video clip."
      },
      {
        q: "Do I need a subscription to use ShootzInsight Q1?",
        a: "No. The Q1 works out of the box for recording and AI Moments (auto-detecting key plays) — both are free forever. The optional Shootz Cloud subscription unlocks premium AI features like One-Tap Highlight reels, full Game Analytics reports, and cloud storage & sharing."
      },
      {
        q: "How much is the subscription?",
        a: "Shootz Cloud offers three plans (annual pricing): Lite at $9.6/month (120 credits/month), Plus at $88.8/month (1,200 credits/month), and Max at $196.2/month (3,600 credits/month). Monthly billing is also available at slightly higher rates. All plans are managed through the ShootzInsight App."
      },
      {
        q: "How do credits work?",
        a: "Credits are the currency for premium AI features. Game Analytics costs 500 credits per video (plus 10 credits/minute beyond 50 minutes). AI Highlight Clips cost 5 credits per minute of source video. Highlight Reel Compilation costs 2 credits per clip used. Credits are issued monthly and reset each billing cycle. Purchasing the Q1 hardware includes 800 free credits to get you started."
      },
      {
        q: "Can I subscribe on this website?",
        a: "Subscriptions will be managed through the ShootzInsight iPhone app. The App Store listing is still under review, so subscriptions cannot yet be started from this website."
      },
      {
        q: "Can I cancel my subscription anytime?",
        a: "Yes, cancel anytime in the app with no cancellation fees. Your credits remain active until the end of your current billing period. You'll still have full access to free features (recording and AI Moments) after cancellation."
      },
      {
        q: "What if I buy the Q1 but don't subscribe?",
        a: "You get all hardware features: AI auto-tracking, full-court recording, live streaming, RC1 remote control, and free AI Moments detection. The 800 included credits let you try premium features. Cloud AI features (Highlights, Analytics, sharing) require an active subscription or credit balance after your initial credits are used."
      }
    ]
  },
  {
    category: "Setup & Usage",
    questions: [
      {
        q: "How long does setup take?",
        a: "Under 30 seconds. Mount Q1 on a tripod, clamp your phone, open the app, connect via Bluetooth, and press record. That's it."
      },
      {
        q: "Where should I position ShootzInsight Q1?",
        a: "At half-court, elevated 8-12 feet if possible. The higher and more centered, the better the AI tracking performs."
      },
      {
        q: "Does it work indoors and outdoors?",
        a: "Yes. ShootzInsight Q1 works in both environments. For outdoor use, avoid positioning directly facing strong sunlight."
      },
      {
        q: "Do I need WiFi during the game?",
        a: "No. Recording and AI tracking work offline. WiFi is only needed to transfer footage and generate reels/analytics."
      }
    ]
  },
  {
    category: "Accuracy & Test Methodology",
    questions: [
      {
        q: "What do the 97% and 99% figures mean?",
        a: "97% refers to the full-court tracking result, and 99% refers to made-basket detection and clipping. Both figures are based on internal testing. Results may vary by venue, lighting, iPhone placement and game conditions."
      },
      {
        q: "What does 20,000 basketball-court environments mean?",
        a: "This is the current product-team description of the data coverage used in internal evaluation. A detailed methodology page will document the statistical unit, test phones, indoor and outdoor mix, accuracy definitions and failure cases before broader claims are published."
      }
    ]
  }
];
function fE({ q: n, a: i }) {
  const [l, o] = E.useState(!1);
  return /* @__PURE__ */ s.jsxs("div", { className: "border-b border-white/5", children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        onClick: () => o(!l),
        className: "w-full flex items-center justify-between py-5 text-left",
        children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-white font-medium pr-4", children: n }),
          /* @__PURE__ */ s.jsx(
            Jr,
            {
              size: 18,
              className: `text-[#FF6B35] shrink-0 transition-transform duration-200 ${l ? "rotate-180" : ""}`
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: `overflow-hidden transition-all duration-200 ${l ? "max-h-96 pb-5" : "max-h-0"}`,
        children: /* @__PURE__ */ s.jsx("p", { className: "text-white/50 text-sm leading-relaxed", children: i })
      }
    )
  ] });
}
function mE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "FAQ - Frequently Asked Questions", description: "Find answers to common questions about ShootzInsight Q1, AI features, setup, compatibility, and technical support.", keywords: "ShootzInsight FAQ, sports recording system questions, AI sports FAQ", url: "/pages/faq" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        className: "container mx-auto pt-16",
        initial: "hidden",
        animate: "visible",
        variants: Ah,
        children: [
          /* @__PURE__ */ s.jsx(C.p, { variants: Ci, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Help Center" }),
          /* @__PURE__ */ s.jsxs(C.h1, { variants: Ci, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
            "FREQUENTLY ASKED",
            /* @__PURE__ */ s.jsx("br", {}),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "QUESTIONS" })
          ] }),
          /* @__PURE__ */ s.jsx(C.p, { variants: Ci, className: "text-white/60 text-lg max-w-2xl leading-relaxed mt-6", children: "Everything you need to know about ShootzInsight, from hardware setup to AI features and pricing." })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      C.div,
      {
        className: "max-w-3xl mx-auto space-y-12",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ah,
        children: hE.map((n) => /* @__PURE__ */ s.jsxs(C.div, { id: n.category === "Accuracy & Test Methodology" ? "accuracy-test-methodology" : void 0, variants: Ci, children: [
          /* @__PURE__ */ s.jsx("h2", { className: "font-[family-name:var(--font-display)] text-xl font-bold text-[#FF6B35] mb-4", children: n.category }),
          /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl bg-white/[0.02] border border-white/5 px-6", children: n.questions.map((i) => /* @__PURE__ */ s.jsx(fE, { q: i.q, a: i.a }, i.q)) })
        ] }, n.category))
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(C.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ah, children: [
      /* @__PURE__ */ s.jsx(C.h2, { variants: Ci, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: "STILL HAVE QUESTIONS?" }),
      /* @__PURE__ */ s.jsx(C.p, { variants: Ci, className: "text-white/50 text-lg mb-8 max-w-lg mx-auto", children: "Our support team is here to help. Reach out anytime." }),
      /* @__PURE__ */ s.jsxs(C.div, { variants: Ci, className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/contact",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "Contact Support"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/user-guide",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "User Guide"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const pE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mE
}, Symbol.toStringTag, { value: "Module" })), Ts = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Ch = { visible: { transition: { staggerChildren: 0.1 } } }, gE = [
  {
    icon: Xv,
    title: "Customer Support",
    desc: "For product questions, technical issues, and account help.",
    detail: "support@shootzinsight.com"
  },
  {
    icon: XN,
    title: "Business & Partnerships",
    desc: "For bulk orders, club partnerships, and media inquiries.",
    detail: "business@shootzinsight.com"
  },
  {
    icon: DN,
    title: "Business Hours",
    desc: "Our support team is available during business hours.",
    detail: "Mon - Fri, 9:00 AM - 6:00 PM (EST)"
  },
  {
    icon: YN,
    title: "Headquarters",
    desc: "ShootzInsight (Qiuxiu Sports Technology Co., Ltd.)",
    detail: "Shenzhen, China"
  }
];
function xE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "Contact Us", description: "Get in touch with the ShootzInsight team. Technical support, sales inquiries, partnership opportunities, and feedback.", keywords: "ShootzInsight contact, support, customer service", url: "/pages/contact" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        className: "container mx-auto pt-16",
        initial: "hidden",
        animate: "visible",
        variants: Ch,
        children: [
          /* @__PURE__ */ s.jsx(C.p, { variants: Ts, className: "text-[#FF6B35] text-sm tracking-widest uppercase font-semibold mb-4", children: "Help Center" }),
          /* @__PURE__ */ s.jsxs(C.h1, { variants: Ts, className: "font-[family-name:var(--font-display)] text-4xl md:text-6xl font-bold text-white leading-[1.1]", children: [
            "GET IN",
            /* @__PURE__ */ s.jsx("br", {}),
            /* @__PURE__ */ s.jsx("span", { className: "text-[#FF6B35]", children: "TOUCH" })
          ] }),
          /* @__PURE__ */ s.jsx(C.p, { variants: Ts, className: "text-white/60 text-lg max-w-2xl leading-relaxed mt-6", children: "Have a question, need support, or want to explore a partnership? We'd love to hear from you." })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-24", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto", children: /* @__PURE__ */ s.jsx(
      C.div,
      {
        className: "grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto",
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Ch,
        children: gE.map((n) => /* @__PURE__ */ s.jsxs(
          C.div,
          {
            variants: Ts,
            className: "p-8 rounded-2xl bg-white/[0.02] border border-white/5",
            children: [
              /* @__PURE__ */ s.jsx(n.icon, { size: 28, className: "text-[#FF6B35] mb-4" }),
              /* @__PURE__ */ s.jsx("h3", { className: "text-white font-semibold text-lg mb-1", children: n.title }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-3", children: n.desc }),
              /* @__PURE__ */ s.jsx("p", { className: "text-white/70 text-sm font-medium", children: n.detail })
            ]
          },
          n.title
        ))
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0d0d14]", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto text-center", children: /* @__PURE__ */ s.jsxs(C.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Ch, children: [
      /* @__PURE__ */ s.jsx(C.h2, { variants: Ts, className: "font-[family-name:var(--font-display)] text-3xl md:text-4xl font-bold text-white mb-4", children: "LOOKING FOR SOMETHING ELSE?" }),
      /* @__PURE__ */ s.jsxs(C.div, { variants: Ts, className: "flex flex-col sm:flex-row items-center justify-center gap-4 mt-8", children: [
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/faq",
            className: "px-10 py-4 bg-[#FF6B35] text-white font-bold rounded-lg hover:bg-[#FF6B35]/90 transition-all active:scale-[0.97]",
            children: "View FAQ"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/user-guide",
            className: "px-10 py-4 border border-white/20 text-white rounded-lg hover:border-[#FF6B35]/50 transition-all",
            children: "User Guide"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const yE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xE
}, Symbol.toStringTag, { value: "Module" }));
function bE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "Privacy Policy", description: "ShootzInsight Privacy Policy — how we collect, use, and protect your personal information.", url: "/pages/privacy-policy" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto pt-16 max-w-3xl", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-8", children: "Privacy Policy" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-12", children: "Last updated: August 3, 2026" }),
      /* @__PURE__ */ s.jsxs("div", { className: "prose prose-invert prose-sm max-w-none space-y-8 text-white/70 leading-relaxed", children: [
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("p", { children: 'ShootzInsight operates this website and related services, including the ShootzInsight mobile application and Shootz Cloud platform, in order to provide you with AI-powered sports recording, analysis, and highlight generation services (the "Services"). Our e-commerce is powered by Shopify, which enables us to sell products to you. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit, use, or make a purchase through the Services or otherwise communicate with us.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Please read this Privacy Policy carefully. By using and accessing any of the Services, you acknowledge that you have read this Privacy Policy and understand the collection, use, and disclosure of your information as described herein. If there is a conflict between our Terms of Service and this Privacy Policy, this Privacy Policy controls with respect to the collection, processing, and disclosure of your personal information." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Personal Information We Collect" }),
          /* @__PURE__ */ s.jsx("p", { children: "We may collect the following categories of personal information depending on how you interact with the Services:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Contact details" }),
              " — your name, address, billing address, shipping address, phone number, and email address."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Financial information" }),
              " — credit card, debit card, and financial account numbers, payment card information, transaction details, and payment confirmation."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Account information" }),
              " — your username, password, preferences, subscription plan, and credit balance."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Transaction information" }),
              " — items you view, add to cart, purchase, return, or cancel, subscription history, and credit usage records."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Communications" }),
              " — information you include in communications with us, such as customer support inquiries."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Device information" }),
              " — information about your device, browser, network connection, IP address, and other unique identifiers."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Usage information" }),
              " — how and when you interact with or navigate the Services, including AI analysis requests, video uploads, and feature usage."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Video content" }),
              " — sports videos you upload for AI processing. These are processed solely to deliver the requested services."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Personal Information Sources" }),
          /* @__PURE__ */ s.jsx("p", { children: "We may collect personal information from the following sources:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Directly from you" }),
              " — when you create an account, make a purchase, upload videos, subscribe to Shootz Cloud, or communicate with us."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Automatically through the Services" }),
              " — from your device when you use our products or services, through cookies and similar technologies."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "From our service providers" }),
              " — including payment processors (Shopify Payments), analytics providers, and cloud infrastructure partners."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "From our partners" }),
              " — such as Shopify (e-commerce platform) and the ShootzInsight iPhone app distribution platform."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "How We Use Your Personal Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "Depending on how you interact with us, we may use personal information for the following purposes:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Provide, tailor, and improve the Services" }),
              " — process payments, fulfill orders, deliver AI analysis results, manage your subscription and credits, arrange shipping, facilitate returns and exchanges, and improve our AI algorithms and user experience."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Marketing and advertising" }),
              " — send marketing and promotional communications by email (with your consent), show relevant advertisements, and inform you of new features or products."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Security and fraud prevention" }),
              " — authenticate your account, provide a secure payment experience, detect and investigate fraudulent or malicious activity, and secure our services."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Communication" }),
              " — provide customer support, respond to inquiries, send order and subscription notifications, and maintain our business relationship with you."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Legal compliance" }),
              " — comply with applicable law, respond to valid legal process, investigate potential violations of our terms, and enforce our policies."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Video Content & AI Processing" }),
          /* @__PURE__ */ s.jsx("p", { children: "When you upload sports videos for AI analysis through the Shootz Cloud service, your video content is processed on our secure servers to generate highlights, analytics, and player tracking data. We retain your uploaded videos and generated content for the duration of your active subscription. You may delete your videos and associated data at any time through the ShootzInsight app." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We do not use your video content to train AI models without your explicit consent. We do not share your video content with third parties for marketing purposes. Video recordings remain on your device until you explicitly upload them for AI processing." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "How We Disclose Personal Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "We may disclose your personal information to third parties in the following circumstances:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "With Shopify, payment processors, cloud service providers, and other vendors who perform services on our behalf (e.g., IT management, payment processing, data analytics, customer support, cloud storage, fulfillment and shipping)." }),
            /* @__PURE__ */ s.jsx("li", { children: "With business and marketing partners to provide marketing services and advertise to you. Our business partners will use your information in accordance with their own privacy notices." }),
            /* @__PURE__ */ s.jsx("li", { children: "When you direct, request, or otherwise consent to disclosure, such as sharing highlights on social media platforms." }),
            /* @__PURE__ */ s.jsx("li", { children: "With our affiliates or within our corporate group." }),
            /* @__PURE__ */ s.jsx("li", { children: "In connection with a business transaction such as a merger, to comply with applicable legal obligations, to enforce our terms of service, and to protect the Services, our rights, and the rights of our users." })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We do not sell your personal information." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Cookies & Tracking Technologies" }),
          /* @__PURE__ */ s.jsx("p", { children: "We use cookies and similar technologies to recognize your browser, remember your preferences, understand how you use our Services, and improve your experience. A cookie is a small amount of information that is downloaded to your device when you visit our website. We use the following types of cookies:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Essential cookies" }),
              " — required for the website to function properly (shopping cart, authentication)."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Analytics cookies" }),
              " — help us understand how visitors interact with our website."
            ] }),
            /* @__PURE__ */ s.jsxs("li", { children: [
              /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Marketing cookies" }),
              " — used to deliver relevant advertisements and track campaign effectiveness."
            ] })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You can control cookie preferences through your browser settings. Disabling cookies may limit certain features of the Services." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Children's Privacy" }),
          /* @__PURE__ */ s.jsx("p", { children: "Our Services are not directed to children under 13. We do not knowingly collect personal information directly from children under 13. Our Service may capture video of minors during sports activities — such video recordings are managed by the account holder (parent, coach, or organization) who is responsible for obtaining appropriate consent." }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            "If a parent or guardian becomes aware that their child has provided us with personal information without their consent, please contact us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            " and we will delete such information. For users between 13 and 18, parental or guardian consent is required to use our cloud subscription services."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Data Security" }),
          /* @__PURE__ */ s.jsx("p", { children: "We implement industry-standard security measures to protect your personal information, including encryption of data in transit (TLS 1.3) and at rest, secure cloud infrastructure, access controls, and regular security audits. However, no method of transmission over the Internet or method of electronic storage is 100% secure, and we cannot guarantee absolute security." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Your Data Rights" }),
          /* @__PURE__ */ s.jsx("p", { children: "Depending on your jurisdiction, you may have the right to:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Access the personal information we hold about you." }),
            /* @__PURE__ */ s.jsx("li", { children: "Request correction of inaccurate data." }),
            /* @__PURE__ */ s.jsx("li", { children: "Request deletion of your personal data." }),
            /* @__PURE__ */ s.jsx("li", { children: "Opt out of marketing communications." }),
            /* @__PURE__ */ s.jsx("li", { children: "Data portability — export your data in a machine-readable format." }),
            /* @__PURE__ */ s.jsx("li", { children: "Object to or restrict certain processing of your data." })
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            "To exercise these rights, contact us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            ". You can also manage your account settings and delete your data directly through the ShootzInsight app. We will respond to your request within 30 days."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "European Union — 14-Day Cooling Off Period" }),
          /* @__PURE__ */ s.jsx("p", { children: "If you are located in the European Union, you have the right to withdraw consent for data processing within 14 days. For digital services (Shootz Cloud subscriptions), this right may be waived once the service has been accessed and credits have been used, as permitted under EU consumer protection regulations." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "International Data Transfers" }),
          /* @__PURE__ */ s.jsx("p", { children: "Your information may be transferred to and processed in countries other than your country of residence, including the United States and China, where our servers and team are located. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy and applicable law, including standard contractual clauses where required." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Changes to This Privacy Policy" }),
          /* @__PURE__ */ s.jsx("p", { children: 'We may update this Privacy Policy from time to time to reflect changes in our practices or applicable law. We will notify you of material changes by posting the updated policy on this page with a new "Last updated" date. Your continued use of the Services after any changes constitutes acceptance of the updated Privacy Policy.' })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Contact Us" }),
          /* @__PURE__ */ s.jsx("p", { children: "If you have questions or concerns about this Privacy Policy or our data practices, please contact us:" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-white/5 rounded-lg border border-white/10", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-semibold", children: "ShootzInsight" }),
            /* @__PURE__ */ s.jsxs("p", { className: "mt-2", children: [
              "Customer Support: ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsxs("p", { children: [
              "Website: ",
              /* @__PURE__ */ s.jsx("a", { href: "https://shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "https://shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { children: "Address: Shenzhen, Guangdong, China" })
          ] })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const vE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bE
}, Symbol.toStringTag, { value: "Module" }));
function wE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "Terms of Service", description: "ShootzInsight Terms of Service — the rules and guidelines for using our products and services.", url: "/pages/terms-of-service" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto pt-16 max-w-3xl", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-8", children: "Terms of Service" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-12", children: "Last updated: August 3, 2026" }),
      /* @__PURE__ */ s.jsxs("div", { className: "prose prose-invert prose-sm max-w-none space-y-8 text-white/70 leading-relaxed", children: [
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Overview" }),
          /* @__PURE__ */ s.jsx("p", { children: 'This website is operated by ShootzInsight. Throughout the site, the terms "we," "us," and "our" refer to ShootzInsight. ShootzInsight offers this website, including all information, tools, and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies, and notices stated here.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'By visiting our site and/or purchasing something from us, you engage in our "Service" and agree to be bound by the following terms and conditions ("Terms of Service," "Terms"), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change, or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 1 — Online Store Terms" }),
          /* @__PURE__ */ s.jsx("p", { children: "By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws). You must not transmit any worms or viruses or any code of a destructive nature. A breach or violation of any of the Terms will result in an immediate termination of your Services." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 2 — General Conditions" }),
          /* @__PURE__ */ s.jsx("p", { children: "We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (not including credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 3 — Description of Service" }),
          /* @__PURE__ */ s.jsx("p", { children: "ShootzInsight provides an AI-powered sports recording system consisting of hardware (the ShootzInsight Q1 tracking mount) and software (the ShootzInsight mobile application with AI Moments, One-Tap Highlight, and Game Analytics features). The hardware requires a compatible smartphone to function as the recording device." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Premium AI features are available through the Shootz Cloud subscription service, managed through the ShootzInsight iPhone application. Subscription terms, pricing, credit allocations, and renewal policies are presented at the time of purchase within the app." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 4 — Modifications to the Service and Prices" }),
          /* @__PURE__ */ s.jsx("p", { children: "Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension, or discontinuance of the Service." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 5 — Products or Services" }),
          /* @__PURE__ */ s.jsx("p", { children: "Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Refund Policy." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate. We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region, or jurisdiction. All descriptions of products or product pricing are subject to change at any time without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected. While we strive for high accuracy in AI features (up to 99% scoring detection and 97% tracking accuracy), we do not guarantee perfect results in all conditions." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 6 — Accuracy of Billing and Account Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 7 — User Content" }),
          /* @__PURE__ */ s.jsx("p", { children: "You retain all ownership rights to video content you record and upload. By uploading content for AI processing, you grant us a limited license to process, analyze, and store the content solely for the purpose of providing the Service. We do not claim ownership of your content and will not use it for purposes other than delivering the Service without your explicit consent." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials (collectively, "comments"), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate, and otherwise use in any medium any comments that you forward to us.' })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 8 — Subscription & Credits" }),
          /* @__PURE__ */ s.jsx("p", { children: "Premium AI features are accessed through the Shootz Cloud subscription, managed exclusively through the ShootzInsight mobile application. Credits are allocated monthly based on your subscription tier and reset at the beginning of each billing cycle. Unused credits do not carry over to the next billing period." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'Credit top-up purchases ("Boost Packs") are available to active subscribers only. Top-up credits do not expire and remain valid as long as your account is active. Subscription cancellation does not forfeit remaining top-up credits.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We reserve the right to modify credit allocations, pricing, and feature availability with reasonable notice to subscribers." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 9 — Third-Party Links" }),
          /* @__PURE__ */ s.jsx("p", { children: "Certain content, products, and services available via our Service may include materials from third parties. Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third parties." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 10 — Acceptable Use" }),
          /* @__PURE__ */ s.jsx("p", { children: "In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-4 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "For any unlawful purpose or to solicit others to perform unlawful acts" }),
            /* @__PURE__ */ s.jsx("li", { children: "To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances" }),
            /* @__PURE__ */ s.jsx("li", { children: "To infringe upon or violate our intellectual property rights or the intellectual property rights of others" }),
            /* @__PURE__ */ s.jsx("li", { children: "To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate" }),
            /* @__PURE__ */ s.jsx("li", { children: "To submit false or misleading information" }),
            /* @__PURE__ */ s.jsx("li", { children: "To upload or transmit viruses or any other type of malicious code" }),
            /* @__PURE__ */ s.jsx("li", { children: "To collect or track the personal information of others" }),
            /* @__PURE__ */ s.jsx("li", { children: "To record individuals without their knowledge or consent where required by law" }),
            /* @__PURE__ */ s.jsx("li", { children: "To reverse engineer, decompile, or disassemble any part of the Service" }),
            /* @__PURE__ */ s.jsx("li", { children: "To interfere with or circumvent the security features of the Service" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "We reserve the right to terminate your use of the Service for violating any of the prohibited uses." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 11 — Disclaimer of Warranties; Limitation of Liability" }),
          /* @__PURE__ */ s.jsx("p", { children: "We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are provided "as is" and "as available" for your use, without any representation, warranties, or conditions of any kind, either express or implied.' }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "In no case shall ShootzInsight, our directors, officers, employees, affiliates, agents, contractors, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation, lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages. Our total liability shall not exceed the amount you paid for the Service in the 12 months preceding the claim." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 12 — Indemnification" }),
          /* @__PURE__ */ s.jsx("p", { children: "You agree to indemnify, defend, and hold harmless ShootzInsight and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, and employees, harmless from any claim or demand, including reasonable attorneys' fees, made by any third-party due to or arising out of your breach of these Terms of Service or your violation of any law or the rights of a third-party." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 13 — Severability" }),
          /* @__PURE__ */ s.jsx("p", { children: "In the event that any provision of these Terms of Service is determined to be unlawful, void, or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service. Such determination shall not affect the validity and enforceability of any other remaining provisions." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 14 — Termination" }),
          /* @__PURE__ */ s.jsx("p", { children: "The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes. These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof)." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Upon termination, your right to use the Service ceases immediately. You may export your data before termination by contacting support." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 15 — Entire Agreement" }),
          /* @__PURE__ */ s.jsx("p", { children: "The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision. These Terms of Service and any policies or operating rules posted by us on this site or in respect to the Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications, and proposals, whether oral or written, between you and us." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 16 — Governing Law" }),
          /* @__PURE__ */ s.jsx("p", { children: "These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of the People's Republic of China. For international customers, any disputes shall be resolved through arbitration in Shenzhen, Guangdong Province, China, unless local consumer protection laws in your jurisdiction provide otherwise." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 17 — Changes to Terms of Service" }),
          /* @__PURE__ */ s.jsx("p", { children: "You can review the most current version of the Terms of Service at any time at this page. We reserve the right, at our sole discretion, to update, change, or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Section 18 — Contact Information" }),
          /* @__PURE__ */ s.jsx("p", { children: "Questions about the Terms of Service should be sent to us at:" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-white/5 rounded-lg border border-white/10", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-semibold", children: "ShootzInsight" }),
            /* @__PURE__ */ s.jsxs("p", { className: "mt-2", children: [
              "Email: ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsxs("p", { children: [
              "Website: ",
              /* @__PURE__ */ s.jsx("a", { href: "https://shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "https://shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { children: "Address: Shenzhen, Guangdong, China" })
          ] })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const jE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wE
}, Symbol.toStringTag, { value: "Module" }));
function SE() {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(on, { title: "Refund Policy", description: "ShootzInsight Refund Policy — our commitment to your satisfaction with 30-day money-back guarantee.", url: "/pages/refund-policy" }),
    /* @__PURE__ */ s.jsx("section", { className: "pt-[72px] py-24", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto pt-16 max-w-3xl", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "font-[family-name:var(--font-display)] text-4xl font-bold text-white mb-8", children: "Refund Policy" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-white/40 text-sm mb-12", children: "Last updated: August 3, 2026" }),
      /* @__PURE__ */ s.jsxs("div", { className: "prose prose-invert prose-sm max-w-none space-y-8 text-white/70 leading-relaxed", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "p-6 rounded-2xl bg-[#FF6B35]/5 border border-[#FF6B35]/20 text-center mb-12", children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-[#FF6B35] font-[family-name:var(--font-display)] text-2xl font-bold mb-2", children: "30-Day Money-Back Guarantee" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-white/60", children: "Not satisfied? Return within 30 days for a full refund. No questions asked." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Returns" }),
          /* @__PURE__ */ s.jsx("p", { children: "Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can't offer you a refund or exchange. To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers, or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Additional non-returnable items:" }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 mt-2 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Gift cards" }),
            /* @__PURE__ */ s.jsx("li", { children: "Downloadable software products" }),
            /* @__PURE__ */ s.jsx("li", { children: "Some health and personal care items" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "To complete your return, we require a receipt or proof of purchase. Please do not send your purchase back to the manufacturer." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "There are certain situations where only partial refunds are granted (if applicable): any item not in its original condition, is damaged or missing parts for reasons not due to our error; any item that is returned more than 30 days after delivery." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Hardware Returns — ShootzInsight Q1" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "30-Day Return Window:" }),
            " You may return your ShootzInsight Q1 within 30 days of delivery for a full refund."
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Condition:" }),
            " The product must be returned in its original packaging with all included accessories (RC1 remote, charging cable, carry pouch). Minor signs of use are acceptable — we understand you need to try it to know if it's right for you."
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "Return Shipping:" }),
            " Free return shipping for customers in the United States. International customers are responsible for return shipping costs."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Refunds (if applicable)" }),
          /* @__PURE__ */ s.jsx("p", { children: "Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within 5-7 business days." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Late or Missing Refunds (if applicable)" }),
          /* @__PURE__ */ s.jsx("p", { children: "If you haven't received a refund yet, first check your bank account again. Then contact your credit card company, it may take some time before your refund is officially posted." }),
          /* @__PURE__ */ s.jsxs("p", { className: "mt-4", children: [
            "Next contact your bank. There is often some processing time before a refund is posted. If you've done all of this and you still have not received your refund yet, please contact us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            "."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Sale Items (if applicable)" }),
          /* @__PURE__ */ s.jsx("p", { children: "Only regular priced items may be refunded, unfortunately sale items cannot be refunded." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Exchanges (if applicable)" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            "We only replace items if they are defective or damaged. If you need to exchange it for the same item, send us an email at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            " and send your item to our return address."
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Damaged or Defective Products" }),
          /* @__PURE__ */ s.jsx("p", { children: "If your ShootzInsight Q1 arrives damaged or defective, contact us within 48 hours of delivery. We will provide a prepaid return label and ship a replacement immediately, or issue a full refund — your choice." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Please include photos of the damage when contacting support to expedite the process." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Subscription Refunds" }),
          /* @__PURE__ */ s.jsx("p", { children: "Shootz Cloud subscriptions will be managed through the ShootzInsight iPhone app. Subscription refund policies will be governed by the app's published purchase terms when the App Store release is available." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: 'Credit top-up purchases ("Boost Packs") are non-refundable once credits have been used. Unused top-up credits may be eligible for a refund within 7 days of purchase — contact us for assistance.' })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Warranty Claims" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "1-Year Limited Warranty:" }),
            " ShootzInsight Q1 is covered by a 1-year limited warranty from the date of purchase."
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "What's Covered:" }) }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Manufacturing defects in materials and workmanship" }),
            /* @__PURE__ */ s.jsx("li", { children: "Motor or tracking mechanism failure under normal use" }),
            /* @__PURE__ */ s.jsx("li", { children: "Bluetooth connectivity hardware failure" }),
            /* @__PURE__ */ s.jsx("li", { children: "Phone clamp mechanism defects" }),
            /* @__PURE__ */ s.jsx("li", { children: "Battery defects (capacity drops below 50% within warranty period)" })
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: /* @__PURE__ */ s.jsx("strong", { className: "text-white", children: "What's Not Covered:" }) }),
          /* @__PURE__ */ s.jsxs("ul", { className: "list-disc pl-6 space-y-2", children: [
            /* @__PURE__ */ s.jsx("li", { children: "Accidental damage (drops, impacts, crushing)" }),
            /* @__PURE__ */ s.jsx("li", { children: "Water or liquid damage beyond rated IP protection" }),
            /* @__PURE__ */ s.jsx("li", { children: "Unauthorized modifications or repairs" }),
            /* @__PURE__ */ s.jsx("li", { children: "Normal wear and tear (cosmetic scratches, rubber grip aging)" }),
            /* @__PURE__ */ s.jsx("li", { children: "Damage from use with incompatible devices or accessories" })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Shipping" }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            "To return your product, please email us at ",
            /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
            " to receive return instructions and a shipping label (US customers)."
          ] }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "You will be responsible for paying for your own shipping costs for returning your item if you are located outside the United States. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund (international orders only)." }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-4", children: "Depending on where you live, the time it may take for your exchanged product to reach you may vary. If you are shipping an item over $75, you should consider using a trackable shipping service or purchasing shipping insurance. We don't guarantee that we will receive your returned item." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "How to Request a Return or Warranty Claim" }),
          /* @__PURE__ */ s.jsxs("ol", { className: "list-decimal pl-6 space-y-2", children: [
            /* @__PURE__ */ s.jsxs("li", { children: [
              "Email us at ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" }),
              " with your order number"
            ] }),
            /* @__PURE__ */ s.jsx("li", { children: "Describe the issue (include photos if applicable)" }),
            /* @__PURE__ */ s.jsx("li", { children: "We'll respond within 24 hours with return instructions or a warranty determination" }),
            /* @__PURE__ */ s.jsx("li", { children: "Ship the product back using the provided label (US) or at your cost (international)" }),
            /* @__PURE__ */ s.jsx("li", { children: "Receive your refund or replacement within 5-7 business days of receipt" })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Exceptions" }),
          /* @__PURE__ */ s.jsx("p", { children: "Products purchased through unauthorized resellers are not eligible for returns or warranty service. Please purchase only from shootzinsight.com or authorized retail partners." })
        ] }),
        /* @__PURE__ */ s.jsxs("section", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-white text-xl font-semibold mb-4", children: "Contact" }),
          /* @__PURE__ */ s.jsx("p", { children: "For return or warranty questions:" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-white/5 rounded-lg border border-white/10", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-white font-semibold", children: "ShootzInsight Customer Support" }),
            /* @__PURE__ */ s.jsxs("p", { className: "mt-2", children: [
              "Email: ",
              /* @__PURE__ */ s.jsx("a", { href: "mailto:support@shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "support@shootzinsight.com" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { children: "Response time: Within 24 hours (business days)" }),
            /* @__PURE__ */ s.jsxs("p", { children: [
              "Website: ",
              /* @__PURE__ */ s.jsx("a", { href: "https://shootzinsight.com", className: "text-[#FF6B35] hover:underline", children: "https://shootzinsight.com" })
            ] })
          ] })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const NE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SE
}, Symbol.toStringTag, { value: "Module" })), an = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
}, Qa = { visible: { transition: { staggerChildren: 0.1 } } }, TE = [
  {
    name: "Lite",
    monthly: 17.4,
    annual: 115.2,
    annualMonthly: 9.6,
    annualSaving: 93.6,
    credits: "120",
    description: "For clipping and reel creation.",
    popular: !1
  },
  {
    name: "Plus",
    monthly: 160.8,
    annual: 1065.6,
    annualMonthly: 88.8,
    annualSaving: 864,
    credits: "1,200",
    description: "For teams processing games regularly.",
    popular: !0
  },
  {
    name: "Max",
    monthly: 349.2,
    annual: 2354.4,
    annualMonthly: 196.2,
    annualSaving: 1836,
    credits: "3,600",
    description: "For high-volume teams, clubs, and programs.",
    popular: !1
  }
], AE = [
  {
    icon: Rs,
    title: "Video Data Analysis",
    rate: "From 500 credits",
    description: "Includes video clipping, individual player highlights, and a complete data report.",
    detail: "The first 50 minutes cost 500 credits. Each minute beyond 50 costs 10 additional credits."
  },
  {
    icon: ol,
    title: "Highlight Clip Analysis",
    rate: "5 credits / minute",
    description: "Clipping only — turn uploaded game footage into individual highlight clips.",
    detail: "Usage is calculated from the duration of the uploaded source video."
  },
  {
    icon: yc,
    title: "Highlight Reel Creation",
    rate: "2 credits / clip",
    description: "Create a finished highlight reel from your selected clips.",
    detail: "Each clip used in the final reel consumes 2 credits."
  }
], CE = [
  {
    icon: gf,
    title: "Full-Court AI Tracking",
    badge: "Free",
    description: "97% tracking accuracy across the full court — fast breaks, outlet passes, and off-ball screens won't shake it. Every possession stays in frame from tip to buzzer."
  },
  {
    icon: $v,
    title: "AI Moments",
    badge: "Free Forever",
    description: "Every made basket is detected automatically at 99% accuracy. Your scoring highlights are tagged and ready to watch before you pack up your gear bag."
  },
  {
    icon: bf,
    title: "Find Yourself",
    badge: "Free",
    description: "After the game, browse snapshot thumbnails of every scoring play. Tap your photo to instantly pull up all your Moments — no scrubbing, no searching."
  },
  {
    icon: ic,
    title: "Live Stream + Scoreboard",
    badge: "Free",
    description: "Go live on YouTube, Facebook, or any RTMP destination — free and unlimited. Use the included RC1 remote to update the score overlay in real time."
  }
], EE = [
  {
    icon: Rs,
    title: "Game Analytics",
    description: "Turn full-game film into a box score — team totals, individual player points, FG%, and a 3PT / 2PT / FT breakdown, with every stat linked to the play it came from."
  },
  {
    icon: ol,
    title: "AI Clipping (Cloud)",
    description: "Upload any game film — from your Q1, a phone recording, or another camera system — and AI pulls every made basket and scoring play into individual clips, ready to review or share."
  },
  {
    icon: yc,
    title: "One-Tap Highlight",
    description: "Pick your best clips and let AI build a polished highlight reel — smart reframing to vertical, slow-mo on the money plays, and beat-synced music. One tap, done."
  }
];
function As(n) {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: n % 1 === 0 ? 0 : 1,
    maximumFractionDigits: 1
  });
}
function kE() {
  const [n, i] = E.useState("annual"), [l, o] = E.useState("analysis"), [d, f] = E.useState(50), [h, p] = E.useState(800), g = window.__SHOOTZ_CONFIG__?.media?.pricingQ1 || "/q1-pricing.png", m = l === "analysis" ? 500 + Math.max(0, Math.ceil(d) - 50) * 10 : l === "clipping" ? Math.ceil(d) * 5 : Math.ceil(d) * 2;
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-[#0a0a0a]", children: [
    /* @__PURE__ */ s.jsx(rn, {}),
    /* @__PURE__ */ s.jsx(
      on,
      {
        title: "Pricing — Hardware & Cloud Plans",
        description: "Compare ShootzInsight hardware and optional Shootz Cloud plans. Choose monthly or annual billing and see exactly how AI processing credits are used.",
        keywords: "ShootzInsight pricing, basketball recording system price, AI sports subscription, Shootz Cloud plans",
        url: "/pricing"
      }
    ),
    /* @__PURE__ */ s.jsxs("section", { className: "relative overflow-hidden pt-32 pb-14 text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "absolute left-1/2 top-0 h-[420px] w-[760px] -translate-x-1/2 rounded-full bg-[#FF6B35]/[0.07] blur-[140px]" }),
      /* @__PURE__ */ s.jsxs(
        C.div,
        {
          className: "container relative mx-auto",
          initial: "hidden",
          animate: "visible",
          variants: Qa,
          children: [
            /* @__PURE__ */ s.jsx(C.p, { variants: an, className: "mb-3 text-sm uppercase tracking-[0.22em] text-[#FF6B35] font-[family-name:var(--font-mono)]", children: "Simple, Transparent Pricing" }),
            /* @__PURE__ */ s.jsx(C.h1, { variants: an, className: "mb-5 text-4xl font-bold text-white md:text-6xl font-[family-name:var(--font-display)]", children: "Hardware First. Cloud When You Need It." }),
            /* @__PURE__ */ s.jsx(C.p, { variants: an, className: "mx-auto max-w-2xl text-base leading-relaxed text-white/50 md:text-lg", children: "Record, track, save and use AI Moments with Q1. Add credits when you want data analysis or finished highlights." })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Qa,
        children: [
          /* @__PURE__ */ s.jsxs(C.div, { variants: an, className: "mb-5 flex flex-col justify-between gap-2 sm:flex-row sm:items-end", children: [
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs("div", { className: "mb-2 flex items-center gap-2 text-[#FF6B35]", children: [
                /* @__PURE__ */ s.jsx(tl, { size: 17 }),
                /* @__PURE__ */ s.jsx("span", { className: "text-xs font-semibold uppercase tracking-[0.18em]", children: "Hardware" })
              ] }),
              /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-white md:text-3xl font-[family-name:var(--font-display)]", children: "One-Time Purchase" })
            ] }),
            /* @__PURE__ */ s.jsx("p", { className: "text-sm text-white/40", children: "No subscription required to record, track, or use AI Moments." })
          ] }),
          /* @__PURE__ */ s.jsx(C.div, { variants: Qa, className: "grid gap-6 md:grid-cols-2", children: [
            { name: "Q1", price: "$199", description: "For customers who already have a compatible tripod.", href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1", featured: !1 },
            { name: "Q1 + R1 Bundle", price: "$249", description: "Q1 plus the R1 tripod - the ready-to-record setup.", href: window.__SHOOTZ_CONFIG__?.bundleUrl || "/products/shootzinsight-q1-r1-bundle", featured: !0 }
          ].map((b) => /* @__PURE__ */ s.jsxs(C.article, { variants: an, className: `overflow-hidden rounded-2xl border ${b.featured ? "border-[#FF6B35]/60 bg-[#FF6B35]/[0.05]" : "border-white/10 bg-white/[0.025]"}`, children: [
            /* @__PURE__ */ s.jsx("div", { className: "overflow-hidden border-b border-white/10 bg-white/[0.96]", children: /* @__PURE__ */ s.jsx(
              "img",
              {
                src: g,
                alt: `${b.name} AI basketball recording setup`,
                className: "block aspect-[16/9] w-full object-cover object-center"
              }
            ) }),
            /* @__PURE__ */ s.jsxs("div", { className: "p-6 md:p-8", children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.16em] text-[#55D681]", children: "800 bonus credits included" }),
              /* @__PURE__ */ s.jsx("h3", { className: "mt-3 text-2xl font-bold text-white font-[family-name:var(--font-display)]", children: b.name }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-3 min-h-10 text-sm leading-relaxed text-white/50", children: b.description }),
              /* @__PURE__ */ s.jsxs("div", { className: "mt-7 flex items-center justify-between gap-5", children: [
                /* @__PURE__ */ s.jsxs("div", { children: [
                  /* @__PURE__ */ s.jsx("p", { className: "text-xs text-white/35", children: "One-time purchase" }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-4xl font-bold text-white", children: b.price })
                ] }),
                /* @__PURE__ */ s.jsxs(
                  Ne,
                  {
                    href: b.href,
                    className: "inline-flex items-center justify-center gap-2 rounded-xl bg-[#FF6B35] px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#FF6B35]/90",
                    children: [
                      /* @__PURE__ */ s.jsx(Wr, { size: 16 }),
                      " View setup"
                    ]
                  }
                )
              ] })
            ] })
          ] }, b.name)) }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "mb-5 flex flex-wrap items-baseline gap-3", children: [
              /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-white font-[family-name:var(--font-display)]", children: "Included With Q1" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-sm text-white/35", children: "Core AI features. No subscription required." })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-4", children: CE.map((b) => {
              const y = b.icon;
              return /* @__PURE__ */ s.jsxs("article", { className: "relative rounded-xl border border-white/[0.08] bg-white/[0.025] p-4", children: [
                /* @__PURE__ */ s.jsx("span", { className: "absolute right-3 top-3 rounded-md bg-green-400/15 px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-green-300", children: b.badge }),
                /* @__PURE__ */ s.jsx(y, { size: 19, className: "mb-4 text-[#FF6B35]" }),
                /* @__PURE__ */ s.jsx("h4", { className: "pr-14 text-sm font-semibold text-white", children: b.title }),
                /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs leading-relaxed text-white/45", children: b.description })
              ] }, b.title);
            }) })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-10", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "mb-5 flex flex-wrap items-baseline gap-3", children: [
              /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-white font-[family-name:var(--font-display)]", children: "Shootz Cloud — Works With Any Game Film" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-sm text-white/35", children: "Go deeper when you need it. Upload game film from any source." })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "grid gap-3 md:grid-cols-3", children: EE.map((b) => {
              const y = b.icon;
              return /* @__PURE__ */ s.jsxs("article", { className: "rounded-xl border border-white/[0.08] bg-black/20 p-5", children: [
                /* @__PURE__ */ s.jsx(y, { size: 19, className: "mb-4 text-[#FF6B35]" }),
                /* @__PURE__ */ s.jsx("h4", { className: "text-sm font-semibold text-white", children: b.title }),
                /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs leading-relaxed text-white/45", children: b.description })
              ] }, b.title);
            }) })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.06] bg-white/[0.015] py-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Qa,
        children: [
          /* @__PURE__ */ s.jsxs(C.div, { variants: an, className: "mb-8 flex flex-col justify-between gap-6 lg:flex-row lg:items-end", children: [
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs("div", { className: "mb-2 flex items-center gap-2 text-[#FF6B35]", children: [
                /* @__PURE__ */ s.jsx(Oh, { size: 17 }),
                /* @__PURE__ */ s.jsx("span", { className: "text-xs font-semibold uppercase tracking-[0.18em]", children: "Software Subscription" })
              ] }),
              /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-white md:text-3xl font-[family-name:var(--font-display)]", children: "Choose Your Monthly Credit Level" }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-2 max-w-2xl text-sm leading-relaxed text-white/45", children: "Credits are issued every month and used for premium video processing services." })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "inline-flex w-fit rounded-xl border border-white/10 bg-black/30 p-1", children: [
              /* @__PURE__ */ s.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => i("monthly"),
                  className: `rounded-lg px-4 py-2.5 text-xs font-semibold transition-all ${n === "monthly" ? "bg-white/10 text-white shadow-sm" : "text-white/40 hover:text-white/70"}`,
                  children: "Pay Monthly"
                }
              ),
              /* @__PURE__ */ s.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => i("annual"),
                  className: `rounded-lg px-4 py-2.5 text-xs font-semibold transition-all ${n === "annual" ? "bg-[#FF6B35] text-white shadow-sm" : "text-white/40 hover:text-white/70"}`,
                  children: "Pay Annually"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ s.jsx(C.div, { variants: Qa, className: "grid gap-6 md:grid-cols-3", children: TE.map((b) => {
            const y = n === "monthly" ? b.monthly : b.annualMonthly;
            return /* @__PURE__ */ s.jsxs(
              C.article,
              {
                variants: an,
                className: `relative flex flex-col rounded-2xl border p-6 ${b.popular ? "border-[#FF6B35]/50 bg-gradient-to-b from-[#FF6B35]/[0.09] to-white/[0.025] shadow-[0_18px_60px_rgba(255,107,53,0.08)]" : "border-white/10 bg-white/[0.025]"}`,
                children: [
                  b.popular && /* @__PURE__ */ s.jsx("div", { className: "absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#FF6B35] px-3 py-1 text-[10px] font-bold tracking-wider text-white", children: "MOST POPULAR" }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-5 flex items-start justify-between gap-4", children: [
                    /* @__PURE__ */ s.jsxs("div", { children: [
                      /* @__PURE__ */ s.jsx("h3", { className: `text-xl font-bold ${b.popular ? "text-[#FF8A5C]" : "text-white"}`, children: b.name }),
                      /* @__PURE__ */ s.jsx("p", { className: "mt-1 min-h-10 text-xs leading-relaxed text-white/40", children: b.description })
                    ] }),
                    /* @__PURE__ */ s.jsx(yf, { size: 18, className: b.popular ? "fill-[#FF6B35] text-[#FF6B35]" : "text-white/20" })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-5", children: [
                    /* @__PURE__ */ s.jsxs("div", { className: "flex items-end gap-1", children: [
                      /* @__PURE__ */ s.jsxs("span", { className: "text-3xl font-bold text-white", children: [
                        "$",
                        As(y)
                      ] }),
                      /* @__PURE__ */ s.jsx("span", { className: "pb-1 text-sm text-white/40", children: "/ month" })
                    ] }),
                    /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-white/35", children: n === "monthly" ? "Billed every month" : `$${As(b.annual)} billed once per year` })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-5 rounded-xl border border-[#FF6B35]/20 bg-[#FF6B35]/[0.07] p-4", children: [
                    /* @__PURE__ */ s.jsx("p", { className: "text-xs uppercase tracking-wider text-[#FF8A5C]", children: "Credits issued monthly" }),
                    /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-2xl font-bold text-white", children: b.credits })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-6 space-y-2.5 text-xs", children: [
                    /* @__PURE__ */ s.jsxs("div", { className: `flex items-center justify-between rounded-lg px-3 py-2.5 ${n === "monthly" ? "bg-white/[0.07]" : "bg-white/[0.025]"}`, children: [
                      /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Monthly billing" }),
                      /* @__PURE__ */ s.jsxs("span", { className: "font-medium text-white", children: [
                        "$",
                        As(b.monthly),
                        "/mo"
                      ] })
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: `rounded-lg px-3 py-2.5 ${n === "annual" ? "bg-white/[0.07]" : "bg-white/[0.025]"}`, children: [
                      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
                        /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Annual billing" }),
                        /* @__PURE__ */ s.jsxs("span", { className: "font-medium text-white", children: [
                          "$",
                          As(b.annual),
                          "/yr"
                        ] })
                      ] }),
                      /* @__PURE__ */ s.jsxs("div", { className: "mt-1.5 flex items-center justify-between", children: [
                        /* @__PURE__ */ s.jsx("span", { className: "text-white/30", children: "Equivalent monthly rate" }),
                        /* @__PURE__ */ s.jsxs("span", { className: "text-green-400", children: [
                          "$",
                          As(b.annualMonthly),
                          "/mo"
                        ] })
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "mb-6 flex items-center gap-2 text-xs text-green-400/80", children: [
                    /* @__PURE__ */ s.jsx(RN, { size: 13 }),
                    "Save $",
                    As(b.annualSaving),
                    " per year with annual billing"
                  ] }),
                  /* @__PURE__ */ s.jsxs(
                    "button",
                    {
                      type: "button",
                      disabled: !0,
                      className: `mt-auto flex w-full cursor-not-allowed items-center justify-center gap-2 rounded-xl py-3.5 text-sm font-semibold opacity-70 ${b.popular ? "bg-[#FF6B35] text-white hover:bg-[#FF6B35]/90" : "border border-white/10 bg-white/[0.06] text-white/80 hover:bg-white/[0.1]"}`,
                      children: [
                        /* @__PURE__ */ s.jsx(bc, { size: 15 }),
                        "iPhone app coming soon"
                      ]
                    }
                  )
                ]
              },
              b.name
            );
          }) })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { id: "credits-billing", className: "py-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-6xl", children: /* @__PURE__ */ s.jsxs(
      C.div,
      {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: !0 },
        variants: Qa,
        children: [
          /* @__PURE__ */ s.jsxs(C.div, { variants: an, className: "mb-8 text-center", children: [
            /* @__PURE__ */ s.jsx("p", { className: "mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "Credit Usage" }),
            /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-white md:text-3xl font-[family-name:var(--font-display)]", children: "Know Exactly What Each Service Costs" })
          ] }),
          /* @__PURE__ */ s.jsx(C.div, { variants: Qa, className: "grid gap-5 md:grid-cols-3", children: AE.map((b) => {
            const y = b.icon;
            return /* @__PURE__ */ s.jsxs(C.article, { variants: an, className: "rounded-2xl border border-white/10 bg-white/[0.025] p-6", children: [
              /* @__PURE__ */ s.jsx("div", { className: "mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-[#FF6B35]/10", children: /* @__PURE__ */ s.jsx(y, { size: 20, className: "text-[#FF6B35]" }) }),
              /* @__PURE__ */ s.jsx("h3", { className: "text-base font-semibold text-white", children: b.title }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xl font-bold text-[#FF8A5C]", children: b.rate }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-sm leading-relaxed text-white/55", children: b.description }),
              /* @__PURE__ */ s.jsx("p", { className: "mt-3 border-t border-white/[0.07] pt-3 text-xs leading-relaxed text-white/35", children: b.detail })
            ] }, b.title);
          }) }),
          /* @__PURE__ */ s.jsxs(C.div, { variants: an, className: "mt-6 grid gap-4 lg:grid-cols-[1.2fr_0.8fr]", children: [
            /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl border border-amber-400/20 bg-amber-400/[0.06] p-5", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3", children: [
              /* @__PURE__ */ s.jsx(GN, { size: 19, className: "mt-0.5 shrink-0 text-amber-300" }),
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-semibold text-amber-100", children: "Short video notice" }),
                /* @__PURE__ */ s.jsx("p", { className: "mt-1.5 text-xs leading-relaxed text-amber-100/60", children: "Uploading a video shorter than 15 minutes? The app will ask you to confirm before processing because any video up to 50 minutes still uses the 500-credit minimum." })
              ] })
            ] }) }),
            /* @__PURE__ */ s.jsx("div", { className: "rounded-2xl border border-white/10 bg-white/[0.025] p-5", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3", children: [
              /* @__PURE__ */ s.jsx(Oh, { size: 19, className: "mt-0.5 shrink-0 text-[#FF6B35]" }),
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-semibold text-white", children: "Billing-cycle rules" }),
                /* @__PURE__ */ s.jsxs("ul", { className: "mt-2 space-y-1.5 text-xs leading-relaxed text-white/45", children: [
                  /* @__PURE__ */ s.jsx("li", { children: "• Partial minutes are rounded up to one full minute." }),
                  /* @__PURE__ */ s.jsx("li", { children: "• Subscription credits are issued automatically each month." }),
                  /* @__PURE__ */ s.jsx("li", { children: "• Credits reset at the next subscription cycle and do not roll over." })
                ] })
              ] })
            ] }) })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ s.jsx("section", { className: "border-y border-white/[0.07] bg-[#111318] py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-9 flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(ON, { size: 22, className: "text-[#FF6B35]" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "Credits Calculator" }),
          /* @__PURE__ */ s.jsx("h2", { className: "mt-1 text-3xl font-bold text-white font-[family-name:var(--font-display)]", children: "Estimate your processing cost" })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "grid gap-8 lg:grid-cols-[1.1fr_0.9fr]", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "grid gap-5 sm:grid-cols-2", children: [
          /* @__PURE__ */ s.jsxs("label", { className: "text-sm text-white/60", children: [
            "Service",
            /* @__PURE__ */ s.jsxs("select", { value: l, onChange: (b) => o(b.target.value), className: "mt-2 h-12 w-full rounded-lg border border-white/10 bg-[#080808] px-4 text-white outline-none focus:border-[#FF6B35]", children: [
              /* @__PURE__ */ s.jsx("option", { value: "analysis", children: "Full data analysis" }),
              /* @__PURE__ */ s.jsx("option", { value: "clipping", children: "Clipping only" }),
              /* @__PURE__ */ s.jsx("option", { value: "reel", children: "Highlight reel" })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("label", { className: "text-sm text-white/60", children: [
            l === "reel" ? "Number of clips" : "Video length (minutes)",
            /* @__PURE__ */ s.jsx("input", { type: "number", min: "1", value: d, onChange: (b) => f(Math.max(1, Number(b.target.value) || 1)), className: "mt-2 h-12 w-full rounded-lg border border-white/10 bg-[#080808] px-4 text-white outline-none focus:border-[#FF6B35]" })
          ] }),
          /* @__PURE__ */ s.jsxs("label", { className: "text-sm text-white/60 sm:col-span-2", children: [
            "Available credits",
            /* @__PURE__ */ s.jsx("input", { type: "number", min: "0", value: h, onChange: (b) => p(Math.max(0, Number(b.target.value) || 0)), className: "mt-2 h-12 w-full rounded-lg border border-white/10 bg-[#080808] px-4 text-white outline-none focus:border-[#FF6B35]" })
          ] }),
          l === "analysis" && d < 15 && /* @__PURE__ */ s.jsx("p", { className: "rounded-lg border border-amber-400/20 bg-amber-400/[0.06] p-4 text-sm leading-relaxed text-amber-100/70 sm:col-span-2", children: "This video is under 15 minutes. Full data analysis still uses the 500-credit minimum." })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "rounded-lg border border-white/10 bg-[#080808] p-7", children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-white/45", children: "Estimated cost" }),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-5xl font-bold text-white", children: m }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-white/40", children: "credits" }),
          /* @__PURE__ */ s.jsxs("div", { className: "mt-7 border-t border-white/10 pt-5", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between text-sm", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Current balance" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-white", children: h })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "mt-3 flex items-center justify-between text-sm", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Balance after processing" }),
              /* @__PURE__ */ s.jsx("span", { className: h >= m ? "text-[#55D681]" : "text-amber-300", children: h - m })
            ] }),
            l === "reel" && /* @__PURE__ */ s.jsxs("div", { className: "mt-3 flex items-center justify-between text-sm", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-white/45", children: "Clips in reel" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-white", children: Math.ceil(d) })
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "mt-6 flex flex-wrap gap-3 text-xs text-white/40", children: [
        /* @__PURE__ */ s.jsx("span", { children: "50 min analysis = 500 credits" }),
        /* @__PURE__ */ s.jsx("span", { children: "·" }),
        /* @__PURE__ */ s.jsx("span", { children: "60 min analysis = 600 credits" }),
        /* @__PURE__ */ s.jsx("span", { children: "·" }),
        /* @__PURE__ */ s.jsx("span", { children: "24 min clipping = 120 credits" }),
        /* @__PURE__ */ s.jsx("span", { children: "·" }),
        /* @__PURE__ */ s.jsx("span", { children: "20-clip reel = 40 credits" })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "py-20", children: /* @__PURE__ */ s.jsxs("div", { className: "container mx-auto max-w-6xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "mb-9 max-w-2xl", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6B35]", children: "Subscribers Only" }),
        /* @__PURE__ */ s.jsx("h2", { className: "mt-2 text-3xl font-bold text-white font-[family-name:var(--font-display)]", children: "Permanent Top-Up Credits" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-3 text-sm leading-relaxed text-white/50", children: "Top-up credits do not reset. An active subscription is required to purchase them." })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "grid gap-4 sm:grid-cols-2 lg:grid-cols-4", children: [
        { credits: "100", price: "$10", unit: "$0.10 / credit" },
        { credits: "500", price: "$45", unit: "$0.09 / credit" },
        { credits: "2,500", price: "$199", unit: "$0.080 / credit" },
        { credits: "5,000", price: "$349", unit: "$0.070 / credit" }
      ].map((b) => /* @__PURE__ */ s.jsxs("article", { className: "rounded-lg border border-white/10 bg-white/[0.025] p-6", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-2xl font-bold text-white", children: b.credits }),
        /* @__PURE__ */ s.jsx("p", { className: "text-xs text-white/40", children: "permanent credits" }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-6 text-3xl font-bold text-[#FF6B35]", children: b.price }),
        /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-white/35", children: b.unit }),
        /* @__PURE__ */ s.jsx("button", { type: "button", disabled: !0, className: "mt-6 h-11 w-full cursor-not-allowed rounded-lg border border-white/10 bg-white/[0.04] text-xs font-semibold text-white/35", children: "Subscribe to unlock top-ups" })
      ] }, b.credits)) })
    ] }) }),
    /* @__PURE__ */ s.jsx("section", { className: "pb-20", children: /* @__PURE__ */ s.jsx("div", { className: "container mx-auto max-w-3xl text-center", children: /* @__PURE__ */ s.jsxs(C.div, { initial: "hidden", whileInView: "visible", viewport: { once: !0 }, variants: Qa, children: [
      /* @__PURE__ */ s.jsx(C.h3, { variants: an, className: "mb-3 text-xl font-semibold text-white", children: "Questions about pricing?" }),
      /* @__PURE__ */ s.jsx(C.p, { variants: an, className: "mb-6 text-sm leading-relaxed text-white/50", children: "The Q1 works without a subscription. Shootz Cloud plans are optional and managed through the ShootzInsight App." }),
      /* @__PURE__ */ s.jsxs(C.div, { variants: an, className: "flex flex-col items-center justify-center gap-4 sm:flex-row", children: [
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: window.__SHOOTZ_CONFIG__?.productUrl || "/products/q1",
            className: "rounded-lg bg-[#FF6B35] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#FF6B35]/90",
            children: "Shop Q1 — From $199"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ne,
          {
            href: "/pages/faq",
            className: "rounded-lg border border-white/10 bg-white/[0.06] px-6 py-3 text-sm font-medium text-white/70 transition-colors hover:bg-white/[0.1]",
            children: "View Full FAQ"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ s.jsx(ln, {})
  ] });
}
const ME = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kE
}, Symbol.toStringTag, { value: "Module" }));
